/* prettier-ignore */

export const citiesMock = [
{"id":278,"description":"Abacate da Pedreira (Macapá)","state_id":4},
{"id":325,"description":"Abadia (Jandaíra)","state_id":5},
{"id":2049,"description":"Abadia de Goiás","state_id":9},
{"id":2620,"description":"Abadia dos Dourados","state_id":11},
{"id":2050,"description":"Abadiânia","state_id":9},
{"id":4522,"description":"Abaetetuba","state_id":14},
{"id":2621,"description":"Abaeté","state_id":11},
{"id":2622,"description":"Abaeté dos Mendes (Rio Paranaíba)","state_id":11},
{"id":1122,"description":"Abaiara","state_id":6},
{"id":5730,"description":"Abapã (Castro)","state_id":18},
{"id":6839,"description":"Abarracamento (Rio das Flores)","state_id":19},
{"id":327,"description":"Abaré","state_id":5},
{"id":5731,"description":"Abatiá","state_id":18},
{"id":2623,"description":"Abaíba (Leopoldina)","state_id":11},
{"id":326,"description":"Abaíra","state_id":5},
{"id":8319,"description":"Abdon Batista","state_id":24},
{"id":4523,"description":"Abel Figueiredo","state_id":14},
{"id":8320,"description":"Abelardo Luz","state_id":24},
{"id":328,"description":"Abelhas (Vitória da Conquista)","state_id":5},
{"id":330,"description":"Abrantes (Camaçari)","state_id":5},
{"id":6840,"description":"Abraão (Angra dos Reis)","state_id":19},
{"id":2624,"description":"Abre Campo","state_id":11},
{"id":5135,"description":"Abreu e Lima","state_id":16},
{"id":9791,"description":"Abreulândia","state_id":27},
{"id":2625,"description":"Abreus (Alto Rio Doce)","state_id":11},
{"id":7310,"description":"Abunã (Porto Velho)","state_id":21},
{"id":1123,"description":"Abílio Martins (Ipu)","state_id":6},
{"id":329,"description":"Abóbora (Juazeiro)","state_id":5},
{"id":2626,"description":"Acaiaca","state_id":11},
{"id":331,"description":"Acajutiba","state_id":5},
{"id":5732,"description":"Acampamento das Minas (Telêmaco Borba)","state_id":18},
{"id":1124,"description":"Acarape","state_id":6},
{"id":1125,"description":"Acaraú","state_id":6},
{"id":7124,"description":"Acari","state_id":20},
{"id":4524,"description":"Acará","state_id":14},
{"id":5508,"description":"Acauã","state_id":17},
{"id":7388,"description":"Aceguá","state_id":23},
{"id":1797,"description":"Acioli (João Neiva)","state_id":8},
{"id":1126,"description":"Acopiara","state_id":6},
{"id":4272,"description":"Acorizal","state_id":13},
{"id":1,"description":"Acrelândia","state_id":1},
{"id":2051,"description":"Acreúna","state_id":9},
{"id":334,"description":"Acupe (Santo Amaro)","state_id":5},
{"id":2628,"description":"Acuruí (Itabirito)","state_id":11},
{"id":8853,"description":"Adamantina","state_id":26},
{"id":2052,"description":"Adelândia","state_id":9},
{"id":5734,"description":"Adhemar de Barros (Terra Rica)","state_id":18},
{"id":8854,"description":"Adolfo","state_id":26},
{"id":5735,"description":"Adrianópolis","state_id":18},
{"id":1127,"description":"Adrianópolis (Granja)","state_id":6},
{"id":12410,"description":"Adro De São Gonçalo","state_id":5},
{"id":335,"description":"Adustina","state_id":5},
{"id":2629,"description":"Adão Colares (Botumirim)","state_id":11},
{"id":336,"description":"Afligidos (São Gonçalo dos Campos)","state_id":5},
{"id":5136,"description":"Afogados da Ingazeira","state_id":16},
{"id":6841,"description":"Afonso Arinos (Comendador Levy Gasparian)","state_id":19},
{"id":7126,"description":"Afonso Bezerra","state_id":20},
{"id":1798,"description":"Afonso Cláudio","state_id":8},
{"id":2370,"description":"Afonso Cunha","state_id":10},
{"id":7389,"description":"Afonso Rodrigues (São Luiz Gonzaga)","state_id":23},
{"id":5137,"description":"Afrânio","state_id":16},
{"id":337,"description":"Afrânio Peixoto (Lençóis)","state_id":5},
{"id":4525,"description":"Afuá","state_id":14},
{"id":1799,"description":"Aghá (Piúma)","state_id":8},
{"id":8855,"description":"Agisse (Rancharia)","state_id":26},
{"id":5736,"description":"Agostinho (Castro)","state_id":18},
{"id":5138,"description":"Agrestina","state_id":16},
{"id":5509,"description":"Agricolândia","state_id":17},
{"id":8321,"description":"Agrolândia","state_id":24},
{"id":8322,"description":"Agronômica","state_id":24},
{"id":11095,"description":"Agrovila São Sebastião Do Caburi","state_id":3},
{"id":4526,"description":"Agrópolis Bela Vista (Santarém)","state_id":14},
{"id":2634,"description":"Aguanil","state_id":11},
{"id":4276,"description":"Aguapeí (Vila Bela da Santíssima Trindade)","state_id":13},
{"id":11100,"description":"Aguapés","state_id":23},
{"id":4275,"description":"Aguaçu (Cuiabá)","state_id":13},
{"id":8857,"description":"Aguaí","state_id":26},
{"id":1129,"description":"Aguaí (Itapagé)","state_id":6},
{"id":7392,"description":"Agudo","state_id":23},
{"id":8862,"description":"Agudos","state_id":26},
{"id":5743,"description":"Agudos do Sul","state_id":18},
{"id":4849,"description":"Aguiar","state_id":15},
{"id":9792,"description":"Aguiarnópolis","state_id":27},
{"id":8863,"description":"Agulha (Fernando Prestes)","state_id":26},
{"id":6842,"description":"Agulhas Negras (Resende)","state_id":19},
{"id":8329,"description":"Aguti (Nova Trento)","state_id":24},
{"id":2640,"description":"Aimorés","state_id":11},
{"id":4278,"description":"Ainhumas (Rondonópolis)","state_id":13},
{"id":341,"description":"Aiquara","state_id":5},
{"id":5142,"description":"Airi (Floresta)","state_id":16},
{"id":1802,"description":"Airituba (São José do Calçado)","state_id":8},
{"id":1131,"description":"Aiuaba","state_id":6},
{"id":2641,"description":"Aiuruoca","state_id":11},
{"id":8330,"description":"Aiurê (Grão Pará)","state_id":24},
{"id":1130,"description":"Aiuá (Massapê)","state_id":6},
{"id":8864,"description":"Ajapi (Rio Claro)","state_id":26},
{"id":7393,"description":"Ajuricaba","state_id":23},
{"id":2642,"description":"Alagoa","state_id":11},
{"id":4850,"description":"Alagoa Grande","state_id":15},
{"id":4851,"description":"Alagoa Nova","state_id":15},
{"id":5143,"description":"Alagoinha","state_id":16},
{"id":4852,"description":"Alagoinha","state_id":15},
{"id":1132,"description":"Alagoinha (Araripe)","state_id":6},
{"id":1133,"description":"Alagoinha (Paraipaba)","state_id":6},
{"id":5511,"description":"Alagoinha do Piauí","state_id":17},
{"id":342,"description":"Alagoinhas","state_id":5},
{"id":8865,"description":"Alambari","state_id":26},
{"id":24,"description":"Alazão (Arapiraca)","state_id":2},
{"id":7394,"description":"Albardão (Rio Pardo)","state_id":23},
{"id":2643,"description":"Albertina","state_id":11},
{"id":2644,"description":"Alberto Isaacson (Martinho Campos)","state_id":11},
{"id":8866,"description":"Alberto Moreira (Barretos)","state_id":26},
{"id":2645,"description":"Albertos (Formiga)","state_id":11},
{"id":4104,"description":"Albuquerque (Corumbá)","state_id":12},
{"id":5144,"description":"Albuquerque Né (Sertânia)","state_id":16},
{"id":4853,"description":"Alcantil","state_id":15},
{"id":4279,"description":"Alcantilado (Guiratinga)","state_id":13},
{"id":4105,"description":"Alcinópolis","state_id":12},
{"id":343,"description":"Alcobaça","state_id":5},
{"id":2372,"description":"Alcântara","state_id":10},
{"id":1134,"description":"Alcântaras","state_id":6},
{"id":8867,"description":"Aldeia (Barueri)","state_id":26},
{"id":2646,"description":"Aldeia (Conselheiro Pena)","state_id":11},
{"id":8868,"description":"Aldeia de Carapicuíba (Carapicuíba)","state_id":26},
{"id":2373,"description":"Aldeias Altas","state_id":10},
{"id":7395,"description":"Alecrim","state_id":23},
{"id":5744,"description":"Alecrim (Curiúva)","state_id":18},
{"id":25,"description":"Alecrim (Pão de Açúcar)","state_id":2},
{"id":1803,"description":"Alegre","state_id":8},
{"id":344,"description":"Alegre (Condeúba)","state_id":5},
{"id":2647,"description":"Alegre (Coromandel)","state_id":11},
{"id":7396,"description":"Alegrete","state_id":23},
{"id":5512,"description":"Alegrete do Piauí","state_id":17},
{"id":7397,"description":"Alegria","state_id":23},
{"id":2648,"description":"Alegria (Simonésia)","state_id":11},
{"id":4529,"description":"Alenquer","state_id":14},
{"id":5745,"description":"Alexandra (Paranaguá)","state_id":18},
{"id":7128,"description":"Alexandria","state_id":20},
{"id":2650,"description":"Alexandrita (Iturama)","state_id":11},
{"id":2056,"description":"Alexânia","state_id":9},
{"id":2651,"description":"Alfenas","state_id":11},
{"id":7398,"description":"Alfredo Brenner (Ibirubá)","state_id":23},
{"id":1804,"description":"Alfredo Chaves","state_id":8},
{"id":8869,"description":"Alfredo Guedes (Lençóis Paulista)","state_id":26},
{"id":8870,"description":"Alfredo Marcondes","state_id":26},
{"id":2652,"description":"Alfredo Vasconcelos","state_id":11},
{"id":8331,"description":"Alfredo Wagner","state_id":24},
{"id":4530,"description":"Algodoal (Maracanã)","state_id":14},
{"id":345,"description":"Algodão (Ibirataia)","state_id":5},
{"id":4854,"description":"Algodão de Jandaíra","state_id":15},
{"id":346,"description":"Algodões (Quijingue)","state_id":5},
{"id":1135,"description":"Algodões (Quiterianópolis)","state_id":6},
{"id":5145,"description":"Algodões (Sertânia)","state_id":16},
{"id":4855,"description":"Alhandra","state_id":15},
{"id":5146,"description":"Aliança","state_id":16},
{"id":9793,"description":"Aliança do Tocantins","state_id":27},
{"id":347,"description":"Almadina","state_id":5},
{"id":9794,"description":"Almas","state_id":27},
{"id":2653,"description":"Almeida (Jaboticatubas)","state_id":11},
{"id":4531,"description":"Almeirim","state_id":14},
{"id":2654,"description":"Almenara","state_id":11},
{"id":7129,"description":"Almino Afonso","state_id":20},
{"id":5746,"description":"Almirante Tamandaré","state_id":18},
{"id":7399,"description":"Almirante Tamandaré do Sul","state_id":23},
{"id":1136,"description":"Almofala (Itarema)","state_id":6},
{"id":4532,"description":"Almoço (Bragança)","state_id":14},
{"id":2057,"description":"Aloândia","state_id":9},
{"id":2655,"description":"Alpercata","state_id":11},
{"id":7400,"description":"Alpestre","state_id":23},
{"id":2656,"description":"Alpinópolis","state_id":11},
{"id":4280,"description":"Alta Floresta","state_id":13},
{"id":7312,"description":"Alta Floresta D'Oeste","state_id":21},
{"id":4533,"description":"Alta Pará (Santarém)","state_id":14},
{"id":8871,"description":"Altair","state_id":26},
{"id":4534,"description":"Altamira","state_id":14},
{"id":2374,"description":"Altamira do Maranhão","state_id":10},
{"id":5747,"description":"Altamira do Paraná","state_id":18},
{"id":1137,"description":"Altaneira","state_id":6},
{"id":5748,"description":"Altaneira (Maringá)","state_id":18},
{"id":4535,"description":"Alter do Chão (Santarém)","state_id":14},
{"id":2657,"description":"Alterosa","state_id":11},
{"id":5147,"description":"Altinho","state_id":16},
{"id":8872,"description":"Altinópolis","state_id":26},
{"id":8873,"description":"Alto Alegre","state_id":26},
{"id":7401,"description":"Alto Alegre","state_id":23},
{"id":12503,"description":"Alto Alegre","state_id":23},
{"id":7373,"description":"Alto Alegre","state_id":22},
{"id":8332,"description":"Alto Alegre (Capinzal)","state_id":24},
{"id":5749,"description":"Alto Alegre (Colorado)","state_id":18},
{"id":7402,"description":"Alto Alegre (Pedro Osório)","state_id":23},
{"id":5750,"description":"Alto Alegre (Umuarama)","state_id":18},
{"id":5751,"description":"Alto Alegre do Iguaçu (Capitão Leônidas Marques)","state_id":18},
{"id":2375,"description":"Alto Alegre do Maranhão","state_id":10},
{"id":2376,"description":"Alto Alegre do Pindaré","state_id":10},
{"id":7311,"description":"Alto Alegre dos Parecis","state_id":21},
{"id":2058,"description":"Alto Alvorada (Orizona)","state_id":9},
{"id":5752,"description":"Alto Amparo (Telêmaco Borba)","state_id":18},
{"id":4281,"description":"Alto Araguaia","state_id":13},
{"id":8333,"description":"Alto Bela Vista","state_id":24},
{"id":4282,"description":"Alto Boa Vista","state_id":13},
{"id":348,"description":"Alto Bonito (Mundo Novo)","state_id":5},
{"id":1806,"description":"Alto Caldeirão (Santa Teresa)","state_id":8},
{"id":1805,"description":"Alto Calçado (São José do Calçado)","state_id":8},
{"id":2658,"description":"Alto Caparaó","state_id":11},
{"id":2659,"description":"Alto Capim (Aimorés)","state_id":11},
{"id":10111,"description":"Alto Castelinho (Vargem Alta)","state_id":8},
{"id":4283,"description":"Alto Coité (Poxoréo)","state_id":13},
{"id":12558,"description":"Alto Erval Novo","state_id":23},
{"id":7404,"description":"Alto Feliz","state_id":23},
{"id":4284,"description":"Alto Garças","state_id":13},
{"id":2059,"description":"Alto Horizonte","state_id":9},
{"id":2661,"description":"Alto Jequitibá","state_id":11},
{"id":4285,"description":"Alto Juruena (Comodoro)","state_id":13},
{"id":12148,"description":"Alto Lindo","state_id":6},
{"id":5513,"description":"Alto Longá","state_id":17},
{"id":2662,"description":"Alto Maranhão (Congonhas)","state_id":11},
{"id":1807,"description":"Alto Mutum Preto (Baixo Guandu)","state_id":8},
{"id":4286,"description":"Alto Paraguai","state_id":13},
{"id":5755,"description":"Alto Paraná","state_id":18},
{"id":7313,"description":"Alto Paraíso","state_id":21},
{"id":4287,"description":"Alto Paraíso (Alta Floresta)","state_id":13},
{"id":2060,"description":"Alto Paraíso de Goiás","state_id":9},
{"id":7405,"description":"Alto Paredão (Santa Cruz do Sul)","state_id":23},
{"id":2377,"description":"Alto Parnaíba","state_id":10},
{"id":5754,"description":"Alto Pará (Cascavel)","state_id":18},
{"id":5756,"description":"Alto Piquiri","state_id":18},
{"id":5757,"description":"Alto Porã (Ivaiporã)","state_id":18},
{"id":8874,"description":"Alto Porã (Pedregulho)","state_id":26},
{"id":7406,"description":"Alto Recreio (Ronda Alta)","state_id":23},
{"id":2663,"description":"Alto Rio Doce","state_id":11},
{"id":1808,"description":"Alto Rio Novo","state_id":8},
{"id":5758,"description":"Alto Sabiá (Guarapuava)","state_id":18},
{"id":5759,"description":"Alto Santa Fé (Nova Santa Rosa)","state_id":18},
{"id":1809,"description":"Alto Santa Maria (Santa Teresa)","state_id":8},
{"id":1138,"description":"Alto Santo","state_id":6},
{"id":4106,"description":"Alto Sucuriú (Água Clara)","state_id":12},
{"id":5760,"description":"Alto São João (Roncador)","state_id":18},
{"id":4288,"description":"Alto Taquari","state_id":13},
{"id":12566,"description":"Alto Uruguai","state_id":23},
{"id":7407,"description":"Alto Uruguai (Três Passos)","state_id":23},
{"id":8334,"description":"Alto da Serra (Chapecó)","state_id":24},
{"id":7403,"description":"Alto da União (Ijuí)","state_id":23},
{"id":2660,"description":"Alto de Santa Helena (Governador Valadares)","state_id":11},
{"id":5753,"description":"Alto do Amparo (Tibagi)","state_id":18},
{"id":7130,"description":"Alto do Rodrigues","state_id":20},
{"id":2664,"description":"Altolândia (Tapiraí)","state_id":11},
{"id":5514,"description":"Altos","state_id":17},
{"id":8767,"description":"Altos Verdes (Carira)","state_id":25},
{"id":5761,"description":"Altônia","state_id":18},
{"id":8875,"description":"Alumínio","state_id":26},
{"id":2666,"description":"Alvarenga","state_id":11},
{"id":191,"description":"Alvarães","state_id":3},
{"id":2665,"description":"Alvação (Coração de Jesus)","state_id":11},
{"id":11700,"description":"Alverne","state_id":16},
{"id":8879,"description":"Alvinlândia","state_id":26},
{"id":2667,"description":"Alvinópolis","state_id":11},
{"id":9795,"description":"Alvorada","state_id":27},
{"id":11141,"description":"Alvorada","state_id":14},
{"id":7408,"description":"Alvorada","state_id":23},
{"id":2668,"description":"Alvorada (Carangola)","state_id":11},
{"id":4536,"description":"Alvorada (Itaituba)","state_id":14},
{"id":2669,"description":"Alvorada de Minas","state_id":11},
{"id":5515,"description":"Alvorada do Gurguéia","state_id":17},
{"id":5762,"description":"Alvorada do Iguaçu (Foz do Iguaçu)","state_id":18},
{"id":2061,"description":"Alvorada do Norte","state_id":9},
{"id":7314,"description":"Alvorada do Oeste","state_id":21},
{"id":5763,"description":"Alvorada do Sul","state_id":18},
{"id":2649,"description":"Além Paraíba","state_id":11},
{"id":8880,"description":"Amadeu Amaral (Marília)","state_id":26},
{"id":349,"description":"Amado Bahia (Mata de São João)","state_id":5},
{"id":7374,"description":"Amajarí","state_id":22},
{"id":4107,"description":"Amambái","state_id":12},
{"id":1139,"description":"Amanaiara (Reriutaba)","state_id":6},
{"id":1140,"description":"Amanari (Maranguape)","state_id":6},
{"id":2670,"description":"Amanda (Baldim)","state_id":11},
{"id":8881,"description":"Amandaba (Mirandópolis)","state_id":26},
{"id":4108,"description":"Amandina (Ivinhema)","state_id":12},
{"id":2671,"description":"Amanhece (Araguari)","state_id":11},
{"id":1141,"description":"Amaniutuba (Lavras da Mangabeira)","state_id":6},
{"id":350,"description":"Amaniú (Sento Sé)","state_id":5},
{"id":5764,"description":"Amaporã","state_id":18},
{"id":280,"description":"Amapá","state_id":4},
{"id":2378,"description":"Amapá do Maranhão","state_id":10},
{"id":5148,"description":"Amaraji","state_id":16},
{"id":7409,"description":"Amaral Ferrador","state_id":23},
{"id":2062,"description":"Amaralina","state_id":9},
{"id":5516,"description":"Amarante","state_id":17},
{"id":2379,"description":"Amarante do Maranhão","state_id":10},
{"id":2672,"description":"Amarantina (Ouro Preto)","state_id":11},
{"id":1142,"description":"Amarelas (Camocim)","state_id":6},
{"id":351,"description":"Amargosa","state_id":5},
{"id":1143,"description":"Amaro (Assaré)","state_id":6},
{"id":192,"description":"Amatari (Itacoatiara)","state_id":3},
{"id":193,"description":"Amaturá","state_id":3},
{"id":282,"description":"Ambé (Macapá)","state_id":4},
{"id":5149,"description":"Ameixas (Cumaru)","state_id":16},
{"id":8882,"description":"Ameliópolis (Presidente Prudente)","state_id":26},
{"id":8883,"description":"Americana","state_id":26},
{"id":4537,"description":"Americano (Santa Isabel do Pará)","state_id":14},
{"id":2063,"description":"Americano do Brasil","state_id":9},
{"id":7410,"description":"Ametista do Sul","state_id":23},
{"id":4109,"description":"Amolar (Corumbá)","state_id":12},
{"id":1145,"description":"Amontada","state_id":6},
{"id":12475,"description":"Amoras","state_id":23},
{"id":5765,"description":"Amorinha (Ibaiti)","state_id":18},
{"id":2064,"description":"Amorinópolis","state_id":9},
{"id":4856,"description":"Amparo","state_id":15},
{"id":8886,"description":"Amparo","state_id":26},
{"id":6843,"description":"Amparo (Nova Friburgo)","state_id":19},
{"id":8768,"description":"Amparo de São Francisco","state_id":25},
{"id":2673,"description":"Amparo do Serra","state_id":11},
{"id":5766,"description":"Ampére","state_id":18},
{"id":352,"description":"Amélia Rodrigues","state_id":5},
{"id":1144,"description":"América (Ipueiras)","state_id":6},
{"id":353,"description":"América Dourada","state_id":5},
{"id":354,"description":"Américo Alves (Sento Sé)","state_id":5},
{"id":8884,"description":"Américo Brasiliense","state_id":26},
{"id":8885,"description":"Américo de Campos","state_id":26},
{"id":8887,"description":"Ana Dias (Itariri)","state_id":26},
{"id":26,"description":"Anadia","state_id":2},
{"id":355,"description":"Anagé","state_id":5},
{"id":5767,"description":"Anahy","state_id":18},
{"id":9796,"description":"Anajanópolis (Pedro Afonso)","state_id":27},
{"id":2380,"description":"Anajatuba","state_id":10},
{"id":4538,"description":"Anajás","state_id":14},
{"id":8888,"description":"Analândia","state_id":26},
{"id":4289,"description":"Analândia do Norte (Peixoto de Azevedo)","state_id":13},
{"id":194,"description":"Anamã","state_id":3},
{"id":4539,"description":"Ananindeua","state_id":14},
{"id":9797,"description":"Ananás","state_id":27},
{"id":4540,"description":"Anapu","state_id":14},
{"id":2381,"description":"Anapurus","state_id":10},
{"id":4110,"description":"Anastácio","state_id":12},
{"id":4111,"description":"Anaurilândia","state_id":12},
{"id":1146,"description":"Anauá (Mauriti)","state_id":6},
{"id":8335,"description":"Anchieta","state_id":24},
{"id":1810,"description":"Anchieta","state_id":8},
{"id":356,"description":"Andaraí","state_id":5},
{"id":8890,"description":"Andes (Bebedouro)","state_id":26},
{"id":2674,"description":"Andiroba (Esmeraldas)","state_id":11},
{"id":5768,"description":"Andirá","state_id":18},
{"id":357,"description":"Andorinha","state_id":5},
{"id":5769,"description":"Andorinhas (Castro)","state_id":18},
{"id":2675,"description":"Andradas","state_id":11},
{"id":6844,"description":"Andrade Pinto (Vassouras)","state_id":19},
{"id":8891,"description":"Andradina","state_id":26},
{"id":2676,"description":"Andrelândia","state_id":11},
{"id":2677,"description":"Andrequicé (Três Marias)","state_id":11},
{"id":7411,"description":"André da Rocha","state_id":23},
{"id":27,"description":"Anel (Viçosa)","state_id":2},
{"id":5770,"description":"Angai (Fernandes Pinheiro)","state_id":18},
{"id":8892,"description":"Angatuba","state_id":26},
{"id":2678,"description":"Angaturama (Recreio)","state_id":11},
{"id":5150,"description":"Angelim","state_id":16},
{"id":8336,"description":"Angelina","state_id":24},
{"id":2679,"description":"Angelândia","state_id":11},
{"id":358,"description":"Angical","state_id":5},
{"id":5517,"description":"Angical do Piauí","state_id":17},
{"id":9798,"description":"Angico","state_id":27},
{"id":359,"description":"Angico (Mairi)","state_id":5},
{"id":7131,"description":"Angicos","state_id":20},
{"id":2680,"description":"Angicos de Minas (Brasília de Minas)","state_id":11},
{"id":6845,"description":"Angra dos Reis","state_id":19},
{"id":360,"description":"Anguera","state_id":5},
{"id":2681,"description":"Angueretá (Curvelo)","state_id":11},
{"id":2682,"description":"Angustura (Além Paraíba)","state_id":11},
{"id":4112,"description":"Angélica","state_id":12},
{"id":4113,"description":"Anhandui (Campo Grande)","state_id":12},
{"id":2066,"description":"Anhanguera","state_id":9},
{"id":8893,"description":"Anhembi","state_id":26},
{"id":8894,"description":"Anhumas","state_id":26},
{"id":8895,"description":"Anhumas (Piracicaba)","state_id":26},
{"id":2067,"description":"Anicuns","state_id":9},
{"id":12077,"description":"Anil","state_id":6},
{"id":2382,"description":"Anil (São Luís)","state_id":10},
{"id":1147,"description":"Aningás (Horizonte)","state_id":6},
{"id":8337,"description":"Anita Garibaldi","state_id":24},
{"id":8338,"description":"Anitápolis","state_id":24},
{"id":1148,"description":"Anjinhos (Santana do Cariri)","state_id":6},
{"id":195,"description":"Anori","state_id":3},
{"id":6846,"description":"Anta (Sapucaia)","state_id":19},
{"id":7412,"description":"Anta Gorda","state_id":23},
{"id":8339,"description":"Anta Gorda (Videira)","state_id":24},
{"id":12105,"description":"Antarí","state_id":5},
{"id":361,"description":"Antas","state_id":5},
{"id":5772,"description":"Antas (Laranjeiras do Sul)","state_id":18},
{"id":5773,"description":"Antas (Telêmaco Borba)","state_id":18},
{"id":5774,"description":"Antonina","state_id":18},
{"id":1149,"description":"Antonina do Norte","state_id":6},
{"id":2689,"description":"Antunes (Igaratinga)","state_id":11},
{"id":5519,"description":"Antônio Almeida","state_id":17},
{"id":1150,"description":"Antônio Bezerra (Fortaleza)","state_id":6},
{"id":5775,"description":"Antônio Brandão de Oliveira (Jataizinho)","state_id":18},
{"id":362,"description":"Antônio Cardoso","state_id":5},
{"id":8340,"description":"Antônio Carlos","state_id":24},
{"id":2683,"description":"Antônio Carlos","state_id":11},
{"id":2684,"description":"Antônio Dias","state_id":11},
{"id":1151,"description":"Antônio Diogo (Redenção)","state_id":6},
{"id":2686,"description":"Antônio Ferreira (Franciscópolis)","state_id":11},
{"id":363,"description":"Antônio Gonçalves","state_id":5},
{"id":4114,"description":"Antônio João","state_id":12},
{"id":7413,"description":"Antônio Kerpel (Coronel Bicaco)","state_id":23},
{"id":4541,"description":"Antônio Lemos (Breves)","state_id":14},
{"id":1152,"description":"Antônio Marques (Maranguape)","state_id":6},
{"id":7132,"description":"Antônio Martins","state_id":20},
{"id":5776,"description":"Antônio Olinto","state_id":18},
{"id":2687,"description":"Antônio Pereira (Ouro Preto)","state_id":11},
{"id":7414,"description":"Antônio Prado","state_id":23},
{"id":2688,"description":"Antônio Prado de Minas","state_id":11},
{"id":2685,"description":"Antônio dos Santos (Caeté)","state_id":11},
{"id":28,"description":"Anum Novo (Palmeira dos Índios)","state_id":2},
{"id":29,"description":"Anum Velho (Palmeira dos Índios)","state_id":2},
{"id":5777,"description":"Anunciação (Santa Izabel do Oeste)","state_id":18},
{"id":1812,"description":"Anutiba (Alegre)","state_id":8},
{"id":2065,"description":"Anápolis","state_id":9},
{"id":8889,"description":"Anápolis (Iacri)","state_id":26},
{"id":5518,"description":"Anísio de Abreu","state_id":17},
{"id":4857,"description":"Aparecida","state_id":15},
{"id":8896,"description":"Aparecida","state_id":26},
{"id":2068,"description":"Aparecida (Sanclerlândia)","state_id":9},
{"id":8897,"description":"Aparecida D'Oeste","state_id":26},
{"id":12790,"description":"Aparecida Do Ivaí","state_id":18},
{"id":2070,"description":"Aparecida de Goiás (Itapaci)","state_id":9},
{"id":2069,"description":"Aparecida de Goiânia","state_id":9},
{"id":2690,"description":"Aparecida de Minas (Frutal)","state_id":11},
{"id":8898,"description":"Aparecida de Monte Alto (Monte Alto)","state_id":26},
{"id":8899,"description":"Aparecida de São Manuel (São Manuel)","state_id":26},
{"id":8900,"description":"Aparecida do Bonito (Santa Rita D'Oeste)","state_id":26},
{"id":5778,"description":"Aparecida do Oeste (Tuneiras do Oeste)","state_id":18},
{"id":2071,"description":"Aparecida do Rio Claro (Montes Claros de Goiás)","state_id":9},
{"id":2072,"description":"Aparecida do Rio Doce","state_id":9},
{"id":9799,"description":"Aparecida do Rio Negro","state_id":27},
{"id":4115,"description":"Aparecida do Taboado","state_id":12},
{"id":6847,"description":"Aperibé","state_id":19},
{"id":4542,"description":"Apeú (Castanhal)","state_id":14},
{"id":5779,"description":"Apiaba (Imbituva)","state_id":18},
{"id":1813,"description":"Apiacá","state_id":8},
{"id":4290,"description":"Apiacás","state_id":13},
{"id":8901,"description":"Apiaí","state_id":26},
{"id":8902,"description":"Apiaí-Mirim (Capão Bonito)","state_id":26},
{"id":2383,"description":"Apicum-Açu","state_id":10},
{"id":4544,"description":"Apinagés (São João do Araguaia)","state_id":14},
{"id":9800,"description":"Apinajé (São Valério da Natividade)","state_id":27},
{"id":8341,"description":"Apiúna","state_id":24},
{"id":7133,"description":"Apodi","state_id":20},
{"id":283,"description":"Aporema (Tartarugalzinho)","state_id":4},
{"id":364,"description":"Aporá","state_id":5},
{"id":2073,"description":"Aporé","state_id":9},
{"id":5151,"description":"Apoti (Glória do Goitá)","state_id":16},
{"id":1153,"description":"Aprazível (Sobral)","state_id":6},
{"id":365,"description":"Apuarema","state_id":5},
{"id":5780,"description":"Apucarana","state_id":18},
{"id":1154,"description":"Apuiarés","state_id":6},
{"id":196,"description":"Apuí","state_id":3},
{"id":5781,"description":"Aquidaban (Marialva)","state_id":18},
{"id":8769,"description":"Aquidabã","state_id":25},
{"id":4116,"description":"Aquidauana","state_id":12},
{"id":1155,"description":"Aquinópolis (Jaguaribe)","state_id":6},
{"id":1156,"description":"Aquiraz","state_id":6},
{"id":8903,"description":"Arabela (Ouro Verde)","state_id":26},
{"id":8342,"description":"Arabutã","state_id":24},
{"id":11092,"description":"Arabá","state_id":26},
{"id":8770,"description":"Aracaju","state_id":25},
{"id":1158,"description":"Aracati","state_id":6},
{"id":2692,"description":"Aracati de Minas (Cataguases)","state_id":11},
{"id":1160,"description":"Aracatiara (Amontada)","state_id":6},
{"id":1159,"description":"Aracatiaçu (Sobral)","state_id":6},
{"id":367,"description":"Aracatu","state_id":5},
{"id":8904,"description":"Aracaçu (Buri)","state_id":26},
{"id":368,"description":"Araci","state_id":5},
{"id":2693,"description":"Aracitaba","state_id":11},
{"id":1161,"description":"Aracoiaba","state_id":6},
{"id":1816,"description":"Aracruz","state_id":8},
{"id":1817,"description":"Aracui (Castelo)","state_id":8},
{"id":1815,"description":"Aracê (Domingos Martins)","state_id":8},
{"id":2075,"description":"Aragarças","state_id":9},
{"id":9801,"description":"Aragaçuí (Caseara)","state_id":27},
{"id":2076,"description":"Aragoiânia","state_id":9},
{"id":9802,"description":"Aragominas","state_id":27},
{"id":9803,"description":"Araguacema","state_id":27},
{"id":1818,"description":"Araguaia (Marechal Floriano)","state_id":8},
{"id":4291,"description":"Araguaiana","state_id":13},
{"id":4292,"description":"Araguainha","state_id":13},
{"id":2384,"description":"Araguanã","state_id":10},
{"id":9806,"description":"Araguanã","state_id":27},
{"id":2077,"description":"Araguapaz","state_id":9},
{"id":2695,"description":"Araguari","state_id":11},
{"id":9807,"description":"Araguatins","state_id":27},
{"id":9804,"description":"Araguaçu","state_id":27},
{"id":9805,"description":"Araguaína","state_id":27},
{"id":2385,"description":"Araióses","state_id":10},
{"id":1162,"description":"Arajara (Barbalha)","state_id":6},
{"id":4117,"description":"Aral Moreira","state_id":12},
{"id":369,"description":"Aramari","state_id":5},
{"id":7415,"description":"Arambaré","state_id":23},
{"id":2386,"description":"Arame","state_id":10},
{"id":8909,"description":"Aramina","state_id":26},
{"id":2696,"description":"Aramirim (Açucena)","state_id":11},
{"id":1163,"description":"Aranaú (Acaraú)","state_id":6},
{"id":8910,"description":"Arandu","state_id":26},
{"id":2697,"description":"Aranha (Brumadinho)","state_id":11},
{"id":5782,"description":"Aranha (Colombo)","state_id":18},
{"id":2698,"description":"Arantina","state_id":11},
{"id":11472,"description":"Arantina","state_id":9},
{"id":1165,"description":"Arapari (Itapipoca)","state_id":6},
{"id":8911,"description":"Arapeí","state_id":26},
{"id":30,"description":"Arapiraca","state_id":2},
{"id":370,"description":"Arapiranga (Rio de Contas)","state_id":5},
{"id":4545,"description":"Arapixuna (Santarém)","state_id":14},
{"id":9808,"description":"Arapoema","state_id":27},
{"id":2699,"description":"Araponga","state_id":11},
{"id":5783,"description":"Arapongas","state_id":18},
{"id":1166,"description":"Araporanga (Santana do Cariri)","state_id":6},
{"id":2700,"description":"Araporã","state_id":11},
{"id":5784,"description":"Arapoti","state_id":18},
{"id":5786,"description":"Arapuan (Janiópolis)","state_id":18},
{"id":4293,"description":"Araputanga","state_id":13},
{"id":2701,"description":"Arapuá","state_id":11},
{"id":5785,"description":"Arapuã","state_id":18},
{"id":4118,"description":"Arapuã (Três Lagoas)","state_id":12},
{"id":1164,"description":"Arapá (Tianguá)","state_id":6},
{"id":4546,"description":"Araquaim (Curuçá)","state_id":14},
{"id":8343,"description":"Araquari","state_id":24},
{"id":1167,"description":"Araquém (Coreaú)","state_id":6},
{"id":4859,"description":"Arara","state_id":15},
{"id":8344,"description":"Araranguá","state_id":24},
{"id":5787,"description":"Ararapira (Guaraqueçaba)","state_id":18},
{"id":8912,"description":"Araraquara","state_id":26},
{"id":8913,"description":"Araras","state_id":26},
{"id":11770,"description":"Araras","state_id":3},
{"id":1819,"description":"Araraí (Alegre)","state_id":8},
{"id":1168,"description":"Ararendá","state_id":6},
{"id":2387,"description":"Arari","state_id":10},
{"id":7416,"description":"Araricá","state_id":23},
{"id":1169,"description":"Araripe","state_id":6},
{"id":5153,"description":"Araripina","state_id":16},
{"id":1170,"description":"Arariús (Cariré)","state_id":6},
{"id":6848,"description":"Araruama","state_id":19},
{"id":4860,"description":"Araruna","state_id":15},
{"id":5788,"description":"Araruna","state_id":18},
{"id":371,"description":"Arataca","state_id":5},
{"id":1171,"description":"Aratama (Assaré)","state_id":6},
{"id":7417,"description":"Aratiba","state_id":23},
{"id":1172,"description":"Araticum (Ubajara)","state_id":6},
{"id":1173,"description":"Aratuba","state_id":6},
{"id":372,"description":"Aratuípe","state_id":5},
{"id":5789,"description":"Araucária","state_id":18},
{"id":8771,"description":"Arauá","state_id":25},
{"id":2704,"description":"Araxá","state_id":11},
{"id":8914,"description":"Araxás (Presidente Bernardes)","state_id":26},
{"id":4858,"description":"Araçagi","state_id":15},
{"id":12683,"description":"Araçaji De Minas","state_id":11},
{"id":8906,"description":"Araçariguama","state_id":26},
{"id":1814,"description":"Araçatiba (Viana)","state_id":8},
{"id":8907,"description":"Araçatuba","state_id":26},
{"id":2691,"description":"Araçaí","state_id":11},
{"id":8905,"description":"Araçaíba (Apiaí)","state_id":26},
{"id":5152,"description":"Araçoiaba","state_id":16},
{"id":8908,"description":"Araçoiaba da Serra","state_id":26},
{"id":2074,"description":"Araçu","state_id":9},
{"id":2694,"description":"Araçuaí","state_id":11},
{"id":366,"description":"Araçás","state_id":5},
{"id":1157,"description":"Araçás (Paracuru)","state_id":6},
{"id":2702,"description":"Araújos","state_id":11},
{"id":2703,"description":"Araúna (Guapé)","state_id":11},
{"id":8915,"description":"Arcadas (Amparo)","state_id":26},
{"id":2706,"description":"Arceburgo","state_id":11},
{"id":7418,"description":"Arco Verde (Carlos Barbosa)","state_id":23},
{"id":8916,"description":"Arco-Íris","state_id":26},
{"id":7419,"description":"Arco-Íris (Erval Seco)","state_id":23},
{"id":4547,"description":"Arco-Íris (Paragominas)","state_id":14},
{"id":2707,"description":"Arcos","state_id":11},
{"id":5154,"description":"Arcoverde","state_id":16},
{"id":2705,"description":"Arcângelo (São João Del Rei)","state_id":11},
{"id":2708,"description":"Areado","state_id":11},
{"id":4119,"description":"Areado (São Gabriel do Oeste)","state_id":12},
{"id":6849,"description":"Areal","state_id":19},
{"id":8917,"description":"Arealva","state_id":26},
{"id":4861,"description":"Areia","state_id":15},
{"id":8772,"description":"Areia Branca","state_id":25},
{"id":7134,"description":"Areia Branca","state_id":20},
{"id":8773,"description":"Areia Branca (Aracaju)","state_id":25},
{"id":5790,"description":"Areia Branca dos Assis (Mandirituba)","state_id":18},
{"id":4862,"description":"Areia de Baraúnas","state_id":15},
{"id":4863,"description":"Areial","state_id":15},
{"id":1174,"description":"Areial (Santa Quitéria)","state_id":6},
{"id":8918,"description":"Areias","state_id":26},
{"id":11704,"description":"Areias","state_id":16},
{"id":373,"description":"Areias (Camaçari)","state_id":5},
{"id":5791,"description":"Areias (Castro)","state_id":18},
{"id":4548,"description":"Areias (Melgaço)","state_id":14},
{"id":4864,"description":"Areias (Uiraúna)","state_id":15},
{"id":8919,"description":"Areiópolis","state_id":26},
{"id":374,"description":"Arembepe (Camaçari)","state_id":5},
{"id":4294,"description":"Arenápolis","state_id":13},
{"id":2078,"description":"Arenópolis","state_id":9},
{"id":12111,"description":"Areré","state_id":6},
{"id":7135,"description":"Arez","state_id":20},
{"id":2709,"description":"Argenita (Ibiá)","state_id":11},
{"id":2710,"description":"Argirita","state_id":11},
{"id":375,"description":"Argoim (Rafael Jambeiro)","state_id":5},
{"id":1820,"description":"Argolas (Vila Velha)","state_id":8},
{"id":376,"description":"Argolo (Nova Viçosa)","state_id":5},
{"id":12661,"description":"Ariaú","state_id":3},
{"id":197,"description":"Ariaú (Barreirinha)","state_id":3},
{"id":377,"description":"Aribice (Euclides da Cunha)","state_id":5},
{"id":2711,"description":"Aricanduva","state_id":11},
{"id":5792,"description":"Aricanduva (Arapongas)","state_id":18},
{"id":2712,"description":"Arinos","state_id":11},
{"id":5155,"description":"Aripibu (Ribeirão)","state_id":16},
{"id":4295,"description":"Aripuanã","state_id":13},
{"id":7315,"description":"Ariquemes","state_id":21},
{"id":8920,"description":"Ariranha","state_id":26},
{"id":5793,"description":"Ariranha do Ivaí","state_id":18},
{"id":8921,"description":"Ariri (Cananéia)","state_id":26},
{"id":284,"description":"Ariri (Macapá)","state_id":4},
{"id":1175,"description":"Ariscos dos Marianos (Ocara)","state_id":6},
{"id":2713,"description":"Aristides Batista (Coração de Jesus)","state_id":11},
{"id":378,"description":"Aritaguá (Ilhéus)","state_id":5},
{"id":5156,"description":"Arizona (Afrânio)","state_id":16},
{"id":12466,"description":"Arlindo","state_id":23},
{"id":8345,"description":"Armazém","state_id":24},
{"id":6850,"description":"Armação de Búzios","state_id":19},
{"id":1176,"description":"Arneiroz","state_id":6},
{"id":8346,"description":"Arnópolis (Alfredo Wagner)","state_id":24},
{"id":5520,"description":"Aroazes","state_id":17},
{"id":5794,"description":"Aroeira (Cascavel)","state_id":18},
{"id":4865,"description":"Aroeiras","state_id":15},
{"id":12515,"description":"Aroeiras","state_id":23},
{"id":1177,"description":"Aroeiras (Coreaú)","state_id":6},
{"id":11019,"description":"Aroeiras Do Itaim","state_id":17},
{"id":5795,"description":"Arquimedes (Cascavel)","state_id":18},
{"id":5521,"description":"Arraial","state_id":17},
{"id":10209,"description":"Arraial D'Ajuda (Porto Seguro)","state_id":5},
{"id":6851,"description":"Arraial do Cabo","state_id":19},
{"id":9809,"description":"Arraias","state_id":27},
{"id":12472,"description":"Arroio Bonito","state_id":23},
{"id":7420,"description":"Arroio Canoas (Barão)","state_id":23},
{"id":12707,"description":"Arroio Do Ouro","state_id":23},
{"id":12453,"description":"Arroio Dos Mengues","state_id":23},
{"id":7427,"description":"Arroio Grande","state_id":23},
{"id":7428,"description":"Arroio Grande (Santa Maria)","state_id":23},
{"id":7429,"description":"Arroio Grande (Selbach)","state_id":23},
{"id":12452,"description":"Arroio Teixeira","state_id":23},
{"id":8347,"description":"Arroio Trinta","state_id":24},
{"id":7421,"description":"Arroio do Meio","state_id":23},
{"id":7422,"description":"Arroio do Padre","state_id":23},
{"id":7423,"description":"Arroio do Sal","state_id":23},
{"id":7424,"description":"Arroio do Só (Santa Maria)","state_id":23},
{"id":7425,"description":"Arroio do Tigre","state_id":23},
{"id":7426,"description":"Arroio dos Ratos","state_id":23},
{"id":1178,"description":"Arrojado (Lavras da Mangabeira)","state_id":6},
{"id":6852,"description":"Arrozal (Piraí)","state_id":19},
{"id":4296,"description":"Arruda (Rosário Oeste)","state_id":13},
{"id":8922,"description":"Artemis (Piracicaba)","state_id":26},
{"id":8923,"description":"Artur Nogueira","state_id":26},
{"id":2079,"description":"Aruanã","state_id":9},
{"id":1179,"description":"Aruaru (Morada Nova)","state_id":6},
{"id":8924,"description":"Arujá","state_id":26},
{"id":4549,"description":"Arumanduba (Almeirim)","state_id":14},
{"id":4550,"description":"Aruri (Itaituba)","state_id":14},
{"id":8348,"description":"Arvoredo","state_id":24},
{"id":7431,"description":"Arvorezinha","state_id":23},
{"id":2714,"description":"Ascenção (Pará de Minas)","state_id":11},
{"id":8349,"description":"Ascurra","state_id":24},
{"id":8925,"description":"Aspásia","state_id":26},
{"id":2715,"description":"Assaraí (Pocrane)","state_id":11},
{"id":4297,"description":"Assari (Barra do Bugres)","state_id":13},
{"id":1180,"description":"Assaré","state_id":6},
{"id":5796,"description":"Assaí","state_id":18},
{"id":8926,"description":"Assis","state_id":26},
{"id":11631,"description":"Assis","state_id":6},
{"id":2,"description":"Assis Brasil","state_id":1},
{"id":4866,"description":"Assis Chateaubriand","state_id":15},
{"id":5797,"description":"Assis Chateaubriand","state_id":18},
{"id":8927,"description":"Assistência (Rio Claro)","state_id":26},
{"id":4867,"description":"Assunção","state_id":15},
{"id":1181,"description":"Assunção (Itapipoca)","state_id":6},
{"id":1182,"description":"Assunção (Solonópole)","state_id":6},
{"id":5522,"description":"Assunção do Piauí","state_id":17},
{"id":2716,"description":"Astolfo Dutra","state_id":11},
{"id":5798,"description":"Astorga","state_id":18},
{"id":7432,"description":"Atafona (Santo Ângelo)","state_id":23},
{"id":31,"description":"Atalaia","state_id":2},
{"id":5799,"description":"Atalaia","state_id":18},
{"id":198,"description":"Atalaia do Norte","state_id":3},
{"id":8350,"description":"Atalanta","state_id":24},
{"id":2717,"description":"Ataléia","state_id":11},
{"id":11714,"description":"Atapus","state_id":16},
{"id":8351,"description":"Aterrado Torto (Pouso Redondo)","state_id":24},
{"id":7433,"description":"Atiaçu (Sarandi)","state_id":23},
{"id":8928,"description":"Atibaia","state_id":26},
{"id":12495,"description":"Atlântico","state_id":23},
{"id":8929,"description":"Atlântida (Flórida Paulista)","state_id":26},
{"id":4551,"description":"Aturiaí (Augusto Corrêa)","state_id":14},
{"id":1821,"description":"Atílio Vivácqua","state_id":8},
{"id":9810,"description":"Augustinópolis","state_id":27},
{"id":4552,"description":"Augusto Corrêa","state_id":14},
{"id":199,"description":"Augusto Montenegro (Urucurituba)","state_id":3},
{"id":7434,"description":"Augusto Pestana","state_id":23},
{"id":2718,"description":"Augusto de Lima","state_id":11},
{"id":379,"description":"Aurelino Leal","state_id":5},
{"id":8930,"description":"Auriflama","state_id":26},
{"id":2080,"description":"Aurilândia","state_id":9},
{"id":2081,"description":"Auriverde (Crixás)","state_id":9},
{"id":2388,"description":"Aurizona (Godofredo Viana)","state_id":10},
{"id":8352,"description":"Aurora","state_id":24},
{"id":1183,"description":"Aurora","state_id":6},
{"id":5800,"description":"Aurora do Iguaçu (São Miguel do Iguaçu)","state_id":18},
{"id":4553,"description":"Aurora do Pará","state_id":14},
{"id":9811,"description":"Aurora do Tocantins","state_id":27},
{"id":200,"description":"Autazes","state_id":3},
{"id":8932,"description":"Avanhandava","state_id":26},
{"id":8933,"description":"Avaré","state_id":26},
{"id":8931,"description":"Avaí","state_id":26},
{"id":2719,"description":"Avaí do Jacinto (Jacinto)","state_id":11},
{"id":4554,"description":"Aveiro","state_id":14},
{"id":6853,"description":"Avelar (Paty do Alferes)","state_id":19},
{"id":5523,"description":"Avelino Lopes","state_id":17},
{"id":7436,"description":"Avelino Paranhos (Espumoso)","state_id":23},
{"id":2082,"description":"Avelinópolis","state_id":9},
{"id":8934,"description":"Avencas (Marília)","state_id":26},
{"id":201,"description":"Axinim (Borba)","state_id":3},
{"id":2389,"description":"Axixá","state_id":10},
{"id":9812,"description":"Axixá do Tocantins","state_id":27},
{"id":8353,"description":"Azambuja (Pedras Grandes)","state_id":24},
{"id":7437,"description":"Azevedo Sodré (São Gabriel)","state_id":23},
{"id":2720,"description":"Azurita (Mateus Leme)","state_id":11},
{"id":2369,"description":"Açailândia","state_id":10},
{"id":12560,"description":"Açoita Cavalo","state_id":23},
{"id":7125,"description":"Açu","state_id":20},
{"id":332,"description":"Açu da Torre (Mata de São João)","state_id":5},
{"id":2627,"description":"Açucena","state_id":11},
{"id":12216,"description":"Açude Dos Pinheiros","state_id":6},
{"id":333,"description":"Açudina (Santa Maria da Vitória)","state_id":5},
{"id":12680,"description":"Açudinho Dos Costas","state_id":6},
{"id":5733,"description":"Açungui (Rio Branco do Sul)","state_id":18},
{"id":9813,"description":"Babaçulândia","state_id":27},
{"id":2721,"description":"Babilônia (Delfinópolis)","state_id":11},
{"id":2390,"description":"Bacabal","state_id":10},
{"id":2391,"description":"Bacabeira","state_id":10},
{"id":8935,"description":"Bacaetava (Iperó)","state_id":26},
{"id":2392,"description":"Bacatuba (Buriti Bravo)","state_id":10},
{"id":6854,"description":"Bacaxá (Saquarema)","state_id":19},
{"id":2083,"description":"Bacilândia (Fazenda Nova)","state_id":9},
{"id":7438,"description":"Bacupari (Palmares do Sul)","state_id":23},
{"id":2393,"description":"Bacuri","state_id":10},
{"id":8936,"description":"Bacuriti (Cafelândia)","state_id":26},
{"id":2394,"description":"Bacurituba","state_id":10},
{"id":202,"description":"Badajós (Codajás)","state_id":3},
{"id":8937,"description":"Bady Bassitt","state_id":26},
{"id":2723,"description":"Baependi","state_id":11},
{"id":4555,"description":"Bagre","state_id":14},
{"id":2724,"description":"Baguari (Governador Valadares)","state_id":11},
{"id":8938,"description":"Baguaçu (Olímpia)","state_id":26},
{"id":7439,"description":"Bagé","state_id":23},
{"id":8354,"description":"Baia Alta (Ponte Serrada)","state_id":24},
{"id":380,"description":"Baianópolis","state_id":5},
{"id":4121,"description":"Baianópolis (Corguinho)","state_id":12},
{"id":285,"description":"Bailique (Macapá)","state_id":4},
{"id":8939,"description":"Bairro Alto (Natividade da Serra)","state_id":26},
{"id":5801,"description":"Bairro Cachoeira (Guarapuava)","state_id":18},
{"id":5803,"description":"Bairro Limoeiro (Londrina)","state_id":18},
{"id":5802,"description":"Bairro do Felisberto (Telêmaco Borba)","state_id":18},
{"id":2726,"description":"Baixa (Uberaba)","state_id":11},
{"id":382,"description":"Baixa Grande","state_id":5},
{"id":11779,"description":"Baixa Grande","state_id":2},
{"id":1184,"description":"Baixa Grande (Itapagé)","state_id":6},
{"id":5524,"description":"Baixa Grande do Ribeiro","state_id":17},
{"id":11608,"description":"Baixa Quente","state_id":11},
{"id":32,"description":"Baixa da Onça (Arapiraca)","state_id":2},
{"id":33,"description":"Baixa do Capim (Arapiraca)","state_id":2},
{"id":381,"description":"Baixa do Palmeira (Sapeaçu)","state_id":5},
{"id":384,"description":"Baixinha (Ubaíra)","state_id":5},
{"id":1185,"description":"Baixio","state_id":6},
{"id":12751,"description":"Baixio","state_id":6},
{"id":11523,"description":"Baixio Das Palmeiras","state_id":6},
{"id":1186,"description":"Baixio da Donana (Jucás)","state_id":6},
{"id":1823,"description":"Baixo Guandu","state_id":8},
{"id":383,"description":"Baixão (Jequié)","state_id":5},
{"id":4556,"description":"Baião","state_id":14},
{"id":2725,"description":"Baiões (Formiga)","state_id":11},
{"id":4869,"description":"Balanços (Cachoeira dos Índios)","state_id":15},
{"id":203,"description":"Balbina (Presidente Figueiredo)","state_id":3},
{"id":8940,"description":"Balbinos","state_id":26},
{"id":2727,"description":"Balbinópolis (Bertópolis)","state_id":11},
{"id":2728,"description":"Baldim","state_id":11},
{"id":2084,"description":"Baliza","state_id":9},
{"id":7440,"description":"Baliza (Gaurama)","state_id":23},
{"id":8355,"description":"Balneário Arroio do Silva","state_id":24},
{"id":8356,"description":"Balneário Barra do Sul","state_id":24},
{"id":8357,"description":"Balneário Camboriú","state_id":24},
{"id":8358,"description":"Balneário Gaivota","state_id":24},
{"id":8359,"description":"Balneário Morro dos Conventos (Araranguá)","state_id":24},
{"id":7441,"description":"Balneário Pinhal","state_id":23},
{"id":12786,"description":"Balneário Rincão","state_id":24},
{"id":5804,"description":"Balsa Nova","state_id":18},
{"id":2395,"description":"Balsas","state_id":10},
{"id":6855,"description":"Baltazar (Santo Antônio de Pádua)","state_id":19},
{"id":385,"description":"Baluarte (Pilão Arcado)","state_id":5},
{"id":2729,"description":"Bambuí","state_id":11},
{"id":1187,"description":"Banabuiú","state_id":6},
{"id":8942,"description":"Bananal","state_id":26},
{"id":10731,"description":"Bananas","state_id":18},
{"id":4870,"description":"Bananeiras","state_id":15},
{"id":35,"description":"Bananeiras (Arapiraca)","state_id":2},
{"id":386,"description":"Banco Central (Ilhéus)","state_id":5},
{"id":387,"description":"Banco da Vitória (Ilhéus)","state_id":5},
{"id":2730,"description":"Bandeira","state_id":11},
{"id":1188,"description":"Bandeira (Itatira)","state_id":6},
{"id":388,"description":"Bandeira do Almada (Itajuípe)","state_id":5},
{"id":389,"description":"Bandeira do Colônia (Itapetinga)","state_id":5},
{"id":2731,"description":"Bandeira do Sul","state_id":11},
{"id":8360,"description":"Bandeirante","state_id":24},
{"id":4123,"description":"Bandeirantes","state_id":12},
{"id":5805,"description":"Bandeirantes","state_id":18},
{"id":2732,"description":"Bandeirantes (Mariana)","state_id":11},
{"id":2085,"description":"Bandeirantes (Nova Crixás)","state_id":9},
{"id":8943,"description":"Bandeirantes D'Oeste (Sud Mennucci)","state_id":26},
{"id":5806,"description":"Bandeirantes d'Oeste (4º Centenário)","state_id":18},
{"id":9814,"description":"Bandeirantes do Tocantins","state_id":27},
{"id":12490,"description":"Bandeirinha","state_id":23},
{"id":390,"description":"Bandiaçu (Conceição do Coité)","state_id":5},
{"id":5807,"description":"Banhado (Guarapuava)","state_id":18},
{"id":7442,"description":"Banhado do Colégio (Camaquã)","state_id":23},
{"id":4557,"description":"Bannach","state_id":14},
{"id":6856,"description":"Banquete (Bom Jardim)","state_id":19},
{"id":391,"description":"Banzaê","state_id":5},
{"id":12735,"description":"Baracho","state_id":6},
{"id":7138,"description":"Baraúna","state_id":20},
{"id":4871,"description":"Baraúna","state_id":15},
{"id":392,"description":"Baraúnas (Seabra)","state_id":5},
{"id":2735,"description":"Barbacena","state_id":11},
{"id":11536,"description":"Barbada","state_id":6},
{"id":1190,"description":"Barbalha","state_id":6},
{"id":8947,"description":"Barbosa","state_id":26},
{"id":5809,"description":"Barbosa Ferraz","state_id":18},
{"id":2086,"description":"Barbosilândia (Posse)","state_id":9},
{"id":4558,"description":"Barcarena","state_id":14},
{"id":7139,"description":"Barcelona","state_id":20},
{"id":204,"description":"Barcelos","state_id":3},
{"id":6858,"description":"Barcelos (São João da Barra)","state_id":19},
{"id":393,"description":"Barcelos do Sul (Camamu)","state_id":5},
{"id":8948,"description":"Bariri","state_id":26},
{"id":394,"description":"Barra","state_id":5},
{"id":1191,"description":"Barra (Aiuaba)","state_id":6},
{"id":1192,"description":"Barra (Fortim)","state_id":6},
{"id":1193,"description":"Barra (Iguatu)","state_id":6},
{"id":6859,"description":"Barra Alegre (Bom Jardim)","state_id":19},
{"id":2736,"description":"Barra Alegre (Ipatinga)","state_id":11},
{"id":11564,"description":"Barra Avenida","state_id":5},
{"id":8361,"description":"Barra Bonita","state_id":24},
{"id":8949,"description":"Barra Bonita","state_id":26},
{"id":5810,"description":"Barra Bonita (Francisco Beltrão)","state_id":18},
{"id":5811,"description":"Barra Bonita (Mato Rico)","state_id":18},
{"id":8362,"description":"Barra Clara (Angelina)","state_id":24},
{"id":12643,"description":"Barra Curta Baixa","state_id":23},
{"id":5525,"description":"Barra D'Alcântara","state_id":17},
{"id":12682,"description":"Barra Do Ingá","state_id":6},
{"id":10711,"description":"Barra Do Sahy","state_id":8},
{"id":8952,"description":"Barra Dourada (Neves Paulista)","state_id":26},
{"id":2740,"description":"Barra Feliz (Santa Bárbara)","state_id":11},
{"id":8365,"description":"Barra Fria (Erval Velho)","state_id":24},
{"id":7451,"description":"Barra Funda","state_id":23},
{"id":12750,"description":"Barra Grande","state_id":5},
{"id":8366,"description":"Barra Grande (Faxinal dos Guedes)","state_id":24},
{"id":5813,"description":"Barra Grande (Itapejara d'Oeste)","state_id":18},
{"id":39,"description":"Barra Grande (Maragogi)","state_id":2},
{"id":5815,"description":"Barra Grande (Planalto)","state_id":18},
{"id":5816,"description":"Barra Grande (Ponta Grossa)","state_id":18},
{"id":2741,"description":"Barra Longa","state_id":11},
{"id":6863,"description":"Barra Mansa","state_id":19},
{"id":1827,"description":"Barra Nova (São Mateus)","state_id":8},
{"id":1195,"description":"Barra Nova (Tauá)","state_id":6},
{"id":5818,"description":"Barra Santa Salete (Manoel Ribas)","state_id":18},
{"id":1828,"description":"Barra Seca (Jaguaré)","state_id":8},
{"id":6864,"description":"Barra Seca (São Francisco de Itabapoana)","state_id":19},
{"id":8367,"description":"Barra Velha","state_id":24},
{"id":395,"description":"Barra da Estiva","state_id":5},
{"id":2737,"description":"Barra da Figueira (Pocrane)","state_id":11},
{"id":8363,"description":"Barra da Lagoa (Florianópolis)","state_id":24},
{"id":8364,"description":"Barra da Prata (Vítor Meireles)","state_id":24},
{"id":5157,"description":"Barra de Farias (Brejo da Madre de Deus)","state_id":16},
{"id":5158,"description":"Barra de Guabiraba","state_id":16},
{"id":6860,"description":"Barra de Macaé (Macaé)","state_id":19},
{"id":1824,"description":"Barra de Novo Brasil (Governador Lindenberg)","state_id":8},
{"id":4872,"description":"Barra de Santa Rosa","state_id":15},
{"id":4873,"description":"Barra de Santana","state_id":15},
{"id":36,"description":"Barra de Santo Antônio","state_id":2},
{"id":1825,"description":"Barra de São Francisco","state_id":8},
{"id":6861,"description":"Barra de São João (Casimiro de Abreu)","state_id":19},
{"id":37,"description":"Barra de São Miguel","state_id":2},
{"id":4874,"description":"Barra de São Miguel","state_id":15},
{"id":5159,"description":"Barra de São Pedro (Ouricuri)","state_id":16},
{"id":2738,"description":"Barra do Ariranha (Mantena)","state_id":11},
{"id":38,"description":"Barra do Bonifácio (Palmeira dos Índios)","state_id":2},
{"id":5160,"description":"Barra do Brejo (Bom Conselho)","state_id":16},
{"id":4299,"description":"Barra do Bugres","state_id":13},
{"id":4875,"description":"Barra do Camaratuba (Mataraca)","state_id":15},
{"id":8950,"description":"Barra do Chapéu","state_id":26},
{"id":5161,"description":"Barra do Chata (Agrestina)","state_id":16},
{"id":396,"description":"Barra do Choça","state_id":5},
{"id":2398,"description":"Barra do Corda","state_id":10},
{"id":2739,"description":"Barra do Cuieté (Conselheiro Pena)","state_id":11},
{"id":4300,"description":"Barra do Garças","state_id":13},
{"id":9815,"description":"Barra do Grota (Araguaína)","state_id":27},
{"id":7446,"description":"Barra do Guarita","state_id":23},
{"id":1826,"description":"Barra do Itapemirim (Marataízes)","state_id":8},
{"id":5812,"description":"Barra do Jacaré","state_id":18},
{"id":397,"description":"Barra do Jacuípe (Camaçari)","state_id":5},
{"id":5162,"description":"Barra do Jardim (Agrestina)","state_id":16},
{"id":398,"description":"Barra do Mendes","state_id":5},
{"id":9816,"description":"Barra do Ouro","state_id":27},
{"id":7447,"description":"Barra do Ouro (Maquiné)","state_id":23},
{"id":6862,"description":"Barra do Piraí","state_id":19},
{"id":399,"description":"Barra do Pojuca (Camaçari)","state_id":5},
{"id":7448,"description":"Barra do Quaraí","state_id":23},
{"id":5163,"description":"Barra do Riachão (São Joaquim do Monte)","state_id":16},
{"id":7449,"description":"Barra do Ribeiro","state_id":23},
{"id":7450,"description":"Barra do Rio Azul","state_id":23},
{"id":400,"description":"Barra do Rocha","state_id":5},
{"id":5164,"description":"Barra do Sirinhaém (Sirinhaém)","state_id":16},
{"id":1194,"description":"Barra do Sotero (Croatá)","state_id":6},
{"id":401,"description":"Barra do Tarrachil (Chorrochó)","state_id":5},
{"id":8951,"description":"Barra do Turvo","state_id":26},
{"id":8774,"description":"Barra dos Coqueiros","state_id":25},
{"id":8775,"description":"Barracas (Capela)","state_id":25},
{"id":402,"description":"Barracas (Ponto Novo)","state_id":5},
{"id":7452,"description":"Barracão","state_id":23},
{"id":5819,"description":"Barracão","state_id":18},
{"id":12533,"description":"Barragem Do Itu","state_id":23},
{"id":2742,"description":"Barranco Alto (Alfenas)","state_id":11},
{"id":5526,"description":"Barras","state_id":17},
{"id":5820,"description":"Barras (Campo Mourão)","state_id":18},
{"id":1196,"description":"Barreira","state_id":6},
{"id":4559,"description":"Barreira Branca (Santa Maria das Barreiras)","state_id":14},
{"id":4560,"description":"Barreira dos Campos (Santana do Araguaia)","state_id":14},
{"id":1197,"description":"Barreira dos Vianas (Aracati)","state_id":6},
{"id":403,"description":"Barreiras","state_id":5},
{"id":11697,"description":"Barreiras","state_id":2},
{"id":1198,"description":"Barreiras (Iguatu)","state_id":6},
{"id":4561,"description":"Barreiras (Itaituba)","state_id":14},
{"id":5527,"description":"Barreiras do Piauí","state_id":17},
{"id":205,"description":"Barreirinha","state_id":3},
{"id":2399,"description":"Barreirinhas","state_id":10},
{"id":7453,"description":"Barreirinho (Sarandi)","state_id":23},
{"id":2743,"description":"Barreiro (Belo Horizonte)","state_id":11},
{"id":5821,"description":"Barreiro (Cascavel)","state_id":18},
{"id":5822,"description":"Barreiro (Guarapuava)","state_id":18},
{"id":7454,"description":"Barreiro (Ijuí)","state_id":23},
{"id":5823,"description":"Barreiro (Ortigueira)","state_id":18},
{"id":2744,"description":"Barreiro Branco (Catuti)","state_id":11},
{"id":2745,"description":"Barreiro da Raiz (Janaúba)","state_id":11},
{"id":5824,"description":"Barreiro das Frutas (Campo Mourão)","state_id":18},
{"id":2746,"description":"Barreiro do Rio Verde (Janaúba)","state_id":11},
{"id":5165,"description":"Barreiros","state_id":16},
{"id":11386,"description":"Barreiros","state_id":5},
{"id":5825,"description":"Barreiros (Apucarana)","state_id":18},
{"id":1199,"description":"Barreiros (Monsenhor Tabosa)","state_id":6},
{"id":1200,"description":"Barreiros (Potengi)","state_id":6},
{"id":1201,"description":"Barreiros (São Benedito)","state_id":6},
{"id":8368,"description":"Barreiros (São José)","state_id":24},
{"id":1202,"description":"Barrento (Itapipoca)","state_id":6},
{"id":8954,"description":"Barretos","state_id":26},
{"id":2747,"description":"Barretos de Alvinópolis (Alvinópolis)","state_id":11},
{"id":8955,"description":"Barrinha","state_id":26},
{"id":12548,"description":"Barrinha","state_id":23},
{"id":12603,"description":"Barrinha","state_id":23},
{"id":5826,"description":"Barrinha (Castro)","state_id":18},
{"id":1203,"description":"Barro","state_id":6},
{"id":2087,"description":"Barro Alto","state_id":9},
{"id":404,"description":"Barro Alto","state_id":5},
{"id":1204,"description":"Barro Alto (Iguatu)","state_id":6},
{"id":8369,"description":"Barro Branco (Lauro Müller)","state_id":24},
{"id":5528,"description":"Barro Duro","state_id":17},
{"id":2400,"description":"Barro Duro (Tutóia)","state_id":10},
{"id":7455,"description":"Barro Preto (Ajuricaba)","state_id":23},
{"id":5827,"description":"Barro Preto (Cascavel)","state_id":18},
{"id":5828,"description":"Barro Preto (Londrina)","state_id":18},
{"id":5829,"description":"Barro Preto (São José dos Pinhais)","state_id":18},
{"id":11635,"description":"Barro Vermelho","state_id":2},
{"id":7456,"description":"Barro Vermelho (Cachoeira do Sul)","state_id":23},
{"id":406,"description":"Barro Vermelho (Curaçá)","state_id":5},
{"id":7457,"description":"Barro Vermelho (Gravataí)","state_id":23},
{"id":407,"description":"Barrocas","state_id":5},
{"id":12411,"description":"Barrocão","state_id":5},
{"id":2748,"description":"Barrocão (Grão Mogol)","state_id":11},
{"id":9817,"description":"Barrolândia","state_id":27},
{"id":1205,"description":"Barroquinha","state_id":6},
{"id":7458,"description":"Barros Cassal","state_id":23},
{"id":2749,"description":"Barroso","state_id":11},
{"id":8953,"description":"Barrânia (Caconde)","state_id":26},
{"id":8956,"description":"Barueri","state_id":26},
{"id":7443,"description":"Barão","state_id":23},
{"id":8944,"description":"Barão Ataliba Nogueira (Itapira)","state_id":26},
{"id":8945,"description":"Barão de Antonina","state_id":26},
{"id":1189,"description":"Barão de Aquiraz (Campos Sales)","state_id":6},
{"id":2733,"description":"Barão de Cocais","state_id":11},
{"id":7444,"description":"Barão de Cotegipe","state_id":23},
{"id":8946,"description":"Barão de Geraldo (Campinas)","state_id":26},
{"id":2396,"description":"Barão de Grajaú","state_id":10},
{"id":6857,"description":"Barão de Juparana (Valença)","state_id":19},
{"id":5808,"description":"Barão de Lucena (Nova Esperança)","state_id":18},
{"id":4298,"description":"Barão de Melgaço","state_id":13},
{"id":2734,"description":"Barão de Monte Alto","state_id":11},
{"id":7137,"description":"Barão de Serra Branca (Santana do Matos)","state_id":20},
{"id":2397,"description":"Barão de Tromai (Cândido Mendes)","state_id":10},
{"id":7445,"description":"Barão do Triunfo","state_id":23},
{"id":408,"description":"Bastião (Boninal)","state_id":5},
{"id":8957,"description":"Bastos","state_id":26},
{"id":7459,"description":"Basílio (Herval)","state_id":23},
{"id":4124,"description":"Bataguassu","state_id":12},
{"id":4125,"description":"Bataiporã","state_id":12},
{"id":40,"description":"Batalha","state_id":2},
{"id":5529,"description":"Batalha","state_id":17},
{"id":8958,"description":"Batatais","state_id":26},
{"id":10369,"description":"Batatal (Itaocara)","state_id":19},
{"id":5166,"description":"Batateira (Belém de Maria)","state_id":16},
{"id":8959,"description":"Batatuba (Piracaia)","state_id":26},
{"id":100002,"description":"Batayporã","state_id":12},
{"id":409,"description":"Bate Pé (Vitória da Conquista)","state_id":5},
{"id":5830,"description":"Bateias (Campo Largo)","state_id":18},
{"id":8370,"description":"Bateias de Baixo (Campo Alegre)","state_id":24},
{"id":410,"description":"Batinga (Itanhém)","state_id":5},
{"id":41,"description":"Batingas (Arapiraca)","state_id":2},
{"id":8960,"description":"Batista Botelho (Óleo)","state_id":26},
{"id":4301,"description":"Batovi (Tesouro)","state_id":13},
{"id":12481,"description":"Batovira","state_id":23},
{"id":1206,"description":"Baturité","state_id":6},
{"id":4562,"description":"Baturité (Afuá)","state_id":14},
{"id":5831,"description":"Baulândia (Renascença)","state_id":18},
{"id":1829,"description":"Baunilha (Colatina)","state_id":8},
{"id":8961,"description":"Bauru","state_id":26},
{"id":4303,"description":"Bauxi (Rosário Oeste)","state_id":13},
{"id":4876,"description":"Bayeux","state_id":15},
{"id":2722,"description":"Bação (Itabirito)","state_id":11},
{"id":7136,"description":"Baía Formosa","state_id":20},
{"id":1822,"description":"Baía Nova (Guarapari)","state_id":8},
{"id":4868,"description":"Baía da Traição","state_id":15},
{"id":12505,"description":"Baú","state_id":23},
{"id":12712,"description":"Baú","state_id":6},
{"id":2750,"description":"Baú (Estrela do Indaiá)","state_id":11},
{"id":1207,"description":"Baú (Iguatu)","state_id":6},
{"id":4302,"description":"Baús (Acorizal)","state_id":13},
{"id":4126,"description":"Baús (Costa Rica)","state_id":12},
{"id":8962,"description":"Bebedouro","state_id":26},
{"id":1830,"description":"Bebedouro (Linhares)","state_id":8},
{"id":12109,"description":"Bebelândia","state_id":15},
{"id":1208,"description":"Beberibe","state_id":6},
{"id":12737,"description":"Bebida Velha","state_id":20},
{"id":4563,"description":"Beja (Abaetetuba)","state_id":14},
{"id":4304,"description":"Bel Rios (Diamantino)","state_id":13},
{"id":12811,"description":"Bela Alvorada","state_id":12},
{"id":1209,"description":"Bela Cruz","state_id":6},
{"id":411,"description":"Bela Flor (Catu)","state_id":5},
{"id":8963,"description":"Bela Floresta (Pereira Barreto)","state_id":26},
{"id":4127,"description":"Bela Vista","state_id":12},
{"id":11525,"description":"Bela Vista","state_id":6},
{"id":12423,"description":"Bela Vista","state_id":23},
{"id":8371,"description":"Bela Vista (Campos Novos)","state_id":24},
{"id":5832,"description":"Bela Vista (Guaraniaçu)","state_id":18},
{"id":1210,"description":"Bela Vista (Itapipoca)","state_id":6},
{"id":7460,"description":"Bela Vista (Machadinho)","state_id":23},
{"id":5833,"description":"Bela Vista (Manoel Ribas)","state_id":18},
{"id":7461,"description":"Bela Vista (Passo Fundo)","state_id":23},
{"id":7462,"description":"Bela Vista (Segredo)","state_id":23},
{"id":7463,"description":"Bela Vista (Três Passos)","state_id":23},
{"id":12479,"description":"Bela Vista Do Fão","state_id":23},
{"id":8964,"description":"Bela Vista São-Carlense (São Carlos)","state_id":26},
{"id":5834,"description":"Bela Vista da Caroba","state_id":18},
{"id":2088,"description":"Bela Vista de Goiás","state_id":9},
{"id":2751,"description":"Bela Vista de Minas","state_id":11},
{"id":4564,"description":"Bela Vista do Caracol (Itaituba)","state_id":14},
{"id":5835,"description":"Bela Vista do Ivaí (Fênix)","state_id":18},
{"id":2401,"description":"Bela Vista do Maranhão","state_id":10},
{"id":5836,"description":"Bela Vista do Paraíso","state_id":18},
{"id":5530,"description":"Bela Vista do Piauí","state_id":17},
{"id":5837,"description":"Bela Vista do Piquiri (Campina da Lagoa)","state_id":18},
{"id":8372,"description":"Bela Vista do Sul (Mafra)","state_id":24},
{"id":5838,"description":"Bela Vista do Tapiracui (Tapejara)","state_id":18},
{"id":8373,"description":"Bela Vista do Toldo","state_id":24},
{"id":2402,"description":"Belagua","state_id":10},
{"id":6865,"description":"Belford Roxo","state_id":19},
{"id":2752,"description":"Belisário (Muriaé)","state_id":11},
{"id":2753,"description":"Belmiro Braga","state_id":11},
{"id":413,"description":"Belmonte","state_id":5},
{"id":8374,"description":"Belmonte","state_id":24},
{"id":11524,"description":"Belmonte","state_id":6},
{"id":414,"description":"Belo Campo","state_id":5},
{"id":415,"description":"Belo Campo (América Dourada)","state_id":5},
{"id":2754,"description":"Belo Horizonte","state_id":11},
{"id":7140,"description":"Belo Horizonte (Bento Fernandes)","state_id":20},
{"id":5169,"description":"Belo Jardim","state_id":16},
{"id":43,"description":"Belo Monte","state_id":2},
{"id":11142,"description":"Belo Monte","state_id":14},
{"id":2755,"description":"Belo Oriente","state_id":11},
{"id":2756,"description":"Belo Oriente (Teófilo Otoni)","state_id":11},
{"id":2757,"description":"Belo Vale","state_id":11},
{"id":4566,"description":"Belterra","state_id":14},
{"id":12771,"description":"Beltrão","state_id":11},
{"id":7464,"description":"Beluno (São Francisco de Assis)","state_id":23},
{"id":42,"description":"Belém","state_id":2},
{"id":4565,"description":"Belém","state_id":14},
{"id":4877,"description":"Belém","state_id":15},
{"id":12221,"description":"Belém","state_id":6},
{"id":11775,"description":"Belém De Solimões","state_id":3},
{"id":412,"description":"Belém da Cachoeira (Cachoeira)","state_id":5},
{"id":5167,"description":"Belém de Maria","state_id":16},
{"id":5168,"description":"Belém de São Francisco","state_id":16},
{"id":4878,"description":"Belém do Brejo do Cruz","state_id":15},
{"id":5531,"description":"Belém do Piauí","state_id":17},
{"id":416,"description":"Bem-Bom (Casa Nova)","state_id":5},
{"id":6866,"description":"Bemposta (Três Rios)","state_id":19},
{"id":417,"description":"Bendegó (Canudos)","state_id":5},
{"id":5532,"description":"Beneditinos","state_id":17},
{"id":2403,"description":"Benedito Leite","state_id":10},
{"id":8375,"description":"Benedito Novo","state_id":24},
{"id":4567,"description":"Benevides","state_id":14},
{"id":4568,"description":"Benfica (Benevides)","state_id":14},
{"id":5170,"description":"Bengalas (Passira)","state_id":16},
{"id":206,"description":"Benjamin Constant","state_id":3},
{"id":7465,"description":"Benjamin Constant do Sul","state_id":23},
{"id":5171,"description":"Bentivi (Bonito)","state_id":16},
{"id":7141,"description":"Bento Fernandes","state_id":20},
{"id":7466,"description":"Bento Gonçalves","state_id":23},
{"id":418,"description":"Bento Simões (Irará)","state_id":5},
{"id":8965,"description":"Bento de Abreu","state_id":26},
{"id":5839,"description":"Bentópolis (Guaraci)","state_id":18},
{"id":2758,"description":"Bentópolis de Minas (Ubaí)","state_id":11},
{"id":2404,"description":"Bequimão","state_id":10},
{"id":2759,"description":"Berilo","state_id":11},
{"id":2760,"description":"Berizal","state_id":11},
{"id":5840,"description":"Bernardelli (Rondon)","state_id":18},
{"id":4879,"description":"Bernardino Batista","state_id":15},
{"id":8966,"description":"Bernardino de Campos","state_id":26},
{"id":9818,"description":"Bernardo Sayão","state_id":27},
{"id":5172,"description":"Bernardo Vieira (Serra Talhada)","state_id":16},
{"id":2405,"description":"Bernardo do Mearim","state_id":10},
{"id":8967,"description":"Bertioga","state_id":26},
{"id":5533,"description":"Bertolínia","state_id":17},
{"id":2761,"description":"Bertópolis","state_id":11},
{"id":207,"description":"Beruri","state_id":3},
{"id":5841,"description":"Betaras (Almirante Tamandaré)","state_id":18},
{"id":2762,"description":"Betim","state_id":11},
{"id":5173,"description":"Betânia","state_id":16},
{"id":12149,"description":"Betânia","state_id":6},
{"id":1211,"description":"Betânia (Croatá)","state_id":6},
{"id":1212,"description":"Betânia (Hidrolândia)","state_id":6},
{"id":1213,"description":"Betânia (Solonópole)","state_id":6},
{"id":5534,"description":"Betânia do Piauí","state_id":17},
{"id":7467,"description":"Bexiga (Rio Pardo)","state_id":23},
{"id":10207,"description":"Bezerra (Formosa)","state_id":9},
{"id":4305,"description":"Bezerro Branco (Cáceres)","state_id":13},
{"id":5174,"description":"Bezerros","state_id":16},
{"id":2763,"description":"Bias Fortes","state_id":11},
{"id":2764,"description":"Bicas","state_id":11},
{"id":2765,"description":"Bicuíba (Raul Soares)","state_id":11},
{"id":8376,"description":"Biguaçu","state_id":24},
{"id":8968,"description":"Bilac","state_id":26},
{"id":2766,"description":"Biquinhas","state_id":11},
{"id":8969,"description":"Birigui","state_id":26},
{"id":8970,"description":"Biritiba-Mirim","state_id":26},
{"id":8971,"description":"Biritiba-Ussu (Mogi das Cruzes)","state_id":26},
{"id":419,"description":"Biritinga","state_id":5},
{"id":10390,"description":"Biscaia (Ponta Grossa)","state_id":18},
{"id":1214,"description":"Bitupitá (Barroquinha)","state_id":6},
{"id":2767,"description":"Bituri (Jeceaba)","state_id":11},
{"id":5842,"description":"Bituruna","state_id":18},
{"id":1215,"description":"Bixopa (Limoeiro do Norte)","state_id":6},
{"id":5175,"description":"Bizarra (Bom Jardim)","state_id":16},
{"id":8377,"description":"Blumenau","state_id":24},
{"id":420,"description":"Boa Espera (Santanópolis)","state_id":5},
{"id":2768,"description":"Boa Esperança","state_id":11},
{"id":1831,"description":"Boa Esperança","state_id":8},
{"id":5843,"description":"Boa Esperança","state_id":18},
{"id":11678,"description":"Boa Esperança","state_id":11},
{"id":5844,"description":"Boa Esperança (Campo Mourão)","state_id":18},
{"id":4569,"description":"Boa Esperança (Maracanã)","state_id":14},
{"id":6867,"description":"Boa Esperança (Rio Bonito)","state_id":19},
{"id":7468,"description":"Boa Esperança (Rolante)","state_id":23},
{"id":4570,"description":"Boa Esperança (Santarém)","state_id":14},
{"id":4306,"description":"Boa Esperança (Sorriso)","state_id":13},
{"id":1217,"description":"Boa Esperança (Tamboril)","state_id":6},
{"id":5845,"description":"Boa Esperança do Iguaçu","state_id":18},
{"id":8972,"description":"Boa Esperança do Sul","state_id":26},
{"id":2769,"description":"Boa Família (Muriaé)","state_id":11},
{"id":4571,"description":"Boa Fé (Santarém)","state_id":14},
{"id":5535,"description":"Boa Hora","state_id":17},
{"id":421,"description":"Boa Nova","state_id":5},
{"id":7142,"description":"Boa Saúde","state_id":20},
{"id":6868,"description":"Boa Sorte (Cantagalo)","state_id":19},
{"id":44,"description":"Boa Sorte (Palmeira dos Índios)","state_id":2},
{"id":4572,"description":"Boa Sorte (Redenção)","state_id":14},
{"id":422,"description":"Boa União (Alagoinhas)","state_id":5},
{"id":4307,"description":"Boa União (Rio Branco)","state_id":13},
{"id":2770,"description":"Boa União de Itabirinha (Itabirinha)","state_id":11},
{"id":4880,"description":"Boa Ventura","state_id":15},
{"id":6869,"description":"Boa Ventura (Itaperuna)","state_id":19},
{"id":5846,"description":"Boa Ventura de São Roque","state_id":18},
{"id":1218,"description":"Boa Viagem","state_id":6},
{"id":7375,"description":"Boa Vista","state_id":22},
{"id":12212,"description":"Boa Vista","state_id":6},
{"id":12532,"description":"Boa Vista","state_id":23},
{"id":4881,"description":"Boa Vista","state_id":15},
{"id":45,"description":"Boa Vista (Arapiraca)","state_id":2},
{"id":5847,"description":"Boa Vista (Campo Largo)","state_id":18},
{"id":1219,"description":"Boa Vista (Mombaça)","state_id":6},
{"id":5851,"description":"Boa Vista (Nova Tebas)","state_id":18},
{"id":46,"description":"Boa Vista (Palmeira dos Índios)","state_id":2},
{"id":1220,"description":"Boa Vista (Paraipaba)","state_id":6},
{"id":5848,"description":"Boa Vista (Pato Branco)","state_id":18},
{"id":5849,"description":"Boa Vista (Ponta Grossa)","state_id":18},
{"id":4308,"description":"Boa Vista (Rondonópolis)","state_id":13},
{"id":7469,"description":"Boa Vista (Salvador do Sul)","state_id":23},
{"id":7470,"description":"Boa Vista (Santa Cruz do Sul)","state_id":23},
{"id":7471,"description":"Boa Vista (São Lourenço do Sul)","state_id":23},
{"id":5850,"description":"Boa Vista (Toledo)","state_id":18},
{"id":12074,"description":"Boa Vista De Pacarana","state_id":21},
{"id":8974,"description":"Boa Vista Paulista (Suzano)","state_id":26},
{"id":5852,"description":"Boa Vista da Aparecida","state_id":18},
{"id":7472,"description":"Boa Vista das Missões","state_id":23},
{"id":2771,"description":"Boa Vista de Minas (Nova Serrana)","state_id":11},
{"id":7473,"description":"Boa Vista do Buricá","state_id":23},
{"id":7474,"description":"Boa Vista do Cadeado","state_id":23},
{"id":1221,"description":"Boa Vista do Caxitoré (Irauçuba)","state_id":6},
{"id":2406,"description":"Boa Vista do Gurupi","state_id":10},
{"id":7475,"description":"Boa Vista do Incra","state_id":23},
{"id":4573,"description":"Boa Vista do Iririteua (Curuçá)","state_id":14},
{"id":423,"description":"Boa Vista do Lagamar (Ibotirama)","state_id":5},
{"id":2407,"description":"Boa Vista do Pindaré (Cajari)","state_id":10},
{"id":208,"description":"Boa Vista do Ramos","state_id":3},
{"id":7476,"description":"Boa Vista do Sul","state_id":23},
{"id":424,"description":"Boa Vista do Tupim","state_id":5},
{"id":8973,"description":"Boa Vista dos Andradas (Álvares Florence)","state_id":26},
{"id":1216,"description":"Boa Água (Morada Nova)","state_id":6},
{"id":1832,"description":"Boapaba (Colatina)","state_id":8},
{"id":5176,"description":"Boas Novas (Bezerros)","state_id":16},
{"id":425,"description":"Boaçu (Jequié)","state_id":5},
{"id":47,"description":"Boca da Mata","state_id":2},
{"id":209,"description":"Boca do Acre","state_id":3},
{"id":426,"description":"Boca do Córrego (Belmonte)","state_id":5},
{"id":286,"description":"Boca do Jari (Laranjal do Jari)","state_id":4},
{"id":7477,"description":"Boca do Monte (Santa Maria)","state_id":23},
{"id":8975,"description":"Bocaina","state_id":26},
{"id":5536,"description":"Bocaina","state_id":17},
{"id":5853,"description":"Bocaina (Ponta Grossa)","state_id":18},
{"id":2772,"description":"Bocaina de Minas","state_id":11},
{"id":12066,"description":"Bocaiuval","state_id":13},
{"id":2773,"description":"Bocaiúva","state_id":11},
{"id":5854,"description":"Bocaiúva do Sul","state_id":18},
{"id":4128,"description":"Bocajá (Douradina)","state_id":12},
{"id":4129,"description":"Bocajá (Laguna Carapã)","state_id":12},
{"id":8378,"description":"Bocaína do Sul","state_id":24},
{"id":5177,"description":"Bodocó","state_id":16},
{"id":4130,"description":"Bodoquena","state_id":12},
{"id":7143,"description":"Bodó","state_id":20},
{"id":8976,"description":"Bofete","state_id":26},
{"id":7478,"description":"Boi Preto (Chapada)","state_id":23},
{"id":4574,"description":"Boim (Santarém)","state_id":14},
{"id":8379,"description":"Boiteuxburgo (Major Gercino)","state_id":24},
{"id":8977,"description":"Boituva","state_id":26},
{"id":7479,"description":"Bojuru (São José do Norte)","state_id":23},
{"id":5178,"description":"Bom Conselho","state_id":16},
{"id":2774,"description":"Bom Despacho","state_id":11},
{"id":4131,"description":"Bom Fim (Jaraguari)","state_id":12},
{"id":8978,"description":"Bom Fim do Bom Jesus (Cabreúva)","state_id":26},
{"id":11980,"description":"Bom Futuro","state_id":21},
{"id":6870,"description":"Bom Jardim","state_id":19},
{"id":5179,"description":"Bom Jardim","state_id":16},
{"id":2408,"description":"Bom Jardim","state_id":10},
{"id":12561,"description":"Bom Jardim","state_id":23},
{"id":48,"description":"Bom Jardim (Arapiraca)","state_id":2},
{"id":7480,"description":"Bom Jardim (Caçapava do Sul)","state_id":23},
{"id":4575,"description":"Bom Jardim (Maracanã)","state_id":14},
{"id":8380,"description":"Bom Jardim da Serra","state_id":24},
{"id":2089,"description":"Bom Jardim de Goiás","state_id":9},
{"id":2775,"description":"Bom Jardim de Minas","state_id":11},
{"id":5855,"description":"Bom Jardim do Sul (Ivaí)","state_id":18},
{"id":8381,"description":"Bom Jesus","state_id":24},
{"id":7144,"description":"Bom Jesus","state_id":20},
{"id":7481,"description":"Bom Jesus","state_id":23},
{"id":5537,"description":"Bom Jesus","state_id":17},
{"id":4882,"description":"Bom Jesus","state_id":15},
{"id":11982,"description":"Bom Jesus","state_id":21},
{"id":12787,"description":"Bom Jesus De Angicos","state_id":11},
{"id":11875,"description":"Bom Jesus Do Prata","state_id":11},
{"id":2776,"description":"Bom Jesus da Cachoeira (Muriaé)","state_id":11},
{"id":427,"description":"Bom Jesus da Lapa","state_id":5},
{"id":2777,"description":"Bom Jesus da Penha","state_id":11},
{"id":428,"description":"Bom Jesus da Serra","state_id":5},
{"id":2409,"description":"Bom Jesus das Selvas","state_id":10},
{"id":2778,"description":"Bom Jesus de Cardosos (Urucânia)","state_id":11},
{"id":2090,"description":"Bom Jesus de Goiás","state_id":9},
{"id":2779,"description":"Bom Jesus do Amparo","state_id":11},
{"id":10099,"description":"Bom Jesus do Araguaia","state_id":13},
{"id":2780,"description":"Bom Jesus do Divino (Divino)","state_id":11},
{"id":2781,"description":"Bom Jesus do Galho","state_id":11},
{"id":6871,"description":"Bom Jesus do Itabapoana","state_id":19},
{"id":2782,"description":"Bom Jesus do Madeira (Fervedouro)","state_id":11},
{"id":1833,"description":"Bom Jesus do Norte","state_id":8},
{"id":8382,"description":"Bom Jesus do Oeste","state_id":24},
{"id":6872,"description":"Bom Jesus do Querendo (Natividade)","state_id":19},
{"id":5856,"description":"Bom Jesus do Sul","state_id":18},
{"id":4576,"description":"Bom Jesus do Tocantins","state_id":14},
{"id":9819,"description":"Bom Jesus do Tocantins","state_id":27},
{"id":8979,"description":"Bom Jesus dos Perdões","state_id":26},
{"id":2410,"description":"Bom Lugar","state_id":10},
{"id":5180,"description":"Bom Nome (São José do Belmonte)","state_id":16},
{"id":2783,"description":"Bom Pastor (Resplendor)","state_id":11},
{"id":12780,"description":"Bom Plano","state_id":23},
{"id":7482,"description":"Bom Princípio","state_id":23},
{"id":11366,"description":"Bom Princípio","state_id":6},
{"id":5538,"description":"Bom Princípio do Piauí","state_id":17},
{"id":7483,"description":"Bom Progresso","state_id":23},
{"id":5857,"description":"Bom Progresso (Sabáudia)","state_id":18},
{"id":12102,"description":"Bom Recreio","state_id":23},
{"id":2784,"description":"Bom Repouso","state_id":11},
{"id":8383,"description":"Bom Retiro","state_id":24},
{"id":12425,"description":"Bom Retiro","state_id":23},
{"id":7484,"description":"Bom Retiro (Cambará do Sul)","state_id":23},
{"id":5858,"description":"Bom Retiro (Cascavel)","state_id":18},
{"id":5859,"description":"Bom Retiro (Guarapuava)","state_id":18},
{"id":5860,"description":"Bom Retiro (Pato Branco)","state_id":18},
{"id":5861,"description":"Bom Retiro (Pinhão)","state_id":18},
{"id":2785,"description":"Bom Retiro (Santa Bárbara do Tugúrio)","state_id":11},
{"id":8980,"description":"Bom Retiro da Esperança (Angatuba)","state_id":26},
{"id":7485,"description":"Bom Retiro do Guaíba (Guaíba)","state_id":23},
{"id":7486,"description":"Bom Retiro do Sul","state_id":23},
{"id":12493,"description":"Bom Será","state_id":23},
{"id":429,"description":"Bom Sossego (Oliveira dos Brejinhos)","state_id":5},
{"id":2786,"description":"Bom Sucesso","state_id":11},
{"id":4883,"description":"Bom Sucesso","state_id":15},
{"id":5862,"description":"Bom Sucesso","state_id":18},
{"id":5863,"description":"Bom Sucesso (Guarapuava)","state_id":18},
{"id":4884,"description":"Bom Sucesso (Soledade)","state_id":15},
{"id":8384,"description":"Bom Sucesso (Videira)","state_id":24},
{"id":4309,"description":"Bom Sucesso (Várzea Grande)","state_id":13},
{"id":8981,"description":"Bom Sucesso de Itararé","state_id":26},
{"id":2787,"description":"Bom Sucesso de Patos (Patos de Minas)","state_id":11},
{"id":5864,"description":"Bom Sucesso do Sul","state_id":18},
{"id":8385,"description":"Bombinhas","state_id":24},
{"id":2788,"description":"Bonança (Ibiracatu)","state_id":11},
{"id":7376,"description":"Bonfim","state_id":22},
{"id":2789,"description":"Bonfim","state_id":11},
{"id":1222,"description":"Bonfim (Senador Pompeu)","state_id":6},
{"id":1223,"description":"Bonfim (Sobral)","state_id":6},
{"id":5181,"description":"Bonfim (São José do Egito)","state_id":16},
{"id":8982,"description":"Bonfim Paulista (Ribeirão Preto)","state_id":26},
{"id":430,"description":"Bonfim da Feira (Feira de Santana)","state_id":5},
{"id":2411,"description":"Bonfim do Arari (Arari)","state_id":10},
{"id":5539,"description":"Bonfim do Piauí","state_id":17},
{"id":2091,"description":"Bonfinópolis","state_id":9},
{"id":2790,"description":"Bonfinópolis de Minas","state_id":11},
{"id":1224,"description":"Bonhu (Russas)","state_id":6},
{"id":49,"description":"Bonifácio (Palmeira dos Índios)","state_id":2},
{"id":431,"description":"Boninal","state_id":5},
{"id":432,"description":"Bonito","state_id":5},
{"id":5182,"description":"Bonito","state_id":16},
{"id":4577,"description":"Bonito","state_id":14},
{"id":4132,"description":"Bonito","state_id":12},
{"id":7487,"description":"Bonito (Camaquã)","state_id":23},
{"id":1225,"description":"Bonito (Canindé)","state_id":6},
{"id":2791,"description":"Bonito de Minas","state_id":11},
{"id":4885,"description":"Bonito de Santa Fé","state_id":15},
{"id":11083,"description":"Bonsucesso","state_id":2},
{"id":1834,"description":"Bonsucesso (Apiacá)","state_id":8},
{"id":2092,"description":"Bonópolis","state_id":9},
{"id":11303,"description":"Boqueirão","state_id":2},
{"id":12438,"description":"Boqueirão","state_id":23},
{"id":4886,"description":"Boqueirão","state_id":15},
{"id":7488,"description":"Boqueirão (General Câmara)","state_id":23},
{"id":4133,"description":"Boqueirão (Jardim)","state_id":12},
{"id":7489,"description":"Boqueirão (São Lourenço do Sul)","state_id":23},
{"id":7490,"description":"Boqueirão do Leão","state_id":23},
{"id":5540,"description":"Boqueirão do Piauí","state_id":17},
{"id":8776,"description":"Boquim","state_id":25},
{"id":433,"description":"Boquira","state_id":5},
{"id":8984,"description":"Boracéia","state_id":26},
{"id":210,"description":"Borba","state_id":3},
{"id":2792,"description":"Borba Gato (Ferros)","state_id":11},
{"id":8985,"description":"Borborema","state_id":26},
{"id":4887,"description":"Borborema","state_id":15},
{"id":2793,"description":"Borda da Mata","state_id":11},
{"id":5865,"description":"Borda do Campo (Quatro Barras)","state_id":18},
{"id":8986,"description":"Borebi","state_id":26},
{"id":1226,"description":"Borges (Jaguaruana)","state_id":6},
{"id":5867,"description":"Borman (Guaraniaçu)","state_id":18},
{"id":7491,"description":"Bororé (Itaqui)","state_id":23},
{"id":5868,"description":"Borrazópolis","state_id":18},
{"id":11099,"description":"Borussia","state_id":23},
{"id":8983,"description":"Borá","state_id":26},
{"id":7492,"description":"Bossoroca","state_id":23},
{"id":11082,"description":"Botafogo","state_id":2},
{"id":8987,"description":"Botafogo (Bebedouro)","state_id":26},
{"id":12498,"description":"Bote","state_id":23},
{"id":8988,"description":"Botelho (Santa Adélia)","state_id":26},
{"id":2794,"description":"Botelhos","state_id":11},
{"id":7493,"description":"Botucaraí (Candelária)","state_id":23},
{"id":8989,"description":"Botucatu","state_id":26},
{"id":8990,"description":"Botujuru (Campo Limpo Paulista)","state_id":26},
{"id":2795,"description":"Botumirim","state_id":11},
{"id":434,"description":"Botuporã","state_id":5},
{"id":5869,"description":"Botuquara (Ponta Grossa)","state_id":18},
{"id":435,"description":"Botuquara (Riacho de Santana)","state_id":5},
{"id":8386,"description":"Botuverá","state_id":24},
{"id":5870,"description":"Bourbonia (Barbosa Ferraz)","state_id":18},
{"id":7661,"description":"Bozano","state_id":23},
{"id":12765,"description":"Boêmios","state_id":23},
{"id":7494,"description":"Braga","state_id":23},
{"id":5871,"description":"Braganey","state_id":18},
{"id":5872,"description":"Bragantina (Assis Chateaubriand)","state_id":18},
{"id":4578,"description":"Bragança","state_id":14},
{"id":8992,"description":"Bragança Paulista","state_id":26},
{"id":50,"description":"Branquinha","state_id":2},
{"id":4579,"description":"Brasil Novo","state_id":14},
{"id":5541,"description":"Brasileira","state_id":17},
{"id":4134,"description":"Brasilândia","state_id":12},
{"id":9820,"description":"Brasilândia (Araguaína)","state_id":27},
{"id":2797,"description":"Brasilândia de Minas","state_id":11},
{"id":5873,"description":"Brasilândia do Sul","state_id":18},
{"id":9821,"description":"Brasilândia do Tocantins","state_id":27},
{"id":3,"description":"Brasiléia","state_id":1},
{"id":8994,"description":"Brasitânia (Fernandópolis)","state_id":26},
{"id":4310,"description":"Brasnorte","state_id":13},
{"id":1778,"description":"Brasília","state_id":7},
{"id":4580,"description":"Brasília Legal (Aveiro)","state_id":14},
{"id":2798,"description":"Brasília de Minas","state_id":11},
{"id":2799,"description":"Brasópolis","state_id":11},
{"id":2093,"description":"Brazabrantes","state_id":9},
{"id":1779,"description":"Brazlândia","state_id":7},
{"id":8991,"description":"Braço (Eldorado)","state_id":26},
{"id":12553,"description":"Braço Forte","state_id":23},
{"id":8387,"description":"Braço do Norte","state_id":24},
{"id":1835,"description":"Braço do Rio (Conceição da Barra)","state_id":8},
{"id":8388,"description":"Braço do Trombudo","state_id":24},
{"id":8995,"description":"Braúna","state_id":26},
{"id":2800,"description":"Braúnas","state_id":11},
{"id":2802,"description":"Brejaubinha (Governador Valadares)","state_id":11},
{"id":2801,"description":"Brejaúba (Conceição do Mato Dentro)","state_id":11},
{"id":1836,"description":"Brejetuba","state_id":8},
{"id":5184,"description":"Brejinho","state_id":16},
{"id":7145,"description":"Brejinho","state_id":20},
{"id":1227,"description":"Brejinho (Araripe)","state_id":6},
{"id":436,"description":"Brejinho das Ametistas (Caetité)","state_id":5},
{"id":9822,"description":"Brejinho de Nazaré","state_id":27},
{"id":2412,"description":"Brejo","state_id":10},
{"id":8996,"description":"Brejo Alegre","state_id":26},
{"id":2803,"description":"Brejo Bonito (Cruzeiro da Fortaleza)","state_id":11},
{"id":8777,"description":"Brejo Grande","state_id":25},
{"id":1228,"description":"Brejo Grande (Santana do Cariri)","state_id":6},
{"id":4582,"description":"Brejo Grande do Araguaia","state_id":14},
{"id":438,"description":"Brejo Luíza de Brito (Novo Horizonte)","state_id":5},
{"id":439,"description":"Brejo Novo (Boa Vista do Tupim)","state_id":5},
{"id":1229,"description":"Brejo Santo","state_id":6},
{"id":5185,"description":"Brejo da Madre de Deus","state_id":16},
{"id":437,"description":"Brejo da Serra (Pilão Arcado)","state_id":5},
{"id":2413,"description":"Brejo de Areia","state_id":10},
{"id":2414,"description":"Brejo de São Félix (Parnarama)","state_id":10},
{"id":2804,"description":"Brejo do Amparo (Januária)","state_id":11},
{"id":4888,"description":"Brejo do Cruz","state_id":15},
{"id":4581,"description":"Brejo do Meio (Marabá)","state_id":14},
{"id":5542,"description":"Brejo do Piauí","state_id":17},
{"id":4889,"description":"Brejo dos Santos","state_id":15},
{"id":441,"description":"Brejolândia","state_id":5},
{"id":5183,"description":"Brejão","state_id":16},
{"id":440,"description":"Brejões","state_id":5},
{"id":4583,"description":"Breu Branco","state_id":14},
{"id":4584,"description":"Breves","state_id":14},
{"id":12390,"description":"Brianorte","state_id":13},
{"id":2094,"description":"Britânia","state_id":9},
{"id":7495,"description":"Brochier","state_id":23},
{"id":8997,"description":"Brodowski","state_id":26},
{"id":8998,"description":"Brotas","state_id":26},
{"id":1230,"description":"Brotas (Miraíma)","state_id":6},
{"id":442,"description":"Brotas de Macaúbas","state_id":5},
{"id":12647,"description":"Brugnarotto","state_id":23},
{"id":2805,"description":"Brumadinho","state_id":11},
{"id":443,"description":"Brumado","state_id":5},
{"id":2806,"description":"Brumal (Santa Bárbara)","state_id":11},
{"id":8389,"description":"Brunópolis","state_id":24},
{"id":8390,"description":"Brusque","state_id":24},
{"id":8993,"description":"Brás Cubas (Mogi das Cruzes)","state_id":26},
{"id":2796,"description":"Brás Pires","state_id":11},
{"id":2807,"description":"Buarque de Macedo (Conselheiro Lafaiete)","state_id":11},
{"id":444,"description":"Bucuituba (Boquira)","state_id":5},
{"id":2808,"description":"Bueno (Conselheiro Pena)","state_id":11},
{"id":2809,"description":"Bueno Brandão","state_id":11},
{"id":8999,"description":"Bueno de Andrada (Araraquara)","state_id":26},
{"id":2095,"description":"Buenolândia (Goiás)","state_id":9},
{"id":5186,"description":"Buenos Aires","state_id":16},
{"id":2810,"description":"Buenópolis","state_id":11},
{"id":445,"description":"Buerarema","state_id":5},
{"id":2811,"description":"Bugre","state_id":11},
{"id":12616,"description":"Bugre","state_id":23},
{"id":5874,"description":"Bugre (Balsa Nova)","state_id":18},
{"id":4,"description":"Bujari","state_id":1},
{"id":4585,"description":"Bujaru","state_id":14},
{"id":5875,"description":"Bulcão (Castro)","state_id":18},
{"id":446,"description":"Buracica (Teodoro Sampaio)","state_id":5},
{"id":447,"description":"Buranhém (Guaratinga)","state_id":5},
{"id":1837,"description":"Burarama (Cachoeiro de Itapemirim)","state_id":8},
{"id":9000,"description":"Buri","state_id":26},
{"id":448,"description":"Buril (Crisópolis)","state_id":5},
{"id":449,"description":"Buris de Abrantes (Camaçari)","state_id":5},
{"id":9001,"description":"Buritama","state_id":26},
{"id":2415,"description":"Buriti","state_id":10},
{"id":4311,"description":"Buriti (Alto Araguaia)","state_id":13},
{"id":4312,"description":"Buriti (Guiratinga)","state_id":13},
{"id":7496,"description":"Buriti (Santo Ângelo)","state_id":23},
{"id":2096,"description":"Buriti Alegre","state_id":9},
{"id":2416,"description":"Buriti Bravo","state_id":10},
{"id":2417,"description":"Buriti Cortado (Timon)","state_id":10},
{"id":2097,"description":"Buriti de Goiás","state_id":9},
{"id":9823,"description":"Buriti do Tocantins","state_id":27},
{"id":5543,"description":"Buriti dos Lopes","state_id":17},
{"id":5544,"description":"Buriti dos Montes","state_id":17},
{"id":2418,"description":"Buriticupu","state_id":10},
{"id":2098,"description":"Buritinópolis","state_id":9},
{"id":450,"description":"Buritirama","state_id":5},
{"id":2419,"description":"Buritirama","state_id":10},
{"id":7316,"description":"Buritis","state_id":21},
{"id":2812,"description":"Buritis","state_id":11},
{"id":9002,"description":"Buritizal","state_id":26},
{"id":1231,"description":"Buritizal (Poranga)","state_id":6},
{"id":2813,"description":"Buritizeiro","state_id":11},
{"id":1232,"description":"Buritizinho (Mauriti)","state_id":6},
{"id":12447,"description":"Butiatuva","state_id":23},
{"id":7497,"description":"Butiá","state_id":23},
{"id":7498,"description":"Butiás (Tavares)","state_id":23},
{"id":5187,"description":"Buíque","state_id":16},
{"id":8941,"description":"Bálsamo","state_id":26},
{"id":34,"description":"Bálsamo (Arapiraca)","state_id":2},
{"id":4122,"description":"Bálsamo (Ribas do Rio Pardo)","state_id":12},
{"id":211,"description":"Caapiranga","state_id":3},
{"id":4890,"description":"Caaporã","state_id":15},
{"id":4135,"description":"Caarapó","state_id":12},
{"id":451,"description":"Caatiba","state_id":5},
{"id":2814,"description":"Caatinga (João Pinheiro)","state_id":11},
{"id":4891,"description":"Cabaceiras","state_id":15},
{"id":452,"description":"Cabaceiras do Paraguaçu","state_id":5},
{"id":5188,"description":"Cabanas (Cachoeirinha)","state_id":16},
{"id":12010,"description":"Cabeceira Do Jibóia","state_id":5},
{"id":2815,"description":"Cabeceira Grande","state_id":11},
{"id":4136,"description":"Cabeceira do Apá (Ponta Porã)","state_id":12},
{"id":2099,"description":"Cabeceiras","state_id":9},
{"id":5545,"description":"Cabeceiras do Piauí","state_id":17},
{"id":4892,"description":"Cabedelo","state_id":15},
{"id":7317,"description":"Cabixi","state_id":21},
{"id":6873,"description":"Cabo Frio","state_id":19},
{"id":2816,"description":"Cabo Verde","state_id":11},
{"id":5189,"description":"Cabo de Santo Agostinho","state_id":16},
{"id":1233,"description":"Cabreiro (Aracati)","state_id":6},
{"id":9004,"description":"Cabreúva","state_id":26},
{"id":5876,"description":"Cabrito (Paranavaí)","state_id":18},
{"id":5190,"description":"Cabrobó","state_id":16},
{"id":453,"description":"Cabrália (Piatã)","state_id":5},
{"id":9003,"description":"Cabrália Paulista","state_id":26},
{"id":2817,"description":"Caburu (São João Del Rei)","state_id":11},
{"id":6874,"description":"Cabuçu (Itaboraí)","state_id":19},
{"id":11535,"description":"Cabôto","state_id":5},
{"id":5877,"description":"Cacatu (Antonina)","state_id":18},
{"id":10471,"description":"Cacau Pirêra","state_id":3},
{"id":7318,"description":"Cacaulândia","state_id":21},
{"id":7500,"description":"Cacequi","state_id":23},
{"id":454,"description":"Cacha Pregos (Vera Cruz)","state_id":5},
{"id":455,"description":"Cachoeira","state_id":5},
{"id":10774,"description":"Cachoeira","state_id":6},
{"id":5878,"description":"Cachoeira (Cascavel)","state_id":18},
{"id":4893,"description":"Cachoeira (Guarabira)","state_id":15},
{"id":1234,"description":"Cachoeira (Itatira)","state_id":6},
{"id":4137,"description":"Cachoeira (Paranaíba)","state_id":12},
{"id":2820,"description":"Cachoeira Alegre (Barão de Monte Alto)","state_id":11},
{"id":2100,"description":"Cachoeira Alta","state_id":9},
{"id":11139,"description":"Cachoeira Da Serra","state_id":14},
{"id":12791,"description":"Cachoeira Do Aranã","state_id":11},
{"id":11706,"description":"Cachoeira Do Pinto","state_id":16},
{"id":2102,"description":"Cachoeira Dourada","state_id":9},
{"id":2830,"description":"Cachoeira Dourada","state_id":11},
{"id":2420,"description":"Cachoeira Grande","state_id":10},
{"id":1235,"description":"Cachoeira Grande (Poranga)","state_id":6},
{"id":9007,"description":"Cachoeira Paulista","state_id":26},
{"id":11812,"description":"Cachoeira Seca","state_id":16},
{"id":2821,"description":"Cachoeira da Prata","state_id":11},
{"id":5879,"description":"Cachoeira de Cima (Antonina)","state_id":18},
{"id":9006,"description":"Cachoeira de Emas (Pirassununga)","state_id":26},
{"id":8392,"description":"Cachoeira de Fátima (Praia Grande)","state_id":24},
{"id":2101,"description":"Cachoeira de Goiás","state_id":9},
{"id":2822,"description":"Cachoeira de Minas","state_id":11},
{"id":2823,"description":"Cachoeira de Pajeú","state_id":11},
{"id":4586,"description":"Cachoeira de Píria","state_id":14},
{"id":2824,"description":"Cachoeira de Santa Cruz (Viçosa)","state_id":11},
{"id":5880,"description":"Cachoeira de São José (São José dos Pinhais)","state_id":18},
{"id":4587,"description":"Cachoeira do Arari","state_id":14},
{"id":8393,"description":"Cachoeira do Bom Jesus (Florianópolis)","state_id":24},
{"id":2825,"description":"Cachoeira do Brumado (Mariana)","state_id":11},
{"id":2826,"description":"Cachoeira do Campo (Ouro Preto)","state_id":11},
{"id":5881,"description":"Cachoeira do Espírito Santo (Ribeirão Claro)","state_id":18},
{"id":2827,"description":"Cachoeira do Manteiga (Buritizeiro)","state_id":11},
{"id":456,"description":"Cachoeira do Mato (Teixeira de Freitas)","state_id":5},
{"id":5191,"description":"Cachoeira do Roberto (Afrânio)","state_id":16},
{"id":7501,"description":"Cachoeira do Sul","state_id":23},
{"id":2828,"description":"Cachoeira do Vale (Timóteo)","state_id":11},
{"id":2829,"description":"Cachoeira dos Antunes (Rio Manso)","state_id":11},
{"id":4894,"description":"Cachoeira dos Índios","state_id":15},
{"id":6875,"description":"Cachoeiras de Macacu","state_id":19},
{"id":7502,"description":"Cachoeirinha","state_id":23},
{"id":5192,"description":"Cachoeirinha","state_id":16},
{"id":9824,"description":"Cachoeirinha","state_id":27},
{"id":2831,"description":"Cachoeirinha (Córrego Danta)","state_id":11},
{"id":5882,"description":"Cachoeirinha (Guarapuava)","state_id":18},
{"id":4895,"description":"Cachoeirinha (Ibiara)","state_id":15},
{"id":5883,"description":"Cachoeirinha (Pato Branco)","state_id":18},
{"id":1838,"description":"Cachoeirinha de Itaúna (Barra de São Francisco)","state_id":8},
{"id":1839,"description":"Cachoeiro de Itapemirim","state_id":8},
{"id":6876,"description":"Cachoeiros (Macaé)","state_id":19},
{"id":4896,"description":"Cacimba de Areia","state_id":15},
{"id":4897,"description":"Cacimba de Dentro","state_id":15},
{"id":4898,"description":"Cacimbas","state_id":15},
{"id":12218,"description":"Cacimbas","state_id":6},
{"id":51,"description":"Cacimbinhas","state_id":2},
{"id":7503,"description":"Cacique Doble","state_id":23},
{"id":7319,"description":"Cacoal","state_id":21},
{"id":9008,"description":"Caconde","state_id":26},
{"id":457,"description":"Caculé","state_id":5},
{"id":5884,"description":"Cadeadinho (Irati)","state_id":18},
{"id":7504,"description":"Cadorna (Nova Alvorada)","state_id":23},
{"id":2832,"description":"Caetano Lopes (Jeceaba)","state_id":11},
{"id":5885,"description":"Caetano Mendes (Tibagi)","state_id":18},
{"id":459,"description":"Caetanos","state_id":5},
{"id":2833,"description":"Caetanópolis","state_id":11},
{"id":461,"description":"Caetité","state_id":5},
{"id":2834,"description":"Caeté","state_id":11},
{"id":2835,"description":"Caeté (Juiz de Fora)","state_id":11},
{"id":460,"description":"Caeté-Açu (Palmeiras)","state_id":5},
{"id":5193,"description":"Caetés","state_id":16},
{"id":462,"description":"Cafarnaum","state_id":5},
{"id":5886,"description":"Cafeara","state_id":18},
{"id":5887,"description":"Cafeeiros (Cruzeiro do Oeste)","state_id":18},
{"id":9009,"description":"Cafelândia","state_id":26},
{"id":5888,"description":"Cafelândia","state_id":18},
{"id":11900,"description":"Cafemirim","state_id":11},
{"id":9010,"description":"Cafesópolis (Cafelândia)","state_id":26},
{"id":4588,"description":"Cafezal (Magalhães Barata)","state_id":14},
{"id":5889,"description":"Cafezal do Sul","state_id":18},
{"id":1840,"description":"Café (Alegre)","state_id":8},
{"id":9011,"description":"Caiabu","state_id":26},
{"id":12244,"description":"Caiambé","state_id":3},
{"id":2836,"description":"Caiana","state_id":11},
{"id":2837,"description":"Caiapó (Pirapetinga)","state_id":11},
{"id":2104,"description":"Caiapônia","state_id":9},
{"id":7505,"description":"Caibaté","state_id":23},
{"id":8394,"description":"Caibi","state_id":24},
{"id":9012,"description":"Caibura (Santos)","state_id":26},
{"id":7148,"description":"Caicó","state_id":20},
{"id":9013,"description":"Caieiras","state_id":26},
{"id":464,"description":"Caimbé (Euclides da Cunha)","state_id":5},
{"id":1238,"description":"Caio Prado (Itapiúna)","state_id":6},
{"id":1239,"description":"Caioca (Sobral)","state_id":6},
{"id":1240,"description":"Caipu (Cariús)","state_id":6},
{"id":4589,"description":"Cairari (Moju)","state_id":14},
{"id":465,"description":"Cairu","state_id":5},
{"id":4314,"description":"Caite (Santo Antônio do Leverger)","state_id":13},
{"id":5890,"description":"Caitá (São Mateus do Sul)","state_id":18},
{"id":466,"description":"Caiubi (Itapebi)","state_id":5},
{"id":9014,"description":"Caiuá","state_id":26},
{"id":10430,"description":"Caiva (Campo Largo)","state_id":18},
{"id":7506,"description":"Caiçara","state_id":23},
{"id":4899,"description":"Caiçara","state_id":15},
{"id":12119,"description":"Caiçara","state_id":6},
{"id":1236,"description":"Caiçara (Cruz)","state_id":6},
{"id":2105,"description":"Caiçara (Faina)","state_id":9},
{"id":463,"description":"Caiçara (Vitória da Conquista)","state_id":5},
{"id":7146,"description":"Caiçara do Norte","state_id":20},
{"id":7147,"description":"Caiçara do Rio do Vento","state_id":20},
{"id":1237,"description":"Caiçarinha (Choró)","state_id":6},
{"id":5194,"description":"Caiçarinha da Penha (Serra Talhada)","state_id":16},
{"id":9015,"description":"Cajamar","state_id":26},
{"id":2421,"description":"Cajapió","state_id":10},
{"id":52,"description":"Cajarana (Arapiraca)","state_id":2},
{"id":2422,"description":"Cajari","state_id":10},
{"id":9016,"description":"Cajati","state_id":26},
{"id":4900,"description":"Cajazeiras","state_id":15},
{"id":11703,"description":"Cajazeiras","state_id":16},
{"id":5546,"description":"Cajazeiras do Piauí","state_id":17},
{"id":4901,"description":"Cajazeirinhas","state_id":15},
{"id":9017,"description":"Cajobi","state_id":26},
{"id":4590,"description":"Caju (São Miguel do Guamá)","state_id":14},
{"id":53,"description":"Cajueiro","state_id":2},
{"id":12113,"description":"Cajueiro","state_id":6},
{"id":5547,"description":"Cajueiro da Praia","state_id":17},
{"id":2838,"description":"Cajuri","state_id":11},
{"id":9018,"description":"Cajuru","state_id":26},
{"id":467,"description":"Cajuí (Sento Sé)","state_id":5},
{"id":1241,"description":"Calabaça (Várzea Alegre)","state_id":6},
{"id":7320,"description":"Calama (Porto Velho)","state_id":21},
{"id":2106,"description":"Calcilândia (Goiás)","state_id":9},
{"id":2839,"description":"Caldas","state_id":11},
{"id":4902,"description":"Caldas Brandão","state_id":15},
{"id":2107,"description":"Caldas Novas","state_id":9},
{"id":468,"description":"Caldas do Jorro (Tucano)","state_id":5},
{"id":2108,"description":"Caldazinha","state_id":9},
{"id":471,"description":"Caldeiras (Caetité)","state_id":5},
{"id":11709,"description":"Caldeirão","state_id":16},
{"id":1242,"description":"Caldeirão (Salitre)","state_id":6},
{"id":469,"description":"Caldeirão (Uauá)","state_id":5},
{"id":470,"description":"Caldeirão Grande","state_id":5},
{"id":5548,"description":"Caldeirão Grande do Piauí","state_id":17},
{"id":5196,"description":"Caldeirões (Bom Conselho)","state_id":16},
{"id":54,"description":"Caldeirões de Cima (Palmeira dos Índios)","state_id":2},
{"id":6877,"description":"Calheiros (Bom Jesus do Itabapoana)","state_id":19},
{"id":5892,"description":"Califórnia","state_id":18},
{"id":1243,"description":"Califórnia (Quixadá)","state_id":6},
{"id":11406,"description":"Califórnia Da Barra","state_id":19},
{"id":2109,"description":"Calixto (Anápolis)","state_id":9},
{"id":2840,"description":"Calixto (Resplendor)","state_id":11},
{"id":8395,"description":"Calmon","state_id":24},
{"id":1841,"description":"Calogi (Serra)","state_id":8},
{"id":5197,"description":"Calumbi","state_id":16},
{"id":5195,"description":"Calçado","state_id":16},
{"id":287,"description":"Calçoene","state_id":4},
{"id":5893,"description":"Calógeras (Arapoti)","state_id":18},
{"id":472,"description":"Camacan","state_id":5},
{"id":2841,"description":"Camacho","state_id":11},
{"id":55,"description":"Camadanta (Arapiraca)","state_id":2},
{"id":4903,"description":"Camalaú","state_id":15},
{"id":474,"description":"Camamu","state_id":5},
{"id":2842,"description":"Camanducaia","state_id":11},
{"id":4138,"description":"Camapuã","state_id":12},
{"id":7507,"description":"Camaquã","state_id":23},
{"id":5198,"description":"Camaragibe","state_id":16},
{"id":7508,"description":"Camargo","state_id":23},
{"id":2843,"description":"Camargos (Mariana)","state_id":11},
{"id":1244,"description":"Camará (Aquiraz)","state_id":6},
{"id":475,"description":"Camassandi (Jaguaripe)","state_id":5},
{"id":473,"description":"Camaçari","state_id":5},
{"id":9019,"description":"Cambaquara (Ilhabela)","state_id":26},
{"id":9020,"description":"Cambaratiba (Ibitinga)","state_id":26},
{"id":5894,"description":"Cambará","state_id":18},
{"id":7509,"description":"Cambará do Sul","state_id":23},
{"id":6878,"description":"Cambiasca (São Fidélis)","state_id":19},
{"id":5896,"description":"Cambiju (Ponta Grossa)","state_id":18},
{"id":5897,"description":"Cambira","state_id":18},
{"id":1245,"description":"Camboas (Paraipaba)","state_id":6},
{"id":8396,"description":"Camboriú","state_id":24},
{"id":6879,"description":"Cambuci","state_id":19},
{"id":8397,"description":"Cambuinzal (Xanxerê)","state_id":24},
{"id":2845,"description":"Cambuquira","state_id":11},
{"id":4592,"description":"Cambuquira (Santarém)","state_id":14},
{"id":2844,"description":"Cambuí","state_id":11},
{"id":5895,"description":"Cambé","state_id":18},
{"id":5199,"description":"Camela (Ipojuca)","state_id":16},
{"id":4593,"description":"Cametá","state_id":14},
{"id":212,"description":"Cametá (Barreirinha)","state_id":3},
{"id":1246,"description":"Camilos (Meruoca)","state_id":6},
{"id":4594,"description":"Camiranga (Viseu)","state_id":14},
{"id":476,"description":"Camirim (Morro do Chapéu)","state_id":5},
{"id":4139,"description":"Camisão (Aquidauana)","state_id":12},
{"id":7510,"description":"Camobi (Santa Maria)","state_id":23},
{"id":1247,"description":"Camocim","state_id":6},
{"id":5200,"description":"Camocim de São Félix","state_id":16},
{"id":2847,"description":"Campanha","state_id":11},
{"id":2846,"description":"Campanário","state_id":11},
{"id":1248,"description":"Campanário (Uruoca)","state_id":6},
{"id":8398,"description":"Campeche (Florianópolis)","state_id":24},
{"id":56,"description":"Campestre","state_id":2},
{"id":2848,"description":"Campestre","state_id":11},
{"id":12576,"description":"Campestre","state_id":23},
{"id":4140,"description":"Campestre (Antônio João)","state_id":12},
{"id":10123,"description":"Campestre (Chorozinho)","state_id":6},
{"id":1249,"description":"Campestre (Fortim)","state_id":6},
{"id":7511,"description":"Campestre Baixo (Salvador do Sul)","state_id":23},
{"id":7512,"description":"Campestre da Serra","state_id":23},
{"id":2110,"description":"Campestre de Goiás","state_id":9},
{"id":2423,"description":"Campestre do Maranhão","state_id":10},
{"id":2849,"description":"Campestrinho (Andradas)","state_id":11},
{"id":5898,"description":"Campestrinho (Araucária)","state_id":18},
{"id":9021,"description":"Campestrinho (Divinolândia)","state_id":26},
{"id":5899,"description":"Campina (Campo Largo)","state_id":18},
{"id":5900,"description":"Campina (Guarapuava)","state_id":18},
{"id":5901,"description":"Campina (São José dos Pinhais)","state_id":18},
{"id":4904,"description":"Campina Grande","state_id":15},
{"id":5906,"description":"Campina Grande do Sul","state_id":18},
{"id":7514,"description":"Campina Redonda (Espumoso)","state_id":23},
{"id":2850,"description":"Campina Verde","state_id":11},
{"id":5902,"description":"Campina da Lagoa","state_id":18},
{"id":7513,"description":"Campina das Missões","state_id":23},
{"id":9022,"description":"Campina de Fora (Ribeirão Branco)","state_id":26},
{"id":5903,"description":"Campina do Miranguava (São José dos Pinhais)","state_id":18},
{"id":9023,"description":"Campina do Monte Alegre","state_id":26},
{"id":5904,"description":"Campina do Simão","state_id":18},
{"id":5905,"description":"Campina dos Furtados (São José dos Pinhais)","state_id":18},
{"id":9024,"description":"Campinal (Presidente Epitácio)","state_id":26},
{"id":9025,"description":"Campinas","state_id":26},
{"id":11059,"description":"Campinas","state_id":1},
{"id":11769,"description":"Campinas","state_id":3},
{"id":5907,"description":"Campinas (Campo Largo)","state_id":18},
{"id":7515,"description":"Campinas (Saldanha Marinho)","state_id":23},
{"id":8399,"description":"Campinas (São José)","state_id":24},
{"id":5549,"description":"Campinas do Piauí","state_id":17},
{"id":7516,"description":"Campinas do Sul","state_id":23},
{"id":2111,"description":"Campinaçu","state_id":9},
{"id":12464,"description":"Campinho","state_id":23},
{"id":477,"description":"Campinhos (Santo Amaro)","state_id":5},
{"id":2112,"description":"Campinorte","state_id":9},
{"id":4315,"description":"Campinápolis","state_id":13},
{"id":8400,"description":"Campo Alegre","state_id":24},
{"id":57,"description":"Campo Alegre","state_id":2},
{"id":11527,"description":"Campo Alegre","state_id":6},
{"id":11722,"description":"Campo Alegre","state_id":16},
{"id":4905,"description":"Campo Alegre (Sousa)","state_id":15},
{"id":2113,"description":"Campo Alegre de Goiás","state_id":9},
{"id":478,"description":"Campo Alegre de Lourdes","state_id":5},
{"id":2851,"description":"Campo Alegre de Minas (Ibiracatu)","state_id":11},
{"id":2852,"description":"Campo Alegre de Minas (Resplendor)","state_id":11},
{"id":5550,"description":"Campo Alegre do Fidalgo","state_id":17},
{"id":2853,"description":"Campo Azul","state_id":11},
{"id":2854,"description":"Campo Belo","state_id":11},
{"id":8401,"description":"Campo Belo do Sul","state_id":24},
{"id":7517,"description":"Campo Bom","state_id":23},
{"id":5908,"description":"Campo Bonito","state_id":18},
{"id":7518,"description":"Campo Branco (Progresso)","state_id":23},
{"id":12519,"description":"Campo De Sobradinho","state_id":23},
{"id":12609,"description":"Campo Do Meio","state_id":23},
{"id":8402,"description":"Campo Erê","state_id":24},
{"id":2856,"description":"Campo Florido","state_id":11},
{"id":479,"description":"Campo Formoso","state_id":5},
{"id":480,"description":"Campo Formoso (Presidente Dutra)","state_id":5},
{"id":7149,"description":"Campo Grande","state_id":20},
{"id":58,"description":"Campo Grande","state_id":2},
{"id":4141,"description":"Campo Grande","state_id":12},
{"id":4906,"description":"Campo Grande (Itabaiana)","state_id":15},
{"id":5551,"description":"Campo Grande do Piauí","state_id":17},
{"id":5911,"description":"Campo Largo","state_id":18},
{"id":5912,"description":"Campo Largo da Roseira (São José dos Pinhais)","state_id":18},
{"id":5552,"description":"Campo Largo do Piauí","state_id":17},
{"id":2114,"description":"Campo Limpo (Itumbiara)","state_id":9},
{"id":9026,"description":"Campo Limpo Paulista","state_id":26},
{"id":2300,"description":"Campo Limpo de Goiás","state_id":9},
{"id":10238,"description":"Campo Lindo (Cristalina)","state_id":9},
{"id":5913,"description":"Campo Magro","state_id":18},
{"id":5553,"description":"Campo Maior","state_id":17},
{"id":5914,"description":"Campo Mourão","state_id":18},
{"id":7520,"description":"Campo Novo","state_id":23},
{"id":7521,"description":"Campo Novo (Fontoura Xavier)","state_id":23},
{"id":7321,"description":"Campo Novo de Rondônia","state_id":21},
{"id":4316,"description":"Campo Novo do Parecis","state_id":13},
{"id":7150,"description":"Campo Redondo","state_id":20},
{"id":2857,"description":"Campo Redondo (Varzelândia)","state_id":11},
{"id":7522,"description":"Campo Santo (Coronel Bicaco)","state_id":23},
{"id":7523,"description":"Campo Seco (Rosário do Sul)","state_id":23},
{"id":4317,"description":"Campo Verde","state_id":13},
{"id":7524,"description":"Campo Vicente (Nova Hartz)","state_id":23},
{"id":5117,"description":"Campo de Santana","state_id":15},
{"id":8778,"description":"Campo do Brito","state_id":25},
{"id":10391,"description":"Campo do Bugre (Laranjeiras do Sul)","state_id":18},
{"id":6880,"description":"Campo do Coelho (Nova Friburgo)","state_id":19},
{"id":2855,"description":"Campo do Meio","state_id":11},
{"id":7519,"description":"Campo do Meio (Mato Castelhano)","state_id":23},
{"id":5909,"description":"Campo do Meio (Ponta Grossa)","state_id":18},
{"id":5910,"description":"Campo do Tenente","state_id":18},
{"id":2858,"description":"Campolide (Santa Rita do Ibitipoca)","state_id":11},
{"id":2115,"description":"Campolândia (Ivolândia)","state_id":9},
{"id":12122,"description":"Campos","state_id":6},
{"id":2859,"description":"Campos Altos","state_id":11},
{"id":2116,"description":"Campos Belos","state_id":9},
{"id":7525,"description":"Campos Borges","state_id":23},
{"id":6882,"description":"Campos Elíseos (Duque de Caxias)","state_id":19},
{"id":2860,"description":"Campos Gerais","state_id":11},
{"id":9825,"description":"Campos Lindos","state_id":27},
{"id":8403,"description":"Campos Novos","state_id":24},
{"id":4319,"description":"Campos Novos (Alto Paraguai)","state_id":13},
{"id":9029,"description":"Campos Novos Paulista","state_id":26},
{"id":1250,"description":"Campos Sales","state_id":6},
{"id":2117,"description":"Campos Verdes","state_id":9},
{"id":9027,"description":"Campos de Cunha (Cunha)","state_id":26},
{"id":4318,"description":"Campos de Júlio","state_id":13},
{"id":9028,"description":"Campos do Jordão","state_id":26},
{"id":6881,"description":"Campos dos Goytacazes","state_id":19},
{"id":481,"description":"Camurugi (Taperoá)","state_id":5},
{"id":4907,"description":"Camurupim (Rio Tinto)","state_id":15},
{"id":5201,"description":"Camutanga","state_id":16},
{"id":12741,"description":"Cana Brava","state_id":5},
{"id":11698,"description":"Cana Brava","state_id":2},
{"id":9826,"description":"Cana Brava (Arraias)","state_id":27},
{"id":2118,"description":"Cana Brava (Minaçu)","state_id":9},
{"id":2861,"description":"Cana Verde","state_id":11},
{"id":1251,"description":"Canaan (Trairi)","state_id":6},
{"id":2863,"description":"Canabrava (Francisco Sá)","state_id":11},
{"id":2864,"description":"Canabrava (João Pinheiro)","state_id":11},
{"id":4320,"description":"Canabrava do Norte","state_id":13},
{"id":482,"description":"Canabravinha (Paramirim)","state_id":5},
{"id":2119,"description":"Canadá (Jussara)","state_id":9},
{"id":1252,"description":"Canafistula (Apuiarés)","state_id":6},
{"id":1253,"description":"Canafistula (Jucás)","state_id":6},
{"id":60,"description":"Canafístula (Palmeira dos Índios)","state_id":2},
{"id":9030,"description":"Cananéia","state_id":26},
{"id":61,"description":"Canapi","state_id":2},
{"id":484,"description":"Canarana","state_id":5},
{"id":4321,"description":"Canarana","state_id":13},
{"id":9031,"description":"Canas","state_id":26},
{"id":62,"description":"Canastra (Ibateguara)","state_id":2},
{"id":2866,"description":"Canastrão (Tiros)","state_id":11},
{"id":8404,"description":"Canasvieiras (Florianópolis)","state_id":24},
{"id":485,"description":"Canatiba (Macaúbas)","state_id":5},
{"id":5554,"description":"Canavieira","state_id":17},
{"id":486,"description":"Canavieiras","state_id":5},
{"id":2862,"description":"Canaã","state_id":11},
{"id":59,"description":"Canaã (Arapiraca)","state_id":2},
{"id":5202,"description":"Canaã (Triunfo)","state_id":16},
{"id":4595,"description":"Canaã dos Carajás","state_id":14},
{"id":10104,"description":"Canaúna (Ipaumirim)","state_id":6},
{"id":487,"description":"Canché (Jeremoabo)","state_id":5},
{"id":1780,"description":"Candangolândia","state_id":7},
{"id":488,"description":"Candeal","state_id":5},
{"id":10732,"description":"Candeia","state_id":18},
{"id":489,"description":"Candeias","state_id":5},
{"id":2867,"description":"Candeias","state_id":11},
{"id":7322,"description":"Candeias do Jamari","state_id":21},
{"id":7526,"description":"Candelária","state_id":23},
{"id":9032,"description":"Candia (Pontal)","state_id":26},
{"id":490,"description":"Candiba","state_id":5},
{"id":7529,"description":"Candiota","state_id":23},
{"id":12504,"description":"Candiota","state_id":23},
{"id":5916,"description":"Candói","state_id":18},
{"id":7530,"description":"Canela","state_id":23},
{"id":5917,"description":"Canela (Renascença)","state_id":18},
{"id":8405,"description":"Canelinha","state_id":24},
{"id":63,"description":"Cangandu (Arapiraca)","state_id":2},
{"id":4322,"description":"Cangas (Poconé)","state_id":13},
{"id":1254,"description":"Cangati (Mombaça)","state_id":6},
{"id":1255,"description":"Cangati (Solonópole)","state_id":6},
{"id":7151,"description":"Canguaretama","state_id":20},
{"id":9035,"description":"Canguera (São Roque)","state_id":26},
{"id":7531,"description":"Canguçu","state_id":23},
{"id":7532,"description":"Canhembora (Nova Palma)","state_id":23},
{"id":8779,"description":"Canhoba","state_id":25},
{"id":5203,"description":"Canhotinho","state_id":16},
{"id":12214,"description":"Canindezinho","state_id":6},
{"id":1257,"description":"Canindezinho (Nova Russas)","state_id":6},
{"id":1258,"description":"Canindezinho (Potiretama)","state_id":6},
{"id":1259,"description":"Canindezinho (Várzea Alegre)","state_id":6},
{"id":1256,"description":"Canindé","state_id":6},
{"id":8780,"description":"Canindé de São Francisco","state_id":25},
{"id":9036,"description":"Canitar","state_id":26},
{"id":7533,"description":"Canoas","state_id":23},
{"id":8406,"description":"Canoas (Bom Retiro)","state_id":24},
{"id":2868,"description":"Canoeiros (São Gonçalo do Abaeté)","state_id":11},
{"id":8407,"description":"Canoinhas","state_id":24},
{"id":492,"description":"Canoão (Ibititá)","state_id":5},
{"id":493,"description":"Cansanção","state_id":5},
{"id":12117,"description":"Canta Galo","state_id":6},
{"id":6883,"description":"Cantagalo","state_id":19},
{"id":5918,"description":"Cantagalo","state_id":18},
{"id":2869,"description":"Cantagalo","state_id":11},
{"id":2425,"description":"Cantanhede","state_id":10},
{"id":288,"description":"Cantanzal (Macapá)","state_id":4},
{"id":12710,"description":"Canto Krewer","state_id":23},
{"id":5555,"description":"Canto do Buriti","state_id":17},
{"id":494,"description":"Canto do Sol (Camaçari)","state_id":5},
{"id":7377,"description":"Cantá","state_id":22},
{"id":495,"description":"Canudos","state_id":5},
{"id":496,"description":"Canudos (Mulungu do Morro)","state_id":5},
{"id":7534,"description":"Canudos do Vale","state_id":23},
{"id":213,"description":"Canumã (Borba)","state_id":3},
{"id":214,"description":"Canutama","state_id":3},
{"id":5919,"description":"Canzianópolis (Pranchita)","state_id":18},
{"id":483,"description":"Canápolis","state_id":5},
{"id":2865,"description":"Canápolis","state_id":11},
{"id":4596,"description":"Capanema","state_id":14},
{"id":5920,"description":"Capanema","state_id":18},
{"id":7535,"description":"Capané (Cachoeira do Sul)","state_id":23},
{"id":2870,"description":"Caparaó","state_id":11},
{"id":8781,"description":"Capela","state_id":25},
{"id":64,"description":"Capela","state_id":2},
{"id":12776,"description":"Capela Da Luz","state_id":23},
{"id":2871,"description":"Capela Nova","state_id":11},
{"id":12491,"description":"Capela Santo Antônio","state_id":23},
{"id":12436,"description":"Capela São Francisco","state_id":23},
{"id":12535,"description":"Capela São Paulo","state_id":23},
{"id":7545,"description":"Capela Velha (Camaquã)","state_id":23},
{"id":7544,"description":"Capela de Santana","state_id":23},
{"id":9038,"description":"Capela do Alto","state_id":26},
{"id":498,"description":"Capela do Alto Alegre","state_id":5},
{"id":2872,"description":"Capelinha","state_id":11},
{"id":2120,"description":"Capelinha (Anicuns)","state_id":9},
{"id":2873,"description":"Capetinga","state_id":11},
{"id":4908,"description":"Capim","state_id":15},
{"id":2874,"description":"Capim Branco","state_id":11},
{"id":499,"description":"Capim Grosso","state_id":5},
{"id":8409,"description":"Capinzal","state_id":24},
{"id":12757,"description":"Capinzal","state_id":18},
{"id":7546,"description":"Capinzal (Constantina)","state_id":23},
{"id":2426,"description":"Capinzal do Norte","state_id":10},
{"id":2875,"description":"Capinópolis","state_id":11},
{"id":1260,"description":"Capistrano","state_id":6},
{"id":2876,"description":"Capitânia (Montalvânia)","state_id":11},
{"id":7547,"description":"Capitão","state_id":23},
{"id":2877,"description":"Capitão Andrade","state_id":11},
{"id":2878,"description":"Capitão Enéas","state_id":11},
{"id":5557,"description":"Capitão Gervásio Oliveira","state_id":17},
{"id":5927,"description":"Capitão Leônidas Marques","state_id":18},
{"id":12326,"description":"Capitão Mor","state_id":6},
{"id":12511,"description":"Capitão Noronha","state_id":23},
{"id":12118,"description":"Capitão Pedro Sampaio","state_id":6},
{"id":4597,"description":"Capitão Poço","state_id":14},
{"id":5556,"description":"Capitão de Campos","state_id":17},
{"id":2879,"description":"Capitólio","state_id":11},
{"id":12550,"description":"Capivara","state_id":23},
{"id":5928,"description":"Capivara (Almirante Tamandaré)","state_id":18},
{"id":9039,"description":"Capivari","state_id":26},
{"id":9040,"description":"Capivari da Mata (Ituverava)","state_id":26},
{"id":8410,"description":"Capivari de Baixo","state_id":24},
{"id":7548,"description":"Capivari do Sul","state_id":23},
{"id":7549,"description":"Capivarita (Pântano Grande)","state_id":23},
{"id":5,"description":"Capixaba","state_id":1},
{"id":7550,"description":"Capo-Erê (Erechim)","state_id":23},
{"id":7551,"description":"Capoeira Grande (Tenente Portela)","state_id":23},
{"id":5204,"description":"Capoeiras","state_id":16},
{"id":5929,"description":"Capoeirinha (Castro)","state_id":18},
{"id":1261,"description":"Caponga (Cascavel)","state_id":6},
{"id":1262,"description":"Caponga da Bernarda (Aquiraz)","state_id":6},
{"id":9041,"description":"Caporanga (Santa Cruz do Rio Pardo)","state_id":26},
{"id":9042,"description":"Capuava (Santo André)","state_id":26},
{"id":2880,"description":"Caputira","state_id":11},
{"id":497,"description":"Capão (Laje)","state_id":5},
{"id":8408,"description":"Capão Alto","state_id":24},
{"id":12544,"description":"Capão Alto","state_id":23},
{"id":5921,"description":"Capão Alto (Castro)","state_id":18},
{"id":5922,"description":"Capão Alto (Guarapuava)","state_id":18},
{"id":9037,"description":"Capão Bonito","state_id":26},
{"id":5923,"description":"Capão Bonito (Guarapuava)","state_id":18},
{"id":7537,"description":"Capão Bonito (Salto do Jacuí)","state_id":23},
{"id":7536,"description":"Capão Bonito do Sul","state_id":23},
{"id":7538,"description":"Capão Comprido (Tavares)","state_id":23},
{"id":12422,"description":"Capão Da Herança","state_id":23},
{"id":12435,"description":"Capão Do Tigre","state_id":23},
{"id":12424,"description":"Capão Grande","state_id":23},
{"id":5925,"description":"Capão Grande (Ponta Grossa)","state_id":18},
{"id":4323,"description":"Capão Grande (Várzea Grande)","state_id":13},
{"id":12450,"description":"Capão Novo","state_id":23},
{"id":5926,"description":"Capão Rico (Guarapuava)","state_id":18},
{"id":4142,"description":"Capão Seco (Sidrolândia)","state_id":12},
{"id":4324,"description":"Capão Verde (Alto Paraguai)","state_id":13},
{"id":7539,"description":"Capão da Canoa","state_id":23},
{"id":5924,"description":"Capão da Lagoa (Guarapuava)","state_id":18},
{"id":7540,"description":"Capão da Porteira (Viamão)","state_id":23},
{"id":7541,"description":"Capão do Cedro (Lagoa Vermelha)","state_id":23},
{"id":7542,"description":"Capão do Cipó","state_id":23},
{"id":7543,"description":"Capão do Leão","state_id":23},
{"id":5930,"description":"Cara Pintado (Guarapuava)","state_id":18},
{"id":6884,"description":"Carabuçu (Bom Jesus do Itabapoana)","state_id":19},
{"id":7378,"description":"Caracaraí","state_id":22},
{"id":1263,"description":"Caracará (Sobral)","state_id":6},
{"id":4598,"description":"Caracará do Arari (Cachoeira do Arari)","state_id":14},
{"id":4143,"description":"Caracol","state_id":12},
{"id":5558,"description":"Caracol","state_id":17},
{"id":11140,"description":"Caracol","state_id":14},
{"id":9043,"description":"Caraguatatuba","state_id":26},
{"id":500,"description":"Caraguataí (Jussiape)","state_id":5},
{"id":5206,"description":"Caraibeiras (Tacaratu)","state_id":16},
{"id":502,"description":"Caraibuna (Contendas do Sincorá)","state_id":5},
{"id":504,"description":"Caraiva (Porto Seguro)","state_id":5},
{"id":5932,"description":"Carajá (Jesuítas)","state_id":18},
{"id":7553,"description":"Carajá Seival (Caçapava do Sul)","state_id":23},
{"id":4599,"description":"Carajás (Parauapebas)","state_id":14},
{"id":5933,"description":"Carambeí","state_id":18},
{"id":4325,"description":"Caramujo (Cáceres)","state_id":13},
{"id":11731,"description":"Caramuru","state_id":16},
{"id":11810,"description":"Caramuru","state_id":16},
{"id":5934,"description":"Caramuru (Cambé)","state_id":18},
{"id":2882,"description":"Caranaíba","state_id":11},
{"id":2883,"description":"Carandaí","state_id":11},
{"id":2884,"description":"Carangola","state_id":11},
{"id":4600,"description":"Carapajó (Cametá)","state_id":14},
{"id":4601,"description":"Caraparu (Santa Isabel do Pará)","state_id":14},
{"id":6885,"description":"Carapebus","state_id":19},
{"id":9044,"description":"Carapicuíba","state_id":26},
{"id":1843,"description":"Carapina (Serra)","state_id":8},
{"id":5207,"description":"Carapotos (Caruaru)","state_id":16},
{"id":4602,"description":"Caratateua (Bragança)","state_id":14},
{"id":2885,"description":"Caratinga","state_id":11},
{"id":5935,"description":"Caratuva (Arapoti)","state_id":18},
{"id":215,"description":"Carauari","state_id":3},
{"id":4326,"description":"Caravagio (Sorriso)","state_id":13},
{"id":505,"description":"Caravelas","state_id":5},
{"id":7554,"description":"Carazinho","state_id":23},
{"id":5936,"description":"Carazinho (Ponta Grossa)","state_id":18},
{"id":7552,"description":"Caraá","state_id":23},
{"id":2881,"description":"Caraí","state_id":11},
{"id":5205,"description":"Caraíba (Santa Maria da Boa Vista)","state_id":16},
{"id":8411,"description":"Caraíba (Seara)","state_id":24},
{"id":2121,"description":"Caraíba (Vianópolis)","state_id":9},
{"id":2427,"description":"Caraíba do Norte (São Francisco do Maranhão)","state_id":10},
{"id":501,"description":"Caraíbas","state_id":5},
{"id":11655,"description":"Caraíbas","state_id":5},
{"id":11803,"description":"Caraíbas","state_id":16},
{"id":503,"description":"Caraípe (São Felipe)","state_id":5},
{"id":11811,"description":"Caraúba Torta","state_id":16},
{"id":7152,"description":"Caraúbas","state_id":20},
{"id":4909,"description":"Caraúbas","state_id":15},
{"id":5559,"description":"Caraúbas do Piauí","state_id":17},
{"id":5937,"description":"Carbonera (Maria Helena)","state_id":18},
{"id":2886,"description":"Carbonita","state_id":11},
{"id":9045,"description":"Cardeal (Elias Fausto)","state_id":26},
{"id":2887,"description":"Cardeal Mota (Santana do Riacho)","state_id":11},
{"id":506,"description":"Cardeal da Silva","state_id":5},
{"id":9046,"description":"Cardoso","state_id":26},
{"id":4910,"description":"Cardoso (Conceição)","state_id":15},
{"id":9047,"description":"Cardoso (Itajobi)","state_id":26},
{"id":6886,"description":"Cardoso Moreira","state_id":19},
{"id":2888,"description":"Careaçu","state_id":11},
{"id":216,"description":"Careiro","state_id":3},
{"id":11763,"description":"Careiro Parauá","state_id":3},
{"id":217,"description":"Careiro da Várzea","state_id":3},
{"id":1844,"description":"Cariacica","state_id":8},
{"id":5208,"description":"Carice (Itambé)","state_id":16},
{"id":1264,"description":"Caridade","state_id":6},
{"id":5560,"description":"Caridade do Piauí","state_id":17},
{"id":5209,"description":"Carima (Barreiros)","state_id":16},
{"id":507,"description":"Carinhanha","state_id":5},
{"id":2889,"description":"Carioca (Pará de Minas)","state_id":11},
{"id":508,"description":"Caripare (Riachão das Neves)","state_id":5},
{"id":4603,"description":"Caripi (Igarapé-Açu)","state_id":14},
{"id":8782,"description":"Carira","state_id":25},
{"id":9827,"description":"Cariri do Tocantins","state_id":27},
{"id":1266,"description":"Caririaçu","state_id":6},
{"id":5210,"description":"Caririmirim (Moreilândia)","state_id":16},
{"id":1265,"description":"Cariré","state_id":6},
{"id":1268,"description":"Cariutaba (Farias Brito)","state_id":6},
{"id":1267,"description":"Cariús","state_id":6},
{"id":4327,"description":"Carlinda","state_id":13},
{"id":2890,"description":"Carlos Alves (São João Nepomuceno)","state_id":11},
{"id":7555,"description":"Carlos Barbosa","state_id":23},
{"id":2891,"description":"Carlos Chagas","state_id":11},
{"id":7556,"description":"Carlos Gomes","state_id":23},
{"id":5938,"description":"Carlópolis","state_id":18},
{"id":1269,"description":"Carmelópolis (Campos Sales)","state_id":6},
{"id":6887,"description":"Carmo","state_id":19},
{"id":289,"description":"Carmo (Macapá)","state_id":4},
{"id":2893,"description":"Carmo da Cachoeira","state_id":11},
{"id":2894,"description":"Carmo da Mata","state_id":11},
{"id":2895,"description":"Carmo de Minas","state_id":11},
{"id":2896,"description":"Carmo do Cajuru","state_id":11},
{"id":2897,"description":"Carmo do Paranaíba","state_id":11},
{"id":2898,"description":"Carmo do Rio Claro","state_id":11},
{"id":2122,"description":"Carmo do Rio Verde","state_id":9},
{"id":9828,"description":"Carmolândia","state_id":27},
{"id":2892,"description":"Carmésia","state_id":11},
{"id":8783,"description":"Carmópolis","state_id":25},
{"id":2899,"description":"Carmópolis de Minas","state_id":11},
{"id":7154,"description":"Carnaubais","state_id":20},
{"id":1270,"description":"Carnaubal","state_id":6},
{"id":5212,"description":"Carnaubeira da Penha","state_id":16},
{"id":1272,"description":"Carnaubinha (Milhã)","state_id":6},
{"id":5211,"description":"Carnaíba","state_id":16},
{"id":509,"description":"Carnaíba do Sertão (Juazeiro)","state_id":5},
{"id":12760,"description":"Carnaúba","state_id":6},
{"id":7153,"description":"Carnaúba dos Dantas","state_id":20},
{"id":1271,"description":"Carnaúbas (Mombaça)","state_id":6},
{"id":11716,"description":"Carne-De-Vaca","state_id":16},
{"id":2900,"description":"Carneirinho","state_id":11},
{"id":5213,"description":"Carneiro (Buíque)","state_id":16},
{"id":65,"description":"Carneiros","state_id":2},
{"id":11739,"description":"Caroalina","state_id":16},
{"id":11531,"description":"Caroba","state_id":5},
{"id":7379,"description":"Caroebe","state_id":22},
{"id":2428,"description":"Carolina","state_id":10},
{"id":7557,"description":"Carovi (Santiago)","state_id":23},
{"id":5214,"description":"Carpina","state_id":16},
{"id":5215,"description":"Carqueja (Floresta)","state_id":16},
{"id":1273,"description":"Carquejo (Mucambo)","state_id":6},
{"id":2901,"description":"Carrancas","state_id":11},
{"id":4911,"description":"Carrapateira","state_id":15},
{"id":1274,"description":"Carrapateiras (Tauá)","state_id":6},
{"id":510,"description":"Carrapichel (Senhor do Bonfim)","state_id":5},
{"id":66,"description":"Carrasco (Arapiraca)","state_id":2},
{"id":9829,"description":"Carrasco Bonito","state_id":27},
{"id":4604,"description":"Carrazedo (Gurupá)","state_id":14},
{"id":9830,"description":"Cartucho (Goiatins)","state_id":27},
{"id":9048,"description":"Caruara (Santos)","state_id":26},
{"id":5216,"description":"Caruaru","state_id":16},
{"id":1275,"description":"Caruataí (Tianguá)","state_id":6},
{"id":4144,"description":"Carumbé (Itaporã)","state_id":12},
{"id":2429,"description":"Carutapera","state_id":10},
{"id":1276,"description":"Carvalho (Tamboril)","state_id":6},
{"id":2902,"description":"Carvalho de Brito (Sabará)","state_id":11},
{"id":2904,"description":"Carvalhos","state_id":11},
{"id":2903,"description":"Carvalhópolis","state_id":11},
{"id":218,"description":"Carvoeiro (Barcelos)","state_id":3},
{"id":1277,"description":"Carvoeiro (Itarema)","state_id":6},
{"id":5931,"description":"Cará-Cará (Ponta Grossa)","state_id":18},
{"id":9049,"description":"Casa Branca","state_id":26},
{"id":12437,"description":"Casa Branca","state_id":23},
{"id":12754,"description":"Casa Branca","state_id":18},
{"id":2905,"description":"Casa Grande","state_id":11},
{"id":511,"description":"Casa Nova","state_id":5},
{"id":5939,"description":"Casa Nova (Castro)","state_id":18},
{"id":12448,"description":"Casa Velha","state_id":23},
{"id":7558,"description":"Casca","state_id":23},
{"id":2906,"description":"Cascalho Rico","state_id":11},
{"id":7559,"description":"Cascata (Horizontina)","state_id":23},
{"id":7560,"description":"Cascata (Pelotas)","state_id":23},
{"id":5940,"description":"Cascatinha (Cambé)","state_id":18},
{"id":6888,"description":"Cascatinha (Petrópolis)","state_id":19},
{"id":1278,"description":"Cascavel","state_id":6},
{"id":5941,"description":"Cascavel","state_id":18},
{"id":9831,"description":"Caseara","state_id":27},
{"id":7561,"description":"Caseiros","state_id":23},
{"id":6889,"description":"Casimiro de Abreu","state_id":19},
{"id":4912,"description":"Casinha do Homem (Santa Cruz)","state_id":15},
{"id":5217,"description":"Casinhas","state_id":16},
{"id":4913,"description":"Casserengue","state_id":15},
{"id":4145,"description":"Cassilândia","state_id":12},
{"id":4328,"description":"Cassununga (Tesouro)","state_id":13},
{"id":4605,"description":"Castanhal","state_id":14},
{"id":4329,"description":"Castanheira","state_id":13},
{"id":7323,"description":"Castanheiras","state_id":21},
{"id":1279,"description":"Castanhão (Alto Santo)","state_id":6},
{"id":7562,"description":"Castelinho (Frederico Westphalen)","state_id":23},
{"id":1845,"description":"Castelo","state_id":8},
{"id":512,"description":"Castelo Novo (Ilhéus)","state_id":5},
{"id":5561,"description":"Castelo do Piauí","state_id":17},
{"id":4606,"description":"Castelo dos Sonhos (Altamira)","state_id":14},
{"id":2123,"description":"Castelândia","state_id":9},
{"id":9051,"description":"Castilho","state_id":26},
{"id":2124,"description":"Castrinópolis (Rianápolis)","state_id":9},
{"id":5942,"description":"Castro","state_id":18},
{"id":513,"description":"Castro Alves","state_id":5},
{"id":2908,"description":"Cataguarino (Cataguases)","state_id":11},
{"id":2909,"description":"Cataguases","state_id":11},
{"id":2910,"description":"Catajás (Santo Antônio do Jacinto)","state_id":11},
{"id":2125,"description":"Catalão","state_id":9},
{"id":9052,"description":"Catanduva","state_id":26},
{"id":12443,"description":"Catanduva Grande","state_id":23},
{"id":5943,"description":"Catanduvas","state_id":18},
{"id":8412,"description":"Catanduvas","state_id":24},
{"id":5944,"description":"Catanduvas (Castro)","state_id":18},
{"id":5945,"description":"Catanduvas do Sul (Contenda)","state_id":18},
{"id":1280,"description":"Catarina","state_id":6},
{"id":5946,"description":"Catarinenses (Paranavaí)","state_id":18},
{"id":2911,"description":"Catas Altas","state_id":11},
{"id":2912,"description":"Catas Altas da Noruega","state_id":11},
{"id":5218,"description":"Catende","state_id":16},
{"id":2913,"description":"Catiara (Serra do Salitre)","state_id":11},
{"id":9053,"description":"Catiguá","state_id":26},
{"id":11881,"description":"Catimbau","state_id":23},
{"id":5219,"description":"Catimbaú (Buíque)","state_id":16},
{"id":514,"description":"Catinga do Moura (Jacobina)","state_id":5},
{"id":515,"description":"Catingal (Manoel Vitorino)","state_id":5},
{"id":4914,"description":"Catingueira","state_id":15},
{"id":518,"description":"Catolezinho (Itambé)","state_id":5},
{"id":516,"description":"Catolândia","state_id":5},
{"id":4915,"description":"Catolé (Campina Grande)","state_id":15},
{"id":5220,"description":"Catolé (Casinhas)","state_id":16},
{"id":1281,"description":"Catolé (Mombaça)","state_id":6},
{"id":11540,"description":"Catolé Da Pista","state_id":6},
{"id":4916,"description":"Catolé do Rocha","state_id":15},
{"id":517,"description":"Catolés (Abaíra)","state_id":5},
{"id":519,"description":"Catu","state_id":5},
{"id":520,"description":"Catu de Abrantes (Camaçari)","state_id":5},
{"id":4330,"description":"Catuai (São José do Rio Claro)","state_id":13},
{"id":1282,"description":"Catuana (Caucaia)","state_id":6},
{"id":9054,"description":"Catucaba (São Luiz do Paraitinga)","state_id":26},
{"id":2914,"description":"Catuji","state_id":11},
{"id":1283,"description":"Catunda","state_id":6},
{"id":2916,"description":"Catuni (Francisco Sá)","state_id":11},
{"id":2915,"description":"Catuné (Tombos)","state_id":11},
{"id":521,"description":"Caturama","state_id":5},
{"id":2126,"description":"Caturaí","state_id":9},
{"id":4917,"description":"Caturité","state_id":15},
{"id":2917,"description":"Catuti","state_id":11},
{"id":7563,"description":"Catuípe","state_id":23},
{"id":8413,"description":"Catuíra (Alfredo Wagner)","state_id":24},
{"id":1284,"description":"Caucaia","state_id":6},
{"id":9055,"description":"Caucaia do Alto (Cotia)","state_id":26},
{"id":6890,"description":"Cava (Nova Iguaçu)","state_id":19},
{"id":7564,"description":"Cavajureta (São Vicente do Sul)","state_id":23},
{"id":2127,"description":"Cavalcante","state_id":9},
{"id":10185,"description":"Cavaleiro (Jaboatão dos Guararapes)","state_id":16},
{"id":2128,"description":"Cavalheiro (Ipameri)","state_id":9},
{"id":11708,"description":"Cavalo Ruço De Deus","state_id":16},
{"id":7565,"description":"Caverá (Rosário do Sul)","state_id":23},
{"id":11766,"description":"Caviana","state_id":3},
{"id":522,"description":"Cavunge (Ipecaetá)","state_id":5},
{"id":2918,"description":"Caxambu","state_id":11},
{"id":5947,"description":"Caxambu (Castro)","state_id":18},
{"id":8414,"description":"Caxambu do Sul","state_id":24},
{"id":2430,"description":"Caxias","state_id":10},
{"id":7566,"description":"Caxias do Sul","state_id":23},
{"id":5562,"description":"Caxingó","state_id":17},
{"id":1285,"description":"Caxitoré (Tejuçuoca)","state_id":6},
{"id":1286,"description":"Caxitoré (Umirim)","state_id":6},
{"id":7567,"description":"Cazuza Ferreira (Jaquirana)","state_id":23},
{"id":8391,"description":"Caçador","state_id":24},
{"id":9005,"description":"Caçapava","state_id":26},
{"id":7499,"description":"Caçapava do Sul","state_id":23},
{"id":2818,"description":"Caçaratiba (Turmalina)","state_id":11},
{"id":2819,"description":"Caçarema (Capitão Enéas)","state_id":11},
{"id":2103,"description":"Caçu","state_id":9},
{"id":458,"description":"Caém","state_id":5},
{"id":7155,"description":"Ceará-Mirim","state_id":20},
{"id":2129,"description":"Cebrasa (Anápolis)","state_id":9},
{"id":2431,"description":"Cedral","state_id":10},
{"id":9056,"description":"Cedral","state_id":26},
{"id":1287,"description":"Cedro","state_id":6},
{"id":11984,"description":"Cedro","state_id":18},
{"id":5222,"description":"Cedro","state_id":16},
{"id":10121,"description":"Cedro (Chorozinho)","state_id":6},
{"id":8415,"description":"Cedro Alto (Rio dos Cedros)","state_id":24},
{"id":7568,"description":"Cedro Marcado (Tenente Portela)","state_id":23},
{"id":8784,"description":"Cedro de São João","state_id":25},
{"id":2919,"description":"Cedro do Abaeté","state_id":11},
{"id":1781,"description":"Ceilândia","state_id":7},
{"id":1846,"description":"Celina (Alegre)","state_id":8},
{"id":8416,"description":"Celso Ramos","state_id":24},
{"id":1288,"description":"Cemoaba (Tururu)","state_id":6},
{"id":7569,"description":"Centenário","state_id":23},
{"id":9832,"description":"Centenário","state_id":27},
{"id":2920,"description":"Centenário (Mutum)","state_id":11},
{"id":7570,"description":"Centenário (Palmeira das Missões)","state_id":23},
{"id":5948,"description":"Centenário (Ponta Grossa)","state_id":18},
{"id":5949,"description":"Centenário do Sul","state_id":18},
{"id":523,"description":"Central","state_id":5},
{"id":5950,"description":"Central Lupion (Cascavel)","state_id":18},
{"id":2921,"description":"Central de Minas","state_id":11},
{"id":2922,"description":"Central de Santa Helena (Divino das Laranjeiras)","state_id":11},
{"id":2432,"description":"Central do Maranhão","state_id":10},
{"id":2923,"description":"Centralina","state_id":11},
{"id":5951,"description":"Centralito (Cascavel)","state_id":18},
{"id":7571,"description":"Centro Linha Brasil (Venâncio Aires)","state_id":23},
{"id":5952,"description":"Centro Novo (Planalto)","state_id":18},
{"id":2434,"description":"Centro Novo do Maranhão","state_id":10},
{"id":2433,"description":"Centro do Guilherme","state_id":10},
{"id":4918,"description":"Cepilho (Areia)","state_id":15},
{"id":524,"description":"Ceraima (Guanambi)","state_id":5},
{"id":12012,"description":"Cercadinho","state_id":5},
{"id":7324,"description":"Cerejeiras","state_id":21},
{"id":2130,"description":"Ceres","state_id":9},
{"id":5953,"description":"Cerne (Campo Largo)","state_id":18},
{"id":9057,"description":"Cerqueira César","state_id":26},
{"id":9058,"description":"Cerquilho","state_id":26},
{"id":5954,"description":"Cerrado Grande (Ponta Grossa)","state_id":18},
{"id":7572,"description":"Cerrito","state_id":23},
{"id":7573,"description":"Cerrito Alegre (Pelotas)","state_id":23},
{"id":7574,"description":"Cerrito do Ouro ou Vila do Cerrito (São Sepé)","state_id":23},
{"id":12308,"description":"Cerro Alegre Baixo","state_id":23},
{"id":7575,"description":"Cerro Alto (Tuparendi)","state_id":23},
{"id":12648,"description":"Cerro Azul","state_id":23},
{"id":5955,"description":"Cerro Azul","state_id":18},
{"id":7576,"description":"Cerro Branco","state_id":23},
{"id":12499,"description":"Cerro Chato","state_id":23},
{"id":7577,"description":"Cerro Claro (São Pedro do Sul)","state_id":23},
{"id":7156,"description":"Cerro Corá","state_id":20},
{"id":7580,"description":"Cerro Grande","state_id":23},
{"id":7581,"description":"Cerro Grande do Sul","state_id":23},
{"id":7582,"description":"Cerro Largo","state_id":23},
{"id":8417,"description":"Cerro Negro","state_id":24},
{"id":12514,"description":"Cerro Partido","state_id":23},
{"id":12619,"description":"Cerro Preto","state_id":23},
{"id":5956,"description":"Cerro Velho (Ponta Grossa)","state_id":18},
{"id":7578,"description":"Cerro do Martins (Caçapava do Sul)","state_id":23},
{"id":7579,"description":"Cerro do Roque (Butiá)","state_id":23},
{"id":2924,"description":"Cervo (Borda da Mata)","state_id":11},
{"id":9059,"description":"Cesário Lange","state_id":26},
{"id":9060,"description":"Cezar de Souza (Mogi das Cruzes)","state_id":26},
{"id":2131,"description":"Cezarina","state_id":9},
{"id":2926,"description":"Chalé","state_id":11},
{"id":7583,"description":"Chapada","state_id":23},
{"id":7584,"description":"Chapada (Jaquirana)","state_id":23},
{"id":2929,"description":"Chapada Gaúcha","state_id":11},
{"id":9834,"description":"Chapada da Natividade","state_id":27},
{"id":9833,"description":"Chapada de Areia","state_id":27},
{"id":2927,"description":"Chapada de Minas (Estrela do Sul)","state_id":11},
{"id":2928,"description":"Chapada do Norte","state_id":11},
{"id":4331,"description":"Chapada dos Guimarães","state_id":13},
{"id":2435,"description":"Chapadinha","state_id":10},
{"id":2132,"description":"Chapadão do Céu","state_id":9},
{"id":8418,"description":"Chapadão do Lageado","state_id":24},
{"id":4146,"description":"Chapadão do Sul","state_id":12},
{"id":8419,"description":"Chapecó","state_id":24},
{"id":11085,"description":"Chapéu D'Uvas","state_id":11},
{"id":11343,"description":"Charco","state_id":18},
{"id":9061,"description":"Charqueada","state_id":26},
{"id":7585,"description":"Charqueadas","state_id":23},
{"id":7586,"description":"Charrua","state_id":23},
{"id":1289,"description":"Chaval","state_id":6},
{"id":9062,"description":"Chavantes","state_id":26},
{"id":4607,"description":"Chaves","state_id":14},
{"id":11346,"description":"Chaves","state_id":11},
{"id":2930,"description":"Chaveslândia (Santa Vitória)","state_id":11},
{"id":2931,"description":"Chiador","state_id":11},
{"id":7587,"description":"Chiapetta","state_id":23},
{"id":7588,"description":"Chicolomã (Santo Antônio da Patrulha)","state_id":23},
{"id":12217,"description":"Chile","state_id":6},
{"id":7589,"description":"Chimarrão (André da Rocha)","state_id":23},
{"id":2932,"description":"Chonim (Governador Valadares)","state_id":11},
{"id":10205,"description":"Chonin de Baixo (Governador Valadares)","state_id":11},
{"id":5958,"description":"Chopinzinho","state_id":18},
{"id":1291,"description":"Chorozinho","state_id":6},
{"id":525,"description":"Chorrochó","state_id":5},
{"id":7590,"description":"Chorão (Ijuí)","state_id":23},
{"id":1290,"description":"Choró","state_id":6},
{"id":2133,"description":"Choupana (Anicuns)","state_id":9},
{"id":2933,"description":"Chumbo (Patos de Minas)","state_id":11},
{"id":7325,"description":"Chupinguaia","state_id":21},
{"id":7592,"description":"Chuvisca","state_id":23},
{"id":7591,"description":"Chuí","state_id":23},
{"id":2925,"description":"Chácara","state_id":11},
{"id":11802,"description":"Chã De Cruz","state_id":16},
{"id":5225,"description":"Chã Grande","state_id":16},
{"id":67,"description":"Chã Preta","state_id":2},
{"id":5223,"description":"Chã de Alegria","state_id":16},
{"id":5224,"description":"Chã do Rocha (Orobó)","state_id":16},
{"id":5959,"description":"Cianorte","state_id":18},
{"id":2134,"description":"Cibele (Itapuranga)","state_id":9},
{"id":5960,"description":"Cidade Gaúcha","state_id":18},
{"id":4332,"description":"Cidade Morena (Aripuanã)","state_id":13},
{"id":2135,"description":"Cidade Ocidental","state_id":9},
{"id":2436,"description":"Cidelândia","state_id":10},
{"id":7593,"description":"Cidreira","state_id":23},
{"id":5226,"description":"Cimbres (Pesqueira)","state_id":16},
{"id":12420,"description":"Cinco Da Boa Vista","state_id":23},
{"id":527,"description":"Cinco Rios (São Sebastião do Passe)","state_id":5},
{"id":7594,"description":"Cinqüentenário (Tuparendi)","state_id":23},
{"id":5961,"description":"Cintra Pimentel (Nova Londrina)","state_id":18},
{"id":4147,"description":"Cipolândia (Aquidauana)","state_id":12},
{"id":2934,"description":"Cipotânea","state_id":11},
{"id":528,"description":"Cipó","state_id":5},
{"id":1292,"description":"Cipó dos Anjos (Quixadá)","state_id":6},
{"id":9063,"description":"Cipó-Guaçu (Embu-Guaçu)","state_id":26},
{"id":2136,"description":"Cirilândia (Santa Isabel)","state_id":9},
{"id":7595,"description":"Ciríaco","state_id":23},
{"id":2935,"description":"Cisneiros (Palma)","state_id":11},
{"id":2936,"description":"Citrolândia (Betim)","state_id":11},
{"id":7596,"description":"Clara (Mata)","state_id":23},
{"id":5227,"description":"Clarana (Bodocó)","state_id":16},
{"id":2937,"description":"Claraval","state_id":11},
{"id":8420,"description":"Claraíba (Nova Trento)","state_id":24},
{"id":9064,"description":"Clarinia (Santa Cruz do Rio Pardo)","state_id":26},
{"id":2938,"description":"Claro de Minas (Vazante)","state_id":11},
{"id":2939,"description":"Claro dos Poções","state_id":11},
{"id":12222,"description":"Claudinápolis","state_id":9},
{"id":7597,"description":"Clemente Argolo (Lagoa Vermelha)","state_id":23},
{"id":9065,"description":"Clementina","state_id":26},
{"id":5962,"description":"Clevelândia","state_id":18},
{"id":290,"description":"Clevelândia do Norte (Oiapoque)","state_id":4},
{"id":4333,"description":"Cláudia","state_id":13},
{"id":2940,"description":"Cláudio","state_id":11},
{"id":2941,"description":"Cláudio Manuel (Mariana)","state_id":11},
{"id":529,"description":"Coaraci","state_id":5},
{"id":219,"description":"Coari","state_id":3},
{"id":9066,"description":"Cocaes (Sarapuí)","state_id":26},
{"id":2942,"description":"Cocais (Barão de Cocais)","state_id":11},
{"id":5563,"description":"Cocal","state_id":17},
{"id":5564,"description":"Cocal de Telha","state_id":17},
{"id":8421,"description":"Cocal do Sul","state_id":24},
{"id":5565,"description":"Cocal dos Alves","state_id":17},
{"id":4334,"description":"Cocalinho","state_id":13},
{"id":9836,"description":"Cocalinho (Araguaína)","state_id":27},
{"id":2137,"description":"Cocalzinho de Goiás","state_id":9},
{"id":9835,"description":"Cocalândia (Araguaína)","state_id":27},
{"id":5228,"description":"Cocau (Bodocó)","state_id":16},
{"id":5229,"description":"Cocau (Rio Formoso)","state_id":16},
{"id":2943,"description":"Coco (Moeda)","state_id":11},
{"id":1293,"description":"Cococi (Parambu)","state_id":6},
{"id":530,"description":"Cocos","state_id":5},
{"id":220,"description":"Codajás","state_id":3},
{"id":1294,"description":"Codiá (Senador Pompeu)","state_id":6},
{"id":2438,"description":"Codozinho (Codó)","state_id":10},
{"id":2437,"description":"Codó","state_id":10},
{"id":2439,"description":"Coelho Neto","state_id":10},
{"id":6891,"description":"Coelho da Rocha (São João de Meriti)","state_id":19},
{"id":2944,"description":"Coimbra","state_id":11},
{"id":4148,"description":"Coimbra (Corumbá)","state_id":12},
{"id":7598,"description":"Coimbra (São Miguel das Missões)","state_id":23},
{"id":5963,"description":"Coitinho (Guarapuava)","state_id":18},
{"id":11541,"description":"Coité","state_id":6},
{"id":1295,"description":"Coité (Mauriti)","state_id":6},
{"id":68,"description":"Coité do Nóia","state_id":2},
{"id":5566,"description":"Coivaras","state_id":17},
{"id":4608,"description":"Colares","state_id":14},
{"id":1847,"description":"Colatina","state_id":8},
{"id":4335,"description":"Colider","state_id":13},
{"id":9067,"description":"Colina","state_id":26},
{"id":1296,"description":"Colina (Pacoti)","state_id":6},
{"id":7599,"description":"Colinas","state_id":23},
{"id":2440,"description":"Colinas","state_id":10},
{"id":2138,"description":"Colinas do Sul","state_id":9},
{"id":9837,"description":"Colinas do Tocantins","state_id":27},
{"id":9838,"description":"Colméia","state_id":27},
{"id":10092,"description":"Colniza","state_id":13},
{"id":5964,"description":"Colombo","state_id":18},
{"id":12611,"description":"Colombo","state_id":23},
{"id":7606,"description":"Coloninha (Arroio do Tigre)","state_id":23},
{"id":5983,"description":"Colorado","state_id":18},
{"id":7607,"description":"Colorado","state_id":23},
{"id":4336,"description":"Colorado do Norte (Nova Canãa do Norte)","state_id":13},
{"id":7326,"description":"Colorado do Oeste","state_id":21},
{"id":2945,"description":"Coluna","state_id":11},
{"id":9068,"description":"Colômbia","state_id":26},
{"id":531,"description":"Colônia (Eunápolis)","state_id":5},
{"id":6892,"description":"Colônia (São Fidélis)","state_id":19},
{"id":5965,"description":"Colônia Acioli (São José dos Pinhais)","state_id":18},
{"id":5966,"description":"Colônia Castelhanos (São José dos Pinhais)","state_id":18},
{"id":5967,"description":"Colônia Castrolânda (Castro)","state_id":18},
{"id":5968,"description":"Colônia Centenário (Cascavel)","state_id":18},
{"id":5969,"description":"Colônia Cristina (Araucária)","state_id":18},
{"id":5970,"description":"Colônia Dom Carlos (Pato Branco)","state_id":18},
{"id":5971,"description":"Colônia Esperança (Cascavel)","state_id":18},
{"id":5972,"description":"Colônia General Carneiro (General Carneiro)","state_id":18},
{"id":5973,"description":"Colônia Iapó (Castro)","state_id":18},
{"id":69,"description":"Colônia Leopoldina","state_id":2},
{"id":12223,"description":"Colônia Malhada","state_id":18},
{"id":7601,"description":"Colônia Medeiros (Independência)","state_id":23},
{"id":5974,"description":"Colônia Melissa (Cascavel)","state_id":18},
{"id":7602,"description":"Colônia Municipal (Santo Ângelo)","state_id":23},
{"id":5975,"description":"Colônia Murici (São José dos Pinhais)","state_id":18},
{"id":7603,"description":"Colônia Nova (Bagé)","state_id":23},
{"id":5976,"description":"Colônia Padre Paulo (Agudos do Sul)","state_id":18},
{"id":5977,"description":"Colônia Pereira (Paranaguá)","state_id":18},
{"id":8422,"description":"Colônia Santa Tereza (São José)","state_id":24},
{"id":5978,"description":"Colônia Santos Andrade (São José dos Pinhais)","state_id":18},
{"id":5980,"description":"Colônia Sapucaí (Cascavel)","state_id":18},
{"id":5981,"description":"Colônia Saúde (Londrina)","state_id":18},
{"id":5979,"description":"Colônia São José (Cascavel)","state_id":18},
{"id":7604,"description":"Colônia São João (Cruz Alta)","state_id":23},
{"id":5982,"description":"Colônia Tapera (Ponta Grossa)","state_id":18},
{"id":7605,"description":"Colônia Z-3 (Pelotas)","state_id":23},
{"id":7600,"description":"Colônia das Almas (Catuípe)","state_id":23},
{"id":5567,"description":"Colônia do Gurguéia","state_id":17},
{"id":5568,"description":"Colônia do Piauí","state_id":17},
{"id":7608,"description":"Comandai (Santo Ângelo)","state_id":23},
{"id":9839,"description":"Combinado","state_id":27},
{"id":2946,"description":"Comendador Gomes","state_id":11},
{"id":6893,"description":"Comendador Levy Gasparian","state_id":19},
{"id":6894,"description":"Comendador Venâncio (Itaperuna)","state_id":19},
{"id":2947,"description":"Comercinho","state_id":11},
{"id":4337,"description":"Comodoro","state_id":13},
{"id":11473,"description":"Comunidade Parque Boa Vista","state_id":13},
{"id":5984,"description":"Comur (Planaltina do Paraná)","state_id":18},
{"id":532,"description":"Comércio (Conceição do Almeida)","state_id":5},
{"id":4919,"description":"Conceição","state_id":15},
{"id":11239,"description":"Conceição","state_id":26},
{"id":11940,"description":"Conceição","state_id":6},
{"id":5986,"description":"Conceição (Castro)","state_id":18},
{"id":1297,"description":"Conceição (Hidrolândia)","state_id":6},
{"id":4609,"description":"Conceição (Paragominas)","state_id":14},
{"id":2948,"description":"Conceição da Aparecida","state_id":11},
{"id":1848,"description":"Conceição da Barra","state_id":8},
{"id":2949,"description":"Conceição da Barra de Minas","state_id":11},
{"id":2950,"description":"Conceição da Boa Vista (Recreio)","state_id":11},
{"id":2951,"description":"Conceição da Brejaúba (Gonzaga)","state_id":11},
{"id":533,"description":"Conceição da Feira","state_id":5},
{"id":2952,"description":"Conceição da Ibitipoca (Lima Duarte)","state_id":11},
{"id":2953,"description":"Conceição das Alagoas","state_id":11},
{"id":5230,"description":"Conceição das Crioulas (Salgueiro)","state_id":16},
{"id":2954,"description":"Conceição das Pedras","state_id":11},
{"id":2955,"description":"Conceição de Ipanema","state_id":11},
{"id":2956,"description":"Conceição de Itaguá (Brumadinho)","state_id":11},
{"id":6895,"description":"Conceição de Jacareí (Mangaratiba)","state_id":19},
{"id":6896,"description":"Conceição de Macabu","state_id":19},
{"id":2957,"description":"Conceição de Minas (Dionísio)","state_id":11},
{"id":9069,"description":"Conceição de Monte Alegre (Paraguaçu Paulista)","state_id":26},
{"id":2958,"description":"Conceição de Piracicaba (Rio Piracicaba)","state_id":11},
{"id":2959,"description":"Conceição de Tronqueiras (Coroaci)","state_id":11},
{"id":534,"description":"Conceição do Almeida","state_id":5},
{"id":4610,"description":"Conceição do Araguaia","state_id":14},
{"id":5569,"description":"Conceição do Canindé","state_id":17},
{"id":2960,"description":"Conceição do Capim (Aimorés)","state_id":11},
{"id":1849,"description":"Conceição do Castelo","state_id":8},
{"id":535,"description":"Conceição do Coité","state_id":5},
{"id":2961,"description":"Conceição do Formoso (Santos Dumont)","state_id":11},
{"id":536,"description":"Conceição do Jacuípe","state_id":5},
{"id":2441,"description":"Conceição do Lago-Açu","state_id":10},
{"id":2962,"description":"Conceição do Mato Dentro","state_id":11},
{"id":1850,"description":"Conceição do Muqui (Mimoso do Sul)","state_id":8},
{"id":2963,"description":"Conceição do Pará","state_id":11},
{"id":2964,"description":"Conceição do Rio Acima (Santa Bárbara)","state_id":11},
{"id":2965,"description":"Conceição do Rio Verde","state_id":11},
{"id":9840,"description":"Conceição do Tocantins","state_id":27},
{"id":2966,"description":"Conceição dos Ouros","state_id":11},
{"id":9070,"description":"Conchal","state_id":26},
{"id":9071,"description":"Conchas","state_id":26},
{"id":5987,"description":"Conchas Velhas (Ponta Grossa)","state_id":18},
{"id":5988,"description":"Conciolândia (Pérola d'Oeste)","state_id":18},
{"id":8424,"description":"Concórdia","state_id":24},
{"id":2967,"description":"Concórdia de Mucuri (Ladainha)","state_id":11},
{"id":4611,"description":"Concórdia do Pará","state_id":14},
{"id":5231,"description":"Condado","state_id":16},
{"id":4920,"description":"Condado","state_id":15},
{"id":2968,"description":"Condado do Norte (São João da Ponte)","state_id":11},
{"id":537,"description":"Conde","state_id":5},
{"id":4921,"description":"Conde","state_id":15},
{"id":4612,"description":"Condeixa (Salvaterra)","state_id":14},
{"id":538,"description":"Condeúba","state_id":5},
{"id":7609,"description":"Condor","state_id":23},
{"id":1851,"description":"Conduru (Cachoeiro de Itapemirim)","state_id":8},
{"id":2971,"description":"Confins","state_id":11},
{"id":4338,"description":"Confresa","state_id":13},
{"id":4922,"description":"Congo","state_id":15},
{"id":2972,"description":"Congonhal","state_id":11},
{"id":2973,"description":"Congonhas","state_id":11},
{"id":4149,"description":"Congonhas (Bandeirantes)","state_id":12},
{"id":5989,"description":"Congonhas (Cornélio Procópio)","state_id":18},
{"id":2974,"description":"Congonhas do Norte","state_id":11},
{"id":5990,"description":"Congonhinhas","state_id":18},
{"id":2975,"description":"Conquista","state_id":11},
{"id":10091,"description":"Conquista D'Oeste","state_id":13},
{"id":6897,"description":"Conrado (Miguel Pereira)","state_id":19},
{"id":2976,"description":"Conselheiro Lafaiete","state_id":11},
{"id":5991,"description":"Conselheiro Mairinck","state_id":18},
{"id":2977,"description":"Conselheiro Mata (Diamantina)","state_id":11},
{"id":6898,"description":"Conselheiro Paulino (Nova Friburgo)","state_id":19},
{"id":2978,"description":"Conselheiro Pena","state_id":11},
{"id":5992,"description":"Conselheiro Zacarias (Santo Antônio da Platina)","state_id":18},
{"id":6899,"description":"Conservatória (Valença)","state_id":19},
{"id":7610,"description":"Consolata (Três de Maio)","state_id":23},
{"id":2979,"description":"Consolação","state_id":11},
{"id":7611,"description":"Constantina","state_id":23},
{"id":12482,"description":"Constantino","state_id":23},
{"id":2980,"description":"Contagem","state_id":11},
{"id":5993,"description":"Contenda","state_id":18},
{"id":539,"description":"Contendas do Sincorá","state_id":5},
{"id":2981,"description":"Contrato (Itamarandiba)","state_id":11},
{"id":2982,"description":"Contria (Corinto)","state_id":11},
{"id":5994,"description":"Copacabana do Norte (São Jorge do Ivaí)","state_id":18},
{"id":540,"description":"Copixaba (Xique-Xique)","state_id":5},
{"id":2983,"description":"Coqueiral","state_id":11},
{"id":1852,"description":"Coqueiral (Aracruz)","state_id":8},
{"id":4613,"description":"Coqueiro (Ananindeua)","state_id":14},
{"id":7612,"description":"Coqueiro Baixo","state_id":23},
{"id":70,"description":"Coqueiro Seco","state_id":2},
{"id":541,"description":"Coqueiros (Maragogipe)","state_id":5},
{"id":7613,"description":"Coqueiros do Sul","state_id":23},
{"id":542,"description":"Coquinhos (Anagé)","state_id":5},
{"id":2984,"description":"Coração de Jesus","state_id":11},
{"id":543,"description":"Coração de Maria","state_id":5},
{"id":5995,"description":"Corbélia","state_id":18},
{"id":6900,"description":"Cordeiro","state_id":19},
{"id":12492,"description":"Cordeiro","state_id":23},
{"id":11989,"description":"Cordeiro De Minas","state_id":11},
{"id":544,"description":"Cordeiros","state_id":5},
{"id":9072,"description":"Cordeirópolis","state_id":26},
{"id":7614,"description":"Cordilheira (Cachoeira do Sul)","state_id":23},
{"id":8425,"description":"Cordilheira Alta","state_id":24},
{"id":2985,"description":"Cordisburgo","state_id":11},
{"id":2986,"description":"Cordislândia","state_id":11},
{"id":1298,"description":"Coreaú","state_id":6},
{"id":4923,"description":"Coremas","state_id":15},
{"id":4150,"description":"Corguinho","state_id":12},
{"id":545,"description":"Coribe","state_id":5},
{"id":2987,"description":"Corinto","state_id":11},
{"id":5996,"description":"Cornélio Procópio","state_id":18},
{"id":6901,"description":"Coroa Grande (Itaguaí)","state_id":19},
{"id":2988,"description":"Coroaci","state_id":11},
{"id":9073,"description":"Coroados","state_id":26},
{"id":7615,"description":"Coroados (São Valério do Sul)","state_id":23},
{"id":2442,"description":"Coroatá","state_id":10},
{"id":2989,"description":"Coromandel","state_id":11},
{"id":7616,"description":"Coronel Barros","state_id":23},
{"id":7617,"description":"Coronel Bicaco","state_id":23},
{"id":5997,"description":"Coronel Domingos Soares","state_id":18},
{"id":7157,"description":"Coronel Ezequiel","state_id":20},
{"id":2990,"description":"Coronel Fabriciano","state_id":11},
{"id":7618,"description":"Coronel Finzito (Erval Seco)","state_id":23},
{"id":5998,"description":"Coronel Firmino Martins (Clevelândia)","state_id":18},
{"id":8426,"description":"Coronel Freitas","state_id":24},
{"id":9074,"description":"Coronel Goulart (Álvares Machado)","state_id":26},
{"id":5570,"description":"Coronel José Dias","state_id":17},
{"id":7158,"description":"Coronel João Pessoa","state_id":20},
{"id":546,"description":"Coronel João Sá","state_id":5},
{"id":9075,"description":"Coronel Macedo","state_id":26},
{"id":4924,"description":"Coronel Maia (Catolé do Rocha)","state_id":15},
{"id":8427,"description":"Coronel Martins","state_id":24},
{"id":2991,"description":"Coronel Murta","state_id":11},
{"id":2992,"description":"Coronel Pacheco","state_id":11},
{"id":7619,"description":"Coronel Pilar","state_id":23},
{"id":4339,"description":"Coronel Ponce (Campo Verde)","state_id":13},
{"id":12509,"description":"Coronel Prestes","state_id":23},
{"id":4151,"description":"Coronel Sapucaia","state_id":12},
{"id":7620,"description":"Coronel Teixeira (Marcelino Ramos)","state_id":23},
{"id":5999,"description":"Coronel Vivida","state_id":18},
{"id":2993,"description":"Coronel Xavier Chaves","state_id":11},
{"id":291,"description":"Corre Água (Macapá)","state_id":4},
{"id":6902,"description":"Correas (Petrópolis)","state_id":19},
{"id":9076,"description":"Corredeira (Pirajuí)","state_id":26},
{"id":8428,"description":"Correia Pinto","state_id":24},
{"id":3001,"description":"Correia de Almeida (Barbacena)","state_id":11},
{"id":6000,"description":"Correia de Freitas (Apucarana)","state_id":18},
{"id":9841,"description":"Correinha (Araguaína)","state_id":27},
{"id":5571,"description":"Corrente","state_id":17},
{"id":12245,"description":"Corrente","state_id":6},
{"id":5232,"description":"Correntes","state_id":16},
{"id":6905,"description":"Correntezas (Silva Jardim)","state_id":19},
{"id":547,"description":"Correntina","state_id":5},
{"id":3002,"description":"Correntinho (Guanhães)","state_id":11},
{"id":548,"description":"Corta Mão (Amargosa)","state_id":5},
{"id":7621,"description":"Cortado (Novo Cabrais)","state_id":23},
{"id":5233,"description":"Cortês","state_id":16},
{"id":9078,"description":"Corumbataí","state_id":26},
{"id":6001,"description":"Corumbataí do Sul","state_id":18},
{"id":2142,"description":"Corumbaíba","state_id":9},
{"id":7327,"description":"Corumbiara","state_id":21},
{"id":4152,"description":"Corumbá","state_id":12},
{"id":2141,"description":"Corumbá de Goiás","state_id":9},
{"id":8429,"description":"Corupá","state_id":24},
{"id":71,"description":"Coruripe","state_id":2},
{"id":72,"description":"Coruripe da Cal (Palmeira dos Índios)","state_id":2},
{"id":6002,"description":"Corvo (Guarapuava)","state_id":18},
{"id":9080,"description":"Cosmorama","state_id":26},
{"id":9079,"description":"Cosmópolis","state_id":26},
{"id":9081,"description":"Costa Machado (Mirante do Paranapanema)","state_id":26},
{"id":7328,"description":"Costa Marques","state_id":21},
{"id":4153,"description":"Costa Rica","state_id":12},
{"id":3003,"description":"Costa Sena (Conceição do Mato Dentro)","state_id":11},
{"id":7622,"description":"Costa da Cadeia (Triunfo)","state_id":23},
{"id":3004,"description":"Costas (Paraisópolis)","state_id":11},
{"id":3005,"description":"Costas da Mantiqueira (Barbacena)","state_id":11},
{"id":6003,"description":"Costeira (Araucária)","state_id":18},
{"id":7623,"description":"Costão (Estrela)","state_id":23},
{"id":1854,"description":"Cotaxe (Ecoporanga)","state_id":8},
{"id":549,"description":"Cotegipe","state_id":5},
{"id":9082,"description":"Cotia","state_id":26},
{"id":7624,"description":"Cotiporã","state_id":23},
{"id":4340,"description":"Cotrel (Guarantã do Norte)","state_id":13},
{"id":4341,"description":"Cotriguaçu","state_id":13},
{"id":5234,"description":"Couro D'Antas (Riacho das Almas)","state_id":16},
{"id":9842,"description":"Couto de Magalhães","state_id":27},
{"id":3006,"description":"Couto de Magalhães de Minas","state_id":11},
{"id":550,"description":"Coutos (Ilhéus)","state_id":5},
{"id":6004,"description":"Covó (Mangueirinha)","state_id":18},
{"id":7625,"description":"Coxilha","state_id":23},
{"id":12497,"description":"Coxilha Do Lageado","state_id":23},
{"id":7626,"description":"Coxilha Grande (Vacaria)","state_id":23},
{"id":6005,"description":"Coxilha Rica (Itapejara d'Oeste)","state_id":18},
{"id":12645,"description":"Coxilha Seca","state_id":23},
{"id":4154,"description":"Coxim","state_id":12},
{"id":4342,"description":"Coxipó Açu (Cuiabá)","state_id":13},
{"id":4343,"description":"Coxipó da Ponte (Cuiabá)","state_id":13},
{"id":4344,"description":"Coxipó do Ouro (Cuiabá)","state_id":13},
{"id":4925,"description":"Coxixola","state_id":15},
{"id":7627,"description":"Cr-1 (Palmares do Sul)","state_id":23},
{"id":9843,"description":"Craolândia (Goiatins)","state_id":27},
{"id":1300,"description":"Crateús","state_id":6},
{"id":1301,"description":"Crato","state_id":6},
{"id":9083,"description":"Cravinhos","state_id":26},
{"id":551,"description":"Cravolândia","state_id":5},
{"id":73,"description":"Craíbas","state_id":2},
{"id":8430,"description":"Criciúma","state_id":24},
{"id":1302,"description":"Crioulos (Pereiro)","state_id":6},
{"id":4615,"description":"Cripurizinho (Itaituba)","state_id":14},
{"id":4614,"description":"Cripurizão (Itaituba)","state_id":14},
{"id":3009,"description":"Crispim Jaques (Teófilo Otoni)","state_id":11},
{"id":7628,"description":"Crissiumal","state_id":23},
{"id":3010,"description":"Cristais","state_id":11},
{"id":1303,"description":"Cristais (Cascavel)","state_id":6},
{"id":9084,"description":"Cristais Paulista","state_id":26},
{"id":7629,"description":"Cristal","state_id":23},
{"id":1855,"description":"Cristal do Norte (Pedro Canário)","state_id":8},
{"id":7630,"description":"Cristal do Sul","state_id":23},
{"id":2143,"description":"Cristalina","state_id":9},
{"id":4155,"description":"Cristalina (Caarapó)","state_id":12},
{"id":9844,"description":"Cristalândia","state_id":27},
{"id":553,"description":"Cristalândia (Brumado)","state_id":5},
{"id":5572,"description":"Cristalândia do Piauí","state_id":17},
{"id":3012,"description":"Cristiano Otoni","state_id":11},
{"id":2144,"description":"Cristianópolis","state_id":9},
{"id":3013,"description":"Cristina","state_id":11},
{"id":5573,"description":"Cristino Castro","state_id":17},
{"id":8785,"description":"Cristinápolis","state_id":25},
{"id":4345,"description":"Cristinópolis (Salto do Céu)","state_id":13},
{"id":6006,"description":"Cristo Rei (Capanema)","state_id":18},
{"id":6007,"description":"Cristo Rei (Paranavaí)","state_id":18},
{"id":4346,"description":"Cristo Rei (Várzea Grande)","state_id":13},
{"id":3011,"description":"Cristália","state_id":11},
{"id":5235,"description":"Cristália (Petrolina)","state_id":16},
{"id":554,"description":"Cristópolis","state_id":5},
{"id":3007,"description":"Crisólia (Ouro Fino)","state_id":11},
{"id":3008,"description":"Crisólita","state_id":11},
{"id":552,"description":"Crisópolis","state_id":5},
{"id":2145,"description":"Crixás","state_id":9},
{"id":9845,"description":"Crixás (Gurupi)","state_id":27},
{"id":9846,"description":"Crixás do Tocantins","state_id":27},
{"id":7631,"description":"Criúva (Caxias do Sul)","state_id":23},
{"id":1304,"description":"Croatá","state_id":6},
{"id":1305,"description":"Croatá (São Gonçalo do Amarante)","state_id":6},
{"id":1306,"description":"Croatá (Varjota)","state_id":6},
{"id":2146,"description":"Cromínia","state_id":9},
{"id":5236,"description":"Cruanji (Timbaúba)","state_id":16},
{"id":1856,"description":"Crubixá (Alfredo Chaves)","state_id":8},
{"id":3014,"description":"Crucilândia","state_id":11},
{"id":555,"description":"Crussaí (Castro Alves)","state_id":5},
{"id":1307,"description":"Cruxati (Itapipoca)","state_id":6},
{"id":1308,"description":"Cruz","state_id":6},
{"id":1309,"description":"Cruz (Itapagé)","state_id":6},
{"id":7632,"description":"Cruz Alta","state_id":23},
{"id":6008,"description":"Cruz Machado","state_id":18},
{"id":556,"description":"Cruz das Almas","state_id":5},
{"id":9085,"description":"Cruz das Posses (Sertãozinho)","state_id":26},
{"id":1310,"description":"Cruz de Pedra (Iguatu)","state_id":6},
{"id":4926,"description":"Cruz do Espírito Santo","state_id":15},
{"id":7633,"description":"Cruzaltense","state_id":23},
{"id":4156,"description":"Cruzaltina (Douradina)","state_id":12},
{"id":12657,"description":"Cruzaltinha","state_id":23},
{"id":1311,"description":"Cruzeirinho (Icó)","state_id":6},
{"id":9087,"description":"Cruzeiro","state_id":26},
{"id":1782,"description":"Cruzeiro","state_id":7},
{"id":7634,"description":"Cruzeiro (Planalto)","state_id":23},
{"id":11736,"description":"Cruzeiro Do Nordeste","state_id":16},
{"id":3015,"description":"Cruzeiro da Fortaleza","state_id":11},
{"id":6009,"description":"Cruzeiro do Iguaçu","state_id":18},
{"id":2147,"description":"Cruzeiro do Norte (Porangatu)","state_id":9},
{"id":6010,"description":"Cruzeiro do Norte (Uraí)","state_id":18},
{"id":6011,"description":"Cruzeiro do Oeste","state_id":18},
{"id":7635,"description":"Cruzeiro do Sul","state_id":23},
{"id":6,"description":"Cruzeiro do Sul","state_id":1},
{"id":6012,"description":"Cruzeiro do Sul","state_id":18},
{"id":3016,"description":"Cruzeiro dos Peixotos (Uberlândia)","state_id":11},
{"id":5237,"description":"Cruzes (Panelas)","state_id":16},
{"id":7160,"description":"Cruzeta","state_id":20},
{"id":11609,"description":"Cruzinha","state_id":11},
{"id":6013,"description":"Cruzmaltina","state_id":18},
{"id":9086,"description":"Cruzália","state_id":26},
{"id":3017,"description":"Cruzília","state_id":11},
{"id":3018,"description":"Cubas (Ferros)","state_id":11},
{"id":4927,"description":"Cubati","state_id":15},
{"id":9088,"description":"Cubatão","state_id":26},
{"id":221,"description":"Cucuí (São Gabriel da Cachoeira)","state_id":3},
{"id":4347,"description":"Cuiabá","state_id":13},
{"id":9089,"description":"Cuiabá Paulista (Mirante do Paranapanema)","state_id":26},
{"id":5238,"description":"Cuiambuca (Gameleira)","state_id":16},
{"id":11159,"description":"Cuieiras","state_id":16},
{"id":4930,"description":"Cuitegi","state_id":15},
{"id":4928,"description":"Cuité","state_id":15},
{"id":3019,"description":"Cuité Velho (Conselheiro Pena)","state_id":11},
{"id":4929,"description":"Cuité de Mamanguape","state_id":15},
{"id":4616,"description":"Cuiú-Cuiú (Itaituba)","state_id":14},
{"id":7329,"description":"Cujubim","state_id":21},
{"id":4157,"description":"Culturama (Fátima do Sul)","state_id":12},
{"id":2148,"description":"Cumari","state_id":9},
{"id":5239,"description":"Cumaru","state_id":16},
{"id":4617,"description":"Cumaru do Norte","state_id":14},
{"id":8786,"description":"Cumbe","state_id":25},
{"id":557,"description":"Cumuruxatiba (Prado)","state_id":5},
{"id":292,"description":"Cunani (Calçoene)","state_id":4},
{"id":1312,"description":"Cuncas (Barro)","state_id":6},
{"id":9090,"description":"Cunha","state_id":26},
{"id":8431,"description":"Cunha Porã","state_id":24},
{"id":6906,"description":"Cunhambebe (Angra dos Reis)","state_id":19},
{"id":558,"description":"Cunhangi (Jaguaripe)","state_id":5},
{"id":6014,"description":"Cunhaporanga (Castro)","state_id":18},
{"id":8432,"description":"Cunhataí","state_id":24},
{"id":3020,"description":"Cuparaque","state_id":11},
{"id":4158,"description":"Cupins (Aparecida do Taboado)","state_id":12},
{"id":5240,"description":"Cupira","state_id":16},
{"id":4931,"description":"Cupissura (Caaporã)","state_id":15},
{"id":1313,"description":"Curatis (Tamboril)","state_id":6},
{"id":559,"description":"Curaçá","state_id":5},
{"id":293,"description":"Curiaú (Macapá)","state_id":4},
{"id":3021,"description":"Curimataí (Buenópolis)","state_id":11},
{"id":5574,"description":"Curimatá","state_id":17},
{"id":4618,"description":"Curionópolis","state_id":14},
{"id":6015,"description":"Curitiba","state_id":18},
{"id":8433,"description":"Curitibanos","state_id":24},
{"id":6016,"description":"Curiúva","state_id":18},
{"id":5575,"description":"Currais","state_id":17},
{"id":7161,"description":"Currais Novos","state_id":20},
{"id":7636,"description":"Curral Alto (Santa Vitória do Palmar)","state_id":23},
{"id":560,"description":"Curral Falso (Ribeira do Pombal)","state_id":5},
{"id":5576,"description":"Curral Novo do Piauí","state_id":17},
{"id":5241,"description":"Curral Queimado (Petrolina)","state_id":16},
{"id":4933,"description":"Curral Velho","state_id":15},
{"id":11632,"description":"Curral Velho","state_id":6},
{"id":4932,"description":"Curral de Cima","state_id":15},
{"id":3022,"description":"Curral de Dentro","state_id":11},
{"id":4619,"description":"Curralinho","state_id":14},
{"id":5577,"description":"Curralinhos","state_id":17},
{"id":4621,"description":"Curuaí (Santarém)","state_id":14},
{"id":6017,"description":"Curucaca (Guarapuava)","state_id":18},
{"id":7637,"description":"Curumim (Capão da Canoa)","state_id":23},
{"id":4624,"description":"Curumu (Breves)","state_id":14},
{"id":2443,"description":"Curupa (Alto Parnaíba)","state_id":10},
{"id":1314,"description":"Curupira (Ocara)","state_id":6},
{"id":9091,"description":"Curupá (Tabatinga)","state_id":26},
{"id":2444,"description":"Cururupu","state_id":10},
{"id":4620,"description":"Curuá","state_id":14},
{"id":4623,"description":"Curuçambaba (Cametá)","state_id":14},
{"id":4622,"description":"Curuçá","state_id":14},
{"id":2445,"description":"Curva Grande (Santa Helena)","state_id":10},
{"id":3023,"description":"Curvelo","state_id":11},
{"id":4348,"description":"Curvelândia","state_id":13},
{"id":5242,"description":"Custódia","state_id":16},
{"id":1315,"description":"Custódio (Quixadá)","state_id":6},
{"id":2446,"description":"Custódio Lima (Magalhães de Almeida)","state_id":10},
{"id":294,"description":"Cutias","state_id":4},
{"id":4313,"description":"Cáceres","state_id":13},
{"id":2907,"description":"Cássia","state_id":11},
{"id":9050,"description":"Cássia dos Coqueiros","state_id":26},
{"id":1842,"description":"Câmara (Muqui)","state_id":8},
{"id":4591,"description":"Câmara do Marajó (Cachoeira do Arari)","state_id":14},
{"id":7527,"description":"Cândido Freire (Giruá)","state_id":23},
{"id":7528,"description":"Cândido Godói","state_id":23},
{"id":2424,"description":"Cândido Mendes","state_id":10},
{"id":9033,"description":"Cândido Mota","state_id":26},
{"id":9034,"description":"Cândido Rodrigues","state_id":26},
{"id":491,"description":"Cândido Sales","state_id":5},
{"id":5915,"description":"Cândido de Abreu","state_id":18},
{"id":5957,"description":"Céu Azul","state_id":18},
{"id":526,"description":"Cícero Dantas","state_id":5},
{"id":12112,"description":"Córrego","state_id":6},
{"id":2994,"description":"Córrego Danta","state_id":11},
{"id":2998,"description":"Córrego Fundo","state_id":11},
{"id":12679,"description":"Córrego Moacyr Ávidos","state_id":8},
{"id":2999,"description":"Córrego Novo","state_id":11},
{"id":9077,"description":"Córrego Rico (Jaboticabal)","state_id":26},
{"id":2140,"description":"Córrego Rico (Planaltina de Goiás)","state_id":9},
{"id":6903,"description":"Córrego da Prata (Carmo)","state_id":19},
{"id":7159,"description":"Córrego de São Mateus (Boa Saúde)","state_id":20},
{"id":2995,"description":"Córrego do Barro (Pará de Minas)","state_id":11},
{"id":2996,"description":"Córrego do Bom Jesus","state_id":11},
{"id":2139,"description":"Córrego do Ouro","state_id":9},
{"id":2997,"description":"Córrego do Ouro (Campos Gerais)","state_id":11},
{"id":6904,"description":"Córrego do Ouro (Macaé)","state_id":19},
{"id":1299,"description":"Córrego dos Fernandes (Aracati)","state_id":6},
{"id":1853,"description":"Córrego dos Monos (Cachoeiro de Itapemirim)","state_id":8},
{"id":3000,"description":"Córregos (Conceição do Mato Dentro)","state_id":11},
{"id":2969,"description":"Cônego João Pio (São Domingos do Prata)","state_id":11},
{"id":2970,"description":"Cônego Marinho","state_id":11},
{"id":8434,"description":"Dal Pai (Campos Novos)","state_id":24},
{"id":9092,"description":"Dalas (Palmeira D'Oeste)","state_id":26},
{"id":8435,"description":"Dalbérgia (Ibirama)","state_id":24},
{"id":7639,"description":"Daltro Filho (Garibaldi)","state_id":23},
{"id":7638,"description":"Daltro Filho (Imigrante)","state_id":23},
{"id":7640,"description":"Daltro Filho (Tenente Portela)","state_id":23},
{"id":2149,"description":"Damianópolis","state_id":9},
{"id":4934,"description":"Damião","state_id":15},
{"id":2150,"description":"Damolândia","state_id":9},
{"id":1316,"description":"Daniel de Queirós (Quixadá)","state_id":6},
{"id":11986,"description":"Dantelândia","state_id":5},
{"id":9847,"description":"Darcinópolis","state_id":27},
{"id":3024,"description":"Datas","state_id":11},
{"id":7642,"description":"David Canabarro","state_id":23},
{"id":2151,"description":"Davidópolis (Goiás)","state_id":9},
{"id":2447,"description":"Davinópolis","state_id":10},
{"id":2152,"description":"Davinópolis","state_id":9},
{"id":4159,"description":"Debrasa (Brasilândia)","state_id":12},
{"id":4349,"description":"Del Rios (Diamantino)","state_id":13},
{"id":3025,"description":"Delfim Moreira","state_id":11},
{"id":7643,"description":"Delfina (Estrela)","state_id":23},
{"id":562,"description":"Delfino (Campo Formoso)","state_id":5},
{"id":3026,"description":"Delfinópolis","state_id":11},
{"id":74,"description":"Delmiro Gouveia","state_id":2},
{"id":1317,"description":"Delmiro Gouveia (Pires Ferreira)","state_id":6},
{"id":3027,"description":"Delta","state_id":11},
{"id":11448,"description":"Demarcação","state_id":21},
{"id":5578,"description":"Demerval Lobão","state_id":17},
{"id":4350,"description":"Denise","state_id":13},
{"id":7644,"description":"Deodoro (Venâncio Aires)","state_id":23},
{"id":4160,"description":"Deodápolis","state_id":12},
{"id":3028,"description":"Deputado Augusto Clementino (Serro)","state_id":11},
{"id":1318,"description":"Deputado Irapuan Pinheiro","state_id":6},
{"id":6018,"description":"Deputado José Afonso (Paranavaí)","state_id":18},
{"id":7645,"description":"Depósito (Espumoso)","state_id":23},
{"id":3029,"description":"Derribadinha (Governador Valadares)","state_id":11},
{"id":7646,"description":"Derrubadas","state_id":23},
{"id":9093,"description":"Descalvado","state_id":26},
{"id":8436,"description":"Descanso","state_id":24},
{"id":3030,"description":"Descoberto","state_id":11},
{"id":563,"description":"Descoberto (Coribe)","state_id":5},
{"id":3031,"description":"Desembargador Otoni (Diamantina)","state_id":11},
{"id":3032,"description":"Desemboque (Sacramento)","state_id":11},
{"id":1857,"description":"Desengano (Linhares)","state_id":8},
{"id":1319,"description":"Deserto (Itapipoca)","state_id":6},
{"id":6019,"description":"Despique (São José dos Pinhais)","state_id":18},
{"id":12622,"description":"Despraiado","state_id":23},
{"id":4935,"description":"Desterro","state_id":15},
{"id":3033,"description":"Desterro de Entre Rios","state_id":11},
{"id":3034,"description":"Desterro do Melo","state_id":11},
{"id":6021,"description":"Dez de Maio (Toledo)","state_id":18},
{"id":7647,"description":"Dezesseis de Novembro","state_id":23},
{"id":9094,"description":"Diadema","state_id":26},
{"id":4936,"description":"Diamante","state_id":15},
{"id":6023,"description":"Diamante d'Oeste","state_id":18},
{"id":3035,"description":"Diamante de Ubá (Ubá)","state_id":11},
{"id":6024,"description":"Diamante do Norte","state_id":18},
{"id":6025,"description":"Diamante do Sul","state_id":18},
{"id":3036,"description":"Diamantina","state_id":11},
{"id":4351,"description":"Diamantino","state_id":13},
{"id":9848,"description":"Dianópolis","state_id":27},
{"id":3037,"description":"Dias (Brasópolis)","state_id":11},
{"id":564,"description":"Dias Coelho (Morro do Chapéu)","state_id":5},
{"id":565,"description":"Dias D'Ávila","state_id":5},
{"id":3038,"description":"Dias Tavares/Siderúrgica (Juiz de Fora)","state_id":11},
{"id":7648,"description":"Dilermando de Aguiar","state_id":23},
{"id":3039,"description":"Diogo de Vasconcelos","state_id":11},
{"id":2153,"description":"Diolândia (Itapuranga)","state_id":9},
{"id":3040,"description":"Dionísio","state_id":11},
{"id":8437,"description":"Dionísio Cerqueira","state_id":24},
{"id":2154,"description":"Diorama","state_id":9},
{"id":9095,"description":"Dirce Reis","state_id":26},
{"id":9096,"description":"Dirceu (Marília)","state_id":26},
{"id":5579,"description":"Dirceu Arcoverde","state_id":17},
{"id":8787,"description":"Divina Pastora","state_id":25},
{"id":3042,"description":"Divino","state_id":11},
{"id":7649,"description":"Divino (Planalto)","state_id":23},
{"id":3045,"description":"Divino Espirito Santo (Alterosa)","state_id":11},
{"id":1859,"description":"Divino Espírito Santo (São José do Calçado)","state_id":8},
{"id":3043,"description":"Divino das Laranjeiras","state_id":11},
{"id":1858,"description":"Divino de São Lourenço","state_id":8},
{"id":3044,"description":"Divino de Virgolândia (Virgolândia)","state_id":11},
{"id":9097,"description":"Divinolândia","state_id":26},
{"id":3046,"description":"Divinolândia de Minas","state_id":11},
{"id":3041,"description":"Divinésia","state_id":11},
{"id":3047,"description":"Divinópolis","state_id":11},
{"id":2155,"description":"Divinópolis de Goiás","state_id":9},
{"id":9849,"description":"Divinópolis do Tocantins","state_id":27},
{"id":3048,"description":"Divisa Alegre","state_id":11},
{"id":3049,"description":"Divisa Nova","state_id":11},
{"id":3050,"description":"Divisópolis","state_id":11},
{"id":566,"description":"Diógenes Sampaio (Amargosa)","state_id":5},
{"id":1860,"description":"Djalma Coutinho (Santa Leopoldina)","state_id":8},
{"id":9098,"description":"Dobrada","state_id":26},
{"id":6026,"description":"Doce Grande (Quitandinha)","state_id":18},
{"id":9099,"description":"Dois Córregos","state_id":26},
{"id":7650,"description":"Dois Irmãos","state_id":23},
{"id":6027,"description":"Dois Irmãos (São João)","state_id":18},
{"id":6028,"description":"Dois Irmãos (Toledo)","state_id":18},
{"id":7651,"description":"Dois Irmãos das Missões","state_id":23},
{"id":4161,"description":"Dois Irmãos do Buriti","state_id":12},
{"id":9850,"description":"Dois Irmãos do Tocantins","state_id":27},
{"id":7652,"description":"Dois Lajeados","state_id":23},
{"id":5243,"description":"Dois Leões (Pombos)","state_id":16},
{"id":6029,"description":"Dois Marcos (Toledo)","state_id":18},
{"id":75,"description":"Dois Riachos","state_id":2},
{"id":6030,"description":"Dois Vizinhos","state_id":18},
{"id":3051,"description":"Dois de Abril (Palmópolis)","state_id":11},
{"id":9100,"description":"Dolcinópolis","state_id":26},
{"id":4352,"description":"Dom Aquino","state_id":13},
{"id":567,"description":"Dom Basílio","state_id":5},
{"id":3052,"description":"Dom Bosco","state_id":11},
{"id":3053,"description":"Dom Cavati","state_id":11},
{"id":4625,"description":"Dom Eliseu","state_id":14},
{"id":5580,"description":"Dom Expedito Lopes","state_id":17},
{"id":7654,"description":"Dom Feliciano","state_id":23},
{"id":7655,"description":"Dom Feliciano (Gravataí)","state_id":23},
{"id":5581,"description":"Dom Inocêncio","state_id":17},
{"id":3054,"description":"Dom Joaquim","state_id":11},
{"id":3055,"description":"Dom Lara (Caratinga)","state_id":11},
{"id":1320,"description":"Dom Leme (Santana do Cariri)","state_id":6},
{"id":568,"description":"Dom Macedo Costa","state_id":5},
{"id":1321,"description":"Dom Maurício (Quixadá)","state_id":6},
{"id":3056,"description":"Dom Modesto (Caratinga)","state_id":11},
{"id":7656,"description":"Dom Pedrito","state_id":23},
{"id":2448,"description":"Dom Pedro","state_id":10},
{"id":7657,"description":"Dom Pedro de Alcântara","state_id":23},
{"id":1322,"description":"Dom Quintino (Crato)","state_id":6},
{"id":6031,"description":"Dom Rodrigo (Campo Largo)","state_id":18},
{"id":3057,"description":"Dom Silvério","state_id":11},
{"id":3058,"description":"Dom Viçoso","state_id":11},
{"id":2156,"description":"Domiciano Ribeiro (Ipameri)","state_id":9},
{"id":1861,"description":"Domingos Martins","state_id":8},
{"id":5582,"description":"Domingos Mourão","state_id":17},
{"id":1323,"description":"Domingos da Costa (Boa Viagem)","state_id":6},
{"id":9101,"description":"Domélia (Agudos)","state_id":26},
{"id":1862,"description":"Dona América (Mimoso do Sul)","state_id":8},
{"id":8438,"description":"Dona Emma","state_id":24},
{"id":3059,"description":"Dona Eusébia","state_id":11},
{"id":7658,"description":"Dona Francisca","state_id":23},
{"id":4937,"description":"Dona Inês","state_id":15},
{"id":569,"description":"Dona Maria (Olindina)","state_id":5},
{"id":7659,"description":"Dona Otília (Roque Gonzales)","state_id":23},
{"id":1324,"description":"Donato (Pires Ferreira)","state_id":6},
{"id":3060,"description":"Dores da Vitória (Miraí)","state_id":11},
{"id":3061,"description":"Dores de Campos","state_id":11},
{"id":3062,"description":"Dores de Guanhães","state_id":11},
{"id":6908,"description":"Dores de Macabu (Campos dos Goytacazes)","state_id":19},
{"id":3063,"description":"Dores do Indaiá","state_id":11},
{"id":3064,"description":"Dores do Paraibuna (Santos Dumont)","state_id":11},
{"id":1863,"description":"Dores do Rio Preto","state_id":8},
{"id":3065,"description":"Dores do Turvo","state_id":11},
{"id":3066,"description":"Doresópolis","state_id":11},
{"id":6032,"description":"Dorizon (Mallet)","state_id":18},
{"id":5244,"description":"Dormentes","state_id":16},
{"id":6907,"description":"Dorândia (Barra do Piraí)","state_id":19},
{"id":12518,"description":"Douradilho","state_id":23},
{"id":4162,"description":"Douradina","state_id":12},
{"id":6033,"description":"Douradina","state_id":18},
{"id":3067,"description":"Douradinho (Machado)","state_id":11},
{"id":9102,"description":"Dourado","state_id":26},
{"id":12753,"description":"Dourado","state_id":6},
{"id":7660,"description":"Dourado (Aratiba)","state_id":23},
{"id":3068,"description":"Douradoquara","state_id":11},
{"id":4163,"description":"Dourados","state_id":12},
{"id":1325,"description":"Dourados (Horizonte)","state_id":6},
{"id":6034,"description":"Doutor Antônio Paranhos (São Jorge d'Oeste)","state_id":18},
{"id":6035,"description":"Doutor Camargo","state_id":18},
{"id":3069,"description":"Doutor Campolina (Jequitibá)","state_id":11},
{"id":7662,"description":"Doutor Edgardo Pereira Velho (Mostardas)","state_id":23},
{"id":6909,"description":"Doutor Elias (Trajano de Morais)","state_id":19},
{"id":6036,"description":"Doutor Ernesto (Toledo)","state_id":18},
{"id":6910,"description":"Doutor Loreti (Santa Maria Madalena)","state_id":19},
{"id":3070,"description":"Doutor Lund (Pedro Leopoldo)","state_id":11},
{"id":7663,"description":"Doutor Maurício Cardoso","state_id":23},
{"id":6037,"description":"Doutor Oliveira Castro (Guaíra)","state_id":18},
{"id":8439,"description":"Doutor Pedrinho","state_id":24},
{"id":7664,"description":"Doutor Ricardo","state_id":23},
{"id":7162,"description":"Doutor Severiano","state_id":20},
{"id":6038,"description":"Doutor Ulysses","state_id":18},
{"id":2157,"description":"Doverlândia","state_id":9},
{"id":9103,"description":"Dracena","state_id":26},
{"id":9104,"description":"Duartina","state_id":26},
{"id":6911,"description":"Duas Barras","state_id":19},
{"id":1864,"description":"Duas Barras (Iconha)","state_id":8},
{"id":570,"description":"Duas Barras do Morro (Morro do Chapéu)","state_id":5},
{"id":4938,"description":"Duas Estradas","state_id":15},
{"id":9851,"description":"Duerê","state_id":27},
{"id":9105,"description":"Dumont","state_id":26},
{"id":9106,"description":"Duplo Céu (Palestina)","state_id":26},
{"id":2449,"description":"Duque Bacelar","state_id":10},
{"id":6912,"description":"Duque de Caxias","state_id":19},
{"id":3071,"description":"Durandé","state_id":11},
{"id":11882,"description":"Durasnal","state_id":23},
{"id":7641,"description":"Dário Lassance (Bagé)","state_id":23},
{"id":561,"description":"Dário Meira","state_id":5},
{"id":1326,"description":"Ebron (Acopiara)","state_id":6},
{"id":9107,"description":"Echaporã","state_id":26},
{"id":1865,"description":"Ecoporanga","state_id":8},
{"id":2158,"description":"Edealina","state_id":9},
{"id":3072,"description":"Edgard Melo (Itanhomi)","state_id":11},
{"id":10470,"description":"Edilândia (Cocalzinho de Goiás)","state_id":9},
{"id":6039,"description":"Eduardo Xavier da Silva (Jaguariaíva)","state_id":18},
{"id":2159,"description":"Edéia","state_id":9},
{"id":222,"description":"Eirunepé","state_id":3},
{"id":4164,"description":"Eldorado","state_id":12},
{"id":9108,"description":"Eldorado","state_id":26},
{"id":7665,"description":"Eldorado do Sul","state_id":23},
{"id":4626,"description":"Eldorado dos Carajás","state_id":14},
{"id":5583,"description":"Elesbão Veloso","state_id":17},
{"id":7666,"description":"Eletra (Jaquirana)","state_id":23},
{"id":9109,"description":"Eleutério (Itapira)","state_id":26},
{"id":9110,"description":"Elias Fausto","state_id":26},
{"id":5584,"description":"Eliseu Martins","state_id":17},
{"id":9111,"description":"Elisiário","state_id":26},
{"id":12755,"description":"Eliza","state_id":18},
{"id":571,"description":"Elísio Medrado","state_id":5},
{"id":3073,"description":"Elói Mendes","state_id":11},
{"id":12736,"description":"Ema","state_id":6},
{"id":1327,"description":"Ema (Iracema)","state_id":6},
{"id":4939,"description":"Emas","state_id":15},
{"id":1328,"description":"Ematuba (Independência)","state_id":6},
{"id":9112,"description":"Embaúba","state_id":26},
{"id":3074,"description":"Emboabas (São João Del Rei)","state_id":11},
{"id":6040,"description":"Emboguaçu (Paranaguá)","state_id":18},
{"id":6041,"description":"Emboque (Piraquara)","state_id":18},
{"id":6042,"description":"Emboque (São José dos Pinhais)","state_id":18},
{"id":4627,"description":"Emboraí (Augusto Corrêa)","state_id":14},
{"id":9113,"description":"Embu","state_id":26},
{"id":9114,"description":"Embu-Guaçu","state_id":26},
{"id":9115,"description":"Emilianópolis","state_id":26},
{"id":7667,"description":"Encantado","state_id":23},
{"id":1329,"description":"Encantado (Quixeramobim)","state_id":6},
{"id":6043,"description":"Encantado d'Oeste (Assis Chateaubriand)","state_id":18},
{"id":7163,"description":"Encanto","state_id":20},
{"id":572,"description":"Encruzilhada","state_id":5},
{"id":6044,"description":"Encruzilhada (Guarapuava)","state_id":18},
{"id":7668,"description":"Encruzilhada (Itaqui)","state_id":23},
{"id":6045,"description":"Encruzilhada (Pato Branco)","state_id":18},
{"id":12429,"description":"Encruzilhada São Sebastião","state_id":23},
{"id":7669,"description":"Encruzilhada do Sul","state_id":23},
{"id":9116,"description":"Eneida (Presidente Prudente)","state_id":26},
{"id":9117,"description":"Engenheiro Balduíno (Monte Aprazível)","state_id":26},
{"id":6047,"description":"Engenheiro Beltrão","state_id":18},
{"id":3075,"description":"Engenheiro Caldas","state_id":11},
{"id":9118,"description":"Engenheiro Coelho","state_id":26},
{"id":3076,"description":"Engenheiro Correia (Ouro Preto)","state_id":11},
{"id":11679,"description":"Engenheiro Dolabela","state_id":11},
{"id":573,"description":"Engenheiro França (Ubaíra)","state_id":5},
{"id":1331,"description":"Engenheiro José Lopes (Senador Pompeu)","state_id":6},
{"id":1330,"description":"Engenheiro João Tomé (Ipueiras)","state_id":6},
{"id":12610,"description":"Engenheiro Luiz Englert","state_id":23},
{"id":9119,"description":"Engenheiro Maia (Itaberá)","state_id":26},
{"id":3077,"description":"Engenheiro Navarro","state_id":11},
{"id":6913,"description":"Engenheiro Passos (Resende)","state_id":19},
{"id":6914,"description":"Engenheiro Paulo de Frontin","state_id":19},
{"id":6915,"description":"Engenheiro Pedreira (Nova Iguaçu)","state_id":19},
{"id":574,"description":"Engenheiro Pontes (Laje)","state_id":5},
{"id":9120,"description":"Engenheiro Schmidt (São José do Rio Preto)","state_id":26},
{"id":3078,"description":"Engenheiro Schnoor (Araçuaí)","state_id":11},
{"id":4940,"description":"Engenheiro Ávidos (Cajazeiras)","state_id":15},
{"id":4353,"description":"Engenho (Acorizal)","state_id":13},
{"id":12654,"description":"Engenho Grande","state_id":23},
{"id":3080,"description":"Engenho Novo (Mar de Espanha)","state_id":11},
{"id":7670,"description":"Engenho Velho","state_id":23},
{"id":1332,"description":"Engenho Velho (Barro)","state_id":6},
{"id":8440,"description":"Engenho Velho (Concórdia)","state_id":24},
{"id":4354,"description":"Engenho Velho (Santo Antônio do Leverger)","state_id":13},
{"id":3079,"description":"Engenho do Ribeiro (Bom Despacho)","state_id":11},
{"id":8441,"description":"Enseada de Brito (Palhoça)","state_id":24},
{"id":3081,"description":"Entre Folhas","state_id":11},
{"id":575,"description":"Entre Rios","state_id":5},
{"id":8442,"description":"Entre Rios","state_id":24},
{"id":4355,"description":"Entre Rios (Dom Aquino)","state_id":13},
{"id":6048,"description":"Entre Rios (Guarapuava)","state_id":18},
{"id":3082,"description":"Entre Rios de Minas","state_id":11},
{"id":6049,"description":"Entre Rios do Oeste","state_id":18},
{"id":7671,"description":"Entre Rios do Sul","state_id":23},
{"id":7672,"description":"Entre-Ijuís","state_id":23},
{"id":76,"description":"Entremontes (Piranhas)","state_id":2},
{"id":7673,"description":"Entrepelado (Taquara)","state_id":23},
{"id":5245,"description":"Entroncamento (Lagoa dos Gatos)","state_id":16},
{"id":223,"description":"Envira","state_id":3},
{"id":12777,"description":"Enxovia","state_id":23},
{"id":6046,"description":"Enéas Marques","state_id":18},
{"id":3083,"description":"Epaminondas Otoni (Carlos Chagas)","state_id":11},
{"id":7,"description":"Epitaciolândia","state_id":1},
{"id":7164,"description":"Equador","state_id":20},
{"id":7674,"description":"Erebango","state_id":23},
{"id":7675,"description":"Erechim","state_id":23},
{"id":1333,"description":"Ererê","state_id":6},
{"id":3084,"description":"Ermidinha (Montes Claros)","state_id":11},
{"id":8443,"description":"Ermo","state_id":24},
{"id":7676,"description":"Ernestina","state_id":23},
{"id":7677,"description":"Ernesto Alves (Santiago)","state_id":23},
{"id":7678,"description":"Erval Grande","state_id":23},
{"id":7679,"description":"Erval Seco","state_id":23},
{"id":8444,"description":"Erval Velho","state_id":24},
{"id":7680,"description":"Erveiras (Santa Cruz do Sul)","state_id":23},
{"id":3085,"description":"Ervália","state_id":11},
{"id":5246,"description":"Escada","state_id":16},
{"id":9852,"description":"Escondido (Araguaína)","state_id":27},
{"id":7681,"description":"Esmeralda","state_id":23},
{"id":9121,"description":"Esmeralda (Rubinéia)","state_id":26},
{"id":3086,"description":"Esmeraldas","state_id":11},
{"id":3087,"description":"Esmeraldas de Ferros (Ferros)","state_id":11},
{"id":1334,"description":"Espacinha (Nova Russas)","state_id":6},
{"id":3088,"description":"Espera Feliz","state_id":11},
{"id":5585,"description":"Esperantina","state_id":17},
{"id":9853,"description":"Esperantina","state_id":27},
{"id":2450,"description":"Esperantinópolis","state_id":10},
{"id":4941,"description":"Esperança","state_id":15},
{"id":11559,"description":"Esperança","state_id":23},
{"id":1335,"description":"Esperança (Canindé)","state_id":6},
{"id":9122,"description":"Esperança D'Oeste (Caiabu)","state_id":26},
{"id":6051,"description":"Esperança Nova","state_id":18},
{"id":6050,"description":"Esperança do Norte (Alvorada do Sul)","state_id":18},
{"id":7682,"description":"Esperança do Sul","state_id":23},
{"id":9123,"description":"Espigão (Regente Feijó)","state_id":26},
{"id":7683,"description":"Espigão (Viamão)","state_id":23},
{"id":7684,"description":"Espigão Alto (Barracão)","state_id":23},
{"id":6052,"description":"Espigão Alto do Iguaçu","state_id":18},
{"id":7330,"description":"Espigão D'Oeste","state_id":21},
{"id":1336,"description":"Espinho (Guaraciaba do Norte)","state_id":6},
{"id":8445,"description":"Espinilho (Campos Novos)","state_id":24},
{"id":7685,"description":"Espinilho Grande (Tupanciretã)","state_id":23},
{"id":3089,"description":"Espinosa","state_id":11},
{"id":577,"description":"Esplanada","state_id":5},
{"id":7687,"description":"Espumoso","state_id":23},
{"id":7165,"description":"Espírito Santo","state_id":20},
{"id":7686,"description":"Espírito Santo (Alegria)","state_id":23},
{"id":6053,"description":"Espírito Santo (Londrina)","state_id":18},
{"id":5247,"description":"Espírito Santo (São Bento do Una)","state_id":16},
{"id":3090,"description":"Espírito Santo do Dourado","state_id":11},
{"id":7166,"description":"Espírito Santo do Oeste","state_id":20},
{"id":9124,"description":"Espírito Santo do Pinhal","state_id":26},
{"id":4628,"description":"Espírito Santo do Tauá (Santo Antônio do Tauá)","state_id":14},
{"id":9125,"description":"Espírito Santo do Turvo","state_id":26},
{"id":7688,"description":"Esquina Araújo (Independência)","state_id":23},
{"id":7689,"description":"Esquina Bom Sucesso (Catuípe)","state_id":23},
{"id":12568,"description":"Esquina Brasil Neves","state_id":23},
{"id":7690,"description":"Esquina Gaúcha (Crissiumal)","state_id":23},
{"id":7691,"description":"Esquina Gaúcha (Entre-Ijuís)","state_id":23},
{"id":7692,"description":"Esquina Ipiranga (Giruá)","state_id":23},
{"id":7693,"description":"Esquina Piratini (Bossoroca)","state_id":23},
{"id":2451,"description":"Estandarte (Cândido Mendes)","state_id":10},
{"id":7694,"description":"Estação","state_id":23},
{"id":8446,"description":"Estação Cocal (Morro da Fumaça)","state_id":24},
{"id":6054,"description":"Estação General Lúcio (Araucária)","state_id":18},
{"id":6055,"description":"Estação Roça Nova (Piraquara)","state_id":18},
{"id":7697,"description":"Esteio","state_id":23},
{"id":3091,"description":"Esteios (Luz)","state_id":11},
{"id":7698,"description":"Esteira (Vacaria)","state_id":23},
{"id":3092,"description":"Estevão de Araújo (Araponga)","state_id":11},
{"id":11777,"description":"Estirão Do Equador","state_id":3},
{"id":3093,"description":"Estiva","state_id":11},
{"id":9126,"description":"Estiva Gerbi","state_id":26},
{"id":6916,"description":"Estrada Nova (Itaocara)","state_id":19},
{"id":2452,"description":"Estreito","state_id":10},
{"id":7699,"description":"Estreito (São José do Norte)","state_id":23},
{"id":7700,"description":"Estrela","state_id":23},
{"id":7701,"description":"Estrela (Vacaria)","state_id":23},
{"id":9127,"description":"Estrela D'Oeste","state_id":26},
{"id":3095,"description":"Estrela Dalva","state_id":11},
{"id":7702,"description":"Estrela Velha","state_id":23},
{"id":3094,"description":"Estrela da Barra (Carneirinho)","state_id":11},
{"id":77,"description":"Estrela de Alagoas","state_id":2},
{"id":3096,"description":"Estrela de Jordânia (Jordânia)","state_id":11},
{"id":3097,"description":"Estrela do Indaiá","state_id":11},
{"id":4356,"description":"Estrela do Leste (Guiratinga)","state_id":13},
{"id":2160,"description":"Estrela do Norte","state_id":9},
{"id":9128,"description":"Estrela do Norte","state_id":26},
{"id":1866,"description":"Estrela do Norte (Castelo)","state_id":8},
{"id":3098,"description":"Estrela do Sul","state_id":11},
{"id":8788,"description":"Estância","state_id":25},
{"id":7695,"description":"Estância Grande (Alvorada)","state_id":23},
{"id":12467,"description":"Estância Nova","state_id":23},
{"id":7696,"description":"Estância Velha","state_id":23},
{"id":12459,"description":"Estância Velha","state_id":23},
{"id":6917,"description":"Euclidelândia (Cantagalo)","state_id":19},
{"id":578,"description":"Euclides da Cunha","state_id":5},
{"id":9129,"description":"Euclides da Cunha Paulista","state_id":26},
{"id":3099,"description":"Eugenópolis","state_id":11},
{"id":7703,"description":"Eugênio de Castro","state_id":23},
{"id":9130,"description":"Eugênio de Melo (São José dos Campos)","state_id":26},
{"id":579,"description":"Eunápolis","state_id":5},
{"id":6056,"description":"Europa (Paranaguá)","state_id":18},
{"id":1337,"description":"Eusébio","state_id":6},
{"id":3100,"description":"Euxenita (Sabinópolis)","state_id":11},
{"id":6057,"description":"Euzébio de Oliveira (Ibaiti)","state_id":18},
{"id":7704,"description":"Evangelista (Casca)","state_id":23},
{"id":12444,"description":"Evaristo","state_id":23},
{"id":3101,"description":"Ewbank da Câmara","state_id":11},
{"id":3102,"description":"Expedicionário Alício (Aimorés)","state_id":11},
{"id":3103,"description":"Extração (Diamantina)","state_id":11},
{"id":3104,"description":"Extrema","state_id":11},
{"id":7167,"description":"Extremoz","state_id":20},
{"id":5248,"description":"Exu","state_id":16},
{"id":4942,"description":"Fagundes","state_id":15},
{"id":7705,"description":"Fagundes Varela","state_id":23},
{"id":2161,"description":"Faina","state_id":9},
{"id":6058,"description":"Faisqueira (Telêmaco Borba)","state_id":18},
{"id":6918,"description":"Falcão (Quatis)","state_id":19},
{"id":3105,"description":"Fama","state_id":11},
{"id":12061,"description":"Faria","state_id":11},
{"id":3106,"description":"Faria Lemos","state_id":11},
{"id":7707,"description":"Faria Lemos (Bento Gonçalves)","state_id":23},
{"id":3107,"description":"Farias (Guanhães)","state_id":11},
{"id":1338,"description":"Farias Brito","state_id":6},
{"id":7708,"description":"Farinhas (Alpestre)","state_id":23},
{"id":4629,"description":"Faro","state_id":14},
{"id":6059,"description":"Farol","state_id":18},
{"id":7709,"description":"Farrapos (São José do Ouro)","state_id":23},
{"id":11780,"description":"Farrinheira","state_id":2},
{"id":7710,"description":"Farroupilha","state_id":23},
{"id":9131,"description":"Fartura","state_id":26},
{"id":1867,"description":"Fartura (São Gabriel da Palha)","state_id":8},
{"id":5586,"description":"Fartura do Piauí","state_id":17},
{"id":4357,"description":"Faval (Nossa Senhora do Livramento)","state_id":13},
{"id":12078,"description":"Faveira","state_id":6},
{"id":6060,"description":"Faxina (São José dos Pinhais)","state_id":18},
{"id":11561,"description":"Faxinal","state_id":23},
{"id":6061,"description":"Faxinal","state_id":18},
{"id":7711,"description":"Faxinal (Victor Graeff)","state_id":23},
{"id":12432,"description":"Faxinal Preto","state_id":23},
{"id":6064,"description":"Faxinal Santa Cruz (Ponta Grossa)","state_id":18},
{"id":6062,"description":"Faxinal do Céu (Pinhão)","state_id":18},
{"id":7712,"description":"Faxinal do Soturno","state_id":23},
{"id":6063,"description":"Faxinal dos Elias (Guarapuava)","state_id":18},
{"id":8447,"description":"Faxinal dos Guedes","state_id":24},
{"id":7713,"description":"Faxinalzinho","state_id":23},
{"id":12539,"description":"Fazenda Colorado","state_id":23},
{"id":12426,"description":"Fazenda Das Laranjeiras","state_id":23},
{"id":12614,"description":"Fazenda Fialho","state_id":23},
{"id":7714,"description":"Fazenda Fialho (Taquara)","state_id":23},
{"id":1868,"description":"Fazenda Guandu (Afonso Cláudio)","state_id":8},
{"id":6067,"description":"Fazenda Jangada (Cascavel)","state_id":18},
{"id":2162,"description":"Fazenda Nova","state_id":9},
{"id":5249,"description":"Fazenda Nova (Brejo da Madre de Deus)","state_id":16},
{"id":4944,"description":"Fazenda Nova (Uiraúna)","state_id":15},
{"id":6068,"description":"Fazenda Rio Grande","state_id":18},
{"id":6069,"description":"Fazenda Salmo 23 (Umuarama)","state_id":18},
{"id":7715,"description":"Fazenda Souza (Caxias do Sul)","state_id":23},
{"id":9134,"description":"Fazenda Velha (Cesário Lange)","state_id":26},
{"id":7716,"description":"Fazenda Vilanova","state_id":23},
{"id":8448,"description":"Fazenda Zandavalli (Guatambú)","state_id":24},
{"id":4358,"description":"Fazenda de Cima (Poconé)","state_id":13},
{"id":6065,"description":"Fazenda do Brigadeiro (Cascavel)","state_id":18},
{"id":6066,"description":"Fazenda dos Barbosas (Guarapuava)","state_id":18},
{"id":6070,"description":"Fazendinha (Francisco Beltrão)","state_id":18},
{"id":295,"description":"Fazendinha (Macapá)","state_id":4},
{"id":12123,"description":"Faísca","state_id":6},
{"id":3108,"description":"Fechados (Santana de Pirapama)","state_id":11},
{"id":11774,"description":"Feijoal","state_id":3},
{"id":8,"description":"Feijó","state_id":1},
{"id":78,"description":"Feira Grande","state_id":2},
{"id":5250,"description":"Feira Nova","state_id":16},
{"id":8789,"description":"Feira Nova","state_id":25},
{"id":2453,"description":"Feira Nova do Maranhão","state_id":10},
{"id":581,"description":"Feira da Mata","state_id":5},
{"id":582,"description":"Feira de Santana","state_id":5},
{"id":1340,"description":"Feiticeiro (Jaguaribe)","state_id":6},
{"id":5251,"description":"Feitoria (Bodocó)","state_id":16},
{"id":1341,"description":"Feitosa (Caririaçu)","state_id":6},
{"id":3109,"description":"Felicina (Açucena)","state_id":11},
{"id":7168,"description":"Felipe Guerra","state_id":20},
{"id":8449,"description":"Felipe Schmidt (Canoinhas)","state_id":24},
{"id":3111,"description":"Felisburgo","state_id":11},
{"id":3112,"description":"Felixlândia","state_id":11},
{"id":7717,"description":"Feliz","state_id":23},
{"id":79,"description":"Feliz Deserto","state_id":2},
{"id":4359,"description":"Feliz Natal","state_id":13},
{"id":1342,"description":"Felizardo (Ipaumirim)","state_id":6},
{"id":6071,"description":"Felpudo (Campo Largo)","state_id":18},
{"id":3110,"description":"Felício dos Santos","state_id":11},
{"id":4630,"description":"Fernandes Belo (Viseu)","state_id":14},
{"id":6073,"description":"Fernandes Pinheiro","state_id":18},
{"id":3113,"description":"Fernandes Tourinho","state_id":11},
{"id":2454,"description":"Fernando Falcão","state_id":10},
{"id":7169,"description":"Fernando Pedroza","state_id":20},
{"id":9135,"description":"Fernando Prestes","state_id":26},
{"id":5252,"description":"Fernando de Noronha","state_id":16},
{"id":9136,"description":"Fernandópolis","state_id":26},
{"id":9137,"description":"Fernão","state_id":26},
{"id":3114,"description":"Fernão Dias (Brasília de Minas)","state_id":11},
{"id":6074,"description":"Fernão Dias (Munhoz de Melo)","state_id":18},
{"id":583,"description":"Ferradas (Itabuna)","state_id":5},
{"id":6075,"description":"Ferraria (Campo Largo)","state_id":18},
{"id":9138,"description":"Ferraz de Vasconcelos","state_id":26},
{"id":7718,"description":"Ferreira (Cachoeira do Sul)","state_id":23},
{"id":296,"description":"Ferreira Gomes","state_id":4},
{"id":6076,"description":"Ferreiras (Ponta Grossa)","state_id":18},
{"id":3115,"description":"Ferreiras (São Gonçalo do Sapucaí)","state_id":11},
{"id":5253,"description":"Ferreiros","state_id":16},
{"id":3116,"description":"Ferreirópolis (Salinas)","state_id":11},
{"id":3117,"description":"Ferros","state_id":11},
{"id":3118,"description":"Ferruginha (Conselheiro Pena)","state_id":11},
{"id":3119,"description":"Fervedouro","state_id":11},
{"id":3120,"description":"Fidalgo (Pedro Leopoldo)","state_id":11},
{"id":3121,"description":"Fidelândia (Ataléia)","state_id":11},
{"id":6077,"description":"Figueira","state_id":18},
{"id":8450,"description":"Figueira (Chapecó)","state_id":24},
{"id":6078,"description":"Figueira do Oeste (Engenheiro Beltrão)","state_id":18},
{"id":4166,"description":"Figueirão (Camapuã)","state_id":12},
{"id":9855,"description":"Figueirópolis","state_id":27},
{"id":4360,"description":"Figueirópolis D'Oeste","state_id":13},
{"id":584,"description":"Filadélfia","state_id":5},
{"id":9856,"description":"Filadélfia","state_id":27},
{"id":4361,"description":"Filadélfia (Juína)","state_id":13},
{"id":585,"description":"Filanésia (Apuarema)","state_id":5},
{"id":7170,"description":"Firmamento (Lajes)","state_id":20},
{"id":586,"description":"Firmino Alves","state_id":5},
{"id":2163,"description":"Firminópolis","state_id":9},
{"id":6079,"description":"Fiusas (Guarapuava)","state_id":18},
{"id":1343,"description":"Flamengo (Saboeiro)","state_id":6},
{"id":4631,"description":"Flexal (Óbidos)","state_id":14},
{"id":81,"description":"Flexeiras","state_id":2},
{"id":11781,"description":"Flexeiras","state_id":2},
{"id":12147,"description":"Flor Da Serra","state_id":18},
{"id":4362,"description":"Flor da Serra (Guarantã do Norte)","state_id":13},
{"id":6080,"description":"Flor da Serra (Serranópolis do Iguaçu)","state_id":18},
{"id":6081,"description":"Flor da Serra do Sul","state_id":18},
{"id":3122,"description":"Flor de Minas (Gurinhatã)","state_id":11},
{"id":8451,"description":"Flor do Sertão","state_id":24},
{"id":9139,"description":"Flora Rica","state_id":26},
{"id":6082,"description":"Floraí","state_id":18},
{"id":9140,"description":"Floreal","state_id":26},
{"id":5254,"description":"Flores","state_id":16},
{"id":1344,"description":"Flores (Ipu)","state_id":6},
{"id":1345,"description":"Flores (Russas)","state_id":6},
{"id":7719,"description":"Flores da Cunha","state_id":23},
{"id":2164,"description":"Flores de Goiás","state_id":9},
{"id":5587,"description":"Flores do Piauí","state_id":17},
{"id":5255,"description":"Floresta","state_id":16},
{"id":12638,"description":"Floresta","state_id":23},
{"id":6083,"description":"Floresta","state_id":18},
{"id":3124,"description":"Floresta (Central de Minas)","state_id":11},
{"id":7720,"description":"Floresta (Ijuí)","state_id":23},
{"id":4632,"description":"Floresta (Itaituba)","state_id":14},
{"id":7721,"description":"Floresta (Três Passos)","state_id":23},
{"id":587,"description":"Floresta Azul","state_id":5},
{"id":4633,"description":"Floresta do Araguaia","state_id":14},
{"id":5588,"description":"Floresta do Piauí","state_id":17},
{"id":9141,"description":"Floresta do Sul (Presidente Prudente)","state_id":26},
{"id":3125,"description":"Florestal","state_id":11},
{"id":12412,"description":"Florestal","state_id":5},
{"id":3126,"description":"Florestina (Araguari)","state_id":11},
{"id":6084,"description":"Florestópolis","state_id":18},
{"id":5589,"description":"Floriano","state_id":17},
{"id":6919,"description":"Floriano (Barra Mansa)","state_id":19},
{"id":6085,"description":"Floriano (Maringá)","state_id":18},
{"id":7722,"description":"Floriano Peixoto","state_id":23},
{"id":224,"description":"Floriano Peixoto (Boca do Acre)","state_id":3},
{"id":8452,"description":"Florianópolis","state_id":24},
{"id":3123,"description":"Florália (Santa Bárbara)","state_id":11},
{"id":7171,"description":"Florânia","state_id":20},
{"id":9143,"description":"Florínia","state_id":26},
{"id":6087,"description":"Florópolis (Paranacity)","state_id":18},
{"id":6088,"description":"Fluviópolis (São Mateus do Sul)","state_id":18},
{"id":6086,"description":"Flórida","state_id":18},
{"id":7723,"description":"Flórida (Santiago)","state_id":23},
{"id":9142,"description":"Flórida Paulista","state_id":26},
{"id":3127,"description":"Fonseca (Alvinópolis)","state_id":11},
{"id":4363,"description":"Fontanilhas (Castanheira)","state_id":13},
{"id":225,"description":"Fonte Boa","state_id":3},
{"id":7724,"description":"Fontoura Xavier","state_id":23},
{"id":3128,"description":"Formiga","state_id":11},
{"id":6089,"description":"Formigone (Umuarama)","state_id":18},
{"id":7725,"description":"Formigueiro","state_id":23},
{"id":12756,"description":"Formigueiro","state_id":18},
{"id":2165,"description":"Formosa","state_id":9},
{"id":7726,"description":"Formosa (Santa Cruz do Sul)","state_id":23},
{"id":2455,"description":"Formosa da Serra Negra","state_id":10},
{"id":6090,"description":"Formosa do Oeste","state_id":18},
{"id":588,"description":"Formosa do Rio Preto","state_id":5},
{"id":8453,"description":"Formosa do Sul","state_id":24},
{"id":2166,"description":"Formoso","state_id":9},
{"id":3129,"description":"Formoso","state_id":11},
{"id":9857,"description":"Formoso do Araguaia","state_id":27},
{"id":7727,"description":"Forninho (Caçapava do Sul)","state_id":23},
{"id":12484,"description":"Forqueta","state_id":23},
{"id":12708,"description":"Forqueta Baixa","state_id":23},
{"id":7728,"description":"Forquetinha","state_id":23},
{"id":1346,"description":"Forquilha","state_id":6},
{"id":11587,"description":"Forquilha","state_id":6},
{"id":8454,"description":"Forquilhinha","state_id":24},
{"id":1347,"description":"Fortaleza","state_id":6},
{"id":297,"description":"Fortaleza (Santana)","state_id":4},
{"id":11450,"description":"Fortaleza Do Abunã","state_id":21},
{"id":3130,"description":"Fortaleza de Minas","state_id":11},
{"id":9858,"description":"Fortaleza do Tabocão","state_id":27},
{"id":2456,"description":"Fortaleza dos Nogueiras","state_id":10},
{"id":7729,"description":"Fortaleza dos Valos","state_id":23},
{"id":2167,"description":"Forte (São João D'Aliança)","state_id":9},
{"id":4945,"description":"Forte Velho (Santa Rita)","state_id":15},
{"id":1348,"description":"Fortim","state_id":6},
{"id":2457,"description":"Fortuna","state_id":10},
{"id":3131,"description":"Fortuna de Minas","state_id":11},
{"id":6091,"description":"Foz do Iguaçu","state_id":18},
{"id":6092,"description":"Foz do Jordão","state_id":18},
{"id":11282,"description":"Frade","state_id":19},
{"id":8455,"description":"Fragosos (Campo Alegre)","state_id":24},
{"id":8456,"description":"Fraiburgo","state_id":24},
{"id":9144,"description":"Franca","state_id":26},
{"id":12462,"description":"Francesa Alta","state_id":23},
{"id":5590,"description":"Francinópolis","state_id":17},
{"id":6093,"description":"Francisco Alves","state_id":18},
{"id":5591,"description":"Francisco Ayres","state_id":17},
{"id":3132,"description":"Francisco Badaró","state_id":11},
{"id":6094,"description":"Francisco Beltrão","state_id":18},
{"id":7172,"description":"Francisco Dantas","state_id":20},
{"id":3133,"description":"Francisco Dumont","state_id":11},
{"id":6095,"description":"Francisco Frederico Teixeira Guimarães (Palmas)","state_id":18},
{"id":5592,"description":"Francisco Macedo","state_id":17},
{"id":9145,"description":"Francisco Morato","state_id":26},
{"id":5593,"description":"Francisco Santos","state_id":17},
{"id":3134,"description":"Francisco Sá","state_id":11},
{"id":3135,"description":"Franciscópolis","state_id":11},
{"id":9146,"description":"Franco da Rocha","state_id":26},
{"id":589,"description":"França (Piritiba)","state_id":5},
{"id":2458,"description":"Frecheiras (Araióses)","state_id":10},
{"id":1349,"description":"Frecheirinha","state_id":6},
{"id":8457,"description":"Frederico Wastner (São Lourenço do Oeste)","state_id":24},
{"id":7730,"description":"Frederico Westphalen","state_id":23},
{"id":226,"description":"Freguesia do Andirá (Barreirinha)","state_id":3},
{"id":3136,"description":"Frei Eustáquio (Coqueiral)","state_id":11},
{"id":3137,"description":"Frei Gaspar","state_id":11},
{"id":3138,"description":"Frei Inocêncio","state_id":11},
{"id":3139,"description":"Frei Lagonegro","state_id":11},
{"id":4946,"description":"Frei Martinho","state_id":15},
{"id":5256,"description":"Frei Miguelinho","state_id":16},
{"id":3140,"description":"Frei Orlando (Morada Nova de Minas)","state_id":11},
{"id":8790,"description":"Frei Paulo","state_id":25},
{"id":8458,"description":"Frei Rogério","state_id":24},
{"id":7731,"description":"Frei Sebastião (Palmares do Sul)","state_id":23},
{"id":3141,"description":"Frei Serafim (Itambacuri)","state_id":11},
{"id":6096,"description":"Frei Timóteo (Jataizinho)","state_id":18},
{"id":7732,"description":"Freire (Pedro Osório)","state_id":23},
{"id":3142,"description":"Freire Cardoso (Coronel Murta)","state_id":11},
{"id":5257,"description":"Frexeiras (Escada)","state_id":16},
{"id":3143,"description":"Fronteira","state_id":11},
{"id":3144,"description":"Fronteira dos Vales","state_id":11},
{"id":5594,"description":"Fronteiras","state_id":17},
{"id":3145,"description":"Fruta de Leite","state_id":11},
{"id":3146,"description":"Frutal","state_id":11},
{"id":9147,"description":"Frutal do Campo (Cândido Mota)","state_id":26},
{"id":7173,"description":"Frutuoso Gomes","state_id":20},
{"id":6097,"description":"Fueros (Guarapuava)","state_id":18},
{"id":6920,"description":"Fumaça (Resende)","state_id":19},
{"id":3147,"description":"Funchal (São Gotardo)","state_id":11},
{"id":1869,"description":"Fundão","state_id":8},
{"id":6098,"description":"Fundão (Castro)","state_id":18},
{"id":6921,"description":"Funil (Cambuci)","state_id":19},
{"id":3148,"description":"Funilândia","state_id":11},
{"id":3149,"description":"Furnas (Alpinópolis)","state_id":11},
{"id":3150,"description":"Furquim (Mariana)","state_id":11},
{"id":580,"description":"Fátima","state_id":5},
{"id":9854,"description":"Fátima","state_id":27},
{"id":4943,"description":"Fátima (Cachoeira dos Índios)","state_id":15},
{"id":9132,"description":"Fátima (Guaimbê)","state_id":26},
{"id":1339,"description":"Fátima (Pacoti)","state_id":6},
{"id":9133,"description":"Fátima Paulista (Turmalina)","state_id":26},
{"id":4165,"description":"Fátima do Sul","state_id":12},
{"id":7706,"description":"Fão (Lajeado)","state_id":23},
{"id":10862,"description":"Félix Pinto","state_id":22},
{"id":6072,"description":"Fênix","state_id":18},
{"id":590,"description":"Gabiarra (Eunápolis)","state_id":5},
{"id":9148,"description":"Gabriel Monteiro","state_id":26},
{"id":1350,"description":"Gado (Palmácia)","state_id":6},
{"id":4947,"description":"Gado Bravo","state_id":15},
{"id":1351,"description":"Gado dos Rodrigues (Palmácia)","state_id":6},
{"id":298,"description":"Gaivota (Macapá)","state_id":4},
{"id":4948,"description":"Galante (Campina Grande)","state_id":15},
{"id":3151,"description":"Galego (Barbacena)","state_id":11},
{"id":3152,"description":"Galena (Presidente Olegário)","state_id":11},
{"id":591,"description":"Galeão (Cairu)","state_id":5},
{"id":3153,"description":"Galiléia","state_id":11},
{"id":7174,"description":"Galinhos","state_id":20},
{"id":8459,"description":"Galvão","state_id":24},
{"id":1783,"description":"Gama","state_id":7},
{"id":3154,"description":"Gama (Açucena)","state_id":11},
{"id":6099,"description":"Gamadinho (Cascavel)","state_id":18},
{"id":592,"description":"Gamboa (Cairu)","state_id":5},
{"id":11715,"description":"Gambá","state_id":16},
{"id":6100,"description":"Gamela (São José dos Pinhais)","state_id":18},
{"id":5258,"description":"Gameleira","state_id":16},
{"id":7175,"description":"Gameleira (Taipu)","state_id":20},
{"id":593,"description":"Gameleira da Lapa (Sítio do Mato)","state_id":5},
{"id":2168,"description":"Gameleira de Goiás","state_id":9},
{"id":1352,"description":"Gameleira de São Sebastião (Missão Velha)","state_id":6},
{"id":594,"description":"Gameleira do Assuruá (Gentio do Ouro)","state_id":5},
{"id":3155,"description":"Gameleiras","state_id":11},
{"id":595,"description":"Gandu","state_id":5},
{"id":5259,"description":"Garanhuns","state_id":16},
{"id":3156,"description":"Garapuava (Unaí)","state_id":11},
{"id":8791,"description":"Gararu","state_id":25},
{"id":8460,"description":"Garcia (Angelina)","state_id":24},
{"id":4167,"description":"Garcias (Três Lagoas)","state_id":12},
{"id":9151,"description":"Gardênia (Rancharia)","state_id":26},
{"id":7733,"description":"Garibaldi","state_id":23},
{"id":7734,"description":"Garibaldina (Garibaldi)","state_id":23},
{"id":8461,"description":"Garopaba","state_id":24},
{"id":1870,"description":"Garrafão (Santa Maria de Jetibá)","state_id":8},
{"id":4634,"description":"Garrafão do Norte","state_id":14},
{"id":7735,"description":"Garruchos","state_id":23},
{"id":8462,"description":"Garuva","state_id":24},
{"id":9150,"description":"Garça","state_id":26},
{"id":1353,"description":"Garças (Amontada)","state_id":6},
{"id":8463,"description":"Gaspar","state_id":24},
{"id":83,"description":"Gaspar (Arapiraca)","state_id":2},
{"id":9152,"description":"Gastão Vidigal","state_id":26},
{"id":7736,"description":"Gaurama","state_id":23},
{"id":596,"description":"Gavião","state_id":5},
{"id":12768,"description":"Gavião","state_id":6},
{"id":3157,"description":"Gavião (Eugenópolis)","state_id":11},
{"id":6102,"description":"Gavião (Laranjeiras do Sul)","state_id":18},
{"id":6103,"description":"Gavião (Salto do Lontra)","state_id":18},
{"id":9153,"description":"Gavião Peixoto","state_id":26},
{"id":6922,"description":"Gaviões (Silva Jardim)","state_id":19},
{"id":6101,"description":"Gaúcha (Francisco Beltrão)","state_id":18},
{"id":4364,"description":"Gaúcha do Norte","state_id":13},
{"id":5595,"description":"Geminiano","state_id":17},
{"id":4365,"description":"General Carneiro","state_id":13},
{"id":6104,"description":"General Carneiro","state_id":18},
{"id":7737,"description":"General Câmara","state_id":23},
{"id":8792,"description":"General Maynard","state_id":25},
{"id":12463,"description":"General Neto","state_id":23},
{"id":6105,"description":"General Osório (Toledo)","state_id":18},
{"id":9154,"description":"General Salgado","state_id":26},
{"id":1355,"description":"General Sampaio","state_id":6},
{"id":1356,"description":"General Tibúrcio (Viçosa do Ceará)","state_id":6},
{"id":1357,"description":"Genipapeiro (Aracoiaba)","state_id":6},
{"id":7738,"description":"Gentil","state_id":23},
{"id":597,"description":"Gentio do Ouro","state_id":5},
{"id":598,"description":"Geolândia (Cabaceiras do Paraguaçu)","state_id":5},
{"id":6106,"description":"Geremia Lunardelli (Nova Cantu)","state_id":18},
{"id":1358,"description":"Gereraú (Itaitinga)","state_id":6},
{"id":2169,"description":"Geriaçu (Uruaçu)","state_id":9},
{"id":9155,"description":"Getulina","state_id":26},
{"id":6923,"description":"Getulândia (Rio Claro)","state_id":19},
{"id":7739,"description":"Getúlio Vargas","state_id":23},
{"id":5596,"description":"Gilbués","state_id":17},
{"id":1359,"description":"Giqui (Jaguaruana)","state_id":6},
{"id":10469,"description":"Girassol (Cocalzinho de Goiás)","state_id":9},
{"id":1360,"description":"Girau (Aracati)","state_id":6},
{"id":84,"description":"Girau do Ponciano","state_id":2},
{"id":1871,"description":"Gironda (Cachoeiro de Itapemirim)","state_id":8},
{"id":12585,"description":"Giruazinho","state_id":23},
{"id":7740,"description":"Giruá","state_id":23},
{"id":3158,"description":"Glaucilândia","state_id":11},
{"id":3159,"description":"Glaura (Ouro Preto)","state_id":11},
{"id":9156,"description":"Glicério","state_id":26},
{"id":6924,"description":"Glicério (Macaé)","state_id":19},
{"id":7742,"description":"Glorinha","state_id":23},
{"id":3160,"description":"Glucínio (Santa Maria do Suaçuí)","state_id":11},
{"id":599,"description":"Glória","state_id":5},
{"id":12476,"description":"Glória","state_id":23},
{"id":7741,"description":"Glória (Torres)","state_id":23},
{"id":4366,"description":"Glória D'Oeste","state_id":13},
{"id":12076,"description":"Glória De Cataguases","state_id":11},
{"id":4168,"description":"Glória de Dourados","state_id":12},
{"id":5260,"description":"Glória do Goitá","state_id":16},
{"id":2459,"description":"Godofredo Viana","state_id":10},
{"id":6107,"description":"Godoy Moreira","state_id":18},
{"id":3161,"description":"Goiabeira","state_id":11},
{"id":1872,"description":"Goiabeiras (Vitória)","state_id":8},
{"id":2170,"description":"Goialândia (Anápolis)","state_id":9},
{"id":5261,"description":"Goiana","state_id":16},
{"id":3163,"description":"Goianases (Capetinga)","state_id":11},
{"id":2172,"description":"Goiandira","state_id":9},
{"id":7176,"description":"Goianinha","state_id":20},
{"id":2175,"description":"Goianira","state_id":9},
{"id":9859,"description":"Goianorte","state_id":27},
{"id":3162,"description":"Goianá","state_id":11},
{"id":2171,"description":"Goianápolis","state_id":9},
{"id":2173,"description":"Goianésia","state_id":9},
{"id":4635,"description":"Goianésia do Pará","state_id":14},
{"id":9860,"description":"Goiatins","state_id":27},
{"id":2177,"description":"Goiatuba","state_id":9},
{"id":8464,"description":"Goio-En (Chapecó)","state_id":24},
{"id":7743,"description":"Goio-En (Erval Grande)","state_id":23},
{"id":6108,"description":"Goioerê","state_id":18},
{"id":6109,"description":"Goioxim","state_id":18},
{"id":6925,"description":"Goitacazes (Campos dos Goytacazes)","state_id":19},
{"id":2176,"description":"Goiás","state_id":9},
{"id":2174,"description":"Goiânia","state_id":9},
{"id":600,"description":"Gongogi","state_id":5},
{"id":3165,"description":"Gonzaga","state_id":11},
{"id":3164,"description":"Gonçalves","state_id":11},
{"id":2460,"description":"Gonçalves Dias","state_id":10},
{"id":5262,"description":"Gonçalves Ferreira (Caruaru)","state_id":16},
{"id":6111,"description":"Gonçalves Júnior (Irati)","state_id":18},
{"id":3166,"description":"Gororós (Dom Joaquim)","state_id":11},
{"id":3167,"description":"Gorutuba (Porteirinha)","state_id":11},
{"id":3168,"description":"Gouveia","state_id":11},
{"id":2178,"description":"Gouvelândia","state_id":9},
{"id":2461,"description":"Governador Archer","state_id":10},
{"id":8465,"description":"Governador Celso Ramos","state_id":24},
{"id":7177,"description":"Governador Dix-Sept Rosado","state_id":20},
{"id":2462,"description":"Governador Edison Lobão","state_id":10},
{"id":2463,"description":"Governador Eugênio Barros","state_id":10},
{"id":7331,"description":"Governador Jorge Teixeira","state_id":21},
{"id":601,"description":"Governador João Durval Carneiro (Feira de Santana)","state_id":5},
{"id":1873,"description":"Governador Lacerda de Aguiar (Água Doce do Norte)","state_id":8},
{"id":1874,"description":"Governador Lindenberg","state_id":8},
{"id":405,"description":"Governador Lomanto Júnior","state_id":5},
{"id":2464,"description":"Governador Luiz Rocha","state_id":10},
{"id":602,"description":"Governador Mangabeira","state_id":5},
{"id":2465,"description":"Governador Newton Bello","state_id":10},
{"id":2466,"description":"Governador Nunes Freire","state_id":10},
{"id":6926,"description":"Governador Portela (Miguel Pereira)","state_id":19},
{"id":3169,"description":"Governador Valadares","state_id":11},
{"id":8793,"description":"Gracho Cardoso","state_id":25},
{"id":6112,"description":"Graciosa (Paranavaí)","state_id":18},
{"id":4636,"description":"Gradaus (Ourilândia do Norte)","state_id":14},
{"id":2468,"description":"Grajaú","state_id":10},
{"id":9157,"description":"Gramadinho (Itapetininga)","state_id":26},
{"id":7744,"description":"Gramado","state_id":23},
{"id":7746,"description":"Gramado São Pedro (Fontoura Xavier)","state_id":23},
{"id":7747,"description":"Gramado Xavier","state_id":23},
{"id":7745,"description":"Gramado dos Loureiros","state_id":23},
{"id":3170,"description":"Gramínea (Andradas)","state_id":11},
{"id":3171,"description":"Granada (Abre Campo)","state_id":11},
{"id":12686,"description":"Grande Basílio","state_id":6},
{"id":6113,"description":"Grandes Rios","state_id":18},
{"id":5263,"description":"Granito","state_id":16},
{"id":1362,"description":"Granja","state_id":6},
{"id":12449,"description":"Granja Getúlio Vargas","state_id":23},
{"id":1363,"description":"Granjeiro","state_id":6},
{"id":8468,"description":"Gravatal","state_id":24},
{"id":7748,"description":"Gravataí","state_id":23},
{"id":5264,"description":"Gravatá","state_id":16},
{"id":5265,"description":"Gravatá do Ibiapina (Taquaritinga do Norte)","state_id":16},
{"id":1361,"description":"Graça","state_id":6},
{"id":2467,"description":"Graça Aranha","state_id":10},
{"id":1875,"description":"Graça Aranha (Colatina)","state_id":8},
{"id":1364,"description":"Groairas","state_id":6},
{"id":7178,"description":"Grossos","state_id":20},
{"id":11746,"description":"Grossos","state_id":16},
{"id":3173,"description":"Grota (Jequeri)","state_id":11},
{"id":5266,"description":"Grotão (Venturosa)","state_id":16},
{"id":3174,"description":"Grupiara","state_id":11},
{"id":1876,"description":"Gruta (Cachoeiro de Itapemirim)","state_id":8},
{"id":8467,"description":"Grápia (Paraíso)","state_id":24},
{"id":3172,"description":"Grão Mogol","state_id":11},
{"id":8466,"description":"Grão Pará","state_id":24},
{"id":7749,"description":"Guabiju","state_id":23},
{"id":8469,"description":"Guabiruba","state_id":24},
{"id":9158,"description":"Guachos (Martinópolis)","state_id":26},
{"id":5597,"description":"Guadalupe","state_id":17},
{"id":4171,"description":"Guadalupe do Alto Paraná (Três Lagoas)","state_id":12},
{"id":603,"description":"Guagirus (Camaçari)","state_id":5},
{"id":9159,"description":"Guaianas (Pederneiras)","state_id":26},
{"id":9161,"description":"Guaimbê","state_id":26},
{"id":3176,"description":"Guaipava (Paraguaçu)","state_id":11},
{"id":6114,"description":"Guaiporã (Cafezal do Sul)","state_id":18},
{"id":6116,"description":"Guairaçá","state_id":18},
{"id":6117,"description":"Guairaçá (Guarapuava)","state_id":18},
{"id":6118,"description":"Guairaçá (Londrina)","state_id":18},
{"id":9160,"description":"Guaiçara","state_id":26},
{"id":1365,"description":"Guaiúba","state_id":6},
{"id":227,"description":"Guajará","state_id":3},
{"id":4637,"description":"Guajará-Açú (Bujaru)","state_id":14},
{"id":4638,"description":"Guajará-Miri (Acará)","state_id":14},
{"id":7332,"description":"Guajará-Mirim","state_id":21},
{"id":605,"description":"Guajeru","state_id":5},
{"id":1366,"description":"Guajiru (Fortim)","state_id":6},
{"id":6119,"description":"Guajuvira (Araucária)","state_id":18},
{"id":7751,"description":"Guajuviras (Canoas)","state_id":23},
{"id":7179,"description":"Guamaré","state_id":20},
{"id":6120,"description":"Guamiranga","state_id":18},
{"id":6121,"description":"Guamirim (Irati)","state_id":18},
{"id":9163,"description":"Guamium (Piracicaba)","state_id":26},
{"id":1367,"description":"Guanacés (Cascavel)","state_id":6},
{"id":606,"description":"Guanambi","state_id":5},
{"id":3177,"description":"Guanhães","state_id":11},
{"id":5267,"description":"Guanumbi (Buíque)","state_id":16},
{"id":9165,"description":"Guapiara","state_id":26},
{"id":9164,"description":"Guapiaçu","state_id":26},
{"id":6927,"description":"Guapimirim","state_id":19},
{"id":607,"description":"Guapira (Maragogipe)","state_id":5},
{"id":6122,"description":"Guapirama","state_id":18},
{"id":9166,"description":"Guapiranga (Lins)","state_id":26},
{"id":8470,"description":"Guaporanga (Biguaçu)","state_id":24},
{"id":6124,"description":"Guaporema","state_id":18},
{"id":12100,"description":"Guaporé","state_id":21},
{"id":7752,"description":"Guaporé","state_id":23},
{"id":6123,"description":"Guaporé (Guaraniaçu)","state_id":18},
{"id":3178,"description":"Guapé","state_id":11},
{"id":2179,"description":"Guapó","state_id":9},
{"id":4949,"description":"Guarabira","state_id":15},
{"id":9169,"description":"Guaraci","state_id":26},
{"id":6126,"description":"Guaraci","state_id":18},
{"id":3179,"description":"Guaraciaba","state_id":11},
{"id":8471,"description":"Guaraciaba","state_id":24},
{"id":9170,"description":"Guaraciaba D'Oeste (Tupi Paulista)","state_id":26},
{"id":1368,"description":"Guaraciaba do Norte","state_id":6},
{"id":3180,"description":"Guaraciama","state_id":11},
{"id":6127,"description":"Guaragi (Ponta Grossa)","state_id":18},
{"id":6128,"description":"Guaraituba (Colombo)","state_id":18},
{"id":608,"description":"Guarajuba (Camaçari)","state_id":5},
{"id":1369,"description":"Guaramiranga","state_id":6},
{"id":8472,"description":"Guaramirim","state_id":24},
{"id":3182,"description":"Guarani","state_id":11},
{"id":6129,"description":"Guarani (Nova Laranjeiras)","state_id":18},
{"id":9171,"description":"Guarani D'Oeste","state_id":26},
{"id":7753,"description":"Guarani das Missões","state_id":23},
{"id":2181,"description":"Guarani de Goiás","state_id":9},
{"id":6130,"description":"Guaraniaçu","state_id":18},
{"id":3183,"description":"Guaranilândia (Jequitinhonha)","state_id":11},
{"id":9172,"description":"Guarantã","state_id":26},
{"id":4367,"description":"Guarantã do Norte","state_id":13},
{"id":1878,"description":"Guaraná (Aracruz)","state_id":8},
{"id":3181,"description":"Guaranésia","state_id":11},
{"id":1879,"description":"Guarapari","state_id":8},
{"id":9173,"description":"Guarapiranga (Ribeirão Bonito)","state_id":26},
{"id":6131,"description":"Guarapuava","state_id":18},
{"id":6132,"description":"Guarapuavinha (Francisco Beltrão)","state_id":18},
{"id":9174,"description":"Guarapuá (Dois Córregos)","state_id":26},
{"id":6133,"description":"Guaraqueçaba","state_id":18},
{"id":9175,"description":"Guararapes","state_id":26},
{"id":9176,"description":"Guararema","state_id":26},
{"id":6134,"description":"Guararema (Castro)","state_id":18},
{"id":1880,"description":"Guararema (Nova Venécia)","state_id":8},
{"id":1370,"description":"Guararu (Caucaia)","state_id":6},
{"id":3184,"description":"Guarará","state_id":11},
{"id":3185,"description":"Guarataia (Itambacuri)","state_id":11},
{"id":609,"description":"Guaratinga","state_id":5},
{"id":9177,"description":"Guaratinguetá","state_id":26},
{"id":6135,"description":"Guaratuba","state_id":18},
{"id":6137,"description":"Guaravera (Londrina)","state_id":18},
{"id":9168,"description":"Guaraçaí","state_id":26},
{"id":9861,"description":"Guaraí","state_id":27},
{"id":10733,"description":"Guaraí","state_id":18},
{"id":2180,"description":"Guaraíta","state_id":9},
{"id":6136,"description":"Guaraúna (Teixeira Soares)","state_id":18},
{"id":3186,"description":"Guarda dos Ferreiros (São Gotardo)","state_id":11},
{"id":3187,"description":"Guarda-Mor","state_id":11},
{"id":6138,"description":"Guardamoria (Telêmaco Borba)","state_id":18},
{"id":3188,"description":"Guardinha (São Sebastião do Paraíso)","state_id":11},
{"id":9178,"description":"Guareí","state_id":26},
{"id":9179,"description":"Guariba","state_id":26},
{"id":12072,"description":"Guariba","state_id":13},
{"id":5598,"description":"Guaribas","state_id":17},
{"id":2182,"description":"Guarinos","state_id":9},
{"id":9180,"description":"Guariroba (Taquaritinga)","state_id":26},
{"id":4950,"description":"Guarita (Itabaiana)","state_id":15},
{"id":4368,"description":"Guarita (Várzea Grande)","state_id":13},
{"id":9181,"description":"Guarizinho (Itapeva)","state_id":26},
{"id":9182,"description":"Guarujá","state_id":26},
{"id":8473,"description":"Guarujá do Sul","state_id":24},
{"id":9183,"description":"Guarulhos","state_id":26},
{"id":1784,"description":"Guará","state_id":7},
{"id":9167,"description":"Guará","state_id":26},
{"id":12458,"description":"Guará","state_id":23},
{"id":6125,"description":"Guará (Guarapuava)","state_id":18},
{"id":1371,"description":"Guassi (Redenção)","state_id":6},
{"id":1372,"description":"Guassossé (Orós)","state_id":6},
{"id":11878,"description":"Guassu Boi","state_id":23},
{"id":7754,"description":"Guassupi (São Pedro do Sul)","state_id":23},
{"id":8475,"description":"Guatambú","state_id":24},
{"id":9184,"description":"Guatapará","state_id":26},
{"id":8474,"description":"Guatá (Lauro Müller)","state_id":24},
{"id":3189,"description":"Guaxima (Conquista)","state_id":11},
{"id":3190,"description":"Guaxupé","state_id":11},
{"id":4169,"description":"Guaçu (Dourados)","state_id":12},
{"id":4170,"description":"Guaçulândia (Glória de Dourados)","state_id":12},
{"id":1877,"description":"Guaçuí","state_id":8},
{"id":3175,"description":"Guaçuí (Várzea da Palma)","state_id":11},
{"id":604,"description":"Guaí (Maragogipe)","state_id":5},
{"id":7750,"description":"Guaíba","state_id":23},
{"id":9162,"description":"Guaíra","state_id":26},
{"id":6115,"description":"Guaíra","state_id":18},
{"id":610,"description":"Guerém (Valença)","state_id":5},
{"id":1373,"description":"Guia (Boa Viagem)","state_id":6},
{"id":4172,"description":"Guia Lopes da Laguna","state_id":12},
{"id":6928,"description":"Guia de Pacobaíba (Magé)","state_id":19},
{"id":3191,"description":"Guidoval","state_id":11},
{"id":3192,"description":"Guimarânia","state_id":11},
{"id":2469,"description":"Guimarães","state_id":10},
{"id":3193,"description":"Guinda (Diamantina)","state_id":11},
{"id":611,"description":"Guiné (Mucugê)","state_id":5},
{"id":612,"description":"Guirapa (Pindaí)","state_id":5},
{"id":4369,"description":"Guiratinga","state_id":13},
{"id":3194,"description":"Guiricema","state_id":11},
{"id":3195,"description":"Gurinhatã","state_id":11},
{"id":4951,"description":"Gurinhém","state_id":15},
{"id":1374,"description":"Guriú (Camocim)","state_id":6},
{"id":4952,"description":"Gurjão","state_id":15},
{"id":9862,"description":"Gurupi","state_id":27},
{"id":4640,"description":"Gurupizinho (Paragominas)","state_id":14},
{"id":299,"description":"Gurupora (Macapá)","state_id":4},
{"id":4639,"description":"Gurupá","state_id":14},
{"id":613,"description":"Gurupá Mirim (Potiraguá)","state_id":5},
{"id":9185,"description":"Guzolândia","state_id":26},
{"id":9149,"description":"Gália","state_id":26},
{"id":1354,"description":"Gázea (Ipueiras)","state_id":6},
{"id":6110,"description":"Góis (Guarapuava)","state_id":18},
{"id":7755,"description":"Harmonia","state_id":23},
{"id":11560,"description":"Harmonia","state_id":23},
{"id":6139,"description":"Harmonia (Telêmaco Borba)","state_id":18},
{"id":2183,"description":"Heitoraí","state_id":9},
{"id":3196,"description":"Heliodora","state_id":11},
{"id":614,"description":"Heliópolis","state_id":5},
{"id":615,"description":"Helvecia (Nova Viçosa)","state_id":5},
{"id":3197,"description":"Hematita (Antônio Dias)","state_id":11},
{"id":5268,"description":"Henrique Dias (Sertânia)","state_id":16},
{"id":8477,"description":"Herciliópolis (Água Doce)","state_id":24},
{"id":9186,"description":"Herculândia","state_id":26},
{"id":6140,"description":"Herculândia (Ivaté)","state_id":18},
{"id":8476,"description":"Hercílio Luz (Araranguá)","state_id":24},
{"id":3198,"description":"Hermilo Alves (Carandaí)","state_id":11},
{"id":7756,"description":"Herval","state_id":23},
{"id":8478,"description":"Herval D'Oeste","state_id":24},
{"id":6141,"description":"Herval Grande (Laranjeiras do Sul)","state_id":18},
{"id":6142,"description":"Herveira (Campina da Lagoa)","state_id":18},
{"id":6143,"description":"Herveira (Nova Laranjeiras)","state_id":18},
{"id":7757,"description":"Herveiras","state_id":23},
{"id":6144,"description":"Hidrelétrica Itaipu (Foz do Iguaçu)","state_id":18},
{"id":4641,"description":"Hidrelétrica Tucuruí (Tucuruí)","state_id":14},
{"id":2185,"description":"Hidrolina","state_id":9},
{"id":1375,"description":"Hidrolândia","state_id":6},
{"id":2184,"description":"Hidrolândia","state_id":9},
{"id":616,"description":"Hidrolândia (Uibaí)","state_id":5},
{"id":7758,"description":"Hidráulica (Capão do Leão)","state_id":23},
{"id":9187,"description":"Holambra","state_id":26},
{"id":9188,"description":"Holambra II (Paranapanema)","state_id":26},
{"id":1376,"description":"Holanda (Tamboril)","state_id":6},
{"id":3199,"description":"Honorópolis (Campina Verde)","state_id":11},
{"id":6145,"description":"Honório Serpa","state_id":18},
{"id":1377,"description":"Horizonte","state_id":6},
{"id":4370,"description":"Horizonte do Oeste (Cáceres)","state_id":13},
{"id":7759,"description":"Horizontina","state_id":23},
{"id":9189,"description":"Hortolândia","state_id":26},
{"id":5599,"description":"Hugo Napoleão","state_id":17},
{"id":7760,"description":"Hulha Negra","state_id":23},
{"id":228,"description":"Humaitá","state_id":3},
{"id":7761,"description":"Humaitá","state_id":23},
{"id":11090,"description":"Humaitá","state_id":11},
{"id":2470,"description":"Humberto de Campos","state_id":10},
{"id":617,"description":"Humildes (Feira de Santana)","state_id":5},
{"id":9190,"description":"Iacanga","state_id":26},
{"id":2186,"description":"Iaciara","state_id":9},
{"id":9191,"description":"Iacri","state_id":26},
{"id":1378,"description":"Iapi (Independência)","state_id":6},
{"id":3200,"description":"Iapu","state_id":11},
{"id":1379,"description":"Iara (Barro)","state_id":6},
{"id":6146,"description":"Iarama (Umuarama)","state_id":18},
{"id":9192,"description":"Iaras","state_id":26},
{"id":4642,"description":"Iataí (Altamira)","state_id":14},
{"id":5269,"description":"Iateca (Saloá)","state_id":16},
{"id":5270,"description":"Iati","state_id":16},
{"id":229,"description":"Iauaretê (São Gabriel da Cachoeira)","state_id":3},
{"id":618,"description":"Iaçu","state_id":5},
{"id":6147,"description":"Ibaiti","state_id":18},
{"id":7762,"description":"Ibarama","state_id":23},
{"id":1380,"description":"Ibaretama","state_id":6},
{"id":7763,"description":"Ibaré (Lavras do Sul)","state_id":23},
{"id":85,"description":"Ibateguara","state_id":2},
{"id":1881,"description":"Ibatiba","state_id":8},
{"id":619,"description":"Ibatui (Entre Rios)","state_id":5},
{"id":9193,"description":"Ibaté","state_id":26},
{"id":6148,"description":"Ibema","state_id":18},
{"id":3201,"description":"Ibertioga","state_id":11},
{"id":1882,"description":"Ibes (Vila Velha)","state_id":8},
{"id":6149,"description":"Ibiaci (Primeiro de Maio)","state_id":18},
{"id":621,"description":"Ibiajara (Rio do Pires)","state_id":5},
{"id":8479,"description":"Ibiam","state_id":24},
{"id":1381,"description":"Ibiapaba (Crateús)","state_id":6},
{"id":1382,"description":"Ibiapina","state_id":6},
{"id":622,"description":"Ibiapora (Mundo Novo)","state_id":5},
{"id":4953,"description":"Ibiara","state_id":15},
{"id":623,"description":"Ibiassucê","state_id":5},
{"id":620,"description":"Ibiaçu (Maraú)","state_id":5},
{"id":7764,"description":"Ibiaçá","state_id":23},
{"id":3203,"description":"Ibiaí","state_id":11},
{"id":1883,"description":"Ibicaba (Afonso Cláudio)","state_id":8},
{"id":624,"description":"Ibicaraí","state_id":5},
{"id":8480,"description":"Ibicaré","state_id":24},
{"id":1383,"description":"Ibicatu (Várzea Alegre)","state_id":6},
{"id":625,"description":"Ibicoara","state_id":5},
{"id":1385,"description":"Ibicuitaba (Icapuí)","state_id":6},
{"id":1386,"description":"Ibicuitinga","state_id":6},
{"id":1384,"description":"Ibicuã (Piquet Carneiro)","state_id":6},
{"id":626,"description":"Ibicuí","state_id":5},
{"id":8481,"description":"Ibicuí (Campos Novos)","state_id":24},
{"id":5271,"description":"Ibimirim","state_id":16},
{"id":627,"description":"Ibipeba","state_id":5},
{"id":12789,"description":"Ibipeba","state_id":19},
{"id":628,"description":"Ibipetum (Ipupiara)","state_id":5},
{"id":2471,"description":"Ibipira (Mirador)","state_id":10},
{"id":629,"description":"Ibipitanga","state_id":5},
{"id":9194,"description":"Ibiporanga (Tanabi)","state_id":26},
{"id":6150,"description":"Ibiporã","state_id":18},
{"id":630,"description":"Ibiquera","state_id":5},
{"id":631,"description":"Ibiraba (Barra)","state_id":5},
{"id":3204,"description":"Ibiracatu","state_id":11},
{"id":3205,"description":"Ibiraci","state_id":11},
{"id":7765,"description":"Ibiraiaras","state_id":23},
{"id":5272,"description":"Ibirajuba","state_id":16},
{"id":632,"description":"Ibirajá (Itanhém)","state_id":5},
{"id":8482,"description":"Ibirama","state_id":24},
{"id":5273,"description":"Ibiranga (Itambé)","state_id":16},
{"id":633,"description":"Ibiranhém (Mucuri)","state_id":5},
{"id":634,"description":"Ibirapitanga","state_id":5},
{"id":7766,"description":"Ibirapuitã","state_id":23},
{"id":635,"description":"Ibirapuã","state_id":5},
{"id":9196,"description":"Ibirarema","state_id":26},
{"id":636,"description":"Ibirataia","state_id":5},
{"id":5274,"description":"Ibiratinga (Sirinhaém)","state_id":16},
{"id":1884,"description":"Ibiraçu","state_id":8},
{"id":3206,"description":"Ibirité","state_id":11},
{"id":7767,"description":"Ibirubá","state_id":23},
{"id":9195,"description":"Ibirá","state_id":26},
{"id":637,"description":"Ibitiara","state_id":5},
{"id":6929,"description":"Ibitiguaçu (Santo Antônio de Pádua)","state_id":19},
{"id":638,"description":"Ibitiguira (Planaltino)","state_id":5},
{"id":9197,"description":"Ibitinga","state_id":26},
{"id":6930,"description":"Ibitioca (Campos dos Goytacazes)","state_id":19},
{"id":3207,"description":"Ibitira (Martinho Campos)","state_id":11},
{"id":639,"description":"Ibitira (Rio do Antônio)","state_id":5},
{"id":1885,"description":"Ibitirama","state_id":8},
{"id":5275,"description":"Ibitiranga (Carnaíba)","state_id":16},
{"id":9198,"description":"Ibitiruna (Piracicaba)","state_id":26},
{"id":1886,"description":"Ibitiruí (Alfredo Chaves)","state_id":8},
{"id":640,"description":"Ibititá","state_id":5},
{"id":3208,"description":"Ibitiúra de Minas","state_id":11},
{"id":9199,"description":"Ibitiúva (Pitangueiras)","state_id":26},
{"id":9200,"description":"Ibitu (Barretos)","state_id":26},
{"id":1887,"description":"Ibituba (Baixo Guandu)","state_id":8},
{"id":641,"description":"Ibitunane (Gentio do Ouro)","state_id":5},
{"id":642,"description":"Ibitupa (Ibicuí)","state_id":5},
{"id":6931,"description":"Ibituporanga (Itaguaí)","state_id":19},
{"id":3209,"description":"Ibituruna","state_id":11},
{"id":3202,"description":"Ibiá","state_id":11},
{"id":9201,"description":"Ibiúna","state_id":26},
{"id":1387,"description":"Iborepi (Lavras da Mangabeira)","state_id":6},
{"id":644,"description":"Ibotirama","state_id":5},
{"id":1388,"description":"Ibuaçu (Boa Viagem)","state_id":6},
{"id":1389,"description":"Ibuguaçu (Granja)","state_id":6},
{"id":643,"description":"Ibó (Abaré)","state_id":5},
{"id":5276,"description":"Ibó (Belém de São Francisco)","state_id":16},
{"id":5277,"description":"Icaiçara (Parnamirim)","state_id":16},
{"id":1390,"description":"Icapuí","state_id":6},
{"id":1391,"description":"Icaraí (Amontada)","state_id":6},
{"id":3210,"description":"Icaraí de Minas","state_id":11},
{"id":6152,"description":"Icaraíma","state_id":18},
{"id":2472,"description":"Icatu","state_id":10},
{"id":6153,"description":"Icatu (Querência do Norte)","state_id":18},
{"id":645,"description":"Ichu","state_id":5},
{"id":4643,"description":"Icoaraci (Belém)","state_id":14},
{"id":1888,"description":"Iconha","state_id":8},
{"id":1393,"description":"Icozinho (Icó)","state_id":6},
{"id":9202,"description":"Icém","state_id":26},
{"id":1392,"description":"Icó","state_id":6},
{"id":646,"description":"Icó (Morro do Chapéu)","state_id":5},
{"id":9203,"description":"Ida Iolanda (Nhandeara)","state_id":26},
{"id":10752,"description":"Idamar","state_id":24},
{"id":1394,"description":"Ideal (Aracoiaba)","state_id":6},
{"id":7180,"description":"Ielmo Marinho","state_id":20},
{"id":9204,"description":"Iepê","state_id":26},
{"id":86,"description":"Igaci","state_id":2},
{"id":647,"description":"Igaporã","state_id":5},
{"id":5278,"description":"Igapó (Lagoa do Ouro)","state_id":16},
{"id":4954,"description":"Igaracy","state_id":15},
{"id":9208,"description":"Igarapava","state_id":26},
{"id":5279,"description":"Igarapeassu (Lagoa dos Gatos)","state_id":16},
{"id":5280,"description":"Igarapeba (São Benedito do Sul)","state_id":16},
{"id":3211,"description":"Igarapé","state_id":11},
{"id":2474,"description":"Igarapé Grande","state_id":10},
{"id":4644,"description":"Igarapé da Lama (Santarém)","state_id":14},
{"id":300,"description":"Igarapé do Lago (Santana)","state_id":4},
{"id":2473,"description":"Igarapé do Meio","state_id":10},
{"id":4645,"description":"Igarapé-Açu","state_id":14},
{"id":4646,"description":"Igarapé-Miri","state_id":14},
{"id":5281,"description":"Igarassu","state_id":16},
{"id":3212,"description":"Igaratinga","state_id":11},
{"id":9209,"description":"Igaratá","state_id":26},
{"id":9206,"description":"Igaraçu do Tietê","state_id":26},
{"id":9207,"description":"Igaraí (Mococa)","state_id":26},
{"id":649,"description":"Igarité (Barra)","state_id":5},
{"id":1395,"description":"Igaroi (Orós)","state_id":6},
{"id":648,"description":"Igará (Senhor do Bonfim)","state_id":5},
{"id":650,"description":"Igatu (Andaraí)","state_id":5},
{"id":9205,"description":"Igaçaba (Pedregulho)","state_id":26},
{"id":651,"description":"Igrapiúna","state_id":5},
{"id":87,"description":"Igreja Nova","state_id":2},
{"id":11707,"description":"Igreja Nova","state_id":16},
{"id":7181,"description":"Igreja Nova (São Gonçalo do Amarante)","state_id":20},
{"id":7768,"description":"Igrejinha","state_id":23},
{"id":12784,"description":"Igrejinha","state_id":23},
{"id":7769,"description":"Igrejinha (Carazinho)","state_id":23},
{"id":6154,"description":"Igrejinha (Guarapuava)","state_id":18},
{"id":6932,"description":"Iguaba Grande","state_id":19},
{"id":654,"description":"Iguaibi (Iguaí)","state_id":5},
{"id":9210,"description":"Iguape","state_id":26},
{"id":5282,"description":"Iguaraci","state_id":16},
{"id":6155,"description":"Iguaraçu","state_id":18},
{"id":3213,"description":"Iguatama","state_id":11},
{"id":4173,"description":"Iguatemi","state_id":12},
{"id":655,"description":"Iguatemi (Livramento de Nossa Senhora)","state_id":5},
{"id":6156,"description":"Iguatemi (Maringá)","state_id":18},
{"id":1396,"description":"Iguatu","state_id":6},
{"id":6157,"description":"Iguatu","state_id":18},
{"id":12120,"description":"Iguaçu","state_id":6},
{"id":653,"description":"Iguaí","state_id":5},
{"id":6158,"description":"Iguiporã (Marechal Cândido Rondon)","state_id":18},
{"id":656,"description":"Iguira (Xique-Xique)","state_id":5},
{"id":657,"description":"Iguitu (Ibipeba)","state_id":5},
{"id":652,"description":"Iguá (Vitória da Conquista)","state_id":5},
{"id":3214,"description":"Ijaci","state_id":11},
{"id":7770,"description":"Ijucapirama (Jaguari)","state_id":23},
{"id":7771,"description":"Ijuí","state_id":23},
{"id":9863,"description":"Ilha Barreira Branca (Araguaína)","state_id":27},
{"id":9211,"description":"Ilha Comprida","state_id":26},
{"id":4174,"description":"Ilha Comprida (Três Lagoas)","state_id":12},
{"id":10611,"description":"Ilha De Bom Jesus Dos Passos","state_id":5},
{"id":11477,"description":"Ilha De Eufrasina","state_id":18},
{"id":11479,"description":"Ilha De São Miguel","state_id":18},
{"id":9212,"description":"Ilha Diana (Santos)","state_id":26},
{"id":11476,"description":"Ilha Do Amparo","state_id":18},
{"id":12774,"description":"Ilha Do Rio Doce","state_id":11},
{"id":11478,"description":"Ilha Do Teixeira","state_id":18},
{"id":10612,"description":"Ilha Dos Frades","state_id":5},
{"id":11475,"description":"Ilha Encantada","state_id":18},
{"id":5600,"description":"Ilha Grande","state_id":17},
{"id":4175,"description":"Ilha Grande (Aparecida do Taboado)","state_id":12},
{"id":9213,"description":"Ilha Solteira","state_id":26},
{"id":8794,"description":"Ilha das Flores","state_id":25},
{"id":100001,"description":"Ilha de Itamaracá","state_id":16},
{"id":658,"description":"Ilha de Mare (Salvador)","state_id":5},
{"id":301,"description":"Ilha de Santana (Santana)","state_id":4},
{"id":6159,"description":"Ilha do Mel (Paranaguá)","state_id":18},
{"id":7772,"description":"Ilha dos Marinheiros (Rio Grande)","state_id":23},
{"id":6160,"description":"Ilha dos Valadares (Paranaguá)","state_id":18},
{"id":9214,"description":"Ilhabela","state_id":26},
{"id":8484,"description":"Ilhota","state_id":24},
{"id":659,"description":"Ilhéus","state_id":5},
{"id":3215,"description":"Ilhéus do Prata (São Domingos do Prata)","state_id":11},
{"id":3216,"description":"Ilicínea","state_id":11},
{"id":7773,"description":"Ilópolis","state_id":23},
{"id":4955,"description":"Imaculada","state_id":15},
{"id":8485,"description":"Imaruí","state_id":24},
{"id":6933,"description":"Imbariê (Duque de Caxias)","state_id":19},
{"id":6162,"description":"Imbauzinho (Telêmaco Borba)","state_id":18},
{"id":6161,"description":"Imbaú","state_id":18},
{"id":8486,"description":"Imbituba","state_id":24},
{"id":6163,"description":"Imbituva","state_id":18},
{"id":8487,"description":"Imbuia","state_id":24},
{"id":1889,"description":"Imburana (Ecoporanga)","state_id":8},
{"id":7774,"description":"Imbé","state_id":23},
{"id":3217,"description":"Imbé de Minas","state_id":11},
{"id":7775,"description":"Imigrante","state_id":23},
{"id":2475,"description":"Imperatriz","state_id":10},
{"id":2187,"description":"Inaciolândia","state_id":9},
{"id":6165,"description":"Inajá","state_id":18},
{"id":5283,"description":"Inajá","state_id":16},
{"id":302,"description":"Inajá (Macapá)","state_id":4},
{"id":4647,"description":"Inanu (Santarém)","state_id":14},
{"id":3218,"description":"Inconfidentes","state_id":11},
{"id":6934,"description":"Inconfidência (Paraíba do Sul)","state_id":19},
{"id":3219,"description":"Indaiabira","state_id":11},
{"id":8488,"description":"Indaial","state_id":24},
{"id":9216,"description":"Indaiatuba","state_id":26},
{"id":4177,"description":"Indaiá Grande (Paranaíba)","state_id":12},
{"id":9215,"description":"Indaiá do Aguapeí (Flórida Paulista)","state_id":26},
{"id":4176,"description":"Indaiá do Sul (Cassilândia)","state_id":12},
{"id":660,"description":"Indaí (Mundo Novo)","state_id":5},
{"id":1397,"description":"Independência","state_id":6},
{"id":7776,"description":"Independência","state_id":23},
{"id":6166,"description":"Independência (Pato Branco)","state_id":18},
{"id":3220,"description":"Independência (Resplendor)","state_id":11},
{"id":9217,"description":"Indiana","state_id":26},
{"id":4371,"description":"Indianápolis (Barra do Garças)","state_id":13},
{"id":6167,"description":"Indianópolis","state_id":18},
{"id":3221,"description":"Indianópolis","state_id":11},
{"id":9218,"description":"Indiaporã","state_id":26},
{"id":2188,"description":"Indiara","state_id":9},
{"id":8795,"description":"Indiaroba","state_id":25},
{"id":4372,"description":"Indiavaí","state_id":13},
{"id":12738,"description":"Industrial","state_id":21},
{"id":4178,"description":"Indápolis (Dourados)","state_id":12},
{"id":661,"description":"Inema (Ilhéus)","state_id":5},
{"id":5284,"description":"Ingazeira","state_id":16},
{"id":1398,"description":"Ingazeiras (Aurora)","state_id":6},
{"id":3222,"description":"Ingaí","state_id":11},
{"id":8490,"description":"Ingleses do Rio Vermelho (Florianópolis)","state_id":24},
{"id":4956,"description":"Ingá","state_id":15},
{"id":11636,"description":"Ingá","state_id":2},
{"id":9219,"description":"Ingás (Nova Granada)","state_id":26},
{"id":7777,"description":"Inhacorá","state_id":23},
{"id":662,"description":"Inhambupe","state_id":5},
{"id":1399,"description":"Inhamuns (Tauá)","state_id":6},
{"id":11879,"description":"Inhanduí","state_id":23},
{"id":4648,"description":"Inhangapi","state_id":14},
{"id":88,"description":"Inhapi","state_id":2},
{"id":3224,"description":"Inhapim","state_id":11},
{"id":663,"description":"Inhata (Amélia Rodrigues)","state_id":5},
{"id":3223,"description":"Inhaí (Diamantina)","state_id":11},
{"id":3225,"description":"Inhaúma","state_id":11},
{"id":664,"description":"Inhaúmas (Santa Maria da Vitória)","state_id":5},
{"id":665,"description":"Inhobim (Vitória da Conquista)","state_id":5},
{"id":6935,"description":"Inhomirim (Magé)","state_id":19},
{"id":5601,"description":"Inhuma","state_id":17},
{"id":2189,"description":"Inhumas","state_id":9},
{"id":1401,"description":"Inhuporanga (Caridade)","state_id":6},
{"id":1400,"description":"Inhuçu (São Benedito)","state_id":6},
{"id":3226,"description":"Inimutaba","state_id":11},
{"id":4179,"description":"Inocência","state_id":12},
{"id":6936,"description":"Inoã (Maricá)","state_id":19},
{"id":6168,"description":"Inspetor Carvalho (São José dos Pinhais)","state_id":18},
{"id":2190,"description":"Interlândia (Anápolis)","state_id":9},
{"id":6169,"description":"Invernada (Castro)","state_id":18},
{"id":8491,"description":"Invernada (Grão Pará)","state_id":24},
{"id":6170,"description":"Invernadinha (Guarapuava)","state_id":18},
{"id":6164,"description":"Inácio Martins","state_id":18},
{"id":666,"description":"Inúbia (Piatã)","state_id":5},
{"id":9220,"description":"Inúbia Paulista","state_id":26},
{"id":6171,"description":"Iolópolis (São Jorge d'Oeste)","state_id":18},
{"id":8492,"description":"Iomerê","state_id":24},
{"id":3227,"description":"Ipaba","state_id":11},
{"id":11091,"description":"Ipaguaçú","state_id":6},
{"id":2191,"description":"Ipameri","state_id":9},
{"id":3228,"description":"Ipanema","state_id":11},
{"id":11727,"description":"Ipanema","state_id":16},
{"id":7182,"description":"Ipanguaçu","state_id":20},
{"id":1402,"description":"Ipaporanga","state_id":6},
{"id":3229,"description":"Ipatinga","state_id":11},
{"id":1403,"description":"Ipaumirim","state_id":6},
{"id":9221,"description":"Ipaussu","state_id":26},
{"id":667,"description":"Ipecaetá","state_id":5},
{"id":9222,"description":"Iperó","state_id":26},
{"id":4180,"description":"Ipezal (Angélica)","state_id":12},
{"id":9223,"description":"Ipeúna","state_id":26},
{"id":6937,"description":"Ipiabás (Barra do Piraí)","state_id":19},
{"id":3230,"description":"Ipiaçu","state_id":11},
{"id":668,"description":"Ipiaú","state_id":5},
{"id":9224,"description":"Ipiguá","state_id":26},
{"id":6938,"description":"Ipiiba (São Gonçalo)","state_id":19},
{"id":8493,"description":"Ipira","state_id":24},
{"id":6172,"description":"Ipiranga","state_id":18},
{"id":6173,"description":"Ipiranga (Araucária)","state_id":18},
{"id":7779,"description":"Ipiranga (Gravataí)","state_id":23},
{"id":7183,"description":"Ipiranga (São José do Campestre)","state_id":20},
{"id":6174,"description":"Ipiranga (Toledo)","state_id":18},
{"id":11020,"description":"Ipiranga Do Norte","state_id":13},
{"id":10090,"description":"Ipiranga de Goiás","state_id":9},
{"id":5602,"description":"Ipiranga do Piauí","state_id":17},
{"id":7780,"description":"Ipiranga do Sul","state_id":23},
{"id":669,"description":"Ipirá","state_id":5},
{"id":10491,"description":"Ipituna","state_id":19},
{"id":231,"description":"Ipixuna","state_id":3},
{"id":4649,"description":"Ipixuna do Pará","state_id":14},
{"id":670,"description":"Ipiúna (Jaguaquara)","state_id":5},
{"id":3231,"description":"Ipoema (Itabira)","state_id":11},
{"id":5285,"description":"Ipojuca","state_id":16},
{"id":8494,"description":"Ipoméia (Rio das Antas)","state_id":24},
{"id":9225,"description":"Iporanga","state_id":26},
{"id":2192,"description":"Iporá","state_id":9},
{"id":6175,"description":"Iporã","state_id":18},
{"id":8495,"description":"Iporã do Oeste","state_id":24},
{"id":1404,"description":"Ipu","state_id":6},
{"id":8496,"description":"Ipuaçu","state_id":24},
{"id":7781,"description":"Ipuaçu (Caiçara)","state_id":23},
{"id":5286,"description":"Ipubi","state_id":16},
{"id":6939,"description":"Ipuca (São Fidélis)","state_id":19},
{"id":671,"description":"Ipucaba (Oliveira dos Brejinhos)","state_id":5},
{"id":7184,"description":"Ipueira","state_id":20},
{"id":1405,"description":"Ipueiras","state_id":6},
{"id":9864,"description":"Ipueiras","state_id":27},
{"id":1406,"description":"Ipueiras dos Gomes (Canindé)","state_id":6},
{"id":5287,"description":"Ipuera (Serrita)","state_id":16},
{"id":3232,"description":"Ipuiúna","state_id":11},
{"id":8497,"description":"Ipumirim","state_id":24},
{"id":672,"description":"Ipupiara","state_id":5},
{"id":9226,"description":"Ipuã","state_id":26},
{"id":7778,"description":"Ipê","state_id":23},
{"id":7380,"description":"Iracema","state_id":22},
{"id":1407,"description":"Iracema","state_id":6},
{"id":6176,"description":"Iracema do Oeste","state_id":18},
{"id":8498,"description":"Iraceminha","state_id":24},
{"id":9227,"description":"Iracemápolis","state_id":26},
{"id":5288,"description":"Iraguaçu (Triunfo)","state_id":16},
{"id":5289,"description":"Irajaí (Iguaraci)","state_id":16},
{"id":673,"description":"Irajuba","state_id":5},
{"id":1408,"description":"Irajá (Hidrolândia)","state_id":6},
{"id":8499,"description":"Irakitan (Tangará)","state_id":24},
{"id":674,"description":"Iramaia","state_id":5},
{"id":232,"description":"Iranduba","state_id":3},
{"id":8500,"description":"Irani","state_id":24},
{"id":675,"description":"Iraporanga (Iraquara)","state_id":5},
{"id":6177,"description":"Irapuan (Quinta do Sol)","state_id":18},
{"id":9230,"description":"Irapuru","state_id":26},
{"id":8501,"description":"Iraputã (Itaiópolis)","state_id":24},
{"id":9229,"description":"Irapuã","state_id":26},
{"id":1409,"description":"Irapuã (Crateús)","state_id":6},
{"id":9228,"description":"Irapé (Chavantes)","state_id":26},
{"id":676,"description":"Iraquara","state_id":5},
{"id":677,"description":"Irará","state_id":5},
{"id":5290,"description":"Iratama (Garanhuns)","state_id":16},
{"id":6178,"description":"Irati","state_id":18},
{"id":8502,"description":"Irati","state_id":24},
{"id":1410,"description":"Iratinga (Itapagé)","state_id":6},
{"id":1411,"description":"Irauçuba","state_id":6},
{"id":7782,"description":"Iraí","state_id":23},
{"id":3233,"description":"Iraí de Minas","state_id":11},
{"id":678,"description":"Irecê","state_id":5},
{"id":4373,"description":"Irenópolis (Juscimeira)","state_id":13},
{"id":6179,"description":"Irerê (Londrina)","state_id":18},
{"id":6180,"description":"Iretama","state_id":18},
{"id":8503,"description":"Irineópolis","state_id":24},
{"id":1890,"description":"Iriritiba (Anchieta)","state_id":8},
{"id":4650,"description":"Irituia","state_id":14},
{"id":1891,"description":"Irundi (Fundão)","state_id":8},
{"id":679,"description":"Irundiara (Jacaraci)","state_id":5},
{"id":1892,"description":"Irupi","state_id":8},
{"id":7783,"description":"Iruí (Rio Pardo)","state_id":23},
{"id":1893,"description":"Isabel (Domingos Martins)","state_id":8},
{"id":5603,"description":"Isaías Coelho","state_id":17},
{"id":1412,"description":"Isidoro (Acopiara)","state_id":6},
{"id":12563,"description":"Ismael","state_id":23},
{"id":2193,"description":"Israelândia","state_id":9},
{"id":680,"description":"Ita-Azul (Itamaraju)","state_id":5},
{"id":7784,"description":"Itaara","state_id":23},
{"id":8796,"description":"Itabaiana","state_id":25},
{"id":4957,"description":"Itabaiana","state_id":15},
{"id":1894,"description":"Itabaiana (Mucurici)","state_id":8},
{"id":8797,"description":"Itabaianinha","state_id":25},
{"id":6940,"description":"Itabapoana (São Francisco de Itabapoana)","state_id":19},
{"id":10211,"description":"Itabatã (Mucuri)","state_id":5},
{"id":681,"description":"Itabela","state_id":5},
{"id":682,"description":"Itaberaba","state_id":5},
{"id":2194,"description":"Itaberaí","state_id":9},
{"id":9231,"description":"Itaberá","state_id":26},
{"id":8798,"description":"Itabi","state_id":25},
{"id":3234,"description":"Itabira","state_id":11},
{"id":3235,"description":"Itabirinha","state_id":11},
{"id":3236,"description":"Itabirito","state_id":11},
{"id":9232,"description":"Itaboa (Ribeirão Branco)","state_id":26},
{"id":3237,"description":"Itaboca (Santa Rita de Jacutinga)","state_id":11},
{"id":6941,"description":"Itaboraí","state_id":19},
{"id":683,"description":"Itabuna","state_id":5},
{"id":9865,"description":"Itacajá","state_id":27},
{"id":3238,"description":"Itacambira","state_id":11},
{"id":3239,"description":"Itacarambi","state_id":11},
{"id":684,"description":"Itacaré","state_id":5},
{"id":685,"description":"Itacava (Coração de Maria)","state_id":5},
{"id":686,"description":"Itachama (Amargosa)","state_id":5},
{"id":3240,"description":"Itaci (Carmo do Rio Claro)","state_id":11},
{"id":1413,"description":"Itacima (Guaiúba)","state_id":6},
{"id":687,"description":"Itacimirim (Camaçari)","state_id":5},
{"id":233,"description":"Itacoatiara","state_id":3},
{"id":3241,"description":"Itacolomi (Conceição do Mato Dentro)","state_id":11},
{"id":7785,"description":"Itacolomi (Gravataí)","state_id":23},
{"id":5291,"description":"Itacuruba","state_id":16},
{"id":7786,"description":"Itacurubi","state_id":23},
{"id":7787,"description":"Itacurubi (Santiago)","state_id":23},
{"id":6942,"description":"Itacurussá (Mangaratiba)","state_id":19},
{"id":688,"description":"Itaeté","state_id":5},
{"id":689,"description":"Itagi","state_id":5},
{"id":690,"description":"Itagibá","state_id":5},
{"id":691,"description":"Itagimirim","state_id":5},
{"id":6181,"description":"Itaguajé","state_id":18},
{"id":3242,"description":"Itaguara","state_id":11},
{"id":2196,"description":"Itaguari","state_id":9},
{"id":2197,"description":"Itaguaru","state_id":9},
{"id":9866,"description":"Itaguatins","state_id":27},
{"id":1896,"description":"Itaguaçu","state_id":8},
{"id":2195,"description":"Itaguaçu (São Simão)","state_id":9},
{"id":692,"description":"Itaguaçu da Bahia","state_id":5},
{"id":6943,"description":"Itaguaí","state_id":19},
{"id":1414,"description":"Itaguá (Campos Sales)","state_id":6},
{"id":4181,"description":"Itahum (Dourados)","state_id":12},
{"id":693,"description":"Itaia (Firmino Alves)","state_id":5},
{"id":6182,"description":"Itaiacoca (Ponta Grossa)","state_id":18},
{"id":694,"description":"Itaibó (Jequié)","state_id":5},
{"id":1897,"description":"Itaici (Muniz Freire)","state_id":8},
{"id":3243,"description":"Itaim (Cachoeira de Minas)","state_id":11},
{"id":7789,"description":"Itaimbezinho (Bom Jesus)","state_id":23},
{"id":1898,"description":"Itaimbé (Itaguaçu)","state_id":8},
{"id":5604,"description":"Itainópolis","state_id":17},
{"id":1416,"description":"Itaipaba (Pacajus)","state_id":6},
{"id":1899,"description":"Itaipava (Itapemirim)","state_id":8},
{"id":6944,"description":"Itaipava (Petrópolis)","state_id":19},
{"id":2476,"description":"Itaipava do Grajaú","state_id":10},
{"id":6945,"description":"Itaipu (Niterói)","state_id":19},
{"id":695,"description":"Itaipu (Vitória da Conquista)","state_id":5},
{"id":12714,"description":"Itaipuaçu","state_id":19},
{"id":6183,"description":"Itaipulândia","state_id":18},
{"id":3244,"description":"Itaipé","state_id":11},
{"id":1417,"description":"Itaitinga","state_id":6},
{"id":4651,"description":"Itaituba","state_id":14},
{"id":9234,"description":"Itaiuba (Monte Aprazível)","state_id":26},
{"id":1415,"description":"Itaiçaba","state_id":6},
{"id":8505,"description":"Itaió (Itaiópolis)","state_id":24},
{"id":8506,"description":"Itaiópolis","state_id":24},
{"id":6946,"description":"Itajara (Itaperuna)","state_id":19},
{"id":8507,"description":"Itajaí","state_id":24},
{"id":697,"description":"Itajaí (Nova Canaã)","state_id":5},
{"id":9235,"description":"Itajobi","state_id":26},
{"id":9236,"description":"Itaju","state_id":26},
{"id":698,"description":"Itaju do Colônia","state_id":5},
{"id":699,"description":"Itajubaquara (Gentio do Ouro)","state_id":5},
{"id":4958,"description":"Itajubatiba (Catingueira)","state_id":15},
{"id":3245,"description":"Itajubá","state_id":11},
{"id":8508,"description":"Itajubá (Descanso)","state_id":24},
{"id":701,"description":"Itajuru (Jequié)","state_id":5},
{"id":3246,"description":"Itajutiba (Inhapim)","state_id":11},
{"id":700,"description":"Itajuípe","state_id":5},
{"id":7185,"description":"Itajá","state_id":20},
{"id":2198,"description":"Itajá","state_id":9},
{"id":6947,"description":"Italva","state_id":19},
{"id":5293,"description":"Itamaracá","state_id":16},
{"id":702,"description":"Itamaraju","state_id":5},
{"id":3247,"description":"Itamarandiba","state_id":11},
{"id":234,"description":"Itamarati","state_id":3},
{"id":3248,"description":"Itamarati (Águas Vermelhas)","state_id":11},
{"id":4374,"description":"Itamarati Norte (Tangará da Serra)","state_id":13},
{"id":3249,"description":"Itamarati de Minas","state_id":11},
{"id":703,"description":"Itamari","state_id":5},
{"id":2477,"description":"Itamataré (Carutapera)","state_id":10},
{"id":3250,"description":"Itambacuri","state_id":11},
{"id":6184,"description":"Itambaracá","state_id":18},
{"id":10431,"description":"Itambezinho (Campo Largo)","state_id":18},
{"id":6948,"description":"Itambi (Itaboraí)","state_id":19},
{"id":6185,"description":"Itambé","state_id":18},
{"id":704,"description":"Itambé","state_id":5},
{"id":5294,"description":"Itambé","state_id":16},
{"id":6186,"description":"Itambé (Campo Largo)","state_id":18},
{"id":3251,"description":"Itambé do Mato Dentro","state_id":11},
{"id":705,"description":"Itamira (Aporá)","state_id":5},
{"id":1900,"description":"Itamira (Ponto Belo)","state_id":8},
{"id":3252,"description":"Itamirim (Espinosa)","state_id":11},
{"id":3253,"description":"Itamogi","state_id":11},
{"id":3254,"description":"Itamonte","state_id":11},
{"id":706,"description":"Itamotinga (Juazeiro)","state_id":5},
{"id":3255,"description":"Itamuri (Muriaé)","state_id":11},
{"id":708,"description":"Itanagra","state_id":5},
{"id":707,"description":"Itanagé (Livramento de Nossa Senhora)","state_id":5},
{"id":3256,"description":"Itanhandu","state_id":11},
{"id":11021,"description":"Itanhangá","state_id":13},
{"id":9237,"description":"Itanhaém","state_id":26},
{"id":710,"description":"Itanhi (Jandaíra)","state_id":5},
{"id":3257,"description":"Itanhomi","state_id":11},
{"id":709,"description":"Itanhém","state_id":5},
{"id":1418,"description":"Itans (Itapiúna)","state_id":6},
{"id":3258,"description":"Itaobim","state_id":11},
{"id":6949,"description":"Itaocara","state_id":19},
{"id":2199,"description":"Itapaci","state_id":9},
{"id":3259,"description":"Itapagipe","state_id":11},
{"id":1419,"description":"Itapagé","state_id":6},
{"id":6187,"description":"Itapanhacanga (Castro)","state_id":18},
{"id":3260,"description":"Itapanhoacanga (Alvorada de Minas)","state_id":11},
{"id":6188,"description":"Itapara (Irati)","state_id":18},
{"id":711,"description":"Itaparica","state_id":5},
{"id":11755,"description":"Itapeaçu","state_id":3},
{"id":713,"description":"Itapebi","state_id":5},
{"id":1420,"description":"Itapebussu (Maranguape)","state_id":6},
{"id":3261,"description":"Itapecerica","state_id":11},
{"id":9239,"description":"Itapecerica da Serra","state_id":26},
{"id":1902,"description":"Itapecoá (Itapemirim)","state_id":8},
{"id":2478,"description":"Itapecuru Mirim","state_id":10},
{"id":1421,"description":"Itapeim (Beberibe)","state_id":6},
{"id":714,"description":"Itapeipu (Jacobina)","state_id":5},
{"id":6189,"description":"Itapejara d'Oeste","state_id":18},
{"id":8509,"description":"Itapema","state_id":24},
{"id":1903,"description":"Itapemirim","state_id":8},
{"id":2479,"description":"Itapera (Icatu)","state_id":10},
{"id":6950,"description":"Itaperuna","state_id":19},
{"id":1904,"description":"Itaperuna (Barra de São Francisco)","state_id":8},
{"id":6190,"description":"Itaperuçu","state_id":18},
{"id":5295,"description":"Itapetim","state_id":16},
{"id":715,"description":"Itapetinga","state_id":5},
{"id":9240,"description":"Itapetininga","state_id":26},
{"id":9241,"description":"Itapeuna (Eldorado)","state_id":26},
{"id":3262,"description":"Itapeva","state_id":11},
{"id":9242,"description":"Itapeva","state_id":26},
{"id":9243,"description":"Itapevi","state_id":26},
{"id":716,"description":"Itapicuru","state_id":5},
{"id":12688,"description":"Itapicuru","state_id":5},
{"id":1905,"description":"Itapina (Colatina)","state_id":8},
{"id":1422,"description":"Itapipoca","state_id":6},
{"id":9244,"description":"Itapira","state_id":26},
{"id":235,"description":"Itapiranga","state_id":3},
{"id":8510,"description":"Itapiranga","state_id":24},
{"id":2200,"description":"Itapirapuã","state_id":9},
{"id":9245,"description":"Itapirapuã Paulista","state_id":26},
{"id":9867,"description":"Itapiratins","state_id":27},
{"id":717,"description":"Itapirema (Vitória da Conquista)","state_id":5},
{"id":3263,"description":"Itapiru (Rubim)","state_id":11},
{"id":3264,"description":"Itapirucu (Palma)","state_id":11},
{"id":5296,"description":"Itapissuma","state_id":16},
{"id":718,"description":"Itapitanga","state_id":5},
{"id":4652,"description":"Itapixuna (Augusto Corrêa)","state_id":14},
{"id":1423,"description":"Itapiúna","state_id":6},
{"id":8512,"description":"Itapocu (Araquari)","state_id":24},
{"id":719,"description":"Itapora (Muritiba)","state_id":5},
{"id":4959,"description":"Itaporanga","state_id":15},
{"id":9247,"description":"Itaporanga","state_id":26},
{"id":8799,"description":"Itaporanga D'Ajuda","state_id":25},
{"id":4960,"description":"Itapororoca","state_id":15},
{"id":11877,"description":"Itapororó","state_id":23},
{"id":4182,"description":"Itaporã","state_id":12},
{"id":9868,"description":"Itaporã do Tocantins","state_id":27},
{"id":8511,"description":"Itapoá","state_id":24},
{"id":7792,"description":"Itapucá","state_id":23},
{"id":7793,"description":"Itapucá (Anta Gorda)","state_id":23},
{"id":9249,"description":"Itapura","state_id":26},
{"id":720,"description":"Itapura (Miguel Calmon)","state_id":5},
{"id":2201,"description":"Itapuranga","state_id":9},
{"id":7791,"description":"Itapuã (Viamão)","state_id":23},
{"id":7334,"description":"Itapuã do Oeste","state_id":21},
{"id":9248,"description":"Itapuí","state_id":26},
{"id":712,"description":"Itapé","state_id":5},
{"id":1424,"description":"Itapó (Pacatuba)","state_id":6},
{"id":9250,"description":"Itaquaquecetuba","state_id":26},
{"id":721,"description":"Itaquara","state_id":5},
{"id":722,"description":"Itaquaraí (Brumado)","state_id":5},
{"id":1906,"description":"Itaquari (Cariacica)","state_id":8},
{"id":9251,"description":"Itaqueri da Serra (Itirapina)","state_id":26},
{"id":7794,"description":"Itaqui","state_id":23},
{"id":6191,"description":"Itaqui (Campo Largo)","state_id":18},
{"id":4183,"description":"Itaquiraí","state_id":12},
{"id":5297,"description":"Itaquitinga","state_id":16},
{"id":723,"description":"Itarantim","state_id":5},
{"id":1907,"description":"Itaraná","state_id":8},
{"id":9252,"description":"Itararé","state_id":26},
{"id":1425,"description":"Itarema","state_id":6},
{"id":9253,"description":"Itariri","state_id":26},
{"id":2202,"description":"Itarumã","state_id":9},
{"id":7795,"description":"Itati","state_id":23},
{"id":724,"description":"Itati (Itororó)","state_id":5},
{"id":6951,"description":"Itatiaia","state_id":19},
{"id":3265,"description":"Itatiaiuçu","state_id":11},
{"id":9254,"description":"Itatiba","state_id":26},
{"id":7796,"description":"Itatiba do Sul","state_id":23},
{"id":725,"description":"Itatim","state_id":5},
{"id":9255,"description":"Itatinga","state_id":26},
{"id":726,"description":"Itatingui (Arataca)","state_id":5},
{"id":1426,"description":"Itatira","state_id":6},
{"id":4961,"description":"Itatuba","state_id":15},
{"id":4653,"description":"Itatupã (Gurupá)","state_id":14},
{"id":303,"description":"Itaubal","state_id":4},
{"id":5605,"description":"Itaueira","state_id":17},
{"id":3268,"description":"Itauninha (Santa Maria de Itabira)","state_id":11},
{"id":1909,"description":"Itauninhas (São Mateus)","state_id":8},
{"id":2203,"description":"Itauçu","state_id":9},
{"id":3269,"description":"Itaverava","state_id":11},
{"id":1895,"description":"Itaçu (Itaguaçu)","state_id":8},
{"id":9233,"description":"Itaí","state_id":26},
{"id":7788,"description":"Itaí (Ijuí)","state_id":23},
{"id":5292,"description":"Itaíba","state_id":16},
{"id":12543,"description":"Itaíba","state_id":23},
{"id":696,"description":"Itaítu (Jacobina)","state_id":5},
{"id":9238,"description":"Itaóca","state_id":26},
{"id":1901,"description":"Itaóca (Cachoeiro de Itapemirim)","state_id":8},
{"id":7186,"description":"Itaú","state_id":20},
{"id":3266,"description":"Itaú de Minas","state_id":11},
{"id":4375,"description":"Itaúba","state_id":13},
{"id":12526,"description":"Itaúba","state_id":23},
{"id":7797,"description":"Itaúba (Arroio do Tigre)","state_id":23},
{"id":3267,"description":"Itaúna","state_id":11},
{"id":11813,"description":"Itaúna","state_id":16},
{"id":6192,"description":"Itaúna do Sul","state_id":18},
{"id":1908,"description":"Itaúnas (Conceição da Barra)","state_id":8},
{"id":3270,"description":"Itererê (Wenceslau Braz)","state_id":11},
{"id":3271,"description":"Itinga","state_id":11},
{"id":6193,"description":"Itinga (Paranaguá)","state_id":18},
{"id":2480,"description":"Itinga do Maranhão","state_id":10},
{"id":4376,"description":"Itiquira","state_id":13},
{"id":3272,"description":"Itira (Araçuaí)","state_id":11},
{"id":9256,"description":"Itirapina","state_id":26},
{"id":9257,"description":"Itirapuã","state_id":26},
{"id":727,"description":"Itiruçu","state_id":5},
{"id":728,"description":"Itiúba","state_id":5},
{"id":9258,"description":"Itobi","state_id":26},
{"id":729,"description":"Itororó","state_id":5},
{"id":9259,"description":"Itororó do Paranapanema (Pirapozinho)","state_id":26},
{"id":8513,"description":"Itoupava (Blumenau)","state_id":24},
{"id":9260,"description":"Itu","state_id":26},
{"id":730,"description":"Ituaçu","state_id":5},
{"id":731,"description":"Ituberá","state_id":5},
{"id":3273,"description":"Itueta","state_id":11},
{"id":5298,"description":"Ituguaçu (Altinho)","state_id":16},
{"id":7798,"description":"Ituim (Vacaria)","state_id":23},
{"id":3275,"description":"Ituiutaba","state_id":11},
{"id":2204,"description":"Itumbiara","state_id":9},
{"id":3276,"description":"Itumirim","state_id":11},
{"id":9261,"description":"Itupeva","state_id":26},
{"id":732,"description":"Itupeva (Medeiros Neto)","state_id":5},
{"id":4654,"description":"Itupiranga","state_id":14},
{"id":8514,"description":"Ituporanga","state_id":24},
{"id":3277,"description":"Iturama","state_id":11},
{"id":3278,"description":"Itutinga","state_id":11},
{"id":9262,"description":"Ituverava","state_id":26},
{"id":3274,"description":"Ituí (São João Nepomuceno)","state_id":11},
{"id":8504,"description":"Itá","state_id":24},
{"id":9246,"description":"Itápolis","state_id":26},
{"id":7790,"description":"Itão (Itaqui)","state_id":23},
{"id":9263,"description":"Iubatinga (Caiabu)","state_id":26},
{"id":5299,"description":"Iuiteporã (Bonito)","state_id":16},
{"id":733,"description":"Iuiu","state_id":5},
{"id":6195,"description":"Ivailândia (Engenheiro Beltrão)","state_id":18},
{"id":6196,"description":"Ivaiporã","state_id":18},
{"id":6197,"description":"Ivaitinga (Nova Esperança)","state_id":18},
{"id":6199,"description":"Ivatuba","state_id":18},
{"id":6198,"description":"Ivaté","state_id":18},
{"id":6194,"description":"Ivaí","state_id":18},
{"id":7799,"description":"Ivaí (Bossoroca)","state_id":23},
{"id":4184,"description":"Ivinhema","state_id":12},
{"id":2205,"description":"Ivolândia","state_id":9},
{"id":7800,"description":"Ivorá","state_id":23},
{"id":7801,"description":"Ivoti","state_id":23},
{"id":12191,"description":"Izacolandia","state_id":16},
{"id":230,"description":"Içanã (São Gabriel da Cachoeira)","state_id":3},
{"id":8483,"description":"Içara","state_id":24},
{"id":6151,"description":"Içara (Astorga)","state_id":18},
{"id":1910,"description":"Iúna","state_id":8},
{"id":10206,"description":"JK (Formosa)","state_id":9},
{"id":1911,"description":"Jabaquara (Anchieta)","state_id":8},
{"id":5300,"description":"Jabitaca (Iguaraci)","state_id":16},
{"id":10164,"description":"Jaboatão (Jaboatão dos Guararapes)","state_id":16},
{"id":5302,"description":"Jaboatão dos Guararapes","state_id":16},
{"id":734,"description":"Jaborandi","state_id":5},
{"id":9264,"description":"Jaborandi","state_id":26},
{"id":6200,"description":"Jaborandi (Umuarama)","state_id":18},
{"id":8515,"description":"Jaborá","state_id":24},
{"id":6201,"description":"Jaboti","state_id":18},
{"id":7802,"description":"Jaboticaba","state_id":23},
{"id":9265,"description":"Jaboticabal","state_id":26},
{"id":6202,"description":"Jaboticabal (Ponta Grossa)","state_id":18},
{"id":3279,"description":"Jaboticatubas","state_id":11},
{"id":6203,"description":"Jaburu (Ponta Grossa)","state_id":18},
{"id":1427,"description":"Jaburuna (Ubajara)","state_id":6},
{"id":4185,"description":"Jabuti (Bonito)","state_id":12},
{"id":1428,"description":"Jacampari (Boa Viagem)","state_id":6},
{"id":735,"description":"Jacaraci","state_id":5},
{"id":1912,"description":"Jacaraipe (Serra)","state_id":8},
{"id":3280,"description":"Jacarandira (Resende Costa)","state_id":11},
{"id":4962,"description":"Jacaraú","state_id":15},
{"id":4655,"description":"Jacareacanga","state_id":14},
{"id":1429,"description":"Jacarecoara (Cascavel)","state_id":6},
{"id":6205,"description":"Jacarezinho","state_id":18},
{"id":11821,"description":"Jacarezinho","state_id":16},
{"id":9267,"description":"Jacareí","state_id":26},
{"id":4186,"description":"Jacareí (Japorã)","state_id":12},
{"id":9266,"description":"Jacaré (Cabreúva)","state_id":26},
{"id":6204,"description":"Jacaré (Francisco Beltrão)","state_id":18},
{"id":3281,"description":"Jacaré (Itinga)","state_id":11},
{"id":11814,"description":"Jacaré Grande","state_id":16},
{"id":89,"description":"Jacaré dos Homens","state_id":2},
{"id":1430,"description":"Jacaúna (Aquiraz)","state_id":6},
{"id":9268,"description":"Jaci","state_id":26},
{"id":7333,"description":"Jaci Paraná (Porto Velho)","state_id":21},
{"id":6206,"description":"Jaciaba (Prudentópolis)","state_id":18},
{"id":4377,"description":"Jaciara","state_id":13},
{"id":1913,"description":"Jaciguá (Vargem Alta)","state_id":8},
{"id":2206,"description":"Jacilândia (Itapirapuã)","state_id":9},
{"id":3282,"description":"Jacinto","state_id":11},
{"id":8516,"description":"Jacinto Machado","state_id":24},
{"id":9269,"description":"Jaciporã (Dracena)","state_id":26},
{"id":736,"description":"Jacobina","state_id":5},
{"id":5606,"description":"Jacobina do Piauí","state_id":17},
{"id":737,"description":"Jacu (Terra Nova)","state_id":5},
{"id":12792,"description":"Jacu Das Piranhas","state_id":11},
{"id":9270,"description":"Jacuba (Arealva)","state_id":26},
{"id":6952,"description":"Jacuecanga (Angra dos Reis)","state_id":19},
{"id":7803,"description":"Jacuizinho","state_id":23},
{"id":4656,"description":"Jacundá","state_id":14},
{"id":1914,"description":"Jacupemba (Aracruz)","state_id":8},
{"id":9271,"description":"Jacupiranga","state_id":26},
{"id":739,"description":"Jacuruna (Jaguaripe)","state_id":5},
{"id":3284,"description":"Jacutinga","state_id":11},
{"id":7804,"description":"Jacutinga","state_id":23},
{"id":6207,"description":"Jacutinga (Francisco Beltrão)","state_id":18},
{"id":6208,"description":"Jacutinga (Goioxim)","state_id":18},
{"id":6209,"description":"Jacutinga (Ivaiporã)","state_id":18},
{"id":6210,"description":"Jacutinga (Santa Izabel do Oeste)","state_id":18},
{"id":3283,"description":"Jacuí","state_id":11},
{"id":90,"description":"Jacuípe","state_id":2},
{"id":738,"description":"Jacuípe (São Sebastião do Passe)","state_id":5},
{"id":9272,"description":"Jafa (Garça)","state_id":26},
{"id":6211,"description":"Jaguapitã","state_id":18},
{"id":740,"description":"Jaguaquara","state_id":5},
{"id":741,"description":"Jaguara (Feira de Santana)","state_id":5},
{"id":742,"description":"Jaguarari","state_id":5},
{"id":4657,"description":"Jaguarari (Acará)","state_id":14},
{"id":3285,"description":"Jaguaraçu","state_id":11},
{"id":6953,"description":"Jaguarembé (Itaocara)","state_id":19},
{"id":1432,"description":"Jaguaretama","state_id":6},
{"id":7806,"description":"Jaguarete (Erechim)","state_id":23},
{"id":7807,"description":"Jaguari","state_id":23},
{"id":6212,"description":"Jaguariaíva","state_id":18},
{"id":1433,"description":"Jaguaribara","state_id":6},
{"id":1434,"description":"Jaguaribe","state_id":6},
{"id":743,"description":"Jaguaripe","state_id":5},
{"id":3287,"description":"Jaguaritira (Malacacheta)","state_id":11},
{"id":9273,"description":"Jaguariúna","state_id":26},
{"id":1435,"description":"Jaguaruana","state_id":6},
{"id":8517,"description":"Jaguaruna","state_id":24},
{"id":7805,"description":"Jaguarão","state_id":23},
{"id":1431,"description":"Jaguarão (Aracoiaba)","state_id":6},
{"id":3286,"description":"Jaguarão (Jacinto)","state_id":11},
{"id":12501,"description":"Jaguarão Chico","state_id":23},
{"id":12506,"description":"Jaguarão Grande","state_id":23},
{"id":1915,"description":"Jaguaré","state_id":8},
{"id":1436,"description":"Jaibaras (Sobral)","state_id":6},
{"id":5607,"description":"Jaicós","state_id":17},
{"id":9274,"description":"Jales","state_id":26},
{"id":1437,"description":"Jamacaru (Missão Velha)","state_id":6},
{"id":9275,"description":"Jamaica (Dracena)","state_id":26},
{"id":4658,"description":"Jamanxinzinho (Itaituba)","state_id":14},
{"id":6954,"description":"Jamapará (Sapucaia)","state_id":19},
{"id":9276,"description":"Jambeiro","state_id":26},
{"id":4659,"description":"Jambuaçu (São Francisco do Pará)","state_id":14},
{"id":3289,"description":"Jampruca","state_id":11},
{"id":3290,"description":"Janaúba","state_id":11},
{"id":2207,"description":"Jandaia","state_id":9},
{"id":6213,"description":"Jandaia do Sul","state_id":18},
{"id":7188,"description":"Jandaíra","state_id":20},
{"id":745,"description":"Jandaíra","state_id":5},
{"id":4660,"description":"Jandiaí (Inhangapi)","state_id":14},
{"id":9277,"description":"Jandira","state_id":26},
{"id":1438,"description":"Jandrangoeira (Independência)","state_id":6},
{"id":7189,"description":"Janduís","state_id":20},
{"id":4378,"description":"Jangada","state_id":13},
{"id":6214,"description":"Jangada (Cafezal do Sul)","state_id":18},
{"id":6215,"description":"Jangada do Sul (General Carneiro)","state_id":18},
{"id":6216,"description":"Janiópolis","state_id":18},
{"id":7808,"description":"Jansen (Farroupilha)","state_id":23},
{"id":3291,"description":"Januária","state_id":11},
{"id":91,"description":"Japaratinga","state_id":2},
{"id":8800,"description":"Japaratuba","state_id":25},
{"id":3292,"description":"Japaraíba","state_id":11},
{"id":5303,"description":"Japecanga (Pedra)","state_id":16},
{"id":6955,"description":"Japeri","state_id":19},
{"id":4661,"description":"Japerica (Primavera)","state_id":14},
{"id":7190,"description":"Japi","state_id":20},
{"id":6217,"description":"Japira","state_id":18},
{"id":8801,"description":"Japoatã","state_id":25},
{"id":746,"description":"Japomirim (Itagibá)","state_id":5},
{"id":3293,"description":"Japonvar","state_id":11},
{"id":4187,"description":"Japorã","state_id":12},
{"id":747,"description":"Japu (Ilhéus)","state_id":5},
{"id":236,"description":"Japurá","state_id":3},
{"id":6218,"description":"Japurá","state_id":18},
{"id":6956,"description":"Japuíba (Cachoeiras de Macacu)","state_id":19},
{"id":5304,"description":"Jaqueira","state_id":16},
{"id":7809,"description":"Jaquirana","state_id":23},
{"id":6219,"description":"Jaracatiá (Goioerê)","state_id":18},
{"id":4188,"description":"Jaraguari","state_id":12},
{"id":2208,"description":"Jaraguá","state_id":9},
{"id":8518,"description":"Jaraguá do Sul","state_id":24},
{"id":92,"description":"Jaramataia","state_id":2},
{"id":4189,"description":"Jardim","state_id":12},
{"id":1439,"description":"Jardim","state_id":6},
{"id":6220,"description":"Jardim (Londrina)","state_id":18},
{"id":1440,"description":"Jardim (Paracuru)","state_id":6},
{"id":10691,"description":"Jardim Abc De Goiás","state_id":9},
{"id":12649,"description":"Jardim Alegre","state_id":23},
{"id":6221,"description":"Jardim Alegre","state_id":18},
{"id":9278,"description":"Jardim Belval (Barueri)","state_id":26},
{"id":6222,"description":"Jardim Olinda","state_id":18},
{"id":6223,"description":"Jardim Paredão (Altônia)","state_id":18},
{"id":9279,"description":"Jardim Presidente Dutra (Guarulhos)","state_id":26},
{"id":9280,"description":"Jardim Santa Luzia (Ribeirão Pires)","state_id":26},
{"id":9281,"description":"Jardim Silveira (Barueri)","state_id":26},
{"id":7191,"description":"Jardim de Angicos","state_id":20},
{"id":7192,"description":"Jardim de Piranhas","state_id":20},
{"id":5608,"description":"Jardim do Mulato","state_id":17},
{"id":7193,"description":"Jardim do Seridó","state_id":20},
{"id":1441,"description":"Jardimirim (Jardim)","state_id":6},
{"id":3294,"description":"Jardinésia (Prata)","state_id":11},
{"id":9282,"description":"Jardinópolis","state_id":26},
{"id":8519,"description":"Jardinópolis","state_id":24},
{"id":6225,"description":"Jardinópolis (Leópolis)","state_id":18},
{"id":7810,"description":"Jari","state_id":23},
{"id":9283,"description":"Jarinu","state_id":26},
{"id":7335,"description":"Jaru","state_id":21},
{"id":4379,"description":"Jarudore (Poxoréo)","state_id":13},
{"id":6226,"description":"Jataizinho","state_id":18},
{"id":2209,"description":"Jataí","state_id":9},
{"id":5305,"description":"Jataúba","state_id":16},
{"id":4190,"description":"Jateí","state_id":12},
{"id":1442,"description":"Jati","state_id":6},
{"id":5306,"description":"Jatiúca (Triunfo)","state_id":16},
{"id":2481,"description":"Jatobá","state_id":10},
{"id":5307,"description":"Jatobá","state_id":16},
{"id":9284,"description":"Jatobá (Alto Alegre)","state_id":26},
{"id":4380,"description":"Jatobá (Jaciara)","state_id":13},
{"id":5609,"description":"Jatobá do Piauí","state_id":17},
{"id":2210,"description":"Jaupaci","state_id":9},
{"id":4381,"description":"Jauru","state_id":13},
{"id":4191,"description":"Jauru (Coxim)","state_id":12},
{"id":748,"description":"Jauá (Camaçari)","state_id":5},
{"id":6227,"description":"Javacaé (Campo Largo)","state_id":18},
{"id":7811,"description":"Jazidas ou Capela São Vicente (São Sepé)","state_id":23},
{"id":7187,"description":"Jaçanã","state_id":20},
{"id":3288,"description":"Jaíba","state_id":11},
{"id":744,"description":"Jaíba (Feira de Santana)","state_id":5},
{"id":9285,"description":"Jaú","state_id":26},
{"id":9869,"description":"Jaú do Tocantins","state_id":27},
{"id":3295,"description":"Jeceaba","state_id":11},
{"id":93,"description":"Jenipapo (Arapiraca)","state_id":2},
{"id":5308,"description":"Jenipapo (Sanharó)","state_id":16},
{"id":3296,"description":"Jenipapo de Minas","state_id":11},
{"id":2482,"description":"Jenipapo dos Vieiras","state_id":10},
{"id":3297,"description":"Jequeri","state_id":11},
{"id":750,"description":"Jequiriçá","state_id":5},
{"id":3298,"description":"Jequitaí","state_id":11},
{"id":3299,"description":"Jequitibá","state_id":11},
{"id":3300,"description":"Jequitinhonha","state_id":11},
{"id":10089,"description":"Jequiá da Praia","state_id":2},
{"id":749,"description":"Jequié","state_id":5},
{"id":751,"description":"Jeremoabo","state_id":5},
{"id":4963,"description":"Jericó","state_id":15},
{"id":9286,"description":"Jeriquara","state_id":26},
{"id":2211,"description":"Jeroaquara (Faina)","state_id":9},
{"id":5610,"description":"Jerumenha","state_id":17},
{"id":1916,"description":"Jerônimo Monteiro","state_id":8},
{"id":3301,"description":"Jesuânia","state_id":11},
{"id":6228,"description":"Jesuítas","state_id":18},
{"id":2212,"description":"Jesúpolis","state_id":9},
{"id":7336,"description":"Ji-Paraná","state_id":21},
{"id":1443,"description":"Jijoca de Jericoacoara","state_id":6},
{"id":11720,"description":"Jirau","state_id":16},
{"id":752,"description":"Jiribatuba (Vera Cruz)","state_id":5},
{"id":753,"description":"Jitaúna","state_id":5},
{"id":4662,"description":"Joana Coeli (Cametá)","state_id":14},
{"id":4663,"description":"Joana Peres (Baião)","state_id":14},
{"id":4664,"description":"Joanes (Salvaterra)","state_id":14},
{"id":2213,"description":"Joanápolis (Anápolis)","state_id":9},
{"id":3303,"description":"Joanésia","state_id":11},
{"id":9287,"description":"Joanópolis","state_id":26},
{"id":9289,"description":"Joaquim Egídio (Campinas)","state_id":26},
{"id":3306,"description":"Joaquim Felício","state_id":11},
{"id":94,"description":"Joaquim Gomes","state_id":2},
{"id":5310,"description":"Joaquim Nabuco","state_id":16},
{"id":5612,"description":"Joaquim Pires","state_id":17},
{"id":6230,"description":"Joaquim Távora","state_id":18},
{"id":1919,"description":"Joatuba (Laranja da Terra)","state_id":8},
{"id":8520,"description":"Joaçaba","state_id":24},
{"id":1917,"description":"Joaçuba (Ecoporanga)","state_id":8},
{"id":3302,"description":"Joaíma","state_id":11},
{"id":5613,"description":"Joca Marques","state_id":17},
{"id":8521,"description":"Joinville","state_id":24},
{"id":9290,"description":"Jordanésia (Cajamar)","state_id":26},
{"id":3307,"description":"Jordânia","state_id":11},
{"id":9,"description":"Jordão","state_id":1},
{"id":10389,"description":"Jordão (Guarapuava)","state_id":18},
{"id":1445,"description":"Jordão (Sobral)","state_id":6},
{"id":6231,"description":"Jordãozinho (Guarapuava)","state_id":18},
{"id":10751,"description":"Jorge Lacerda","state_id":24},
{"id":2484,"description":"Joselândia","state_id":10},
{"id":4382,"description":"Joselândia (Barão de Melgaço)","state_id":13},
{"id":3310,"description":"Joselândia (Santana dos Montes)","state_id":11},
{"id":3311,"description":"Josenópolis","state_id":11},
{"id":8522,"description":"José Boiteux","state_id":24},
{"id":9291,"description":"José Bonifácio","state_id":26},
{"id":1920,"description":"José Carlos (Apiacá)","state_id":8},
{"id":757,"description":"José Gonçalves (Vitória da Conquista)","state_id":5},
{"id":3308,"description":"José Gonçalves de Minas","state_id":11},
{"id":6232,"description":"José Lacerda (Reserva)","state_id":18},
{"id":5312,"description":"José Mariano (Ribeirão)","state_id":16},
{"id":7816,"description":"José Otávio (Bagé)","state_id":23},
{"id":3309,"description":"José Raydan","state_id":11},
{"id":5311,"description":"José da Costa (Gameleira)","state_id":16},
{"id":7196,"description":"José da Penha","state_id":20},
{"id":1446,"description":"José de Alencar (Iguatu)","state_id":6},
{"id":5614,"description":"José de Freitas","state_id":17},
{"id":2214,"description":"Joviânia","state_id":9},
{"id":6229,"description":"Joá (Joaquim Távora)","state_id":18},
{"id":5309,"description":"João Alfredo","state_id":16},
{"id":754,"description":"João Amaro (Iaçu)","state_id":5},
{"id":7812,"description":"João Arregui (Uruguaiana)","state_id":23},
{"id":1444,"description":"João Cordeiro (Santana do Acaraú)","state_id":6},
{"id":755,"description":"João Correia (Mucugê)","state_id":5},
{"id":5611,"description":"João Costa","state_id":17},
{"id":7194,"description":"João Câmara","state_id":20},
{"id":7195,"description":"João Dias","state_id":20},
{"id":756,"description":"João Dourado","state_id":5},
{"id":2483,"description":"João Lisboa","state_id":10},
{"id":3304,"description":"João Monlevade","state_id":11},
{"id":1918,"description":"João Neiva","state_id":8},
{"id":4964,"description":"João Pessoa","state_id":15},
{"id":3305,"description":"João Pinheiro","state_id":11},
{"id":9288,"description":"João Ramalho","state_id":26},
{"id":7813,"description":"João Rodrigues (Rio Pardo)","state_id":23},
{"id":7814,"description":"Joça Tavares (Bagé)","state_id":23},
{"id":4665,"description":"Juabá (Cametá)","state_id":14},
{"id":758,"description":"Juacema (Jaguarari)","state_id":5},
{"id":4965,"description":"Juarez Távora","state_id":15},
{"id":9870,"description":"Juarina","state_id":27},
{"id":4383,"description":"Juará","state_id":13},
{"id":1449,"description":"Juatama (Quixadá)","state_id":6},
{"id":3312,"description":"Juatuba","state_id":11},
{"id":4966,"description":"Juazeirinho","state_id":15},
{"id":759,"description":"Juazeiro","state_id":5},
{"id":1450,"description":"Juazeiro de Baixo (Morada Nova)","state_id":6},
{"id":1451,"description":"Juazeiro do Norte","state_id":6},
{"id":5615,"description":"Juazeiro do Piauí","state_id":17},
{"id":10777,"description":"Jubaia","state_id":6},
{"id":1452,"description":"Jubaia (Maranguape)","state_id":6},
{"id":3313,"description":"Jubaí (Conquista)","state_id":11},
{"id":4666,"description":"Jubim (Salvaterra)","state_id":14},
{"id":11743,"description":"Juca Ferrado","state_id":16},
{"id":5314,"description":"Jucati","state_id":16},
{"id":6233,"description":"Juciara (Kaloré)","state_id":18},
{"id":1921,"description":"Jucu (Vila Velha)","state_id":8},
{"id":7197,"description":"Jucurutu","state_id":20},
{"id":760,"description":"Jucuruçu","state_id":5},
{"id":12219,"description":"Jucá","state_id":6},
{"id":1453,"description":"Jucás","state_id":6},
{"id":761,"description":"Juerana (Caravelas)","state_id":5},
{"id":3314,"description":"Juiraçu (São Domingos do Prata)","state_id":11},
{"id":3315,"description":"Juiz de Fora","state_id":11},
{"id":9292,"description":"Juliânia (Herculândia)","state_id":26},
{"id":9294,"description":"Jumirim","state_id":26},
{"id":11711,"description":"Junco","state_id":16},
{"id":762,"description":"Junco (Juazeiro)","state_id":5},
{"id":3316,"description":"Junco de Minas (Malacacheta)","state_id":11},
{"id":2485,"description":"Junco do Maranhão","state_id":10},
{"id":4967,"description":"Junco do Seridó","state_id":15},
{"id":9296,"description":"Jundiapeba (Mogi das Cruzes)","state_id":26},
{"id":9295,"description":"Jundiaí","state_id":26},
{"id":6234,"description":"Jundiaí do Sul","state_id":18},
{"id":7198,"description":"Jundiá","state_id":20},
{"id":95,"description":"Jundiá","state_id":2},
{"id":9297,"description":"Junqueira (Monte Aprazível)","state_id":26},
{"id":96,"description":"Junqueiro","state_id":2},
{"id":9298,"description":"Junqueirópolis","state_id":26},
{"id":763,"description":"Jupaguá (Cotegipe)","state_id":5},
{"id":5315,"description":"Jupi","state_id":16},
{"id":8523,"description":"Jupiá","state_id":24},
{"id":9300,"description":"Juquiratiba (Conchas)","state_id":26},
{"id":9301,"description":"Juquitiba","state_id":26},
{"id":9299,"description":"Juquiá","state_id":26},
{"id":764,"description":"Juraci (Marcionílio Souza)","state_id":5},
{"id":10115,"description":"Jurama (Vila Valério)","state_id":8},
{"id":3317,"description":"Juramento","state_id":11},
{"id":6235,"description":"Juranda","state_id":18},
{"id":5316,"description":"Jurema","state_id":16},
{"id":5617,"description":"Jurema","state_id":17},
{"id":1454,"description":"Jurema (Caucaia)","state_id":6},
{"id":765,"description":"Juremal (Juazeiro)","state_id":5},
{"id":4968,"description":"Juripiranga","state_id":15},
{"id":11941,"description":"Juritianha","state_id":6},
{"id":9302,"description":"Juritis (Glicério)","state_id":26},
{"id":4969,"description":"Juru","state_id":15},
{"id":3319,"description":"Juruaia","state_id":11},
{"id":9303,"description":"Jurucê (Jardinópolis)","state_id":26},
{"id":4385,"description":"Juruena","state_id":13},
{"id":3320,"description":"Jurumirim (Rio Casca)","state_id":11},
{"id":9304,"description":"Jurupeba (Palestina)","state_id":26},
{"id":9305,"description":"Jurupema (Taquaritinga)","state_id":26},
{"id":4667,"description":"Juruti","state_id":14},
{"id":237,"description":"Juruá","state_id":3},
{"id":3318,"description":"Juréia (Monte Belo)","state_id":11},
{"id":2216,"description":"Juscelino Kubitschek (Formoso)","state_id":9},
{"id":10591,"description":"Juscelândia","state_id":9},
{"id":2215,"description":"Juscelândia (Jussara)","state_id":9},
{"id":4192,"description":"Juscelândia (Rio Verde de Mato Grosso)","state_id":12},
{"id":4386,"description":"Juscimeira","state_id":13},
{"id":766,"description":"Jussara","state_id":5},
{"id":2217,"description":"Jussara","state_id":9},
{"id":6236,"description":"Jussara","state_id":18},
{"id":9871,"description":"Jussara (Araguaína)","state_id":27},
{"id":767,"description":"Jussari","state_id":5},
{"id":768,"description":"Jussiape","state_id":5},
{"id":1455,"description":"Justiniano Serpa (Aquiraz)","state_id":6},
{"id":3321,"description":"Justinópolis (Ribeirão das Neves)","state_id":11},
{"id":238,"description":"Jutaí","state_id":3},
{"id":5317,"description":"Jutaí (Santa Maria da Boa Vista)","state_id":16},
{"id":4193,"description":"Jutí","state_id":12},
{"id":3322,"description":"Juvenília","state_id":11},
{"id":6237,"description":"Juvinópolis (Cascavel)","state_id":18},
{"id":11815,"description":"Juá","state_id":16},
{"id":12145,"description":"Juá","state_id":6},
{"id":1447,"description":"Juá (Irauçuba)","state_id":6},
{"id":7817,"description":"Juá (Jaquirana)","state_id":23},
{"id":1448,"description":"Juá (Quixadá)","state_id":6},
{"id":5313,"description":"Juçaral (Cabo de Santo Agostinho)","state_id":16},
{"id":4384,"description":"Juína","state_id":13},
{"id":7815,"description":"Jóia","state_id":23},
{"id":12637,"description":"Júlio Borges","state_id":23},
{"id":5616,"description":"Júlio Borges","state_id":17},
{"id":9293,"description":"Júlio Mesquita","state_id":26},
{"id":7818,"description":"Júlio de Castilhos","state_id":23},
{"id":6238,"description":"Kaloré","state_id":18},
{"id":11861,"description":"Km 25","state_id":16},
{"id":769,"description":"Km Sete (Feira de Santana)","state_id":5},
{"id":1456,"description":"Lacerda (Quixeramobim)","state_id":6},
{"id":3323,"description":"Lacerdinha (Carangola)","state_id":11},
{"id":8524,"description":"Lacerdópolis","state_id":24},
{"id":3324,"description":"Ladainha","state_id":11},
{"id":1457,"description":"Ladeira Grande (Maranguape)","state_id":6},
{"id":4194,"description":"Ladário","state_id":12},
{"id":770,"description":"Lafaiete Coutinho","state_id":5},
{"id":3325,"description":"Lagamar","state_id":11},
{"id":8802,"description":"Lagarto","state_id":25},
{"id":11240,"description":"Lageado De Araçaíba","state_id":26},
{"id":10773,"description":"Lages","state_id":6},
{"id":8525,"description":"Lages","state_id":24},
{"id":11767,"description":"Lago Do Jacaré","state_id":3},
{"id":12660,"description":"Lago Do Limão","state_id":3},
{"id":1785,"description":"Lago Norte","state_id":7},
{"id":240,"description":"Lago Preto (Boa Vista do Ramos)","state_id":3},
{"id":1786,"description":"Lago Sul","state_id":7},
{"id":2489,"description":"Lago Verde","state_id":10},
{"id":2486,"description":"Lago da Pedra","state_id":10},
{"id":2487,"description":"Lago do Junco","state_id":10},
{"id":2488,"description":"Lago dos Rodrigues","state_id":10},
{"id":4970,"description":"Lagoa","state_id":15},
{"id":6240,"description":"Lagoa (Castro)","state_id":18},
{"id":8526,"description":"Lagoa (Florianópolis)","state_id":24},
{"id":5318,"description":"Lagoa (Petrolina)","state_id":16},
{"id":6241,"description":"Lagoa (Telêmaco Borba)","state_id":18},
{"id":5618,"description":"Lagoa Alegre","state_id":17},
{"id":9307,"description":"Lagoa Azul (Osvaldo Cruz)","state_id":26},
{"id":6242,"description":"Lagoa Bonita (Castro)","state_id":18},
{"id":3326,"description":"Lagoa Bonita (Cordisburgo)","state_id":11},
{"id":4195,"description":"Lagoa Bonita (Deodápolis)","state_id":12},
{"id":7819,"description":"Lagoa Bonita do Sul","state_id":23},
{"id":9308,"description":"Lagoa Branca (Casa Branca)","state_id":26},
{"id":771,"description":"Lagoa Clara (Macaúbas)","state_id":5},
{"id":7199,"description":"Lagoa D'Anta","state_id":20},
{"id":12746,"description":"Lagoa Da Cruz","state_id":6},
{"id":11710,"description":"Lagoa Da Pedra","state_id":16},
{"id":11742,"description":"Lagoa Da Vaca","state_id":16},
{"id":100,"description":"Lagoa Dantas (Palmeira dos Índios)","state_id":2},
{"id":11633,"description":"Lagoa Das Pedras","state_id":6},
{"id":12114,"description":"Lagoa Do Barro","state_id":6},
{"id":11942,"description":"Lagoa Do Carneiro","state_id":6},
{"id":11563,"description":"Lagoa Dos Patos","state_id":23},
{"id":3329,"description":"Lagoa Dourada","state_id":11},
{"id":6244,"description":"Lagoa Dourada (Ponta Grossa)","state_id":18},
{"id":3330,"description":"Lagoa Formosa","state_id":11},
{"id":8803,"description":"Lagoa Funda (Gararu)","state_id":25},
{"id":3331,"description":"Lagoa Grande","state_id":11},
{"id":5326,"description":"Lagoa Grande","state_id":16},
{"id":11283,"description":"Lagoa Grande","state_id":2},
{"id":12115,"description":"Lagoa Grande","state_id":6},
{"id":1462,"description":"Lagoa Grande (Amontada)","state_id":6},
{"id":774,"description":"Lagoa Grande (Cândido Sales)","state_id":5},
{"id":775,"description":"Lagoa Grande (Ibipeba)","state_id":5},
{"id":1463,"description":"Lagoa Grande (Morada Nova)","state_id":6},
{"id":1464,"description":"Lagoa Grande (Russas)","state_id":6},
{"id":11610,"description":"Lagoa Grande De Minas Novas","state_id":11},
{"id":2491,"description":"Lagoa Grande do Maranhão","state_id":10},
{"id":776,"description":"Lagoa José Luis (Vitória da Conquista)","state_id":5},
{"id":7202,"description":"Lagoa Nova","state_id":20},
{"id":777,"description":"Lagoa Preta (Tremedal)","state_id":5},
{"id":778,"description":"Lagoa Real","state_id":5},
{"id":7203,"description":"Lagoa Salgada","state_id":20},
{"id":2347,"description":"Lagoa Santa","state_id":9},
{"id":3332,"description":"Lagoa Santa","state_id":11},
{"id":4973,"description":"Lagoa Seca","state_id":15},
{"id":11261,"description":"Lagoa Seca","state_id":11},
{"id":6245,"description":"Lagoa Seca (Guarapuava)","state_id":18},
{"id":6246,"description":"Lagoa Verde (Quitandinha)","state_id":18},
{"id":7821,"description":"Lagoa Vermelha","state_id":23},
{"id":97,"description":"Lagoa da Areia (Palmeira dos Índios)","state_id":2},
{"id":98,"description":"Lagoa da Canoa","state_id":2},
{"id":9872,"description":"Lagoa da Confusão","state_id":27},
{"id":8527,"description":"Lagoa da Estiva (Anita Garibaldi)","state_id":24},
{"id":99,"description":"Lagoa da Pedra (Arapiraca)","state_id":2},
{"id":3327,"description":"Lagoa da Prata","state_id":11},
{"id":4971,"description":"Lagoa de Dentro","state_id":15},
{"id":4972,"description":"Lagoa de Dentro (Campina Grande)","state_id":15},
{"id":772,"description":"Lagoa de Melquíades (Vitória da Conquista)","state_id":5},
{"id":7200,"description":"Lagoa de Pedras","state_id":20},
{"id":5619,"description":"Lagoa de São Francisco","state_id":17},
{"id":1458,"description":"Lagoa de São José (Aracoiaba)","state_id":6},
{"id":5319,"description":"Lagoa de São José (Bom Conselho)","state_id":16},
{"id":7201,"description":"Lagoa de Velhos","state_id":20},
{"id":5320,"description":"Lagoa do Barro (Araripina)","state_id":16},
{"id":5620,"description":"Lagoa do Barro do Piauí","state_id":17},
{"id":2218,"description":"Lagoa do Bauzinho (Rio Verde)","state_id":9},
{"id":773,"description":"Lagoa do Boi (Barro Alto)","state_id":5},
{"id":101,"description":"Lagoa do Caldeirão (Palmeira dos Índios)","state_id":2},
{"id":102,"description":"Lagoa do Canto (Palmeira dos Índios)","state_id":2},
{"id":5321,"description":"Lagoa do Carro","state_id":16},
{"id":103,"description":"Lagoa do Exú (Palmeira dos Índios)","state_id":2},
{"id":5322,"description":"Lagoa do Itaenga","state_id":16},
{"id":1459,"description":"Lagoa do Juvenal (Maranguape)","state_id":6},
{"id":2490,"description":"Lagoa do Mato","state_id":10},
{"id":1460,"description":"Lagoa do Mato (Itatira)","state_id":6},
{"id":5323,"description":"Lagoa do Ouro","state_id":16},
{"id":5621,"description":"Lagoa do Piauí","state_id":17},
{"id":104,"description":"Lagoa do Rancho (Arapiraca)","state_id":2},
{"id":105,"description":"Lagoa do Rancho (Palmeira dos Índios)","state_id":2},
{"id":5324,"description":"Lagoa do Souza (Lagoa dos Gatos)","state_id":16},
{"id":5622,"description":"Lagoa do Sítio","state_id":17},
{"id":9873,"description":"Lagoa do Tocantins","state_id":27},
{"id":1461,"description":"Lagoa dos Crioulos (Salitre)","state_id":6},
{"id":5325,"description":"Lagoa dos Gatos","state_id":16},
{"id":3328,"description":"Lagoa dos Patos","state_id":11},
{"id":6243,"description":"Lagoa dos Ribas (Castro)","state_id":18},
{"id":7820,"description":"Lagoa dos Três Cantos","state_id":23},
{"id":9309,"description":"Lagoinha","state_id":26},
{"id":1465,"description":"Lagoinha (Quixeré)","state_id":6},
{"id":6247,"description":"Lagoinha (Telêmaco Borba)","state_id":18},
{"id":5623,"description":"Lagoinha do Piauí","state_id":17},
{"id":2219,"description":"Lagolândia (Pirenópolis)","state_id":9},
{"id":7822,"description":"Lagoão","state_id":23},
{"id":8528,"description":"Laguna","state_id":24},
{"id":4196,"description":"Laguna Carapã","state_id":12},
{"id":779,"description":"Laje","state_id":5},
{"id":11816,"description":"Laje","state_id":16},
{"id":5328,"description":"Laje Grande (Catende)","state_id":16},
{"id":5327,"description":"Laje de São José (Cupira)","state_id":16},
{"id":780,"description":"Laje do Banco (Aurelino Leal)","state_id":5},
{"id":6957,"description":"Laje do Muriaé","state_id":19},
{"id":7823,"description":"Lajeado","state_id":23},
{"id":9874,"description":"Lajeado","state_id":27},
{"id":6248,"description":"Lajeado (Castro)","state_id":18},
{"id":6249,"description":"Lajeado (Ponta Grossa)","state_id":18},
{"id":6250,"description":"Lajeado (São Mateus do Sul)","state_id":18},
{"id":12549,"description":"Lajeado Bonito","state_id":23},
{"id":7824,"description":"Lajeado Bonito (Cotiporã)","state_id":23},
{"id":6251,"description":"Lajeado Bonito (Ortigueira)","state_id":18},
{"id":7825,"description":"Lajeado Bonito (Tiradentes do Sul)","state_id":23},
{"id":7826,"description":"Lajeado Cerne (Santo Ângelo)","state_id":23},
{"id":8529,"description":"Lajeado Grande","state_id":24},
{"id":7828,"description":"Lajeado Grande (Crissiumal)","state_id":23},
{"id":6252,"description":"Lajeado Grande (Guarapuava)","state_id":18},
{"id":7829,"description":"Lajeado Grande (Jaquirana)","state_id":23},
{"id":2492,"description":"Lajeado Novo","state_id":10},
{"id":7827,"description":"Lajeado do Bugre","state_id":23},
{"id":782,"description":"Lajedinho","state_id":5},
{"id":5329,"description":"Lajedo","state_id":16},
{"id":783,"description":"Lajedo Alto (Iaçu)","state_id":5},
{"id":5330,"description":"Lajedo do Cedro (Caruaru)","state_id":16},
{"id":784,"description":"Lajedo do Tabocal","state_id":5},
{"id":781,"description":"Lajedão","state_id":5},
{"id":7204,"description":"Lajes","state_id":20},
{"id":7205,"description":"Lajes Pintadas","state_id":20},
{"id":106,"description":"Lajes do Caldeirão (Palmeira dos Índios)","state_id":2},
{"id":3333,"description":"Lajinha","state_id":11},
{"id":1922,"description":"Lajinha (Pancas)","state_id":8},
{"id":785,"description":"Lamarão","state_id":5},
{"id":786,"description":"Lamarão do Passe (São Sebastião do Passe)","state_id":5},
{"id":3334,"description":"Lambari","state_id":11},
{"id":6253,"description":"Lambari (Sapopema)","state_id":18},
{"id":4387,"description":"Lambari D'Oeste","state_id":13},
{"id":1466,"description":"Lambedouro (Viçosa do Ceará)","state_id":6},
{"id":1467,"description":"Lameiro (Crato)","state_id":6},
{"id":3335,"description":"Lamim","state_id":11},
{"id":3336,"description":"Lamounier (Itapecerica)","state_id":11},
{"id":5624,"description":"Landri Sales","state_id":17},
{"id":6254,"description":"Lapa","state_id":18},
{"id":12758,"description":"Lapa","state_id":6},
{"id":2493,"description":"Lapela (Vitória do Mearim)","state_id":10},
{"id":3337,"description":"Lapinha (Lagoa Santa)","state_id":11},
{"id":787,"description":"Lapão","state_id":5},
{"id":12562,"description":"Lara","state_id":23},
{"id":7830,"description":"Lara (Três Passos)","state_id":23},
{"id":6255,"description":"Laranja Azeda (Telêmaco Borba)","state_id":18},
{"id":1923,"description":"Laranja da Terra","state_id":8},
{"id":6958,"description":"Laranjais (Itaocara)","state_id":19},
{"id":3338,"description":"Laranjal","state_id":11},
{"id":6256,"description":"Laranjal","state_id":18},
{"id":107,"description":"Laranjal (Arapiraca)","state_id":2},
{"id":9310,"description":"Laranjal Paulista","state_id":26},
{"id":304,"description":"Laranjal do Jari","state_id":4},
{"id":12606,"description":"Laranjeira","state_id":23},
{"id":7831,"description":"Laranjeira (Vicente Dutra)","state_id":23},
{"id":8804,"description":"Laranjeiras","state_id":25},
{"id":11528,"description":"Laranjeiras","state_id":6},
{"id":3339,"description":"Laranjeiras de Caldas (Caldas)","state_id":11},
{"id":6257,"description":"Laranjeiras do Sul","state_id":18},
{"id":9311,"description":"Laras (Laranjal Paulista)","state_id":26},
{"id":788,"description":"Largo (Piritiba)","state_id":5},
{"id":3340,"description":"Lassance","state_id":11},
{"id":4974,"description":"Lastro","state_id":15},
{"id":8530,"description":"Laurentino","state_id":24},
{"id":8531,"description":"Lauro Müller","state_id":24},
{"id":9312,"description":"Lauro Penteado (Clementina)","state_id":26},
{"id":4670,"description":"Lauro Sodré (Curuçá)","state_id":14},
{"id":789,"description":"Lauro de Freitas","state_id":5},
{"id":7832,"description":"Lava-Pés (Santiago)","state_id":23},
{"id":9875,"description":"Lavandeira","state_id":27},
{"id":4388,"description":"Lavouras (Alto Paraguai)","state_id":13},
{"id":6258,"description":"Lavra (Campo Largo)","state_id":18},
{"id":3341,"description":"Lavras","state_id":11},
{"id":12417,"description":"Lavras Novas","state_id":11},
{"id":1468,"description":"Lavras da Mangabeira","state_id":6},
{"id":7833,"description":"Lavras do Sul","state_id":23},
{"id":6259,"description":"Lavrinha (Guarapuava)","state_id":18},
{"id":6260,"description":"Lavrinha (Pinhalão)","state_id":18},
{"id":9314,"description":"Lavrinhas","state_id":26},
{"id":9313,"description":"Lavínia","state_id":26},
{"id":2494,"description":"Leandro (Barra do Corda)","state_id":10},
{"id":3342,"description":"Leandro Ferreira","state_id":11},
{"id":8533,"description":"Lebon Régis","state_id":24},
{"id":12575,"description":"Lejeado Micuim","state_id":23},
{"id":9315,"description":"Leme","state_id":26},
{"id":3343,"description":"Leme do Prado","state_id":11},
{"id":790,"description":"Lençóis","state_id":5},
{"id":9316,"description":"Lençóis Paulista","state_id":26},
{"id":8534,"description":"Leoberto Leal","state_id":24},
{"id":7834,"description":"Leonel Rocha (Sagrada Família)","state_id":23},
{"id":3344,"description":"Leopoldina","state_id":11},
{"id":2220,"description":"Leopoldo de Bulhões","state_id":9},
{"id":4975,"description":"Lerolândia (Santa Rita)","state_id":15},
{"id":6262,"description":"Lerroville (Londrina)","state_id":18},
{"id":3345,"description":"Levinópolis (Januária)","state_id":11},
{"id":8532,"description":"Leão (Campos Novos)","state_id":24},
{"id":6261,"description":"Leópolis","state_id":18},
{"id":7835,"description":"Liberato Salzano","state_id":23},
{"id":3346,"description":"Liberdade","state_id":11},
{"id":791,"description":"Licínio de Almeida","state_id":5},
{"id":6263,"description":"Lidianópolis","state_id":18},
{"id":4671,"description":"Ligação do Pará (Paragominas)","state_id":14},
{"id":2495,"description":"Lima Campos","state_id":10},
{"id":1469,"description":"Lima Campos (Icó)","state_id":6},
{"id":3347,"description":"Lima Duarte","state_id":11},
{"id":9317,"description":"Limeira","state_id":26},
{"id":3349,"description":"Limeira de Mantena (Mantena)","state_id":11},
{"id":3348,"description":"Limeira do Oeste","state_id":11},
{"id":5331,"description":"Limoeiro","state_id":16},
{"id":11773,"description":"Limoeiro","state_id":3},
{"id":1924,"description":"Limoeiro (Castelo)","state_id":8},
{"id":108,"description":"Limoeiro de Anadia","state_id":2},
{"id":4672,"description":"Limoeiro do Ajuru","state_id":14},
{"id":792,"description":"Limoeiro do Bom Viver (Feira de Santana)","state_id":5},
{"id":1470,"description":"Limoeiro do Norte","state_id":6},
{"id":6264,"description":"Lindoeste","state_id":18},
{"id":7836,"description":"Lindolfo Collor","state_id":23},
{"id":9318,"description":"Lindóia","state_id":26},
{"id":8535,"description":"Lindóia do Sul","state_id":24},
{"id":12628,"description":"Linha Bonita","state_id":23},
{"id":12531,"description":"Linha Bonita","state_id":23},
{"id":7837,"description":"Linha Comprida (Salvador do Sul)","state_id":23},
{"id":12631,"description":"Linha Ferrari","state_id":23},
{"id":12658,"description":"Linha Francesa Alta","state_id":23},
{"id":6265,"description":"Linha Giacomini (Toledo)","state_id":18},
{"id":12641,"description":"Linha Glória","state_id":23},
{"id":12537,"description":"Linha Harmonia","state_id":23},
{"id":7838,"description":"Linha Nova","state_id":23},
{"id":12522,"description":"Linha Ocidental","state_id":23},
{"id":12538,"description":"Linha Porto Alegre","state_id":23},
{"id":12623,"description":"Linha Silveira","state_id":23},
{"id":12465,"description":"Linha São João","state_id":23},
{"id":7839,"description":"Linha Vitória (Carazinho)","state_id":23},
{"id":8536,"description":"Linha das Palmeiras (Xavantina)","state_id":24},
{"id":1925,"description":"Linhares","state_id":8},
{"id":9319,"description":"Lins","state_id":26},
{"id":1471,"description":"Lisieux (Santa Quitéria)","state_id":6},
{"id":4976,"description":"Livramento","state_id":15},
{"id":11749,"description":"Livramento","state_id":16},
{"id":1472,"description":"Livramento (Ipueiras)","state_id":6},
{"id":793,"description":"Livramento de Nossa Senhora","state_id":5},
{"id":305,"description":"Livramento do Pacuí (Macapá)","state_id":4},
{"id":5332,"description":"Livramento do Tiúma (Timbaúba)","state_id":16},
{"id":9876,"description":"Lizarda","state_id":27},
{"id":6266,"description":"Loanda","state_id":18},
{"id":6267,"description":"Lobato","state_id":18},
{"id":9320,"description":"Lobo (Itatinga)","state_id":26},
{"id":3350,"description":"Lobo Leite (Congonhas)","state_id":11},
{"id":4977,"description":"Logradouro","state_id":15},
{"id":1473,"description":"Logradouro (Santa Quitéria)","state_id":6},
{"id":11705,"description":"Logradouro Dos Leões","state_id":16},
{"id":6268,"description":"Londrina","state_id":18},
{"id":3351,"description":"Lontra","state_id":11},
{"id":8537,"description":"Lontras","state_id":24},
{"id":6269,"description":"Lopei (Toledo)","state_id":18},
{"id":9321,"description":"Lorena","state_id":26},
{"id":2496,"description":"Loreto","state_id":10},
{"id":7840,"description":"Loreto (São Vicente do Sul)","state_id":23},
{"id":9322,"description":"Lourdes","state_id":26},
{"id":8538,"description":"Lourdes (Videira)","state_id":24},
{"id":306,"description":"Lourenço (Calçoene)","state_id":4},
{"id":3352,"description":"Lourenço Velho (Itajubá)","state_id":11},
{"id":9323,"description":"Louveira","state_id":26},
{"id":6270,"description":"Lovat (Umuarama)","state_id":18},
{"id":5333,"description":"Luanda (Serra Talhada)","state_id":16},
{"id":6271,"description":"Luar (São João do Ivaí)","state_id":18},
{"id":794,"description":"Lucaia (Planalto)","state_id":5},
{"id":4389,"description":"Lucas do Rio Verde","state_id":13},
{"id":4978,"description":"Lucena","state_id":15},
{"id":4390,"description":"Lucialva (Jauru)","state_id":13},
{"id":9325,"description":"Lucianópolis","state_id":26},
{"id":4391,"description":"Luciara","state_id":13},
{"id":2221,"description":"Lucilândia (Montes Claros de Goiás)","state_id":9},
{"id":7206,"description":"Lucrécia","state_id":20},
{"id":9324,"description":"Lucélia","state_id":26},
{"id":3353,"description":"Lufa (Novo Cruzeiro)","state_id":11},
{"id":795,"description":"Luis Viana (Casa Nova)","state_id":5},
{"id":3354,"description":"Luisburgo","state_id":11},
{"id":3355,"description":"Luislândia","state_id":11},
{"id":11262,"description":"Luiz Alves","state_id":9},
{"id":8539,"description":"Luiz Alves","state_id":24},
{"id":3356,"description":"Luiz Pires de Minas (Coração de Jesus)","state_id":11},
{"id":6272,"description":"Luiziana","state_id":18},
{"id":9327,"description":"Luiziânia","state_id":26},
{"id":3357,"description":"Luizlândia do Oeste (João Pinheiro)","state_id":11},
{"id":6960,"description":"Lumiar (Nova Friburgo)","state_id":19},
{"id":3359,"description":"Luminosa (Brasópolis)","state_id":11},
{"id":3358,"description":"Luminárias","state_id":11},
{"id":6273,"description":"Lunardelli","state_id":18},
{"id":6274,"description":"Lupionópolis","state_id":18},
{"id":9328,"description":"Lupércio","state_id":26},
{"id":9329,"description":"Lusitânia (Jaboticabal)","state_id":26},
{"id":796,"description":"Lustosa (Teodoro Sampaio)","state_id":5},
{"id":9330,"description":"Lutécia","state_id":26},
{"id":3360,"description":"Luz","state_id":11},
{"id":8540,"description":"Luzerna","state_id":24},
{"id":5626,"description":"Luzilândia","state_id":17},
{"id":9877,"description":"Luzinópolis","state_id":27},
{"id":11241,"description":"Luziápolis","state_id":2},
{"id":2222,"description":"Luziânia","state_id":9},
{"id":9326,"description":"Luís Antônio","state_id":26},
{"id":5625,"description":"Luís Correia","state_id":17},
{"id":2497,"description":"Luís Domingues","state_id":10},
{"id":834,"description":"Luís Eduardo Magalhães","state_id":5},
{"id":7207,"description":"Luís Gomes","state_id":20},
{"id":239,"description":"Lábrea","state_id":3},
{"id":9306,"description":"Lácio (Marília)","state_id":26},
{"id":11744,"description":"Lério De Cima","state_id":16},
{"id":6959,"description":"Lídice (Rio Claro)","state_id":19},
{"id":6961,"description":"Macabuzinho (Conceição de Macabu)","state_id":19},
{"id":6275,"description":"Macaco (Castro)","state_id":18},
{"id":3361,"description":"Macaia (Bom Sucesso)","state_id":11},
{"id":797,"description":"Macajuba","state_id":5},
{"id":8805,"description":"Macambira","state_id":25},
{"id":1474,"description":"Macambira (Poranga)","state_id":6},
{"id":5334,"description":"Macaparana","state_id":16},
{"id":307,"description":"Macapá","state_id":4},
{"id":798,"description":"Macarani","state_id":5},
{"id":1476,"description":"Macaraú (Santa Quitéria)","state_id":6},
{"id":9331,"description":"Macatuba","state_id":26},
{"id":7209,"description":"Macau","state_id":20},
{"id":9332,"description":"Macaubal","state_id":26},
{"id":6962,"description":"Macaé","state_id":19},
{"id":7208,"description":"Macaíba","state_id":20},
{"id":1475,"description":"Macaóca (Madalena)","state_id":6},
{"id":799,"description":"Macaúbas","state_id":5},
{"id":9333,"description":"Macedônia","state_id":26},
{"id":109,"description":"Maceió","state_id":2},
{"id":1477,"description":"Maceió (Fortim)","state_id":6},
{"id":3362,"description":"Machacalis","state_id":11},
{"id":7842,"description":"Machadinho","state_id":23},
{"id":7337,"description":"Machadinho D'Oeste","state_id":21},
{"id":3363,"description":"Machado","state_id":11},
{"id":4392,"description":"Machado (Cuiabá)","state_id":13},
{"id":5335,"description":"Machados","state_id":16},
{"id":8541,"description":"Machados (Navegantes)","state_id":24},
{"id":8542,"description":"Macieira","state_id":24},
{"id":6963,"description":"Macuco","state_id":19},
{"id":3364,"description":"Macuco (Muriaé)","state_id":11},
{"id":3365,"description":"Macuco de Minas (Itumirim)","state_id":11},
{"id":9334,"description":"Macucos (Getulina)","state_id":26},
{"id":6276,"description":"Macucos (Guarapuava)","state_id":18},
{"id":5336,"description":"Macujé (Aliança)","state_id":16},
{"id":800,"description":"Macururé","state_id":5},
{"id":1478,"description":"Madalena","state_id":6},
{"id":11533,"description":"Madeira","state_id":5},
{"id":5627,"description":"Madeiro","state_id":17},
{"id":801,"description":"Madre de Deus","state_id":5},
{"id":3366,"description":"Madre de Deus de Minas","state_id":11},
{"id":802,"description":"Maetinga","state_id":5},
{"id":8543,"description":"Mafra","state_id":24},
{"id":4674,"description":"Magalhães Barata","state_id":14},
{"id":2498,"description":"Magalhães de Almeida","state_id":10},
{"id":9335,"description":"Magda","state_id":26},
{"id":7843,"description":"Magistério (Cidreira)","state_id":23},
{"id":6964,"description":"Magé","state_id":19},
{"id":4980,"description":"Maia (Bananeiras)","state_id":15},
{"id":4675,"description":"Maiauata (Igarapé-Miri)","state_id":14},
{"id":9336,"description":"Mailasqui (São Roque)","state_id":26},
{"id":2499,"description":"Maioba (Paço do Lumiar)","state_id":10},
{"id":803,"description":"Maiquinique","state_id":5},
{"id":804,"description":"Mairi","state_id":5},
{"id":9337,"description":"Mairinque","state_id":26},
{"id":9338,"description":"Mairiporã","state_id":26},
{"id":2223,"description":"Mairipotaba","state_id":9},
{"id":6277,"description":"Mairá (Lupionópolis)","state_id":18},
{"id":6278,"description":"Maitá (Guarapuava)","state_id":18},
{"id":3368,"description":"Major Ezequiel (Alvinópolis)","state_id":11},
{"id":7210,"description":"Major Felipe (José da Penha)","state_id":20},
{"id":8544,"description":"Major Gercino","state_id":24},
{"id":110,"description":"Major Isidoro","state_id":2},
{"id":3369,"description":"Major Porto (Patos de Minas)","state_id":11},
{"id":9339,"description":"Major Prado (Santo Antônio do Aracanguá)","state_id":26},
{"id":7211,"description":"Major Sales","state_id":20},
{"id":1479,"description":"Major Simplício (Nova Russas)","state_id":6},
{"id":8545,"description":"Major Vieira","state_id":24},
{"id":1480,"description":"Majorlândia (Aracati)","state_id":6},
{"id":3370,"description":"Malacacheta","state_id":11},
{"id":805,"description":"Malhada","state_id":5},
{"id":11817,"description":"Malhada Barreiras Queimadas","state_id":16},
{"id":11822,"description":"Malhada De Pedra","state_id":16},
{"id":1481,"description":"Malhada Grande (Santa Quitéria)","state_id":6},
{"id":806,"description":"Malhada de Pedras","state_id":5},
{"id":8806,"description":"Malhada dos Bois","state_id":25},
{"id":8807,"description":"Malhador","state_id":25},
{"id":6279,"description":"Mallet","state_id":18},
{"id":4981,"description":"Malta","state_id":15},
{"id":6280,"description":"Malu (Terra Boa)","state_id":18},
{"id":4982,"description":"Mamanguape","state_id":15},
{"id":2224,"description":"Mambaí","state_id":9},
{"id":6281,"description":"Mamborê","state_id":18},
{"id":6965,"description":"Mambucaba (Angra dos Reis)","state_id":19},
{"id":3371,"description":"Mamonas","state_id":11},
{"id":7844,"description":"Mampituba","state_id":23},
{"id":241,"description":"Manacapuru","state_id":3},
{"id":242,"description":"Manaquiri","state_id":3},
{"id":5337,"description":"Manari","state_id":16},
{"id":243,"description":"Manaus","state_id":3},
{"id":4983,"description":"Manaíra","state_id":15},
{"id":7845,"description":"Manchinha (Três de Maio)","state_id":23},
{"id":5338,"description":"Mandacaia (Brejo da Madre de Deus)","state_id":16},
{"id":5339,"description":"Mandacaru (Gravatá)","state_id":16},
{"id":6284,"description":"Mandaguari","state_id":18},
{"id":6283,"description":"Mandaguaçu","state_id":18},
{"id":6282,"description":"Mandaçaia (Guarapuava)","state_id":18},
{"id":6285,"description":"Mandiocaba (Paranavaí)","state_id":18},
{"id":6286,"description":"Mandirituba","state_id":18},
{"id":807,"description":"Mandiroba (Sebastião Laranjeiras)","state_id":5},
{"id":9340,"description":"Manduri","state_id":26},
{"id":6287,"description":"Manfrinópolis","state_id":18},
{"id":3372,"description":"Manga","state_id":11},
{"id":1482,"description":"Mangabeira (Lavras da Mangabeira)","state_id":6},
{"id":11782,"description":"Mangabeiras","state_id":2},
{"id":6966,"description":"Mangaratiba","state_id":19},
{"id":9341,"description":"Mangaratu (Nova Granada)","state_id":26},
{"id":1926,"description":"Mangaraí (Santa Leopoldina)","state_id":8},
{"id":808,"description":"Mangue Seco (Jandaíra)","state_id":5},
{"id":7846,"description":"Mangueiras (Rosário do Sul)","state_id":23},
{"id":6288,"description":"Mangueirinha","state_id":18},
{"id":3373,"description":"Manhuaçu","state_id":11},
{"id":3374,"description":"Manhumirim","state_id":11},
{"id":809,"description":"Maniaçu (Caetité)","state_id":5},
{"id":1483,"description":"Manibu (Icapuí)","state_id":6},
{"id":244,"description":"Manicoré","state_id":3},
{"id":12107,"description":"Manilha","state_id":19},
{"id":1484,"description":"Manituba (Quixeramobim)","state_id":6},
{"id":6967,"description":"Maniva (São Francisco de Itabapoana)","state_id":19},
{"id":5340,"description":"Maniçoba (São Caitano)","state_id":16},
{"id":4676,"description":"Manjeiro (Mocajuba)","state_id":14},
{"id":5628,"description":"Manoel Emídio","state_id":17},
{"id":10778,"description":"Manoel Guedes","state_id":6},
{"id":6289,"description":"Manoel Ribas","state_id":18},
{"id":6968,"description":"Manoel Ribeiro (Maricá)","state_id":19},
{"id":11,"description":"Manoel Urbano","state_id":1},
{"id":7847,"description":"Manoel Viana","state_id":23},
{"id":810,"description":"Manoel Vitorino","state_id":5},
{"id":811,"description":"Mansidão","state_id":5},
{"id":3375,"description":"Mantena","state_id":11},
{"id":1927,"description":"Mantenópolis","state_id":8},
{"id":812,"description":"Mantiba (Feira de Santana)","state_id":5},
{"id":3376,"description":"Mantiqueira (Santos Dumont)","state_id":11},
{"id":3377,"description":"Mantiqueira do Palmital (Barbacena)","state_id":11},
{"id":6969,"description":"Manuel Duarte (Rio das Flores)","state_id":19},
{"id":1485,"description":"Mapuá (Jaguaribe)","state_id":6},
{"id":7848,"description":"Maquiné","state_id":23},
{"id":813,"description":"Mar Grande (Vera Cruz)","state_id":5},
{"id":111,"description":"Mar Vermelho","state_id":2},
{"id":3378,"description":"Mar de Espanha","state_id":11},
{"id":2225,"description":"Mara Rosa","state_id":9},
{"id":4677,"description":"Marabá","state_id":14},
{"id":6290,"description":"Marabá (Tuneiras do Oeste)","state_id":18},
{"id":9342,"description":"Marabá Paulista","state_id":26},
{"id":8546,"description":"Maracajá","state_id":24},
{"id":4197,"description":"Maracajú","state_id":12},
{"id":1486,"description":"Maracanaú","state_id":6},
{"id":4678,"description":"Maracanã","state_id":14},
{"id":6291,"description":"Maracanã (Castro)","state_id":18},
{"id":2500,"description":"Maracaçumé","state_id":10},
{"id":814,"description":"Maracás","state_id":5},
{"id":112,"description":"Maragogi","state_id":2},
{"id":815,"description":"Maragogipe","state_id":5},
{"id":816,"description":"Maragogipinho (Aratuípe)","state_id":5},
{"id":1487,"description":"Maraguá (Mauriti)","state_id":6},
{"id":5341,"description":"Maraial","state_id":16},
{"id":4679,"description":"Marajoara (Redenção)","state_id":14},
{"id":2501,"description":"Marajá do Sena","state_id":10},
{"id":6292,"description":"Marajó (Nova Aurora)","state_id":18},
{"id":3379,"description":"Marambainha (Caraí)","state_id":11},
{"id":6970,"description":"Marangatu (Santo Antônio de Pádua)","state_id":19},
{"id":1488,"description":"Maranguape","state_id":6},
{"id":2502,"description":"Maranhãozinho","state_id":10},
{"id":4680,"description":"Marapanim","state_id":14},
{"id":9344,"description":"Marapoama","state_id":26},
{"id":8547,"description":"Marari (Tangará)","state_id":24},
{"id":1489,"description":"Mararupá (Mauriti)","state_id":6},
{"id":1928,"description":"Marataízes","state_id":8},
{"id":7849,"description":"Maratá","state_id":23},
{"id":8548,"description":"Maratá (São Domingos)","state_id":24},
{"id":7850,"description":"Marau","state_id":23},
{"id":8549,"description":"Maravilha","state_id":24},
{"id":113,"description":"Maravilha","state_id":2},
{"id":11537,"description":"Maravilha","state_id":6},
{"id":5342,"description":"Maravilha (Custódia)","state_id":16},
{"id":6293,"description":"Maravilha (Londrina)","state_id":18},
{"id":6294,"description":"Maravilha (Realeza)","state_id":18},
{"id":3380,"description":"Maravilhas","state_id":11},
{"id":245,"description":"Maraã","state_id":3},
{"id":9343,"description":"Maraçaí","state_id":26},
{"id":817,"description":"Maraú","state_id":5},
{"id":4984,"description":"Marcação","state_id":15},
{"id":6295,"description":"Marcelino (São José dos Pinhais)","state_id":18},
{"id":7851,"description":"Marcelino Ramos","state_id":23},
{"id":7212,"description":"Marcelino Vieira","state_id":20},
{"id":4393,"description":"Marcelândia","state_id":13},
{"id":2226,"description":"Marcianópolis (Bom Jesus de Goiás)","state_id":9},
{"id":818,"description":"Marcionílio Souza","state_id":5},
{"id":6296,"description":"Marcionópolis (Santo Antônio do Sudoeste)","state_id":18},
{"id":1490,"description":"Marco","state_id":6},
{"id":7338,"description":"Marco Rondon (Pimenta Bueno)","state_id":21},
{"id":819,"description":"Marcolino Moura (Rio de Contas)","state_id":5},
{"id":5629,"description":"Marcolândia","state_id":17},
{"id":9345,"description":"Marcondésia (Monte Azul Paulista)","state_id":26},
{"id":7852,"description":"Marcorama (Garibaldi)","state_id":23},
{"id":5630,"description":"Marcos Parente","state_id":17},
{"id":8550,"description":"Marcílio Dias (Canoinhas)","state_id":24},
{"id":8551,"description":"Marechal Bormann (Chapecó)","state_id":24},
{"id":6297,"description":"Marechal Cândido Rondon","state_id":18},
{"id":114,"description":"Marechal Deodoro","state_id":2},
{"id":1929,"description":"Marechal Floriano","state_id":8},
{"id":12073,"description":"Marechal Rondon","state_id":13},
{"id":12,"description":"Marechal Thaumaturgo","state_id":1},
{"id":8552,"description":"Marema","state_id":24},
{"id":9346,"description":"Maresias (São Sebastião)","state_id":26},
{"id":6298,"description":"Margarida (Marechal Cândido Rondon)","state_id":18},
{"id":4985,"description":"Mari","state_id":15},
{"id":6299,"description":"Maria Helena","state_id":18},
{"id":6300,"description":"Maria Luiza (Paranaguá)","state_id":18},
{"id":820,"description":"Maria Quitéria (Feira de Santana)","state_id":5},
{"id":12512,"description":"Maria Santa","state_id":23},
{"id":3381,"description":"Maria da Fé","state_id":11},
{"id":6301,"description":"Marialva","state_id":18},
{"id":3382,"description":"Mariana","state_id":11},
{"id":7853,"description":"Mariana Pimentel","state_id":23},
{"id":7854,"description":"Mariano Moro","state_id":23},
{"id":7855,"description":"Mariante (Venâncio Aires)","state_id":23},
{"id":2503,"description":"Marianópolis (Pedreiras)","state_id":10},
{"id":9878,"description":"Marianópolis do Tocantins","state_id":27},
{"id":115,"description":"Maribondo","state_id":2},
{"id":821,"description":"Maricoabo (Valença)","state_id":5},
{"id":6971,"description":"Maricá","state_id":19},
{"id":6302,"description":"Mariental (Lapa)","state_id":18},
{"id":8553,"description":"Mariflor (São José do Cedro)","state_id":24},
{"id":3383,"description":"Marilac","state_id":11},
{"id":6304,"description":"Marilena","state_id":18},
{"id":6305,"description":"Marilu (Iretama)","state_id":18},
{"id":6306,"description":"Mariluz","state_id":18},
{"id":1930,"description":"Marilândia","state_id":8},
{"id":3384,"description":"Marilândia (Itapecerica)","state_id":11},
{"id":6303,"description":"Marilândia do Sul","state_id":18},
{"id":6307,"description":"Marimbondo (Siqueira Campos)","state_id":18},
{"id":6308,"description":"Maringá","state_id":18},
{"id":1491,"description":"Marinheiros (Itapipoca)","state_id":6},
{"id":9349,"description":"Marinópolis","state_id":26},
{"id":6310,"description":"Maripá","state_id":18},
{"id":3386,"description":"Maripá de Minas","state_id":11},
{"id":822,"description":"Mariquita (Tabocas do Brejo Velho)","state_id":5},
{"id":6311,"description":"Maristela (Alto Paraná)","state_id":18},
{"id":9350,"description":"Maristela (Laranjal Paulista)","state_id":26},
{"id":4681,"description":"Marituba","state_id":14},
{"id":6312,"description":"Mariza (São Pedro do Ivaí)","state_id":18},
{"id":4986,"description":"Marizópolis","state_id":15},
{"id":9347,"description":"Mariápolis","state_id":26},
{"id":7856,"description":"Mariápolis (Osório)","state_id":23},
{"id":6309,"description":"Mariópolis","state_id":18},
{"id":3387,"description":"Marliéria","state_id":11},
{"id":6314,"description":"Marmeleiro","state_id":18},
{"id":12650,"description":"Marmeleiro","state_id":23},
{"id":6313,"description":"Marmelândia (Realeza)","state_id":18},
{"id":3388,"description":"Marmelópolis","state_id":11},
{"id":8554,"description":"Marombas (Brunópolis)","state_id":24},
{"id":8555,"description":"Marombas Bossardi (Curitibanos)","state_id":24},
{"id":7857,"description":"Marques de Souza","state_id":23},
{"id":6316,"description":"Marquinho","state_id":18},
{"id":12742,"description":"Marquês Dos Reis","state_id":18},
{"id":6315,"description":"Marquês de Abrantes (Tunas do Paraná)","state_id":18},
{"id":6317,"description":"Marrecas (Guarapuava)","state_id":18},
{"id":1492,"description":"Marrecas (Tauá)","state_id":6},
{"id":1493,"description":"Marrocos (Juazeiro do Norte)","state_id":6},
{"id":1494,"description":"Marruás (Tauá)","state_id":6},
{"id":9351,"description":"Martim Francisco (Mogi Mirim)","state_id":26},
{"id":3390,"description":"Martinho Campos","state_id":11},
{"id":9352,"description":"Martinho Prado Júnior (Mogi Guaçu)","state_id":26},
{"id":7213,"description":"Martins","state_id":20},
{"id":6318,"description":"Martins (Araucária)","state_id":18},
{"id":3391,"description":"Martins Guimarães (Lagoa da Prata)","state_id":11},
{"id":3392,"description":"Martins Soares","state_id":11},
{"id":11627,"description":"Martinslândia","state_id":6},
{"id":3389,"description":"Martinésia (Uberlândia)","state_id":11},
{"id":1495,"description":"Martinópole","state_id":6},
{"id":9353,"description":"Martinópolis","state_id":26},
{"id":12031,"description":"Martinópolis","state_id":18},
{"id":4682,"description":"Marudá (Marapanim)","state_id":14},
{"id":8808,"description":"Maruim","state_id":25},
{"id":6319,"description":"Marumbi","state_id":18},
{"id":2227,"description":"Marzagão","state_id":9},
{"id":4394,"description":"Marzagão (Rosário Oeste)","state_id":13},
{"id":9348,"description":"Marília","state_id":26},
{"id":823,"description":"Mascote","state_id":5},
{"id":824,"description":"Massacara (Euclides da Cunha)","state_id":5},
{"id":11841,"description":"Massangano","state_id":16},
{"id":1496,"description":"Massapê","state_id":6},
{"id":5631,"description":"Massapê do Piauí","state_id":17},
{"id":4987,"description":"Massaranduba","state_id":15},
{"id":8556,"description":"Massaranduba","state_id":24},
{"id":116,"description":"Massaranduba (Arapiraca)","state_id":2},
{"id":825,"description":"Massaroca (Juazeiro)","state_id":5},
{"id":246,"description":"Massauari (Boa Vista do Ramos)","state_id":3},
{"id":7858,"description":"Mata","state_id":23},
{"id":2504,"description":"Mata (São José de Ribamar)","state_id":10},
{"id":4395,"description":"Mata Dentro (Cuiabá)","state_id":13},
{"id":1497,"description":"Mata Fresca (Aracati)","state_id":6},
{"id":4683,"description":"Mata Geral (Redenção)","state_id":14},
{"id":117,"description":"Mata Grande","state_id":2},
{"id":11783,"description":"Mata Limpa","state_id":2},
{"id":4988,"description":"Mata Limpa (Areia)","state_id":15},
{"id":2505,"description":"Mata Roma","state_id":10},
{"id":3393,"description":"Mata Verde","state_id":11},
{"id":4989,"description":"Mata Virgem (Umbuzeiro)","state_id":15},
{"id":826,"description":"Mata da Aliança (Amélia Rodrigues)","state_id":5},
{"id":7214,"description":"Mata de São Braz (Tenente Ananias)","state_id":20},
{"id":827,"description":"Mata de São João","state_id":5},
{"id":4684,"description":"Matapiquara (Marapanim)","state_id":14},
{"id":4990,"description":"Mataraca","state_id":15},
{"id":7859,"description":"Matarazzo (Pedro Osório)","state_id":23},
{"id":828,"description":"Mataripe (São Francisco do Conde)","state_id":5},
{"id":9879,"description":"Mateiros","state_id":27},
{"id":6320,"description":"Matelândia","state_id":18},
{"id":3394,"description":"Materlândia","state_id":11},
{"id":3395,"description":"Mateus Leme","state_id":11},
{"id":3396,"description":"Mathias Lobato","state_id":11},
{"id":1498,"description":"Matias (Pentecoste)","state_id":6},
{"id":3397,"description":"Matias Barbosa","state_id":11},
{"id":3398,"description":"Matias Cardoso","state_id":11},
{"id":5632,"description":"Matias Olímpio","state_id":17},
{"id":1931,"description":"Matilde (Alfredo Chaves)","state_id":8},
{"id":829,"description":"Matina","state_id":5},
{"id":11724,"description":"Matinada","state_id":16},
{"id":11988,"description":"Matinha","state_id":5},
{"id":2506,"description":"Matinha","state_id":10},
{"id":830,"description":"Matinha (Feira de Santana)","state_id":5},
{"id":4991,"description":"Matinhas","state_id":15},
{"id":6321,"description":"Matinhos","state_id":18},
{"id":6322,"description":"Matinhos (Guarapuava)","state_id":18},
{"id":3399,"description":"Matipó","state_id":11},
{"id":7860,"description":"Mato Castelhano","state_id":23},
{"id":12578,"description":"Mato Grande","state_id":23},
{"id":7861,"description":"Mato Grande (Giruá)","state_id":23},
{"id":4992,"description":"Mato Grosso","state_id":15},
{"id":7862,"description":"Mato Leitão","state_id":23},
{"id":10839,"description":"Mato Perso","state_id":23},
{"id":7863,"description":"Mato Queimado","state_id":23},
{"id":6323,"description":"Mato Queimado (Ponta Grossa)","state_id":18},
{"id":6324,"description":"Mato Rico","state_id":18},
{"id":3400,"description":"Mato Verde","state_id":11},
{"id":8557,"description":"Matos Costa","state_id":24},
{"id":3401,"description":"Matozinhos","state_id":11},
{"id":2228,"description":"Matrinchã","state_id":9},
{"id":1499,"description":"Matriz (Ipueiras)","state_id":6},
{"id":118,"description":"Matriz de Camaragibe","state_id":2},
{"id":4396,"description":"Matupá","state_id":13},
{"id":4993,"description":"Maturéia","state_id":15},
{"id":3402,"description":"Matutina","state_id":11},
{"id":9354,"description":"Matão","state_id":26},
{"id":2507,"description":"Matões","state_id":10},
{"id":2508,"description":"Matões do Norte","state_id":10},
{"id":2229,"description":"Maurilândia","state_id":9},
{"id":9880,"description":"Maurilândia do Tocantins","state_id":27},
{"id":1500,"description":"Mauriti","state_id":6},
{"id":9355,"description":"Mauá","state_id":26},
{"id":7864,"description":"Mauá (Arroio Grande)","state_id":23},
{"id":7865,"description":"Mauá (Ijuí)","state_id":23},
{"id":6325,"description":"Mauá da Serra","state_id":18},
{"id":247,"description":"Maués","state_id":3},
{"id":7215,"description":"Maxaranguape","state_id":20},
{"id":7866,"description":"Maximiliano de Almeida","state_id":23},
{"id":308,"description":"Mazagão","state_id":4},
{"id":309,"description":"Mazagão Velho (Mazagão)","state_id":4},
{"id":7841,"description":"Maçambará","state_id":23},
{"id":3403,"description":"Medeiros","state_id":11},
{"id":831,"description":"Medeiros Neto","state_id":5},
{"id":6326,"description":"Medianeira","state_id":18},
{"id":7867,"description":"Medianeira (Ajuricaba)","state_id":23},
{"id":4685,"description":"Medicilândia","state_id":14},
{"id":3404,"description":"Medina","state_id":11},
{"id":2230,"description":"Meia Ponte (Itumbiara)","state_id":9},
{"id":6327,"description":"Meia-Lua (Almirante Tamandaré)","state_id":18},
{"id":1501,"description":"Mel (Jucás)","state_id":6},
{"id":8558,"description":"Meleiro","state_id":24},
{"id":4686,"description":"Melgaço","state_id":14},
{"id":1932,"description":"Melgaço (Domingos Martins)","state_id":8},
{"id":4994,"description":"Melo (Cuité)","state_id":15},
{"id":3405,"description":"Melo Viana (Esmeraldas)","state_id":11},
{"id":6328,"description":"Memória (Toledo)","state_id":18},
{"id":3406,"description":"Mendanha (Diamantina)","state_id":11},
{"id":6972,"description":"Mendes","state_id":19},
{"id":3407,"description":"Mendes Pimentel","state_id":11},
{"id":6329,"description":"Mendeslândia (Nossa Senhora das Graças)","state_id":18},
{"id":9356,"description":"Mendonça","state_id":26},
{"id":3408,"description":"Mendonça (Veredinha)","state_id":11},
{"id":4687,"description":"Menino Deus do Anapu (Igarapé-Miri)","state_id":14},
{"id":11532,"description":"Menino Jesus","state_id":5},
{"id":1933,"description":"Menino Jesus (Muniz Freire)","state_id":8},
{"id":6330,"description":"Mercedes","state_id":18},
{"id":3409,"description":"Mercês","state_id":11},
{"id":3410,"description":"Mercês de Água Limpa (São Tiago)","state_id":11},
{"id":9357,"description":"Meridiano","state_id":26},
{"id":1502,"description":"Meruoca","state_id":6},
{"id":4688,"description":"Meruú (Igarapé-Miri)","state_id":14},
{"id":6973,"description":"Mesquita","state_id":19},
{"id":3411,"description":"Mesquita","state_id":11},
{"id":1503,"description":"Messejana (Fortaleza)","state_id":6},
{"id":2231,"description":"Messianópolis (Moiporá)","state_id":9},
{"id":119,"description":"Messias","state_id":2},
{"id":7216,"description":"Messias Targino","state_id":20},
{"id":3412,"description":"Mestre Caetano (Sabará)","state_id":11},
{"id":9358,"description":"Mesópolis","state_id":26},
{"id":5633,"description":"Miguel Alves","state_id":17},
{"id":3413,"description":"Miguel Burnier (Ouro Preto)","state_id":11},
{"id":832,"description":"Miguel Calmon","state_id":5},
{"id":5634,"description":"Miguel Leão","state_id":17},
{"id":6974,"description":"Miguel Pereira","state_id":19},
{"id":1504,"description":"Miguel Xavier (Caririaçu)","state_id":6},
{"id":9359,"description":"Miguelópolis","state_id":26},
{"id":3414,"description":"Milagre (Monte Santo de Minas)","state_id":11},
{"id":1505,"description":"Milagres","state_id":6},
{"id":833,"description":"Milagres","state_id":5},
{"id":2509,"description":"Milagres do Maranhão","state_id":10},
{"id":3415,"description":"Milho Verde (Serro)","state_id":11},
{"id":1506,"description":"Milhã","state_id":6},
{"id":1507,"description":"Milton Belo (Aracoiaba)","state_id":6},
{"id":5635,"description":"Milton Brandão","state_id":17},
{"id":11745,"description":"Mimoso","state_id":16},
{"id":5343,"description":"Mimoso (Pesqueira)","state_id":16},
{"id":4397,"description":"Mimoso (Santo Antônio do Leverger)","state_id":13},
{"id":2232,"description":"Mimoso de Goiás","state_id":9},
{"id":1934,"description":"Mimoso do Sul","state_id":8},
{"id":120,"description":"Minador do Negrão","state_id":2},
{"id":3416,"description":"Minas Novas","state_id":11},
{"id":835,"description":"Minas do Espírito Santo (Barra do Mendes)","state_id":5},
{"id":7868,"description":"Minas do Leão","state_id":23},
{"id":836,"description":"Minas do Mimoso (Sento Sé)","state_id":5},
{"id":2233,"description":"Minaçu","state_id":9},
{"id":3417,"description":"Minduri","state_id":11},
{"id":1508,"description":"Mineirolândia (Pedra Branca)","state_id":6},
{"id":2234,"description":"Mineiros","state_id":9},
{"id":9360,"description":"Mineiros do Tietê","state_id":26},
{"id":12500,"description":"Mingote","state_id":23},
{"id":7339,"description":"Ministro Andreazza","state_id":21},
{"id":9361,"description":"Mira Estrela","state_id":26},
{"id":3418,"description":"Mirabela","state_id":11},
{"id":9362,"description":"Miracatu","state_id":26},
{"id":6975,"description":"Miracema","state_id":19},
{"id":9881,"description":"Miracema do Tocantins","state_id":27},
{"id":5344,"description":"Miracica (Garanhuns)","state_id":16},
{"id":2510,"description":"Mirador","state_id":10},
{"id":6331,"description":"Mirador","state_id":18},
{"id":8559,"description":"Mirador (Presidente Getúlio)","state_id":24},
{"id":3419,"description":"Miradouro","state_id":11},
{"id":3420,"description":"Miragaia (Ubá)","state_id":11},
{"id":1509,"description":"Miragem (Caririaçu)","state_id":6},
{"id":7870,"description":"Miraguaia (Santo Antônio da Patrulha)","state_id":23},
{"id":7869,"description":"Miraguaí","state_id":23},
{"id":3422,"description":"Miralta (Montes Claros)","state_id":11},
{"id":9363,"description":"Miraluz (Neves Paulista)","state_id":26},
{"id":1511,"description":"Mirambé (Caucaia)","state_id":6},
{"id":4198,"description":"Miranda","state_id":12},
{"id":12767,"description":"Miranda","state_id":6},
{"id":8809,"description":"Miranda (Capela)","state_id":25},
{"id":6332,"description":"Miranda (Telêmaco Borba)","state_id":18},
{"id":2511,"description":"Miranda do Norte","state_id":10},
{"id":837,"description":"Mirandela (Banzaê)","state_id":5},
{"id":5345,"description":"Mirandiba","state_id":16},
{"id":9364,"description":"Mirandópolis","state_id":26},
{"id":9882,"description":"Mirandópolis (Guaraí)","state_id":27},
{"id":838,"description":"Miranga (Pojuca)","state_id":5},
{"id":839,"description":"Mirangaba","state_id":5},
{"id":9883,"description":"Miranorte","state_id":27},
{"id":840,"description":"Mirante","state_id":5},
{"id":7340,"description":"Mirante da Serra","state_id":21},
{"id":9365,"description":"Mirante do Paranapanema","state_id":26},
{"id":6333,"description":"Mirante do Piquiri (Alto Piquiri)","state_id":18},
{"id":3423,"description":"Mirantão (Bocaina de Minas)","state_id":11},
{"id":3424,"description":"Miraporanga (Uberlândia)","state_id":11},
{"id":6334,"description":"Miraselva","state_id":18},
{"id":4689,"description":"Mirasselvas (Capanema)","state_id":14},
{"id":9366,"description":"Mirassol","state_id":26},
{"id":4398,"description":"Mirassol D'Oeste","state_id":13},
{"id":9367,"description":"Mirassolândia","state_id":26},
{"id":3425,"description":"Miravânia","state_id":11},
{"id":3421,"description":"Miraí","state_id":11},
{"id":1510,"description":"Miraíma","state_id":6},
{"id":8560,"description":"Mirim (Imbituba)","state_id":24},
{"id":7871,"description":"Mirim (Santa Vitória do Palmar)","state_id":23},
{"id":7872,"description":"Mirim (Severiano de Almeida)","state_id":23},
{"id":8561,"description":"Mirim Doce","state_id":24},
{"id":2512,"description":"Mirinzal","state_id":10},
{"id":4690,"description":"Miritituba (Itaituba)","state_id":14},
{"id":6335,"description":"Missal","state_id":18},
{"id":1514,"description":"Missi (Irauçuba)","state_id":6},
{"id":3426,"description":"Missionário (Alto Rio Doce)","state_id":11},
{"id":1512,"description":"Missão Nova (Missão Velha)","state_id":6},
{"id":1513,"description":"Missão Velha","state_id":6},
{"id":4691,"description":"Mocajuba","state_id":14},
{"id":3427,"description":"Mocambeiro (Matozinhos)","state_id":11},
{"id":3428,"description":"Mocambinho (Porteirinha)","state_id":11},
{"id":11628,"description":"Mocambo","state_id":6},
{"id":12171,"description":"Mocambo","state_id":6},
{"id":841,"description":"Mocambo (Ibitiara)","state_id":5},
{"id":248,"description":"Mocambo (Parintins)","state_id":3},
{"id":9368,"description":"Mococa","state_id":26},
{"id":8562,"description":"Modelo","state_id":24},
{"id":11737,"description":"Moderna","state_id":16},
{"id":3429,"description":"Moeda","state_id":11},
{"id":3430,"description":"Moema","state_id":11},
{"id":4995,"description":"Mogeiro","state_id":15},
{"id":9370,"description":"Mogi Guaçu","state_id":26},
{"id":9371,"description":"Mogi Mirim","state_id":26},
{"id":9369,"description":"Mogi das Cruzes","state_id":26},
{"id":842,"description":"Mogiquiçaba (Belmonte)","state_id":5},
{"id":2235,"description":"Moiporá","state_id":9},
{"id":4692,"description":"Moiraba (Cametá)","state_id":14},
{"id":8810,"description":"Moita Bonita","state_id":25},
{"id":1515,"description":"Moitas (Amontada)","state_id":6},
{"id":4693,"description":"Moju","state_id":14},
{"id":1516,"description":"Mombaça","state_id":6},
{"id":9372,"description":"Mombuca","state_id":26},
{"id":8563,"description":"Mondaí","state_id":24},
{"id":1517,"description":"Mondubim (Fortaleza)","state_id":6},
{"id":6976,"description":"Monera (Duas Barras)","state_id":19},
{"id":9374,"description":"Mongaguá","state_id":26},
{"id":1518,"description":"Monguba (Pacatuba)","state_id":6},
{"id":6336,"description":"Monjolinho (Ortigueira)","state_id":18},
{"id":3431,"description":"Monjolinho de Minas (Lagoa Formosa)","state_id":11},
{"id":6977,"description":"Monjolo (São Gonçalo)","state_id":19},
{"id":3432,"description":"Monjolos","state_id":11},
{"id":4694,"description":"Monsaras (Salvaterra)","state_id":14},
{"id":5636,"description":"Monsenhor Gil","state_id":17},
{"id":5637,"description":"Monsenhor Hipólito","state_id":17},
{"id":3433,"description":"Monsenhor Horta (Mariana)","state_id":11},
{"id":3434,"description":"Monsenhor Isidro (Itaverava)","state_id":11},
{"id":3435,"description":"Monsenhor João Alexandre (Cláudio)","state_id":11},
{"id":3436,"description":"Monsenhor Paulo","state_id":11},
{"id":1519,"description":"Monsenhor Tabosa","state_id":6},
{"id":4996,"description":"Montadas","state_id":15},
{"id":3437,"description":"Montalvânia","state_id":11},
{"id":9375,"description":"Montalvão (Presidente Prudente)","state_id":26},
{"id":1935,"description":"Montanha","state_id":8},
{"id":7217,"description":"Montanhas","state_id":20},
{"id":7873,"description":"Montauri","state_id":23},
{"id":7218,"description":"Monte Alegre","state_id":20},
{"id":4695,"description":"Monte Alegre","state_id":14},
{"id":11732,"description":"Monte Alegre","state_id":16},
{"id":1520,"description":"Monte Alegre (Barro)","state_id":6},
{"id":8564,"description":"Monte Alegre (Camboriú)","state_id":24},
{"id":1521,"description":"Monte Alegre (Canindé)","state_id":6},
{"id":7874,"description":"Monte Alegre (General Câmara)","state_id":23},
{"id":7875,"description":"Monte Alegre (Santiago)","state_id":23},
{"id":6978,"description":"Monte Alegre (Santo Antônio de Pádua)","state_id":19},
{"id":2236,"description":"Monte Alegre de Goiás","state_id":9},
{"id":3438,"description":"Monte Alegre de Minas","state_id":11},
{"id":8811,"description":"Monte Alegre de Sergipe","state_id":25},
{"id":4696,"description":"Monte Alegre do Mau (Marapanim)","state_id":14},
{"id":5638,"description":"Monte Alegre do Piauí","state_id":17},
{"id":9376,"description":"Monte Alegre do Sul","state_id":26},
{"id":7876,"description":"Monte Alegre dos Campos","state_id":23},
{"id":9377,"description":"Monte Alto","state_id":26},
{"id":11526,"description":"Monte Alverne","state_id":6},
{"id":7877,"description":"Monte Alverne (Santa Cruz do Sul)","state_id":23},
{"id":9378,"description":"Monte Aprazível","state_id":26},
{"id":3439,"description":"Monte Azul","state_id":11},
{"id":9379,"description":"Monte Azul Paulista","state_id":26},
{"id":3440,"description":"Monte Belo","state_id":11},
{"id":12565,"description":"Monte Belo","state_id":23},
{"id":7878,"description":"Monte Belo do Sul","state_id":23},
{"id":7879,"description":"Monte Bonito (Pelotas)","state_id":23},
{"id":9380,"description":"Monte Cabrão (Santos)","state_id":26},
{"id":8565,"description":"Monte Carlo","state_id":24},
{"id":3441,"description":"Monte Carmelo","state_id":11},
{"id":1936,"description":"Monte Carmelo do Rio Novo (Alto Rio Novo)","state_id":8},
{"id":8566,"description":"Monte Castelo","state_id":24},
{"id":11538,"description":"Monte Castelo","state_id":6},
{"id":9381,"description":"Monte Castelo","state_id":26},
{"id":12516,"description":"Monte Castelo","state_id":23},
{"id":1522,"description":"Monte Castelo (Campos Sales)","state_id":6},
{"id":3442,"description":"Monte Celeste (São Geraldo)","state_id":11},
{"id":843,"description":"Monte Cruzeiro (Elísio Medrado)","state_id":5},
{"id":4697,"description":"Monte Dourado (Almeirim)","state_id":14},
{"id":3443,"description":"Monte Formoso","state_id":11},
{"id":844,"description":"Monte Gordo (Camaçari)","state_id":5},
{"id":1523,"description":"Monte Grave (Milhã)","state_id":6},
{"id":4997,"description":"Monte Horebe","state_id":15},
{"id":9885,"description":"Monte Lindo (Goiatins)","state_id":27},
{"id":9382,"description":"Monte Mor","state_id":26},
{"id":7341,"description":"Monte Negro","state_id":21},
{"id":1937,"description":"Monte Pio (Castelo)","state_id":8},
{"id":6337,"description":"Monte Real (Santo Antônio da Platina)","state_id":18},
{"id":845,"description":"Monte Recôncavo (São Francisco do Conde)","state_id":5},
{"id":3444,"description":"Monte Rei (Juvenília)","state_id":11},
{"id":846,"description":"Monte Santo","state_id":5},
{"id":12687,"description":"Monte Santo","state_id":5},
{"id":3445,"description":"Monte Santo de Minas","state_id":11},
{"id":9886,"description":"Monte Santo do Tocantins","state_id":27},
{"id":1938,"description":"Monte Sinai (Barra de São Francisco)","state_id":8},
{"id":1524,"description":"Monte Sion (Parambu)","state_id":6},
{"id":3446,"description":"Monte Sião","state_id":11},
{"id":11087,"description":"Monte Verde","state_id":11},
{"id":3447,"description":"Monte Verde (Camanducaia)","state_id":11},
{"id":6979,"description":"Monte Verde (Cambuci)","state_id":19},
{"id":9383,"description":"Monte Verde Paulista (Cajobi)","state_id":26},
{"id":7219,"description":"Monte das Gameleiras","state_id":20},
{"id":9884,"description":"Monte do Carmo","state_id":27},
{"id":4998,"description":"Monteiro","state_id":15},
{"id":9384,"description":"Monteiro Lobato","state_id":26},
{"id":121,"description":"Monteirópolis","state_id":2},
{"id":1525,"description":"Montenebo (Crateús)","state_id":6},
{"id":7880,"description":"Montenegro","state_id":23},
{"id":2514,"description":"Montes Altos","state_id":10},
{"id":3448,"description":"Montes Claros","state_id":11},
{"id":2237,"description":"Montes Claros de Goiás","state_id":9},
{"id":4199,"description":"Montese (Itaporã)","state_id":12},
{"id":4999,"description":"Montevidéu (Conceição)","state_id":15},
{"id":3449,"description":"Montezuma","state_id":11},
{"id":2238,"description":"Montividiu","state_id":9},
{"id":2239,"description":"Montividiu do Norte","state_id":9},
{"id":6980,"description":"Monumento (Piraí)","state_id":19},
{"id":2513,"description":"Monção","state_id":10},
{"id":9373,"description":"Monções","state_id":26},
{"id":1526,"description":"Morada Nova","state_id":6},
{"id":4698,"description":"Morada Nova (Marabá)","state_id":14},
{"id":3450,"description":"Morada Nova de Minas","state_id":11},
{"id":11060,"description":"Moraes Almeida","state_id":14},
{"id":5346,"description":"Morais (Araripina)","state_id":16},
{"id":6981,"description":"Morangaba (Campos dos Goytacazes)","state_id":19},
{"id":4200,"description":"Morangas (Inocência)","state_id":12},
{"id":1527,"description":"Moraújo","state_id":6},
{"id":5347,"description":"Moreilândia","state_id":16},
{"id":122,"description":"Moreira (Palmeira dos Índios)","state_id":2},
{"id":9385,"description":"Moreira César (Pindamonhangaba)","state_id":26},
{"id":6338,"description":"Moreira Sales","state_id":18},
{"id":5348,"description":"Moreno","state_id":16},
{"id":7881,"description":"Mormaço","state_id":23},
{"id":847,"description":"Morpará","state_id":5},
{"id":4201,"description":"Morraria do Sul (Bodoquena)","state_id":12},
{"id":6339,"description":"Morretes","state_id":18},
{"id":1528,"description":"Morrinhos","state_id":6},
{"id":2240,"description":"Morrinhos","state_id":9},
{"id":848,"description":"Morrinhos (Feira de Santana)","state_id":5},
{"id":7882,"description":"Morrinhos (São Jerônimo)","state_id":23},
{"id":1529,"description":"Morrinhos Novos (Guaraciaba do Norte)","state_id":6},
{"id":7883,"description":"Morrinhos do Sul","state_id":23},
{"id":3451,"description":"Morro (São Francisco)","state_id":11},
{"id":9386,"description":"Morro Agudo","state_id":26},
{"id":2241,"description":"Morro Agudo de Goiás","state_id":9},
{"id":7884,"description":"Morro Alto (Maquiné)","state_id":23},
{"id":6340,"description":"Morro Alto (São José dos Pinhais)","state_id":18},
{"id":7885,"description":"Morro Azul (Três Cachoeiras)","state_id":23},
{"id":1530,"description":"Morro Branco (Itatira)","state_id":6},
{"id":5639,"description":"Morro Cabeça no Tempo","state_id":17},
{"id":8567,"description":"Morro Chato (Turvo)","state_id":24},
{"id":12454,"description":"Morro Dos Leffas","state_id":23},
{"id":12709,"description":"Morro Gaúcho","state_id":23},
{"id":8570,"description":"Morro Grande","state_id":24},
{"id":12428,"description":"Morro Grande","state_id":23},
{"id":6983,"description":"Morro Grande (Araruama)","state_id":19},
{"id":6341,"description":"Morro Inglês (Paranaguá)","state_id":18},
{"id":7886,"description":"Morro Redondo","state_id":23},
{"id":7887,"description":"Morro Reuter","state_id":23},
{"id":3455,"description":"Morro Vermelho (Caeté)","state_id":11},
{"id":8568,"description":"Morro da Fumaça","state_id":24},
{"id":3452,"description":"Morro da Garça","state_id":11},
{"id":849,"description":"Morro das Flores (Ruy Barbosa)","state_id":5},
{"id":850,"description":"Morro de São Paulo (Cairu)","state_id":5},
{"id":9387,"description":"Morro do Alto (Itapetininga)","state_id":26},
{"id":851,"description":"Morro do Chapéu","state_id":5},
{"id":5640,"description":"Morro do Chapéu do Piauí","state_id":17},
{"id":6982,"description":"Morro do Côco (Campos dos Goytacazes)","state_id":19},
{"id":3453,"description":"Morro do Ferro (Oliveira)","state_id":11},
{"id":8569,"description":"Morro do Meio (Joinville)","state_id":24},
{"id":3454,"description":"Morro do Pilar","state_id":11},
{"id":2515,"description":"Morros","state_id":10},
{"id":852,"description":"Mortugaba","state_id":5},
{"id":4202,"description":"Morumbi (Eldorado)","state_id":12},
{"id":9388,"description":"Morungaba","state_id":26},
{"id":7888,"description":"Morungava (Gravataí)","state_id":23},
{"id":8812,"description":"Mosqueiro (Aracaju)","state_id":25},
{"id":4699,"description":"Mosqueiro (Belém)","state_id":14},
{"id":12063,"description":"Mosquito","state_id":6},
{"id":7220,"description":"Mossoró","state_id":20},
{"id":2242,"description":"Mossâmedes","state_id":9},
{"id":7889,"description":"Mostardas","state_id":23},
{"id":9389,"description":"Mostardas (Monte Alegre do Sul)","state_id":26},
{"id":9390,"description":"Motuca","state_id":26},
{"id":249,"description":"Moura (Barcelos)","state_id":3},
{"id":9391,"description":"Mourão (Mariápolis)","state_id":26},
{"id":5349,"description":"Moxotó (Ibimirim)","state_id":16},
{"id":2243,"description":"Mozarlândia","state_id":9},
{"id":4700,"description":"Muaná","state_id":14},
{"id":7381,"description":"Mucajaí","state_id":22},
{"id":1531,"description":"Mucambo","state_id":6},
{"id":853,"description":"Mucugê","state_id":5},
{"id":854,"description":"Mucuri","state_id":5},
{"id":3456,"description":"Mucuri (Teófilo Otoni)","state_id":11},
{"id":1939,"description":"Mucurici","state_id":8},
{"id":7891,"description":"Muitos Capões","state_id":23},
{"id":4701,"description":"Mujuí dos Campos (Santarém)","state_id":14},
{"id":7892,"description":"Muliterno","state_id":23},
{"id":1532,"description":"Mulungu","state_id":6},
{"id":5000,"description":"Mulungu","state_id":15},
{"id":1533,"description":"Mulungu (Piquet Carneiro)","state_id":6},
{"id":5350,"description":"Mulungu (Sanharó)","state_id":16},
{"id":855,"description":"Mulungu do Morro","state_id":5},
{"id":1534,"description":"Mumbaba (Massapê)","state_id":6},
{"id":1535,"description":"Mundau (Trairi)","state_id":6},
{"id":856,"description":"Mundo Novo","state_id":5},
{"id":4203,"description":"Mundo Novo","state_id":12},
{"id":2244,"description":"Mundo Novo","state_id":9},
{"id":12630,"description":"Mundo Novo","state_id":23},
{"id":1940,"description":"Mundo Novo (Dores do Rio Preto)","state_id":8},
{"id":3457,"description":"Mundo Novo de Minas (Aimorés)","state_id":11},
{"id":123,"description":"Munguba (Santana do Mundaú)","state_id":2},
{"id":3458,"description":"Munhoz","state_id":11},
{"id":6342,"description":"Munhoz de Melo","state_id":18},
{"id":857,"description":"Muniz Ferreira","state_id":5},
{"id":1941,"description":"Muniz Freire","state_id":8},
{"id":1942,"description":"Muqui","state_id":8},
{"id":5001,"description":"Muquém (Areia)","state_id":15},
{"id":3459,"description":"Muquém (Mirabela)","state_id":11},
{"id":858,"description":"Muquém de São Francisco","state_id":5},
{"id":4702,"description":"Murajá (Curuçá)","state_id":14},
{"id":3460,"description":"Muriaé","state_id":11},
{"id":8813,"description":"Muribeca","state_id":25},
{"id":1536,"description":"Muribeca (Santa Quitéria)","state_id":6},
{"id":124,"description":"Murici","state_id":2},
{"id":11828,"description":"Murici","state_id":16},
{"id":5641,"description":"Murici dos Portelas","state_id":17},
{"id":9888,"description":"Muricilândia","state_id":27},
{"id":1537,"description":"Muriti (Crato)","state_id":6},
{"id":859,"description":"Muritiba","state_id":5},
{"id":11771,"description":"Murituba","state_id":3},
{"id":12520,"description":"Murta","state_id":23},
{"id":4703,"description":"Murucupi (Barcarena)","state_id":14},
{"id":4704,"description":"Murumuru (Marabá)","state_id":14},
{"id":5351,"description":"Murupé (Vicência)","state_id":16},
{"id":250,"description":"Murutinga (Autazes)","state_id":3},
{"id":9392,"description":"Murutinga do Sul","state_id":26},
{"id":6984,"description":"Mussurepe (Campos dos Goytacazes)","state_id":19},
{"id":4705,"description":"Muta (Ponta de Pedras)","state_id":14},
{"id":1538,"description":"Mutambeiras (Santana do Acaraú)","state_id":6},
{"id":860,"description":"Mutas (Guanambi)","state_id":5},
{"id":5352,"description":"Mutuca (Pesqueira)","state_id":16},
{"id":4706,"description":"Mutucal (Curuçá)","state_id":14},
{"id":3461,"description":"Mutum","state_id":11},
{"id":11449,"description":"Mutum Paraná","state_id":21},
{"id":2245,"description":"Mutunópolis","state_id":9},
{"id":861,"description":"Mutuípe","state_id":5},
{"id":3462,"description":"Muzambinho","state_id":11},
{"id":7890,"description":"Muçum","state_id":23},
{"id":3385,"description":"Mário Campos","state_id":11},
{"id":10,"description":"Mâncio Lima","state_id":1},
{"id":4979,"description":"Mãe D'Água","state_id":15},
{"id":4673,"description":"Mãe do Rio","state_id":14},
{"id":3367,"description":"Mãe dos Homens (São Sebastião do Maranhão)","state_id":11},
{"id":3463,"description":"Nacip Raydan","state_id":11},
{"id":862,"description":"Nagé (Maragogipe)","state_id":5},
{"id":9393,"description":"Nantes","state_id":26},
{"id":3464,"description":"Nanuque","state_id":11},
{"id":3465,"description":"Naque","state_id":11},
{"id":3466,"description":"Naque-Nanuque (Açucena)","state_id":11},
{"id":9394,"description":"Narandiba","state_id":26},
{"id":863,"description":"Narandiba (Alagoinhas)","state_id":5},
{"id":1539,"description":"Naraniu (Várzea Alegre)","state_id":6},
{"id":1540,"description":"Nascente (Amontada)","state_id":6},
{"id":5353,"description":"Nascente (Araripina)","state_id":16},
{"id":7221,"description":"Natal","state_id":20},
{"id":9889,"description":"Natal (Araguatins)","state_id":27},
{"id":3467,"description":"Natalândia","state_id":11},
{"id":6343,"description":"Natingui (Ortigueira)","state_id":18},
{"id":2246,"description":"Natinópolis (Goianésia)","state_id":9},
{"id":6985,"description":"Natividade","state_id":19},
{"id":9890,"description":"Natividade","state_id":27},
{"id":9395,"description":"Natividade da Serra","state_id":26},
{"id":5002,"description":"Natuba","state_id":15},
{"id":3468,"description":"Natércia","state_id":11},
{"id":10184,"description":"Navarro (Paulista)","state_id":16},
{"id":8571,"description":"Navegantes","state_id":24},
{"id":4204,"description":"Naviraí","state_id":12},
{"id":3470,"description":"Nazareno","state_id":11},
{"id":5004,"description":"Nazarezinho","state_id":15},
{"id":864,"description":"Nazaré","state_id":5},
{"id":11447,"description":"Nazaré","state_id":21},
{"id":9891,"description":"Nazaré","state_id":27},
{"id":5003,"description":"Nazaré (Pocinhos)","state_id":15},
{"id":7894,"description":"Nazaré (Santiago)","state_id":23},
{"id":9396,"description":"Nazaré Paulista","state_id":26},
{"id":5355,"description":"Nazaré da Mata","state_id":16},
{"id":3469,"description":"Nazaré de Minas (Nepomuceno)","state_id":11},
{"id":4707,"description":"Nazaré de Mocajuba (Curuçá)","state_id":14},
{"id":5642,"description":"Nazaré do Piauí","state_id":17},
{"id":4708,"description":"Nazaré dos Patos (Tucuruí)","state_id":14},
{"id":11896,"description":"Nazária","state_id":17},
{"id":2247,"description":"Nazário","state_id":9},
{"id":5356,"description":"Negras (Itaíba)","state_id":16},
{"id":3471,"description":"Nelson de Sena (São João Evangelista)","state_id":11},
{"id":1541,"description":"Nenenlândia (Quixeramobim)","state_id":6},
{"id":3472,"description":"Neolândia (Itapecerica)","state_id":11},
{"id":3473,"description":"Nepomuceno","state_id":11},
{"id":2248,"description":"Nerópolis","state_id":9},
{"id":1943,"description":"Nestor Gomes (São Mateus)","state_id":8},
{"id":11721,"description":"Neves","state_id":16},
{"id":6986,"description":"Neves (São Gonçalo)","state_id":19},
{"id":9397,"description":"Neves Paulista","state_id":26},
{"id":8814,"description":"Neópolis","state_id":25},
{"id":251,"description":"Nhamundá","state_id":3},
{"id":9398,"description":"Nhandeara","state_id":26},
{"id":3474,"description":"Nhandutiba (Manga)","state_id":11},
{"id":4205,"description":"Nhecolândia (Corumbá)","state_id":12},
{"id":6987,"description":"Nhunguaçu (Teresópolis)","state_id":19},
{"id":7895,"description":"Nicolau Vergueiro","state_id":23},
{"id":3475,"description":"Nicolândia (Resplendor)","state_id":11},
{"id":865,"description":"Nilo Peçanha","state_id":5},
{"id":6344,"description":"Nilza (Iporã)","state_id":18},
{"id":6988,"description":"Nilópolis","state_id":19},
{"id":2516,"description":"Nina Rodrigues","state_id":10},
{"id":3476,"description":"Ninheira","state_id":11},
{"id":4206,"description":"Nioaque","state_id":12},
{"id":9399,"description":"Nipoã","state_id":26},
{"id":2249,"description":"Niquelândia","state_id":9},
{"id":6989,"description":"Niterói","state_id":19},
{"id":4399,"description":"Nobres","state_id":13},
{"id":9400,"description":"Nogueira (Avaí)","state_id":26},
{"id":7896,"description":"Nonoai","state_id":23},
{"id":4400,"description":"Nonoai do Norte (Colider)","state_id":13},
{"id":866,"description":"Nordestina","state_id":5},
{"id":6345,"description":"Nordestina (Amaporã)","state_id":18},
{"id":7382,"description":"Normandia","state_id":22},
{"id":4401,"description":"Nortelândia","state_id":13},
{"id":8815,"description":"Nossa Senhora Aparecida","state_id":25},
{"id":12620,"description":"Nossa Senhora Aparecida","state_id":23},
{"id":11806,"description":"Nossa Senhora Aparecida","state_id":16},
{"id":6346,"description":"Nossa Senhora Aparecida (Andirá)","state_id":18},
{"id":7897,"description":"Nossa Senhora Aparecida (Saldanha Marinho)","state_id":23},
{"id":12441,"description":"Nossa Senhora Da Saúde","state_id":23},
{"id":12440,"description":"Nossa Senhora De Fátima","state_id":23},
{"id":12557,"description":"Nossa Senhora De Fátima","state_id":23},
{"id":6347,"description":"Nossa Senhora da Aparecida (Rolândia)","state_id":18},
{"id":6990,"description":"Nossa Senhora da Aparecida (Sapucaia)","state_id":19},
{"id":6348,"description":"Nossa Senhora da Candelária (Bandeirantes)","state_id":18},
{"id":7898,"description":"Nossa Senhora da Conceição (São Sebastião do Caí)","state_id":23},
{"id":8816,"description":"Nossa Senhora da Glória","state_id":25},
{"id":4402,"description":"Nossa Senhora da Guia (Cuiabá)","state_id":13},
{"id":5357,"description":"Nossa Senhora da Luz (São Lourenço da Mata)","state_id":16},
{"id":6991,"description":"Nossa Senhora da Penha (Itaperuna)","state_id":19},
{"id":8817,"description":"Nossa Senhora das Dores","state_id":25},
{"id":6349,"description":"Nossa Senhora das Graças","state_id":18},
{"id":8572,"description":"Nossa Senhora de Caravaggio (Nova Veneza)","state_id":24},
{"id":4207,"description":"Nossa Senhora de Fátima (Bela Vista)","state_id":12},
{"id":10109,"description":"Nossa Senhora de Fátima (Jaguaré)","state_id":8},
{"id":8818,"description":"Nossa Senhora de Lourdes","state_id":25},
{"id":6350,"description":"Nossa Senhora de Lourdes (Cascavel)","state_id":18},
{"id":5643,"description":"Nossa Senhora de Nazaré","state_id":17},
{"id":6992,"description":"Nossa Senhora do Amparo (Barra Mansa)","state_id":19},
{"id":6351,"description":"Nossa Senhora do Carmo (Pato Branco)","state_id":18},
{"id":5358,"description":"Nossa Senhora do Carmo (Pombos)","state_id":16},
{"id":4403,"description":"Nossa Senhora do Livramento","state_id":13},
{"id":1542,"description":"Nossa Senhora do Livramento (Monsenhor Tabosa)","state_id":6},
{"id":5005,"description":"Nossa Senhora do Livramento (Santa Rita)","state_id":15},
{"id":9401,"description":"Nossa Senhora do Remédio (Salesópolis)","state_id":26},
{"id":8819,"description":"Nossa Senhora do Socorro","state_id":25},
{"id":5359,"description":"Nossa Senhora do Ó (Ipojuca)","state_id":16},
{"id":5644,"description":"Nossa Senhora dos Remédios","state_id":17},
{"id":867,"description":"Nova Alegria (Itamaraju)","state_id":5},
{"id":9402,"description":"Nova Alexandria (Cândido Mota)","state_id":26},
{"id":9403,"description":"Nova Aliança","state_id":26},
{"id":6352,"description":"Nova Aliança do Ivaí","state_id":18},
{"id":1944,"description":"Nova Almeida (Serra)","state_id":8},
{"id":6353,"description":"Nova Altamira (Faxinal)","state_id":18},
{"id":7899,"description":"Nova Alvorada","state_id":23},
{"id":4404,"description":"Nova Alvorada (Comodoro)","state_id":13},
{"id":4208,"description":"Nova Alvorada do Sul","state_id":12},
{"id":6355,"description":"Nova Amoreira (Marilândia do Sul)","state_id":18},
{"id":2250,"description":"Nova América","state_id":9},
{"id":4209,"description":"Nova América (Caarapó)","state_id":12},
{"id":9404,"description":"Nova América (Itápolis)","state_id":26},
{"id":6354,"description":"Nova América da Colina","state_id":18},
{"id":4210,"description":"Nova Andradina","state_id":12},
{"id":9405,"description":"Nova Aparecida (Campinas)","state_id":26},
{"id":7900,"description":"Nova Araçá","state_id":23},
{"id":2251,"description":"Nova Aurora","state_id":9},
{"id":6356,"description":"Nova Aurora","state_id":18},
{"id":4405,"description":"Nova Bandeirantes","state_id":13},
{"id":7901,"description":"Nova Bassano","state_id":23},
{"id":3477,"description":"Nova Belém","state_id":11},
{"id":1543,"description":"Nova Betânia (Farias Brito)","state_id":6},
{"id":1544,"description":"Nova Betânia (Nova Russas)","state_id":6},
{"id":6357,"description":"Nova Bilac (Floraí)","state_id":18},
{"id":7902,"description":"Nova Boa Vista","state_id":23},
{"id":4406,"description":"Nova Brasilândia","state_id":13},
{"id":7342,"description":"Nova Brasilândia D'Oeste","state_id":21},
{"id":6358,"description":"Nova Brasília (Araruna)","state_id":18},
{"id":4407,"description":"Nova Brasília (Nova Xavantina)","state_id":13},
{"id":868,"description":"Nova Brasília (Ribeirão do Largo)","state_id":5},
{"id":6359,"description":"Nova Brasília (Toledo)","state_id":18},
{"id":6360,"description":"Nova Brasília do Itararé (Carlópolis)","state_id":18},
{"id":7903,"description":"Nova Bréscia","state_id":23},
{"id":11451,"description":"Nova Califórnia","state_id":21},
{"id":9406,"description":"Nova Campina","state_id":26},
{"id":869,"description":"Nova Canaã","state_id":5},
{"id":1945,"description":"Nova Canaã (Itapemirim)","state_id":8},
{"id":9407,"description":"Nova Canaã Paulista","state_id":26},
{"id":7904,"description":"Nova Candelária","state_id":23},
{"id":6361,"description":"Nova Cantu","state_id":18},
{"id":4408,"description":"Nova Canãa do Norte","state_id":13},
{"id":11080,"description":"Nova Casa Verde","state_id":12},
{"id":9408,"description":"Nova Castilho","state_id":26},
{"id":4409,"description":"Nova Catanduva (Rondonópolis)","state_id":13},
{"id":12763,"description":"Nova Colina","state_id":21},
{"id":2517,"description":"Nova Colinas","state_id":10},
{"id":6362,"description":"Nova Concórdia (Francisco Beltrão)","state_id":18},
{"id":6363,"description":"Nova Concórdia (Toledo)","state_id":18},
{"id":12349,"description":"Nova Conquista","state_id":21},
{"id":2252,"description":"Nova Crixás","state_id":9},
{"id":7223,"description":"Nova Cruz","state_id":20},
{"id":5360,"description":"Nova Cruz (Igarassu)","state_id":16},
{"id":8573,"description":"Nova Cultura (Papanduva)","state_id":24},
{"id":12070,"description":"Nova Cáceres","state_id":13},
{"id":11831,"description":"Nova Descoberta","state_id":16},
{"id":12348,"description":"Nova Dimensão","state_id":21},
{"id":3478,"description":"Nova Era","state_id":11},
{"id":8574,"description":"Nova Erechim","state_id":24},
{"id":6364,"description":"Nova Esperança","state_id":18},
{"id":12075,"description":"Nova Esperança","state_id":21},
{"id":4211,"description":"Nova Esperança (Jateí)","state_id":12},
{"id":3479,"description":"Nova Esperança (Montes Claros)","state_id":11},
{"id":4212,"description":"Nova Esperança (Rio Negro)","state_id":12},
{"id":4709,"description":"Nova Esperança do Piriá","state_id":14},
{"id":6365,"description":"Nova Esperança do Sudoeste","state_id":18},
{"id":7905,"description":"Nova Esperança do Sul","state_id":23},
{"id":9409,"description":"Nova Europa","state_id":26},
{"id":5006,"description":"Nova Floresta","state_id":15},
{"id":1546,"description":"Nova Floresta (Jaguaribe)","state_id":6},
{"id":6993,"description":"Nova Friburgo","state_id":19},
{"id":870,"description":"Nova Fátima","state_id":5},
{"id":11426,"description":"Nova Fátima","state_id":9},
{"id":6366,"description":"Nova Fátima","state_id":18},
{"id":1545,"description":"Nova Fátima (Ipueiras)","state_id":6},
{"id":4410,"description":"Nova Galileia (Rondonópolis)","state_id":13},
{"id":2253,"description":"Nova Glória","state_id":9},
{"id":9410,"description":"Nova Granada","state_id":26},
{"id":4411,"description":"Nova Guarita","state_id":13},
{"id":8575,"description":"Nova Guarita (Sombrio)","state_id":24},
{"id":9411,"description":"Nova Guataporanga","state_id":26},
{"id":7906,"description":"Nova Hartz","state_id":23},
{"id":871,"description":"Nova Ibiá","state_id":5},
{"id":6994,"description":"Nova Iguaçu","state_id":19},
{"id":2254,"description":"Nova Iguaçu de Goiás","state_id":9},
{"id":9412,"description":"Nova Independência","state_id":26},
{"id":2518,"description":"Nova Iorque","state_id":10},
{"id":4710,"description":"Nova Ipixuna","state_id":14},
{"id":8576,"description":"Nova Itaberaba","state_id":24},
{"id":872,"description":"Nova Itaipê (Planaltino)","state_id":5},
{"id":9413,"description":"Nova Itapirema (Nova Aliança)","state_id":26},
{"id":873,"description":"Nova Itarana","state_id":5},
{"id":4213,"description":"Nova Jales (Paranaíba)","state_id":12},
{"id":4412,"description":"Nova Lacerda","state_id":13},
{"id":6367,"description":"Nova Laranjeiras","state_id":18},
{"id":3480,"description":"Nova Lima","state_id":11},
{"id":12764,"description":"Nova Londrina","state_id":21},
{"id":6368,"description":"Nova Londrina","state_id":18},
{"id":6369,"description":"Nova Lourdes (São João)","state_id":18},
{"id":9414,"description":"Nova Luzitânia","state_id":26},
{"id":874,"description":"Nova Lídice (Medeiros Neto)","state_id":5},
{"id":7343,"description":"Nova Mamoré","state_id":21},
{"id":4413,"description":"Nova Marilândia","state_id":13},
{"id":4414,"description":"Nova Maringá","state_id":13},
{"id":7907,"description":"Nova Milano (Farroupilha)","state_id":23},
{"id":3481,"description":"Nova Minda (Japonvar)","state_id":11},
{"id":4711,"description":"Nova Mocajuba (Bragança)","state_id":14},
{"id":4415,"description":"Nova Monte Verde","state_id":13},
{"id":4416,"description":"Nova Mutum","state_id":13},
{"id":3482,"description":"Nova Módica","state_id":11},
{"id":10097,"description":"Nova Nazaré","state_id":13},
{"id":9415,"description":"Nova Odessa","state_id":26},
{"id":1547,"description":"Nova Olinda","state_id":6},
{"id":5007,"description":"Nova Olinda","state_id":15},
{"id":9892,"description":"Nova Olinda","state_id":27},
{"id":2519,"description":"Nova Olinda do Maranhão","state_id":10},
{"id":252,"description":"Nova Olinda do Norte","state_id":3},
{"id":4417,"description":"Nova Olímpia","state_id":13},
{"id":6370,"description":"Nova Olímpia","state_id":18},
{"id":7909,"description":"Nova Palma","state_id":23},
{"id":5008,"description":"Nova Palmeira","state_id":15},
{"id":7910,"description":"Nova Petrópolis","state_id":23},
{"id":8577,"description":"Nova Petrópolis (Joaçaba)","state_id":24},
{"id":3483,"description":"Nova Ponte","state_id":11},
{"id":3484,"description":"Nova Porteirinha","state_id":11},
{"id":7911,"description":"Nova Prata","state_id":23},
{"id":6371,"description":"Nova Prata do Iguaçu","state_id":18},
{"id":12069,"description":"Nova Primavera","state_id":13},
{"id":7908,"description":"Nova Pádua","state_id":23},
{"id":9416,"description":"Nova Pátria (Presidente Bernardes)","state_id":26},
{"id":7912,"description":"Nova Ramada","state_id":23},
{"id":875,"description":"Nova Redenção","state_id":5},
{"id":3485,"description":"Nova Resende","state_id":11},
{"id":6372,"description":"Nova Riqueza (Pinhal de São Bento)","state_id":18},
{"id":2255,"description":"Nova Roma","state_id":9},
{"id":7913,"description":"Nova Roma do Sul","state_id":23},
{"id":9893,"description":"Nova Rosalândia","state_id":27},
{"id":1548,"description":"Nova Russas","state_id":6},
{"id":6373,"description":"Nova Santa Bárbara","state_id":18},
{"id":10095,"description":"Nova Santa Helena","state_id":13},
{"id":7914,"description":"Nova Santa Rita","state_id":23},
{"id":5645,"description":"Nova Santa Rita","state_id":17},
{"id":6374,"description":"Nova Santa Rosa","state_id":18},
{"id":7915,"description":"Nova Sardenha (Farroupilha)","state_id":23},
{"id":3486,"description":"Nova Serrana","state_id":11},
{"id":876,"description":"Nova Soure","state_id":5},
{"id":6375,"description":"Nova Tebas","state_id":18},
{"id":8578,"description":"Nova Teutônia (Seara)","state_id":24},
{"id":4712,"description":"Nova Timboteua","state_id":14},
{"id":6376,"description":"Nova Tirol (Piraquara)","state_id":18},
{"id":12460,"description":"Nova Tramandaí","state_id":23},
{"id":8579,"description":"Nova Trento","state_id":24},
{"id":4418,"description":"Nova Ubiratã","state_id":13},
{"id":3487,"description":"Nova União","state_id":11},
{"id":7344,"description":"Nova União","state_id":21},
{"id":8580,"description":"Nova Veneza","state_id":24},
{"id":2256,"description":"Nova Veneza","state_id":9},
{"id":12150,"description":"Nova Veneza","state_id":6},
{"id":9417,"description":"Nova Veneza (Sumaré)","state_id":26},
{"id":1946,"description":"Nova Venécia","state_id":8},
{"id":1947,"description":"Nova Verona (São Mateus)","state_id":8},
{"id":7345,"description":"Nova Vida (Ariquemes)","state_id":21},
{"id":1549,"description":"Nova Vida (Ibaretama)","state_id":6},
{"id":6377,"description":"Nova Videira (Toledo)","state_id":18},
{"id":877,"description":"Nova Viçosa","state_id":5},
{"id":4419,"description":"Nova Xavantina","state_id":13},
{"id":9418,"description":"Novais","state_id":26},
{"id":3488,"description":"Novilhona (Novo Cruzeiro)","state_id":11},
{"id":9894,"description":"Novo Acordo","state_id":27},
{"id":878,"description":"Novo Acre (Iramaia)","state_id":5},
{"id":253,"description":"Novo Airão","state_id":3},
{"id":9895,"description":"Novo Alegre","state_id":27},
{"id":254,"description":"Novo Aripuanã","state_id":3},
{"id":1550,"description":"Novo Assis (Parambu)","state_id":6},
{"id":7916,"description":"Novo Barreiro","state_id":23},
{"id":2257,"description":"Novo Brasil","state_id":9},
{"id":1948,"description":"Novo Brasil (Governador Lindenberg)","state_id":8},
{"id":7917,"description":"Novo Cabrais","state_id":23},
{"id":9419,"description":"Novo Cravinhos (Pompéia)","state_id":26},
{"id":3489,"description":"Novo Cruzeiro","state_id":11},
{"id":11760,"description":"Novo Céu","state_id":3},
{"id":4420,"description":"Novo Diamantino (Diamantino)","state_id":13},
{"id":4421,"description":"Novo Eldorado (Tapurah)","state_id":13},
{"id":2258,"description":"Novo Gama","state_id":9},
{"id":11898,"description":"Novo Goiás","state_id":9},
{"id":7918,"description":"Novo Hamburgo","state_id":23},
{"id":8581,"description":"Novo Horizonte","state_id":24},
{"id":879,"description":"Novo Horizonte","state_id":5},
{"id":9420,"description":"Novo Horizonte","state_id":26},
{"id":9896,"description":"Novo Horizonte (Araguaína)","state_id":27},
{"id":3490,"description":"Novo Horizonte (Ataléia)","state_id":11},
{"id":6378,"description":"Novo Horizonte (Cascavel)","state_id":18},
{"id":1949,"description":"Novo Horizonte (Ecoporanga)","state_id":8},
{"id":6379,"description":"Novo Horizonte (Marechal Cândido Rondon)","state_id":18},
{"id":7919,"description":"Novo Horizonte (Salto do Jacuí)","state_id":23},
{"id":4422,"description":"Novo Horizonte do Norte","state_id":13},
{"id":7346,"description":"Novo Horizonte do Oeste","state_id":21},
{"id":4214,"description":"Novo Horizonte do Sul","state_id":12},
{"id":6380,"description":"Novo Itacolomi","state_id":18},
{"id":9897,"description":"Novo Jardim","state_id":27},
{"id":6381,"description":"Novo Jardim (Japira)","state_id":18},
{"id":125,"description":"Novo Lino","state_id":2},
{"id":7920,"description":"Novo Machado","state_id":23},
{"id":12034,"description":"Novo Mato Grosso","state_id":13},
{"id":4423,"description":"Novo Mundo","state_id":13},
{"id":5646,"description":"Novo Nilo (União)","state_id":17},
{"id":1551,"description":"Novo Oriente","state_id":6},
{"id":1552,"description":"Novo Oriente (Ocara)","state_id":6},
{"id":3491,"description":"Novo Oriente de Minas","state_id":11},
{"id":5647,"description":"Novo Oriente do Piauí","state_id":17},
{"id":4424,"description":"Novo Paraná (Porto dos Gaúchos)","state_id":13},
{"id":10864,"description":"Novo Paraíso","state_id":22},
{"id":12477,"description":"Novo Paraíso","state_id":23},
{"id":2259,"description":"Novo Planalto","state_id":9},
{"id":4713,"description":"Novo Planalto (Redenção)","state_id":14},
{"id":7921,"description":"Novo Planalto (Tiradentes do Sul)","state_id":23},
{"id":4714,"description":"Novo Progresso","state_id":14},
{"id":11096,"description":"Novo Remanso","state_id":3},
{"id":4715,"description":"Novo Repartimento","state_id":14},
{"id":5648,"description":"Novo Santo Antônio","state_id":17},
{"id":4521,"description":"Novo Santo Antônio","state_id":13},
{"id":6382,"description":"Novo Sarandi (Toledo)","state_id":18},
{"id":6383,"description":"Novo Sobradinho (Toledo)","state_id":18},
{"id":4425,"description":"Novo São Joaquim","state_id":13},
{"id":7922,"description":"Novo Tiradentes","state_id":23},
{"id":880,"description":"Novo Triunfo","state_id":5},
{"id":6384,"description":"Novo Três Passos (Marechal Cândido Rondon)","state_id":18},
{"id":8318,"description":"Novo Xingu","state_id":23},
{"id":3492,"description":"Novorizonte","state_id":11},
{"id":11832,"description":"Ns2 Núcleo De Serviços","state_id":16},
{"id":882,"description":"Nuguaçu (Mirangaba)","state_id":5},
{"id":9421,"description":"Nuporanga","state_id":26},
{"id":7893,"description":"Não-Me-Toque","state_id":23},
{"id":7222,"description":"Nísia Floresta","state_id":20},
{"id":1787,"description":"Núcleo Bandeirante","state_id":7},
{"id":12752,"description":"Núcleo Colonial Pio Xii","state_id":6},
{"id":5009,"description":"Núcleo N 2 (Sousa)","state_id":15},
{"id":5010,"description":"Núcleo N 3 (Sousa)","state_id":15},
{"id":881,"description":"Núcleo Residencial Pilar (Jaguarari)","state_id":5},
{"id":4716,"description":"Núcleo Urbano Quilômetro 30 (Itaituba)","state_id":14},
{"id":1553,"description":"Ocara","state_id":6},
{"id":9423,"description":"Ocauçu","state_id":26},
{"id":3493,"description":"Ocidente (Mutum)","state_id":11},
{"id":5011,"description":"Odilândia (Santa Rita)","state_id":15},
{"id":5649,"description":"Oeiras","state_id":17},
{"id":4718,"description":"Oeiras do Pará","state_id":14},
{"id":310,"description":"Oiapoque","state_id":4},
{"id":12766,"description":"Oiticica","state_id":6},
{"id":1554,"description":"Oiticica (Crateús)","state_id":6},
{"id":1555,"description":"Oiticica (Ibaretama)","state_id":6},
{"id":3494,"description":"Olaria","state_id":11},
{"id":6385,"description":"Olaria (Cascavel)","state_id":18},
{"id":6386,"description":"Olaria (Telêmaco Borba)","state_id":18},
{"id":2260,"description":"Olaria do Angico (Itarumã)","state_id":9},
{"id":3495,"description":"Olegário Maciel (Piranguinho)","state_id":11},
{"id":6387,"description":"Olho Agudo (São José dos Pinhais)","state_id":18},
{"id":12761,"description":"Olho D'Água","state_id":6},
{"id":126,"description":"Olho D'Água Grande","state_id":2},
{"id":2520,"description":"Olho D'Água das Cunhãs","state_id":10},
{"id":127,"description":"Olho D'Água das Flores","state_id":2},
{"id":128,"description":"Olho D'Água de Cima (Arapiraca)","state_id":2},
{"id":5361,"description":"Olho D'Água de Dentro (Canhotinho)","state_id":16},
{"id":129,"description":"Olho D'Água do Casado","state_id":2},
{"id":5650,"description":"Olho D'Água do Piauí","state_id":17},
{"id":130,"description":"Olho D'Água dos Dandanhas (Arapiraca)","state_id":2},
{"id":5012,"description":"Olho d'Água","state_id":15},
{"id":6388,"description":"Olho d'Água (Castro)","state_id":18},
{"id":7224,"description":"Olho d'Água do Borges","state_id":20},
{"id":1556,"description":"Olho-D'Água (Sobral)","state_id":6},
{"id":1557,"description":"Olho-D'Água da Bica (Tabuleiro do Norte)","state_id":6},
{"id":3496,"description":"Olhos D' Água do Oeste (João Pinheiro)","state_id":11},
{"id":10819,"description":"Olhos D'Água","state_id":9},
{"id":2261,"description":"Olhos D'Água (Catalão)","state_id":9},
{"id":883,"description":"Olhos D'Água do Seco (Ibitiara)","state_id":5},
{"id":884,"description":"Olhos D'Água do Serafim (Novo Horizonte)","state_id":5},
{"id":3497,"description":"Olhos-d'Água","state_id":11},
{"id":5362,"description":"Olinda","state_id":16},
{"id":6995,"description":"Olinda (Nilópolis)","state_id":19},
{"id":2521,"description":"Olinda Nova do Maranhão","state_id":10},
{"id":885,"description":"Olindina","state_id":5},
{"id":7923,"description":"Oliva (Caxias do Sul)","state_id":23},
{"id":5013,"description":"Olivedos","state_id":15},
{"id":3500,"description":"Oliveira","state_id":11},
{"id":9426,"description":"Oliveira Barros (Miracatu)","state_id":26},
{"id":3501,"description":"Oliveira Fortes","state_id":11},
{"id":9898,"description":"Oliveira de Fátima","state_id":27},
{"id":886,"description":"Oliveira dos Brejinhos","state_id":5},
{"id":1558,"description":"Oliveiras (Tamboril)","state_id":6},
{"id":131,"description":"Olivença","state_id":2},
{"id":887,"description":"Olivença (Ilhéus)","state_id":5},
{"id":9425,"description":"Olímpia","state_id":26},
{"id":3498,"description":"Olímpio Campos (São João da Ponte)","state_id":11},
{"id":3499,"description":"Olímpio Noronha","state_id":11},
{"id":9427,"description":"Onda Branca (Nova Granada)","state_id":26},
{"id":9428,"description":"Onda Verde","state_id":26},
{"id":888,"description":"Onha (Muniz Ferreira)","state_id":5},
{"id":3502,"description":"Onça de Pitangui","state_id":11},
{"id":7924,"description":"Oralina (Salto do Jacuí)","state_id":23},
{"id":5363,"description":"Oratório (Casinhas)","state_id":16},
{"id":3503,"description":"Oratórios","state_id":11},
{"id":5364,"description":"Ori (Serrita)","state_id":16},
{"id":9429,"description":"Oriente","state_id":26},
{"id":4215,"description":"Oriente (Aparecida do Taboado)","state_id":12},
{"id":889,"description":"Oriente Novo (Jequié)","state_id":5},
{"id":9430,"description":"Orindiúva","state_id":26},
{"id":4719,"description":"Oriximiná","state_id":14},
{"id":2262,"description":"Orizona","state_id":9},
{"id":3504,"description":"Orizânia","state_id":11},
{"id":8582,"description":"Orleans","state_id":24},
{"id":9431,"description":"Orlândia","state_id":26},
{"id":5365,"description":"Orobó","state_id":16},
{"id":5366,"description":"Orocó","state_id":16},
{"id":6389,"description":"Oroité (Iporã)","state_id":18},
{"id":6390,"description":"Ortigueira","state_id":18},
{"id":1559,"description":"Orós","state_id":6},
{"id":9432,"description":"Osasco","state_id":26},
{"id":9433,"description":"Oscar Bressane","state_id":26},
{"id":4720,"description":"Osvaldilândia (Redenção)","state_id":14},
{"id":9434,"description":"Osvaldo Cruz","state_id":26},
{"id":7926,"description":"Osvaldo Cruz (Frederico Westphalen)","state_id":23},
{"id":7927,"description":"Osvaldo Kroeff (Cambará do Sul)","state_id":23},
{"id":7925,"description":"Osório","state_id":23},
{"id":255,"description":"Osório da Fonseca (Maués)","state_id":3},
{"id":8583,"description":"Otacílio Costa","state_id":24},
{"id":4721,"description":"Otelo (Belém)","state_id":14},
{"id":7928,"description":"Otávio Rocha (Flores da Cunha)","state_id":23},
{"id":890,"description":"Ouricana (Canavieiras)","state_id":5},
{"id":5367,"description":"Ouricuri","state_id":16},
{"id":892,"description":"Ouricuri do Ouro (Brotas de Macaúbas)","state_id":5},
{"id":6391,"description":"Ourilândia (Barbosa Ferraz)","state_id":18},
{"id":4723,"description":"Ourilândia do Norte","state_id":14},
{"id":9435,"description":"Ourinhos","state_id":26},
{"id":6392,"description":"Ourizona","state_id":18},
{"id":891,"description":"Ouriçangas","state_id":5},
{"id":8584,"description":"Ouro","state_id":24},
{"id":7225,"description":"Ouro Branco","state_id":20},
{"id":132,"description":"Ouro Branco","state_id":2},
{"id":3505,"description":"Ouro Branco","state_id":11},
{"id":3506,"description":"Ouro Fino","state_id":11},
{"id":9436,"description":"Ouro Fino Paulista (Ribeirão Pires)","state_id":26},
{"id":3507,"description":"Ouro Preto","state_id":11},
{"id":12098,"description":"Ouro Preto","state_id":18},
{"id":7347,"description":"Ouro Preto do Oeste","state_id":21},
{"id":5014,"description":"Ouro Velho","state_id":15},
{"id":8585,"description":"Ouro Verde","state_id":24},
{"id":9437,"description":"Ouro Verde","state_id":26},
{"id":10734,"description":"Ouro Verde","state_id":18},
{"id":8586,"description":"Ouro Verde (Guaraciaba)","state_id":24},
{"id":2263,"description":"Ouro Verde de Goiás","state_id":9},
{"id":3508,"description":"Ouro Verde de Minas","state_id":11},
{"id":6393,"description":"Ouro Verde do Oeste","state_id":18},
{"id":6394,"description":"Ouro Verde do Piquiri (Corbélia)","state_id":18},
{"id":2264,"description":"Ouroana (Rio Verde)","state_id":9},
{"id":9438,"description":"Ouroeste","state_id":26},
{"id":893,"description":"Ourolândia","state_id":5},
{"id":6996,"description":"Ourânia (Natividade)","state_id":19},
{"id":4722,"description":"Ourém","state_id":14},
{"id":4724,"description":"Outeiro (Belém)","state_id":14},
{"id":894,"description":"Outeiro Redondo (São Félix)","state_id":5},
{"id":2265,"description":"Ouvidor","state_id":9},
{"id":9422,"description":"Oásis (Tupi Paulista)","state_id":26},
{"id":9439,"description":"Pacaembu","state_id":26},
{"id":1560,"description":"Pacajus","state_id":6},
{"id":4725,"description":"Pacajá","state_id":14},
{"id":7383,"description":"Pacaraima","state_id":22},
{"id":1561,"description":"Pacatuba","state_id":6},
{"id":8820,"description":"Pacatuba","state_id":25},
{"id":7929,"description":"Pacheca (Camaquã)","state_id":23},
{"id":12106,"description":"Pachecos","state_id":19},
{"id":3509,"description":"Paciência (Porteirinha)","state_id":11},
{"id":1562,"description":"Pacoti","state_id":6},
{"id":1950,"description":"Pacotuba (Cachoeiro de Itapemirim)","state_id":8},
{"id":4726,"description":"Pacoval (Prainha)","state_id":14},
{"id":1563,"description":"Pacujá","state_id":6},
{"id":7930,"description":"Padilha (Taquara)","state_id":23},
{"id":2266,"description":"Padre Bernardo","state_id":9},
{"id":3510,"description":"Padre Brito (Barbacena)","state_id":11},
{"id":3511,"description":"Padre Carvalho","state_id":11},
{"id":1564,"description":"Padre Cícero (Juazeiro do Norte)","state_id":6},
{"id":3512,"description":"Padre Felisberto (Amparo do Serra)","state_id":11},
{"id":3513,"description":"Padre Fialho (Matipó)","state_id":11},
{"id":7931,"description":"Padre Gonzales (Três Passos)","state_id":23},
{"id":3514,"description":"Padre João Afonso (Itamarandiba)","state_id":11},
{"id":3515,"description":"Padre Júlio Maria (Alto Jequitibá)","state_id":11},
{"id":1565,"description":"Padre Linhares (Massapê)","state_id":6},
{"id":5651,"description":"Padre Marcos","state_id":17},
{"id":9440,"description":"Padre Nóbrega (Marília)","state_id":26},
{"id":3516,"description":"Padre Paraíso","state_id":11},
{"id":3517,"description":"Padre Pinto (Rio Piracicaba)","state_id":11},
{"id":6395,"description":"Padre Ponciano (Coronel Domingos Soares)","state_id":18},
{"id":3518,"description":"Padre Viegas (Mariana)","state_id":11},
{"id":1566,"description":"Padre Vieira (Viçosa do Ceará)","state_id":6},
{"id":4426,"description":"Padronal (Comodoro)","state_id":13},
{"id":5652,"description":"Paes Landim","state_id":17},
{"id":4427,"description":"Pai Andre (Várzea Grande)","state_id":13},
{"id":12110,"description":"Pai João","state_id":6},
{"id":3519,"description":"Pai Pedro","state_id":11},
{"id":4216,"description":"Paiaguás (Corumbá)","state_id":12},
{"id":8587,"description":"Paial","state_id":24},
{"id":7932,"description":"Paim Filho","state_id":23},
{"id":3520,"description":"Paineiras","state_id":11},
{"id":1951,"description":"Paineiras (Itapemirim)","state_id":8},
{"id":8588,"description":"Painel","state_id":24},
{"id":3521,"description":"Pains","state_id":11},
{"id":895,"description":"Paiol (Jacaraci)","state_id":5},
{"id":6398,"description":"Paiol Queimado (Castro)","state_id":18},
{"id":6397,"description":"Paiol de Baixo (Campina Grande do Sul)","state_id":18},
{"id":3522,"description":"Paiolinho (Poço Fundo)","state_id":11},
{"id":6400,"description":"Paiquerê (Londrina)","state_id":18},
{"id":3523,"description":"Paiva","state_id":11},
{"id":6396,"description":"Paiçandu","state_id":18},
{"id":1567,"description":"Pajeú (Araripe)","state_id":6},
{"id":5368,"description":"Pajeú (Serra Talhada)","state_id":16},
{"id":5653,"description":"Pajeú do Piauí","state_id":17},
{"id":896,"description":"Pajeú do Vento (Caetité)","state_id":5},
{"id":897,"description":"Palame (Esplanada)","state_id":5},
{"id":12468,"description":"Palanque","state_id":23},
{"id":133,"description":"Palestina","state_id":2},
{"id":9441,"description":"Palestina","state_id":26},
{"id":12744,"description":"Palestina","state_id":6},
{"id":1569,"description":"Palestina (Mauriti)","state_id":6},
{"id":1570,"description":"Palestina (Orós)","state_id":6},
{"id":2267,"description":"Palestina de Goiás","state_id":9},
{"id":1571,"description":"Palestina do Norte (Meruoca)","state_id":6},
{"id":4727,"description":"Palestina do Pará","state_id":14},
{"id":1572,"description":"Palhano","state_id":6},
{"id":8589,"description":"Palhoça","state_id":24},
{"id":3524,"description":"Palma","state_id":11},
{"id":12285,"description":"Palma","state_id":23},
{"id":8590,"description":"Palma Sola","state_id":24},
{"id":5369,"description":"Palmares","state_id":16},
{"id":11985,"description":"Palmares","state_id":5},
{"id":12170,"description":"Palmares","state_id":14},
{"id":8821,"description":"Palmares (Riachão do Dantas)","state_id":25},
{"id":9442,"description":"Palmares Paulista","state_id":26},
{"id":7933,"description":"Palmares do Sul","state_id":23},
{"id":12486,"description":"Palmas","state_id":23},
{"id":6401,"description":"Palmas","state_id":18},
{"id":9899,"description":"Palmas","state_id":27},
{"id":7934,"description":"Palmas (Bagé)","state_id":23},
{"id":898,"description":"Palmas de Monte Alto","state_id":5},
{"id":11820,"description":"Palmatória","state_id":16},
{"id":1574,"description":"Palmatória (Itapiúna)","state_id":6},
{"id":8591,"description":"Palmeira","state_id":24},
{"id":6402,"description":"Palmeira","state_id":18},
{"id":1952,"description":"Palmeira (Itaguaçu)","state_id":8},
{"id":9443,"description":"Palmeira D'Oeste","state_id":26},
{"id":7935,"description":"Palmeira das Missões","state_id":23},
{"id":134,"description":"Palmeira de Fora (Palmeira dos Índios)","state_id":2},
{"id":5654,"description":"Palmeira do Piauí","state_id":17},
{"id":135,"description":"Palmeira dos Índios","state_id":2},
{"id":5655,"description":"Palmeirais","state_id":17},
{"id":3525,"description":"Palmeiral (Botelhos)","state_id":11},
{"id":9900,"description":"Palmeirante","state_id":27},
{"id":899,"description":"Palmeiras","state_id":5},
{"id":11776,"description":"Palmeiras","state_id":3},
{"id":12064,"description":"Palmeiras","state_id":21},
{"id":4217,"description":"Palmeiras (Dois Irmãos do Buriti)","state_id":12},
{"id":2268,"description":"Palmeiras de Goiás","state_id":9},
{"id":9444,"description":"Palmeiras de São Paulo (Suzano)","state_id":26},
{"id":9887,"description":"Palmeiras do Tocantins","state_id":27},
{"id":5370,"description":"Palmeirina","state_id":16},
{"id":6403,"description":"Palmeirinha (Castro)","state_id":18},
{"id":6404,"description":"Palmeirinha (Guarapuava)","state_id":18},
{"id":3526,"description":"Palmeirinha (Unaí)","state_id":11},
{"id":2523,"description":"Palmeirândia","state_id":10},
{"id":9901,"description":"Palmeirópolis","state_id":27},
{"id":2269,"description":"Palmelo","state_id":9},
{"id":1953,"description":"Palmerino (Alto Rio Novo)","state_id":8},
{"id":2270,"description":"Palminópolis","state_id":9},
{"id":6405,"description":"Palmira (São João do Triunfo)","state_id":18},
{"id":9445,"description":"Palmital","state_id":26},
{"id":6406,"description":"Palmital","state_id":18},
{"id":6407,"description":"Palmital (Castro)","state_id":18},
{"id":12038,"description":"Palmital De Minas","state_id":11},
{"id":6408,"description":"Palmital de São Silvestre (Campo Largo)","state_id":18},
{"id":3527,"description":"Palmital dos Carvalhos (Senhora dos Remédios)","state_id":11},
{"id":7936,"description":"Palmitinho","state_id":23},
{"id":8592,"description":"Palmitos","state_id":24},
{"id":6409,"description":"Palmitópolis (Nova Aurora)","state_id":18},
{"id":1573,"description":"Palmácia","state_id":6},
{"id":3528,"description":"Palmópolis","state_id":11},
{"id":6410,"description":"Palotina","state_id":18},
{"id":7937,"description":"Pampeiro (Santana do Livramento)","state_id":23},
{"id":12775,"description":"Pana","state_id":12},
{"id":1575,"description":"Panacuí (Marco)","state_id":6},
{"id":7938,"description":"Panambi","state_id":23},
{"id":4218,"description":"Panambi (Dourados)","state_id":12},
{"id":2271,"description":"Panamá","state_id":9},
{"id":1954,"description":"Pancas","state_id":8},
{"id":5371,"description":"Panelas","state_id":16},
{"id":6411,"description":"Panema (Santa Mariana)","state_id":18},
{"id":6412,"description":"Pangaré (Quitandinha)","state_id":18},
{"id":9446,"description":"Panorama","state_id":26},
{"id":2524,"description":"Papagaio (Barra do Corda)","state_id":10},
{"id":5374,"description":"Papagaio (Pesqueira)","state_id":16},
{"id":3530,"description":"Papagaios","state_id":11},
{"id":6413,"description":"Papagaios Novos (Palmeira)","state_id":18},
{"id":8594,"description":"Papanduva","state_id":24},
{"id":10776,"description":"Papara","state_id":6},
{"id":6997,"description":"Papucaia (Cachoeiras de Macacu)","state_id":19},
{"id":6998,"description":"Paquequer Pequeno (Teresópolis)","state_id":19},
{"id":5656,"description":"Paquetá","state_id":17},
{"id":5375,"description":"Paquevira (Canhotinho)","state_id":16},
{"id":6999,"description":"Paracambi","state_id":19},
{"id":3532,"description":"Paracatu","state_id":11},
{"id":1577,"description":"Paracuru","state_id":6},
{"id":1576,"description":"Paracuá (Uruoca)","state_id":6},
{"id":900,"description":"Parafuso (Camaçari)","state_id":5},
{"id":4728,"description":"Paragominas","state_id":14},
{"id":3534,"description":"Paraguai (Cajuri)","state_id":11},
{"id":3533,"description":"Paraguaçu","state_id":11},
{"id":9447,"description":"Paraguaçu Paulista","state_id":26},
{"id":2525,"description":"Paraibano","state_id":10},
{"id":9448,"description":"Paraibuna","state_id":26},
{"id":1578,"description":"Paraipaba","state_id":6},
{"id":11629,"description":"Paraiso","state_id":6},
{"id":4428,"description":"Paraiso do Leste (Poxoréo)","state_id":13},
{"id":9450,"description":"Paraisolândia (Charqueada)","state_id":26},
{"id":3536,"description":"Paraisópolis","state_id":11},
{"id":1955,"description":"Paraju (Domingos Martins)","state_id":8},
{"id":1579,"description":"Parajuru (Beberibe)","state_id":6},
{"id":1580,"description":"Parambu","state_id":6},
{"id":901,"description":"Paramirim","state_id":5},
{"id":1581,"description":"Paramoti","state_id":6},
{"id":9451,"description":"Paranabi (Ilhabela)","state_id":26},
{"id":6416,"description":"Paranacity","state_id":18},
{"id":6417,"description":"Paranagi (Sertaneja)","state_id":18},
{"id":6418,"description":"Paranaguá","state_id":18},
{"id":2272,"description":"Paranaiguara","state_id":9},
{"id":4429,"description":"Paranaitá","state_id":13},
{"id":9452,"description":"Paranapanema","state_id":26},
{"id":9453,"description":"Paranapiacaba (Santo André)","state_id":26},
{"id":6419,"description":"Paranapoema","state_id":18},
{"id":9454,"description":"Paranapuã","state_id":26},
{"id":5377,"description":"Paranatama","state_id":16},
{"id":4430,"description":"Paranatinga","state_id":13},
{"id":6420,"description":"Paranavaí","state_id":18},
{"id":4220,"description":"Paranaíba","state_id":12},
{"id":1582,"description":"Parangaba (Fortaleza)","state_id":6},
{"id":4221,"description":"Paranhos","state_id":12},
{"id":1788,"description":"Paranoá","state_id":7},
{"id":7226,"description":"Paraná","state_id":20},
{"id":6415,"description":"Paraná d'Oeste (Moreira Sales)","state_id":18},
{"id":9903,"description":"Paranã","state_id":27},
{"id":3537,"description":"Paraopeba","state_id":11},
{"id":7002,"description":"Paraoquena (Santo Antônio de Pádua)","state_id":19},
{"id":7003,"description":"Parapeúna (Valença)","state_id":19},
{"id":9455,"description":"Parapuã","state_id":26},
{"id":1583,"description":"Parapuí (Santana do Acaraú)","state_id":6},
{"id":5015,"description":"Parari","state_id":15},
{"id":902,"description":"Parateca (Malhada)","state_id":5},
{"id":7004,"description":"Parati","state_id":19},
{"id":7005,"description":"Parati Mirim (Parati)","state_id":19},
{"id":10187,"description":"Paratibe (Paulista)","state_id":16},
{"id":903,"description":"Paratinga","state_id":5},
{"id":4729,"description":"Paratins (Marabá)","state_id":14},
{"id":4730,"description":"Parauapebas","state_id":14},
{"id":7227,"description":"Parazinho","state_id":20},
{"id":1584,"description":"Parazinho (Granja)","state_id":6},
{"id":7940,"description":"Paraí","state_id":23},
{"id":7000,"description":"Paraíba do Sul","state_id":19},
{"id":8595,"description":"Paraíso","state_id":24},
{"id":9449,"description":"Paraíso","state_id":26},
{"id":4219,"description":"Paraíso (Costa Rica)","state_id":12},
{"id":3535,"description":"Paraíso Garcia (Santa Rita do Ibitipoca)","state_id":11},
{"id":6414,"description":"Paraíso do Norte","state_id":18},
{"id":7941,"description":"Paraíso do Sul","state_id":23},
{"id":7001,"description":"Paraíso do Tobias (Miracema)","state_id":19},
{"id":9902,"description":"Paraíso do Tocantins","state_id":27},
{"id":2273,"description":"Paraúna","state_id":9},
{"id":9456,"description":"Pardinho","state_id":26},
{"id":7942,"description":"Pareci Novo","state_id":23},
{"id":7348,"description":"Parecis","state_id":21},
{"id":311,"description":"Paredão (Ferreira Gomes)","state_id":4},
{"id":3538,"description":"Paredão de Minas (Buritizeiro)","state_id":11},
{"id":7228,"description":"Parelhas","state_id":20},
{"id":12659,"description":"Paricatuba","state_id":3},
{"id":137,"description":"Pariconha","state_id":2},
{"id":256,"description":"Parintins","state_id":3},
{"id":904,"description":"Paripiranga","state_id":5},
{"id":138,"description":"Paripueira","state_id":2},
{"id":1585,"description":"Paripueira (Beberibe)","state_id":6},
{"id":9457,"description":"Pariquera-Açu","state_id":26},
{"id":9458,"description":"Parisi","state_id":26},
{"id":5657,"description":"Parnaguá","state_id":17},
{"id":7229,"description":"Parnamirim","state_id":20},
{"id":5379,"description":"Parnamirim","state_id":16},
{"id":2526,"description":"Parnarama","state_id":10},
{"id":9459,"description":"Parnaso (Tupã)","state_id":26},
{"id":5658,"description":"Parnaíba","state_id":17},
{"id":7943,"description":"Parobé","state_id":23},
{"id":3539,"description":"Parque Durval de Barros (Ibirité)","state_id":11},
{"id":3540,"description":"Parque Industrial (Contagem)","state_id":11},
{"id":9460,"description":"Parque Meia Lua (Jacareí)","state_id":26},
{"id":12036,"description":"Parque Água Limpa","state_id":13},
{"id":9461,"description":"Paruru (Ibiúna)","state_id":26},
{"id":5376,"description":"Pará (Santa Cruz do Capibaribe)","state_id":16},
{"id":3531,"description":"Pará de Minas","state_id":11},
{"id":3541,"description":"Passa Dez (Bom Jesus do Galho)","state_id":11},
{"id":3542,"description":"Passa Quatro","state_id":11},
{"id":7944,"description":"Passa Sete","state_id":23},
{"id":3543,"description":"Passa Tempo","state_id":11},
{"id":7006,"description":"Passa Três (Rio Claro)","state_id":19},
{"id":6421,"description":"Passa Una (Araucária)","state_id":18},
{"id":3544,"description":"Passa Vinte","state_id":11},
{"id":7230,"description":"Passa e Fica","state_id":20},
{"id":3545,"description":"Passabém","state_id":11},
{"id":7231,"description":"Passagem","state_id":20},
{"id":5016,"description":"Passagem","state_id":15},
{"id":1586,"description":"Passagem (Chaval)","state_id":6},
{"id":1587,"description":"Passagem (Quixeramobim)","state_id":6},
{"id":11534,"description":"Passagem Dos Teixeiras","state_id":5},
{"id":2527,"description":"Passagem Franca","state_id":10},
{"id":5659,"description":"Passagem Franca do Piauí","state_id":17},
{"id":1588,"description":"Passagem Funda (Aracoiaba)","state_id":6},
{"id":4431,"description":"Passagem da Conceição (Várzea Grande)","state_id":13},
{"id":3546,"description":"Passagem de Mariana (Mariana)","state_id":11},
{"id":5380,"description":"Passagem do Tó (Jataúba)","state_id":16},
{"id":7945,"description":"Passinhos (Osório)","state_id":23},
{"id":5381,"description":"Passira","state_id":16},
{"id":11960,"description":"Passo Amarelo","state_id":18},
{"id":7946,"description":"Passo Burmann (Catuípe)","state_id":23},
{"id":12778,"description":"Passo Do Carro","state_id":23},
{"id":11094,"description":"Passo Do Goulart","state_id":23},
{"id":12494,"description":"Passo Do Mendonça","state_id":23},
{"id":10652,"description":"Passo Do Verde","state_id":23},
{"id":7953,"description":"Passo Fundo","state_id":23},
{"id":6424,"description":"Passo Fundo (Campo Largo)","state_id":18},
{"id":6425,"description":"Passo Liso (Laranjeiras do Sul)","state_id":18},
{"id":8597,"description":"Passo Manso (Taió)","state_id":24},
{"id":7954,"description":"Passo Novo (Alegrete)","state_id":23},
{"id":7955,"description":"Passo Raso (Triunfo)","state_id":23},
{"id":12635,"description":"Passo Real","state_id":23},
{"id":12507,"description":"Passo Real De Candiota","state_id":23},
{"id":7947,"description":"Passo da Areia (Viamão)","state_id":23},
{"id":7948,"description":"Passo da Caveira (Gravataí)","state_id":23},
{"id":6422,"description":"Passo da Ilha (Pato Branco)","state_id":18},
{"id":7949,"description":"Passo das Pedras (Capão do Leão)","state_id":23},
{"id":139,"description":"Passo de Camaragibe","state_id":2},
{"id":8596,"description":"Passo de Torres","state_id":24},
{"id":7950,"description":"Passo do Adão (Rio Pardo)","state_id":23},
{"id":7951,"description":"Passo do Sabão (Viamão)","state_id":23},
{"id":7952,"description":"Passo do Sobrado","state_id":23},
{"id":6423,"description":"Passo dos Pupos (Ponta Grossa)","state_id":18},
{"id":3547,"description":"Passos","state_id":11},
{"id":8598,"description":"Passos Maia","state_id":24},
{"id":11530,"description":"Passé","state_id":5},
{"id":1589,"description":"Pasta (Solonópole)","state_id":6},
{"id":2528,"description":"Pastos Bons","state_id":10},
{"id":1590,"description":"Patacas (Aquiraz)","state_id":6},
{"id":906,"description":"Patamuté (Curaçá)","state_id":5},
{"id":905,"description":"Pataíba (Água Fria)","state_id":5},
{"id":3548,"description":"Patis","state_id":11},
{"id":6426,"description":"Pato Bragado","state_id":18},
{"id":6427,"description":"Pato Branco","state_id":18},
{"id":5017,"description":"Patos","state_id":15},
{"id":11819,"description":"Patos","state_id":16},
{"id":6428,"description":"Patos Velhos (Prudentópolis)","state_id":18},
{"id":3549,"description":"Patos de Minas","state_id":11},
{"id":5660,"description":"Patos do Piauí","state_id":17},
{"id":10122,"description":"Patos dos Liberatos (Chorozinho)","state_id":6},
{"id":1591,"description":"Patriarca (Sobral)","state_id":6},
{"id":3550,"description":"Patrimônio (Prata)","state_id":11},
{"id":3551,"description":"Patrocínio","state_id":11},
{"id":9462,"description":"Patrocínio Paulista","state_id":26},
{"id":3552,"description":"Patrocínio do Muriaé","state_id":11},
{"id":7232,"description":"Patu","state_id":20},
{"id":7007,"description":"Paty do Alferes","state_id":19},
{"id":11713,"description":"Pau Amarelo","state_id":16},
{"id":908,"description":"Pau Brasil","state_id":5},
{"id":4731,"description":"Pau D'Arco","state_id":14},
{"id":9904,"description":"Pau D'Arco","state_id":27},
{"id":140,"description":"Pau D'Arco (Arapiraca)","state_id":2},
{"id":10100,"description":"Pau D'Arco do Piauí","state_id":17},
{"id":11729,"description":"Pau Ferro","state_id":16},
{"id":141,"description":"Pau Ferro (Arapiraca)","state_id":2},
{"id":5382,"description":"Pau Ferro (Quipapá)","state_id":16},
{"id":907,"description":"Pau a Pique (Casa Nova)","state_id":5},
{"id":6429,"description":"Pau d'Alho do Sul (Assaí)","state_id":18},
{"id":7233,"description":"Pau dos Ferros","state_id":20},
{"id":11823,"description":"Pau-Santo","state_id":16},
{"id":2274,"description":"Pau-Terra (Campinorte)","state_id":9},
{"id":5383,"description":"Paudalho","state_id":16},
{"id":257,"description":"Pauini","state_id":3},
{"id":3553,"description":"Paula Cândido","state_id":11},
{"id":6430,"description":"Paula Freitas","state_id":18},
{"id":3554,"description":"Paula Lima (Juiz de Fora)","state_id":11},
{"id":8599,"description":"Paula Pereira (Canoinhas)","state_id":24},
{"id":9463,"description":"Paulicéia","state_id":26},
{"id":2529,"description":"Paulino Neves","state_id":10},
{"id":5018,"description":"Paulista","state_id":15},
{"id":5384,"description":"Paulista","state_id":16},
{"id":1956,"description":"Paulista (Barra de São Francisco)","state_id":8},
{"id":5661,"description":"Paulistana","state_id":17},
{"id":3555,"description":"Paulistas","state_id":11},
{"id":9465,"description":"Paulistânia","state_id":26},
{"id":6431,"description":"Paulistânia (Alto Piquiri)","state_id":18},
{"id":909,"description":"Paulo Afonso","state_id":5},
{"id":7956,"description":"Paulo Bento","state_id":23},
{"id":6432,"description":"Paulo Frontin","state_id":18},
{"id":142,"description":"Paulo Jacinto","state_id":2},
{"id":8600,"description":"Paulo Lopes","state_id":24},
{"id":2530,"description":"Paulo Ramos","state_id":10},
{"id":9466,"description":"Paulo de Faria","state_id":26},
{"id":9464,"description":"Paulínia","state_id":26},
{"id":9467,"description":"Paulópolis (Pompéia)","state_id":26},
{"id":12749,"description":"Paus Brancos","state_id":6},
{"id":7958,"description":"Paverama","state_id":23},
{"id":1592,"description":"Pavuna (Pacatuba)","state_id":6},
{"id":5662,"description":"Pavussu","state_id":17},
{"id":3556,"description":"Pavão","state_id":11},
{"id":7957,"description":"Pavão (Capão do Leão)","state_id":23},
{"id":2522,"description":"Paço do Lumiar","state_id":10},
{"id":6433,"description":"Peabiru","state_id":18},
{"id":1593,"description":"Pecém (São Gonçalo do Amarante)","state_id":6},
{"id":9468,"description":"Pederneiras","state_id":26},
{"id":5385,"description":"Pedra","state_id":16},
{"id":10860,"description":"Pedra Alta","state_id":5},
{"id":3559,"description":"Pedra Azul","state_id":11},
{"id":9469,"description":"Pedra Bela","state_id":26},
{"id":3560,"description":"Pedra Bonita","state_id":11},
{"id":1594,"description":"Pedra Branca","state_id":6},
{"id":5019,"description":"Pedra Branca","state_id":15},
{"id":1595,"description":"Pedra Branca (Aracoiaba)","state_id":6},
{"id":2275,"description":"Pedra Branca (Catalão)","state_id":9},
{"id":9470,"description":"Pedra Branca de Itararé (Itararé)","state_id":26},
{"id":281,"description":"Pedra Branca do Amapari","state_id":4},
{"id":6434,"description":"Pedra Branca do Araraquara (Guaratuba)","state_id":18},
{"id":3561,"description":"Pedra Corrida (Açucena)","state_id":11},
{"id":12734,"description":"Pedra De Fogo","state_id":6},
{"id":3565,"description":"Pedra Dourada","state_id":11},
{"id":7234,"description":"Pedra Grande","state_id":20},
{"id":3566,"description":"Pedra Grande (Almenara)","state_id":11},
{"id":5020,"description":"Pedra Lavrada","state_id":15},
{"id":3567,"description":"Pedra Menina (Rio Vermelho)","state_id":11},
{"id":8822,"description":"Pedra Mole","state_id":25},
{"id":7235,"description":"Pedra Preta","state_id":20},
{"id":4432,"description":"Pedra Preta","state_id":13},
{"id":7008,"description":"Pedra Selada (Resende)","state_id":19},
{"id":3562,"description":"Pedra do Anta","state_id":11},
{"id":3563,"description":"Pedra do Indaiá","state_id":11},
{"id":3564,"description":"Pedra do Sino (Carandaí)","state_id":11},
{"id":3568,"description":"Pedralva","state_id":11},
{"id":9471,"description":"Pedranópolis","state_id":26},
{"id":258,"description":"Pedras (Barreirinha)","state_id":3},
{"id":8823,"description":"Pedras (Capela)","state_id":25},
{"id":6435,"description":"Pedras (Castro)","state_id":18},
{"id":1596,"description":"Pedras (Morada Nova)","state_id":6},
{"id":7959,"description":"Pedras Altas","state_id":23},
{"id":912,"description":"Pedras Altas do Mirim (Capim Grosso)","state_id":5},
{"id":11529,"description":"Pedras Brancas","state_id":6},
{"id":12421,"description":"Pedras Brancas","state_id":23},
{"id":12040,"description":"Pedras De Marilândia","state_id":11},
{"id":8601,"description":"Pedras Grandes","state_id":24},
{"id":7349,"description":"Pedras Negras (Costa Marques)","state_id":21},
{"id":5021,"description":"Pedras de Fogo","state_id":15},
{"id":3569,"description":"Pedras de Maria da Cruz","state_id":11},
{"id":12621,"description":"Pedregal","state_id":23},
{"id":9472,"description":"Pedregulho","state_id":26},
{"id":9473,"description":"Pedreira","state_id":26},
{"id":4732,"description":"Pedreira (Bagre)","state_id":14},
{"id":2531,"description":"Pedreiras","state_id":10},
{"id":7960,"description":"Pedreiras (Arroio Grande)","state_id":23},
{"id":8824,"description":"Pedrinhas","state_id":25},
{"id":11833,"description":"Pedrinhas","state_id":16},
{"id":1597,"description":"Pedrinhas (Icó)","state_id":6},
{"id":9474,"description":"Pedrinhas Paulista","state_id":26},
{"id":3570,"description":"Pedrinópolis","state_id":11},
{"id":9906,"description":"Pedro Afonso","state_id":27},
{"id":913,"description":"Pedro Alexandre","state_id":5},
{"id":7236,"description":"Pedro Avelino","state_id":20},
{"id":9475,"description":"Pedro Barros (Miracatu)","state_id":26},
{"id":1957,"description":"Pedro Canário","state_id":8},
{"id":7961,"description":"Pedro Garcia (Braga)","state_id":23},
{"id":4222,"description":"Pedro Gomes","state_id":12},
{"id":5663,"description":"Pedro II","state_id":17},
{"id":5664,"description":"Pedro Laurentino","state_id":17},
{"id":3571,"description":"Pedro Leopoldo","state_id":11},
{"id":3572,"description":"Pedro Lessa (Serro)","state_id":11},
{"id":9907,"description":"Pedro Ludovico (Araguaína)","state_id":27},
{"id":6436,"description":"Pedro Lustosa (Reserva do Iguaçu)","state_id":18},
{"id":12065,"description":"Pedro Neca","state_id":13},
{"id":7962,"description":"Pedro Osório","state_id":23},
{"id":7963,"description":"Pedro Paiva (Santo Augusto)","state_id":23},
{"id":5022,"description":"Pedro Régis","state_id":15},
{"id":3573,"description":"Pedro Teixeira","state_id":11},
{"id":7237,"description":"Pedro Velho","state_id":20},
{"id":3574,"description":"Pedro Versiani (Teófilo Otoni)","state_id":11},
{"id":9476,"description":"Pedro de Toledo","state_id":26},
{"id":7009,"description":"Pedro do Rio (Petrópolis)","state_id":19},
{"id":2532,"description":"Pedro do Rosário","state_id":10},
{"id":911,"description":"Pedrão","state_id":5},
{"id":12461,"description":"Pega Fogo","state_id":23},
{"id":9908,"description":"Peixe","state_id":27},
{"id":9909,"description":"Peixe (Araguaína)","state_id":27},
{"id":914,"description":"Peixe (Campo Alegre de Lourdes)","state_id":5},
{"id":1598,"description":"Peixe (Russas)","state_id":6},
{"id":1599,"description":"Peixe Gordo (Tabuleiro do Norte)","state_id":6},
{"id":4733,"description":"Peixe-Boi","state_id":14},
{"id":4433,"description":"Peixoto de Azevedo","state_id":13},
{"id":7964,"description":"Pejuçara","state_id":23},
{"id":11825,"description":"Pelada","state_id":16},
{"id":6437,"description":"Pelado (Guarapuava)","state_id":18},
{"id":5023,"description":"Pelo Sinal (Manaíra)","state_id":15},
{"id":7965,"description":"Pelotas","state_id":23},
{"id":1600,"description":"Penaforte","state_id":6},
{"id":2533,"description":"Penalva","state_id":10},
{"id":1958,"description":"Pendanga (Ibiraçu)","state_id":8},
{"id":7238,"description":"Pendências","state_id":20},
{"id":143,"description":"Penedo","state_id":2},
{"id":10771,"description":"Penedo","state_id":6},
{"id":7010,"description":"Penedo (Resende)","state_id":19},
{"id":8602,"description":"Penha","state_id":24},
{"id":3580,"description":"Penha Longa (Chiador)","state_id":11},
{"id":3576,"description":"Penha de França (Itamarandiba)","state_id":11},
{"id":3577,"description":"Penha do Capim (Aimorés)","state_id":11},
{"id":3578,"description":"Penha do Cassiano (Governador Valadares)","state_id":11},
{"id":3579,"description":"Penha do Norte (Conselheiro Pena)","state_id":11},
{"id":4734,"description":"Penhalonga (Vigia)","state_id":14},
{"id":11086,"description":"Penido","state_id":11},
{"id":7011,"description":"Pentagna (Valença)","state_id":19},
{"id":1601,"description":"Pentecoste","state_id":6},
{"id":9477,"description":"Penápolis","state_id":26},
{"id":3575,"description":"Penédia (Caeté)","state_id":11},
{"id":3581,"description":"Pequeri","state_id":11},
{"id":3582,"description":"Pequi","state_id":11},
{"id":9910,"description":"Pequizeiro","state_id":27},
{"id":1959,"description":"Pequiá (Iúna)","state_id":8},
{"id":3583,"description":"Perdigão","state_id":11},
{"id":3584,"description":"Perdilândia (Santa Vitória)","state_id":11},
{"id":3585,"description":"Perdizes","state_id":11},
{"id":1960,"description":"Perdição (Iúna)","state_id":8},
{"id":3586,"description":"Perdões","state_id":11},
{"id":9478,"description":"Pereira Barreto","state_id":26},
{"id":9479,"description":"Pereiras","state_id":26},
{"id":3587,"description":"Pereirinhas (Desterro de Entre Rios)","state_id":11},
{"id":1602,"description":"Pereiro","state_id":6},
{"id":5024,"description":"Pereiros (Sousa)","state_id":15},
{"id":2534,"description":"Peri Mirim","state_id":10},
{"id":8603,"description":"Pericó (São Joaquim)","state_id":24},
{"id":3588,"description":"Periquito","state_id":11},
{"id":8604,"description":"Peritiba","state_id":24},
{"id":2535,"description":"Peritoró","state_id":10},
{"id":11735,"description":"Pernambuquinho","state_id":16},
{"id":1603,"description":"Pernambuquinho (Guaramiranga)","state_id":6},
{"id":11093,"description":"Peroba","state_id":2},
{"id":6438,"description":"Perobal","state_id":18},
{"id":2276,"description":"Perolândia","state_id":9},
{"id":5386,"description":"Perpétuo Socorro (Alagoinha)","state_id":16},
{"id":3589,"description":"Perpétuo Socorro (Belo Oriente)","state_id":11},
{"id":4735,"description":"Perseverança (São Caetano de Odivelas)","state_id":14},
{"id":9480,"description":"Peruíbe","state_id":26},
{"id":3590,"description":"Pescador","state_id":11},
{"id":8605,"description":"Pescaria Brava (Laguna)","state_id":24},
{"id":5387,"description":"Pesqueira","state_id":16},
{"id":4736,"description":"Pesqueiro (Soure)","state_id":14},
{"id":1604,"description":"Pessoa Anta (Granja)","state_id":6},
{"id":915,"description":"Petim (Castro Alves)","state_id":5},
{"id":5389,"description":"Petrolina","state_id":16},
{"id":2277,"description":"Petrolina de Goiás","state_id":9},
{"id":8606,"description":"Petrolândia","state_id":24},
{"id":5388,"description":"Petrolândia","state_id":16},
{"id":7012,"description":"Petrópolis","state_id":19},
{"id":3591,"description":"Petúnia (Nova Resende)","state_id":11},
{"id":3558,"description":"Peçanha","state_id":11},
{"id":916,"description":"Piabanha (Maraú)","state_id":5},
{"id":4737,"description":"Piabas (Bragança)","state_id":14},
{"id":7013,"description":"Piabetá (Magé)","state_id":19},
{"id":9481,"description":"Piacatu","state_id":26},
{"id":3592,"description":"Piacatuba (Leopoldina)","state_id":11},
{"id":5025,"description":"Piancó","state_id":15},
{"id":6442,"description":"Piassuguera (Paranaguá)","state_id":18},
{"id":917,"description":"Piatã","state_id":5},
{"id":3594,"description":"Piau","state_id":11},
{"id":144,"description":"Piaçabuçu","state_id":2},
{"id":1961,"description":"Piaçu (Muniz Freire)","state_id":8},
{"id":3595,"description":"Pic Sagarana (Arinos)","state_id":11},
{"id":7966,"description":"Picada Café","state_id":23},
{"id":4223,"description":"Picadinha (Dourados)","state_id":12},
{"id":9482,"description":"Picinguaba (Ubatuba)","state_id":26},
{"id":5665,"description":"Picos","state_id":17},
{"id":5026,"description":"Picuí","state_id":15},
{"id":9483,"description":"Piedade","state_id":26},
{"id":3596,"description":"Piedade de Caratinga","state_id":11},
{"id":3597,"description":"Piedade de Ponte Nova","state_id":11},
{"id":3598,"description":"Piedade do Paraopeba (Brumadinho)","state_id":11},
{"id":3599,"description":"Piedade do Rio Grande","state_id":11},
{"id":3600,"description":"Piedade dos Gerais","state_id":11},
{"id":5027,"description":"Pilar","state_id":15},
{"id":145,"description":"Pilar","state_id":2},
{"id":3601,"description":"Pilar (Patos de Minas)","state_id":11},
{"id":2278,"description":"Pilar de Goiás","state_id":9},
{"id":9484,"description":"Pilar do Sul","state_id":26},
{"id":2279,"description":"Piloândia (Israelândia)","state_id":9},
{"id":919,"description":"Pilão Arcado","state_id":5},
{"id":10859,"description":"Pilões","state_id":5},
{"id":7239,"description":"Pilões","state_id":20},
{"id":11784,"description":"Pilões","state_id":2},
{"id":5028,"description":"Pilões","state_id":15},
{"id":9911,"description":"Pilões (Araguaína)","state_id":27},
{"id":5029,"description":"Pilõezinhos","state_id":15},
{"id":3602,"description":"Pimenta","state_id":11},
{"id":7350,"description":"Pimenta Bueno","state_id":21},
{"id":920,"description":"Pimenteira (Ilhéus)","state_id":5},
{"id":5666,"description":"Pimenteiras","state_id":17},
{"id":7351,"description":"Pimenteiras do Oeste","state_id":21},
{"id":2536,"description":"Pimentel (Pindaré Mirim)","state_id":10},
{"id":6444,"description":"Pinaré (Cruz Machado)","state_id":18},
{"id":9485,"description":"Pindamonhangaba","state_id":26},
{"id":2537,"description":"Pindaré Mirim","state_id":10},
{"id":921,"description":"Pindaí","state_id":5},
{"id":3603,"description":"Pindaíbas (Patos de Minas)","state_id":11},
{"id":146,"description":"Pindoba","state_id":2},
{"id":922,"description":"Pindobaçu","state_id":5},
{"id":1605,"description":"Pindoguaba (Tianguá)","state_id":6},
{"id":9486,"description":"Pindorama","state_id":26},
{"id":9912,"description":"Pindorama do Tocantins","state_id":27},
{"id":1606,"description":"Pindoretama","state_id":6},
{"id":8608,"description":"Pindotiba (Orleans)","state_id":24},
{"id":5030,"description":"Pindurão (Camalaú)","state_id":15},
{"id":3604,"description":"Pingo d'Água","state_id":11},
{"id":6445,"description":"Pinhais","state_id":18},
{"id":7967,"description":"Pinhal","state_id":23},
{"id":4740,"description":"Pinhal (Aveiro)","state_id":14},
{"id":7968,"description":"Pinhal (Bom Retiro do Sul)","state_id":23},
{"id":7969,"description":"Pinhal (Sinimbu)","state_id":23},
{"id":7970,"description":"Pinhal (Soledade)","state_id":23},
{"id":7971,"description":"Pinhal Alto (Nova Petrópolis)","state_id":23},
{"id":7973,"description":"Pinhal Grande","state_id":23},
{"id":12488,"description":"Pinhal Queimado","state_id":23},
{"id":7972,"description":"Pinhal da Serra","state_id":23},
{"id":6446,"description":"Pinhal de São Bento","state_id":18},
{"id":8609,"description":"Pinhalzinho","state_id":24},
{"id":9487,"description":"Pinhalzinho","state_id":26},
{"id":6449,"description":"Pinhalzinho (Apucarana)","state_id":18},
{"id":6450,"description":"Pinhalzinho (Cascavel)","state_id":18},
{"id":6451,"description":"Pinhalzinho (Enéas Marques)","state_id":18},
{"id":7974,"description":"Pinhalzinho (Erval Grande)","state_id":23},
{"id":6452,"description":"Pinhalzinho (Goioxim)","state_id":18},
{"id":7975,"description":"Pinhalzinho (Liberato Salzano)","state_id":23},
{"id":6453,"description":"Pinhalzinho (Pinhão)","state_id":18},
{"id":6448,"description":"Pinhalão","state_id":18},
{"id":7015,"description":"Pinheiral","state_id":19},
{"id":8610,"description":"Pinheiral (Major Gercino)","state_id":24},
{"id":7976,"description":"Pinheirinho do Vale","state_id":23},
{"id":12445,"description":"Pinheirinhos","state_id":23},
{"id":3605,"description":"Pinheirinhos (Passa Quatro)","state_id":11},
{"id":2538,"description":"Pinheiro","state_id":10},
{"id":6455,"description":"Pinheiro (Capanema)","state_id":18},
{"id":12059,"description":"Pinheiro Grosso","state_id":11},
{"id":7977,"description":"Pinheiro Machado","state_id":23},
{"id":7978,"description":"Pinheiro Machado (São Paulo das Missões)","state_id":23},
{"id":7979,"description":"Pinheiro Marcado (Carazinho)","state_id":23},
{"id":8611,"description":"Pinheiro Preto","state_id":24},
{"id":1962,"description":"Pinheiros","state_id":8},
{"id":8612,"description":"Pinheiros (Canoinhas)","state_id":24},
{"id":9488,"description":"Pinheiros (Lavrinhas)","state_id":26},
{"id":3606,"description":"Pinheiros Altos (Piranga)","state_id":11},
{"id":3607,"description":"Pinhotiba (Eugenópolis)","state_id":11},
{"id":6454,"description":"Pinhão","state_id":18},
{"id":8825,"description":"Pinhão","state_id":25},
{"id":923,"description":"Pinhões (Juazeiro)","state_id":5},
{"id":924,"description":"Pintadas","state_id":5},
{"id":7980,"description":"Pinto Bandeira","state_id":23},
{"id":3609,"description":"Pintos Negreiros (Maria da Fé)","state_id":11},
{"id":3608,"description":"Pintópolis","state_id":11},
{"id":5667,"description":"Pio IX","state_id":17},
{"id":5031,"description":"Pio X (Sumé)","state_id":15},
{"id":1607,"description":"Pio X (Umari)","state_id":6},
{"id":2539,"description":"Pio XII","state_id":10},
{"id":9489,"description":"Pioneiros (Guará)","state_id":26},
{"id":12125,"description":"Pipa","state_id":20},
{"id":7016,"description":"Pipeiras (São João da Barra)","state_id":19},
{"id":9490,"description":"Piquerobi","state_id":26},
{"id":1608,"description":"Piquet Carneiro","state_id":6},
{"id":9491,"description":"Piquete","state_id":26},
{"id":12099,"description":"Piquiri","state_id":23},
{"id":6456,"description":"Piquirivaí (Campo Mourão)","state_id":18},
{"id":8613,"description":"Pirabeiraba (Joinville)","state_id":24},
{"id":1609,"description":"Pirabibu (Quixeramobim)","state_id":6},
{"id":9492,"description":"Piracaia","state_id":26},
{"id":3610,"description":"Piracaiba (Araguari)","state_id":11},
{"id":2280,"description":"Piracanjuba","state_id":9},
{"id":3611,"description":"Piracema","state_id":11},
{"id":1963,"description":"Piracema (Afonso Cláudio)","state_id":8},
{"id":6457,"description":"Piracema (Paranavaí)","state_id":18},
{"id":9493,"description":"Piracicaba","state_id":26},
{"id":5668,"description":"Piracuruca","state_id":17},
{"id":925,"description":"Piragi (Itamaraju)","state_id":5},
{"id":9494,"description":"Piraju","state_id":26},
{"id":12534,"description":"Piraju","state_id":23},
{"id":3612,"description":"Pirajuba","state_id":11},
{"id":928,"description":"Pirajuia (Jaguaripe)","state_id":5},
{"id":9495,"description":"Pirajuí","state_id":26},
{"id":927,"description":"Pirajá (Itamaraju)","state_id":5},
{"id":8826,"description":"Pirambu","state_id":25},
{"id":9496,"description":"Pirambóia (Anhembi)","state_id":26},
{"id":3613,"description":"Piranga","state_id":11},
{"id":7018,"description":"Pirangaí (Resende)","state_id":19},
{"id":9497,"description":"Pirangi","state_id":26},
{"id":1610,"description":"Pirangi (Ibaretama)","state_id":6},
{"id":3615,"description":"Piranguinho","state_id":11},
{"id":3616,"description":"Piranguita (Rio Espera)","state_id":11},
{"id":3614,"description":"Piranguçu","state_id":11},
{"id":147,"description":"Piranhas","state_id":2},
{"id":2281,"description":"Piranhas","state_id":9},
{"id":3617,"description":"Pirapanema (Muriaé)","state_id":11},
{"id":2540,"description":"Pirapemas","state_id":10},
{"id":3618,"description":"Pirapetinga","state_id":11},
{"id":7019,"description":"Pirapetinga de Bom Jesus (Bom Jesus do Itabapoana)","state_id":19},
{"id":11088,"description":"Pirapitinga","state_id":11},
{"id":9498,"description":"Pirapitingui (Itu)","state_id":26},
{"id":3619,"description":"Pirapora","state_id":11},
{"id":4224,"description":"Pirapora (Itaporã)","state_id":12},
{"id":9499,"description":"Pirapora do Bom Jesus","state_id":26},
{"id":9500,"description":"Pirapozinho","state_id":26},
{"id":4225,"description":"Piraputanga (Aquidauana)","state_id":12},
{"id":7982,"description":"Pirapó","state_id":23},
{"id":6459,"description":"Pirapó (Apucarana)","state_id":18},
{"id":6460,"description":"Piraquara","state_id":18},
{"id":4741,"description":"Piraquara (Santarém)","state_id":14},
{"id":9913,"description":"Piraquê","state_id":27},
{"id":9501,"description":"Pirassununga","state_id":26},
{"id":7983,"description":"Piratini","state_id":23},
{"id":9502,"description":"Piratininga","state_id":26},
{"id":12032,"description":"Piratininga","state_id":13},
{"id":8614,"description":"Piratuba","state_id":24},
{"id":5032,"description":"Pirauá (Natuba)","state_id":15},
{"id":7017,"description":"Piraí","state_id":19},
{"id":7981,"description":"Piraí (Bagé)","state_id":23},
{"id":926,"description":"Piraí do Norte","state_id":5},
{"id":6458,"description":"Piraí do Sul","state_id":18},
{"id":3620,"description":"Piraúba","state_id":11},
{"id":2282,"description":"Pirenópolis","state_id":9},
{"id":2283,"description":"Pires Belo (Catalão)","state_id":9},
{"id":1611,"description":"Pires Ferreira","state_id":6},
{"id":2284,"description":"Pires do Rio","state_id":9},
{"id":3621,"description":"Pires e Albuquerque (Bocaiúva)","state_id":11},
{"id":929,"description":"Piri (Sento Sé)","state_id":5},
{"id":5669,"description":"Piripiri","state_id":17},
{"id":930,"description":"Piripá","state_id":5},
{"id":6461,"description":"Piriquitos (Ponta Grossa)","state_id":18},
{"id":931,"description":"Piritiba","state_id":5},
{"id":5390,"description":"Pirituba (Vitória de Santo Antão)","state_id":16},
{"id":4434,"description":"Pirizal (Nossa Senhora do Livramento)","state_id":13},
{"id":4742,"description":"Piriá (Curralinho)","state_id":14},
{"id":5033,"description":"Pirpirituba","state_id":15},
{"id":3622,"description":"Piscamba (Jequeri)","state_id":11},
{"id":6462,"description":"Pitanga","state_id":18},
{"id":7984,"description":"Pitanga (Doutor Maurício Cardoso)","state_id":23},
{"id":5034,"description":"Pitanga de Estrada (Mamanguape)","state_id":15},
{"id":9503,"description":"Pitangueiras","state_id":26},
{"id":6463,"description":"Pitangueiras","state_id":18},
{"id":3623,"description":"Pitangui","state_id":11},
{"id":6464,"description":"Pitangui (Ponta Grossa)","state_id":18},
{"id":3624,"description":"Pitarana (Montalvânia)","state_id":11},
{"id":5035,"description":"Pitimbu","state_id":15},
{"id":12521,"description":"Pitingal","state_id":23},
{"id":1612,"description":"Pitombeira (Itapagé)","state_id":6},
{"id":1613,"description":"Pitombeiras (Cascavel)","state_id":6},
{"id":932,"description":"Pituba (Gentio do Ouro)","state_id":5},
{"id":9914,"description":"Pium","state_id":27},
{"id":3625,"description":"Piumhi","state_id":11},
{"id":3593,"description":"Pião (Santa Rita de Caldas)","state_id":11},
{"id":7014,"description":"Pião (Sapucaia)","state_id":19},
{"id":4738,"description":"Piçarra","state_id":14},
{"id":4739,"description":"Piçarra (Xinguara)","state_id":14},
{"id":8607,"description":"Piçarras","state_id":24},
{"id":918,"description":"Piçarrão (Sento Sé)","state_id":5},
{"id":6443,"description":"Piên","state_id":18},
{"id":1964,"description":"Piúma","state_id":8},
{"id":4435,"description":"Placa de Santo Antônio (Juscimeira)","state_id":13},
{"id":4743,"description":"Placas","state_id":14},
{"id":10979,"description":"Planalmira","state_id":9},
{"id":1789,"description":"Planaltina","state_id":7},
{"id":2285,"description":"Planaltina de Goiás","state_id":9},
{"id":6465,"description":"Planaltina do Paraná","state_id":18},
{"id":933,"description":"Planaltino","state_id":5},
{"id":934,"description":"Planalto","state_id":5},
{"id":9504,"description":"Planalto","state_id":26},
{"id":6466,"description":"Planalto","state_id":18},
{"id":7985,"description":"Planalto","state_id":23},
{"id":9505,"description":"Planalto (Andradina)","state_id":26},
{"id":8615,"description":"Planalto (Concórdia)","state_id":24},
{"id":7986,"description":"Planalto (Crissiumal)","state_id":23},
{"id":8616,"description":"Planalto Alegre","state_id":24},
{"id":4436,"description":"Planalto da Serra","state_id":13},
{"id":3626,"description":"Planalto de Minas (Diamantina)","state_id":11},
{"id":9506,"description":"Planalto do Sul (Teodoro Sampaio)","state_id":26},
{"id":7987,"description":"Plano Alto (Uruguaiana)","state_id":23},
{"id":3627,"description":"Planura","state_id":11},
{"id":9507,"description":"Platina","state_id":26},
{"id":11778,"description":"Platô Do Piquiá","state_id":3},
{"id":3628,"description":"Plautino Soares (Sobrália)","state_id":11},
{"id":1614,"description":"Plácido Martins (Aracoiaba)","state_id":6},
{"id":13,"description":"Plácido de Castro","state_id":1},
{"id":3629,"description":"Poaia (Santa Maria do Suaçuí)","state_id":11},
{"id":6467,"description":"Pocinho (Barbosa Ferraz)","state_id":18},
{"id":6468,"description":"Pocinho (Ponta Grossa)","state_id":18},
{"id":5036,"description":"Pocinhos","state_id":15},
{"id":4437,"description":"Poconé","state_id":13},
{"id":3633,"description":"Pocrane","state_id":11},
{"id":1619,"description":"Podimirim (Milagres)","state_id":6},
{"id":6469,"description":"Poema (Nova Tebas)","state_id":18},
{"id":939,"description":"Pojuca","state_id":5},
{"id":940,"description":"Polo Petroquímico de Camaçari (Camaçari)","state_id":5},
{"id":9509,"description":"Poloni","state_id":26},
{"id":9510,"description":"Polvilho (Cajamar)","state_id":26},
{"id":7989,"description":"Polígono do Erval (Victor Graeff)","state_id":23},
{"id":5039,"description":"Pombal","state_id":15},
{"id":4438,"description":"Pombas (Dom Aquino)","state_id":13},
{"id":5395,"description":"Pombos","state_id":16},
{"id":8618,"description":"Pomerode","state_id":24},
{"id":12513,"description":"Pompeu Machado","state_id":23},
{"id":9511,"description":"Pompéia","state_id":26},
{"id":3634,"description":"Pompéu","state_id":11},
{"id":3635,"description":"Poncianos (Conceição das Alagoas)","state_id":11},
{"id":9512,"description":"Pongaí","state_id":26},
{"id":6471,"description":"Ponta Grossa","state_id":18},
{"id":12713,"description":"Ponta Negra","state_id":19},
{"id":4226,"description":"Ponta Porã","state_id":12},
{"id":941,"description":"Ponta da Areia (Caravelas)","state_id":5},
{"id":1620,"description":"Ponta da Serra (Crato)","state_id":6},
{"id":4744,"description":"Ponta de Pedras","state_id":14},
{"id":4745,"description":"Ponta de Ramos (Curuçá)","state_id":14},
{"id":6470,"description":"Ponta do Pasto (Paranaguá)","state_id":18},
{"id":9513,"description":"Pontal","state_id":26},
{"id":11081,"description":"Pontal De Coruripe","state_id":2},
{"id":4439,"description":"Pontal do Araguaia","state_id":13},
{"id":6472,"description":"Pontal do Paraná","state_id":18},
{"id":3636,"description":"Pontalete (Três Pontas)","state_id":11},
{"id":2286,"description":"Pontalina","state_id":9},
{"id":9514,"description":"Pontalinda","state_id":26},
{"id":5396,"description":"Pontas de Pedra (Goiana)","state_id":16},
{"id":8619,"description":"Ponte Alta","state_id":24},
{"id":3637,"description":"Ponte Alta (Uberaba)","state_id":11},
{"id":3638,"description":"Ponte Alta de Minas (Carangola)","state_id":11},
{"id":9915,"description":"Ponte Alta do Bom Jesus","state_id":27},
{"id":8620,"description":"Ponte Alta do Norte","state_id":24},
{"id":9916,"description":"Ponte Alta do Tocantins","state_id":27},
{"id":4440,"description":"Ponte Branca","state_id":13},
{"id":12060,"description":"Ponte Do Cosme","state_id":11},
{"id":3640,"description":"Ponte Firme (Presidente Olegário)","state_id":11},
{"id":3641,"description":"Ponte Nova","state_id":11},
{"id":7992,"description":"Ponte Preta","state_id":23},
{"id":3642,"description":"Ponte Segura (Senador Amaral)","state_id":11},
{"id":8621,"description":"Ponte Serrada","state_id":24},
{"id":4227,"description":"Ponte Vermelha (São Gabriel do Oeste)","state_id":12},
{"id":1965,"description":"Ponte de Itabapoana (Mimoso do Sul)","state_id":8},
{"id":4441,"description":"Ponte de Pedra (Rondonópolis)","state_id":13},
{"id":5397,"description":"Ponte dos Carvalhos (Cabo de Santo Agostinho)","state_id":16},
{"id":3639,"description":"Ponte dos Ciganos (Coração de Jesus)","state_id":11},
{"id":9917,"description":"Pontes (Araguaína)","state_id":27},
{"id":12478,"description":"Pontes Filho","state_id":23},
{"id":9515,"description":"Pontes Gestal","state_id":26},
{"id":4442,"description":"Pontes e Lacerda","state_id":13},
{"id":3643,"description":"Pontevila (Formiga)","state_id":11},
{"id":4228,"description":"Pontinha do Cocho (Camapuã)","state_id":12},
{"id":4443,"description":"Pontinópolis (São Félix do Araguaia)","state_id":13},
{"id":1966,"description":"Ponto Belo","state_id":8},
{"id":3644,"description":"Ponto Chique","state_id":11},
{"id":3645,"description":"Ponto Chique do Martelo (Barbacena)","state_id":11},
{"id":942,"description":"Ponto Novo","state_id":5},
{"id":3646,"description":"Ponto do Marambaia (Caraí)","state_id":11},
{"id":3647,"description":"Ponto dos Volantes","state_id":11},
{"id":7991,"description":"Pontão","state_id":23},
{"id":12569,"description":"Pontão Santo Antônio","state_id":23},
{"id":1967,"description":"Pontões (Afonso Cláudio)","state_id":8},
{"id":9516,"description":"Populina","state_id":26},
{"id":1621,"description":"Poranga","state_id":6},
{"id":9517,"description":"Porangaba","state_id":26},
{"id":2287,"description":"Porangatu","state_id":9},
{"id":1968,"description":"Porangá (Barra de São Francisco)","state_id":8},
{"id":7020,"description":"Porciúncula","state_id":19},
{"id":6473,"description":"Porecatu","state_id":18},
{"id":1622,"description":"Porfirio Sampaio (Pentecoste)","state_id":6},
{"id":7241,"description":"Portalegre","state_id":20},
{"id":6475,"description":"Porteira Preta (Fênix)","state_id":18},
{"id":1623,"description":"Porteiras","state_id":6},
{"id":3648,"description":"Porteirinha","state_id":11},
{"id":5040,"description":"Porteirinha de Pedra (Campina Grande)","state_id":15},
{"id":2288,"description":"Porteirão","state_id":9},
{"id":4746,"description":"Portel","state_id":14},
{"id":7021,"description":"Portela (Itaocara)","state_id":19},
{"id":2289,"description":"Portelândia","state_id":9},
{"id":5670,"description":"Porto","state_id":17},
{"id":14,"description":"Porto Acre","state_id":1},
{"id":3649,"description":"Porto Agrário (Juvenília)","state_id":11},
{"id":7994,"description":"Porto Alegre","state_id":23},
{"id":4444,"description":"Porto Alegre do Norte","state_id":13},
{"id":5671,"description":"Porto Alegre do Piauí","state_id":17},
{"id":9919,"description":"Porto Alegre do Tocantins","state_id":27},
{"id":6476,"description":"Porto Amazonas","state_id":18},
{"id":1969,"description":"Porto Barra do Riacho (Aracruz)","state_id":8},
{"id":6477,"description":"Porto Barreiro","state_id":18},
{"id":7995,"description":"Porto Batista (Triunfo)","state_id":23},
{"id":8622,"description":"Porto Belo","state_id":24},
{"id":6478,"description":"Porto Belo (Foz do Iguaçu)","state_id":18},
{"id":6479,"description":"Porto Brasílio (Querência do Norte)","state_id":18},
{"id":151,"description":"Porto Calvo","state_id":2},
{"id":6480,"description":"Porto Camargo (Icaraíma)","state_id":18},
{"id":12455,"description":"Porto Colônia","state_id":23},
{"id":4229,"description":"Porto Esperança (Corumbá)","state_id":12},
{"id":4446,"description":"Porto Esperidião","state_id":13},
{"id":4447,"description":"Porto Estrela","state_id":13},
{"id":9518,"description":"Porto Feliz","state_id":26},
{"id":9519,"description":"Porto Ferreira","state_id":26},
{"id":3652,"description":"Porto Firme","state_id":11},
{"id":2543,"description":"Porto Franco","state_id":10},
{"id":312,"description":"Porto Grande","state_id":4},
{"id":9920,"description":"Porto Lemos (Araguaína)","state_id":27},
{"id":7996,"description":"Porto Lucena","state_id":23},
{"id":7997,"description":"Porto Mauá","state_id":23},
{"id":6482,"description":"Porto Meira (Foz do Iguaçu)","state_id":18},
{"id":6483,"description":"Porto Mendes (Marechal Cândido Rondon)","state_id":18},
{"id":4230,"description":"Porto Murtinho","state_id":12},
{"id":9921,"description":"Porto Nacional","state_id":27},
{"id":9520,"description":"Porto Novo (Caraguatatuba)","state_id":26},
{"id":943,"description":"Porto Novo (Santana)","state_id":5},
{"id":7023,"description":"Porto Real","state_id":19},
{"id":153,"description":"Porto Real do Colégio","state_id":2},
{"id":6484,"description":"Porto Rico","state_id":18},
{"id":2544,"description":"Porto Rico do Maranhão","state_id":10},
{"id":4748,"description":"Porto Salvo (Vigia)","state_id":14},
{"id":6485,"description":"Porto San Juan (Foz do Iguaçu)","state_id":18},
{"id":6486,"description":"Porto Santana (Porto Barreiro)","state_id":18},
{"id":11480,"description":"Porto Sauípe","state_id":5},
{"id":944,"description":"Porto Seguro","state_id":5},
{"id":12567,"description":"Porto Soberbo","state_id":23},
{"id":6487,"description":"Porto São Carlos (São Carlos do Ivaí)","state_id":18},
{"id":6488,"description":"Porto São José (São Pedro do Paraná)","state_id":18},
{"id":4749,"description":"Porto Trombetas (Oriximiná)","state_id":14},
{"id":8623,"description":"Porto União","state_id":24},
{"id":7352,"description":"Porto Velho","state_id":21},
{"id":7024,"description":"Porto Velho do Cunha (Carmo)","state_id":19},
{"id":7998,"description":"Porto Vera Cruz","state_id":23},
{"id":4231,"description":"Porto Vilma (Deodápolis)","state_id":12},
{"id":6489,"description":"Porto Vitória","state_id":18},
{"id":15,"description":"Porto Walter","state_id":1},
{"id":4232,"description":"Porto XV de Novembro (Bataguassu)","state_id":12},
{"id":7999,"description":"Porto Xavier","state_id":23},
{"id":8829,"description":"Porto da Folha","state_id":25},
{"id":7022,"description":"Porto das Caixas (Itaboraí)","state_id":19},
{"id":3650,"description":"Porto das Flores (Belmiro Braga)","state_id":11},
{"id":2542,"description":"Porto das Gabarras (Anajatuba)","state_id":10},
{"id":6481,"description":"Porto de Cima (Morretes)","state_id":18},
{"id":4747,"description":"Porto de Moz","state_id":14},
{"id":152,"description":"Porto de Pedras","state_id":2},
{"id":7242,"description":"Porto do Mangue","state_id":20},
{"id":4445,"description":"Porto dos Gaúchos","state_id":13},
{"id":3651,"description":"Porto dos Mendes (Campo Belo)","state_id":11},
{"id":7993,"description":"Portão","state_id":23},
{"id":6474,"description":"Portão (Cascavel)","state_id":18},
{"id":9918,"description":"Porãozinho (Araguaína)","state_id":27},
{"id":2290,"description":"Posse","state_id":9},
{"id":7025,"description":"Posse (Petrópolis)","state_id":19},
{"id":2291,"description":"Posse D'Abadia (Abadiânia)","state_id":9},
{"id":12642,"description":"Posse Dos Linhares","state_id":23},
{"id":11584,"description":"Posselândia","state_id":9},
{"id":945,"description":"Posto da Mata (Nova Viçosa)","state_id":5},
{"id":1624,"description":"Potengi","state_id":6},
{"id":1625,"description":"Poti (Crateús)","state_id":6},
{"id":9521,"description":"Potim","state_id":26},
{"id":946,"description":"Potiraguá","state_id":5},
{"id":9522,"description":"Potirendaba","state_id":26},
{"id":1626,"description":"Potiretama","state_id":6},
{"id":9523,"description":"Potunduva (Jaú)","state_id":26},
{"id":3653,"description":"Poté","state_id":11},
{"id":3654,"description":"Pouso Alegre","state_id":11},
{"id":11677,"description":"Pouso Alegre","state_id":11},
{"id":3655,"description":"Pouso Alto","state_id":11},
{"id":8000,"description":"Pouso Novo","state_id":23},
{"id":8624,"description":"Pouso Redondo","state_id":24},
{"id":8001,"description":"Povo Novo (Rio Grande)","state_id":23},
{"id":8002,"description":"Povoado Tozzo (Itatiba do Sul)","state_id":23},
{"id":154,"description":"Poxim (Coruripe)","state_id":2},
{"id":947,"description":"Poxim do Sul (Canavieiras)","state_id":5},
{"id":4448,"description":"Poxoréo","state_id":13},
{"id":9508,"description":"Poá","state_id":26},
{"id":11785,"description":"Poço","state_id":2},
{"id":1615,"description":"Poço (Brejo Santo)","state_id":6},
{"id":7240,"description":"Poço Branco","state_id":20},
{"id":935,"description":"Poço Central (Aurelino Leal)","state_id":5},
{"id":1616,"description":"Poço Comprido (Amontada)","state_id":6},
{"id":5393,"description":"Poço Comprido (Correntes)","state_id":16},
{"id":1617,"description":"Poço Comprido (Jaguaribara)","state_id":6},
{"id":12685,"description":"Poço Da Onça","state_id":6},
{"id":11786,"description":"Poço Da Pedra De Cima","state_id":2},
{"id":5037,"description":"Poço Dantas","state_id":15},
{"id":11787,"description":"Poço De Baixo","state_id":2},
{"id":11788,"description":"Poço De Santana","state_id":2},
{"id":3630,"description":"Poço Fundo","state_id":11},
{"id":12474,"description":"Poço Fundo","state_id":23},
{"id":5394,"description":"Poço Fundo (Santa Cruz do Capibaribe)","state_id":16},
{"id":1618,"description":"Poço Grande (Jucás)","state_id":6},
{"id":8617,"description":"Poço Preto (Irineópolis)","state_id":24},
{"id":8827,"description":"Poço Redondo","state_id":25},
{"id":8828,"description":"Poço Verde","state_id":25},
{"id":12347,"description":"Poço Verde","state_id":6},
{"id":149,"description":"Poço da Pedra (Arapiraca)","state_id":2},
{"id":7988,"description":"Poço das Antas","state_id":23},
{"id":150,"description":"Poço das Trincheiras","state_id":2},
{"id":936,"description":"Poço de Fora (Curaçá)","state_id":5},
{"id":5038,"description":"Poço de José de Moura","state_id":15},
{"id":938,"description":"Poços (Remanso)","state_id":5},
{"id":3632,"description":"Poços de Caldas","state_id":11},
{"id":5391,"description":"Poção","state_id":16},
{"id":148,"description":"Poção (Arapiraca)","state_id":2},
{"id":5392,"description":"Poção de Afrânio (Afrânio)","state_id":16},
{"id":2541,"description":"Poção de Pedras","state_id":10},
{"id":937,"description":"Poções","state_id":5},
{"id":3631,"description":"Poções de Paineiras (Paineiras)","state_id":11},
{"id":9524,"description":"Pracinha","state_id":26},
{"id":313,"description":"Pracuúba","state_id":4},
{"id":948,"description":"Prado","state_id":5},
{"id":6490,"description":"Prado Ferreira","state_id":18},
{"id":11562,"description":"Prado Novo","state_id":23},
{"id":3656,"description":"Prados","state_id":11},
{"id":12011,"description":"Pradoso","state_id":5},
{"id":9525,"description":"Pradínia (Pirajuí)","state_id":26},
{"id":9526,"description":"Pradópolis","state_id":26},
{"id":8625,"description":"Praia Grande","state_id":24},
{"id":9527,"description":"Praia Grande","state_id":26},
{"id":1970,"description":"Praia Grande (Fundão)","state_id":8},
{"id":9922,"description":"Praia Norte","state_id":27},
{"id":4449,"description":"Praia Rica (Chapada dos Guimarães)","state_id":13},
{"id":10186,"description":"Praia da Conceição (Paulista)","state_id":16},
{"id":7026,"description":"Praia de Araçatiba (Angra dos Reis)","state_id":19},
{"id":4750,"description":"Prainha","state_id":14},
{"id":8003,"description":"Pranchada (Doutor Maurício Cardoso)","state_id":23},
{"id":6491,"description":"Pranchita","state_id":18},
{"id":3657,"description":"Prata","state_id":11},
{"id":5041,"description":"Prata","state_id":15},
{"id":12351,"description":"Prata","state_id":9},
{"id":1627,"description":"Prata (Bela Cruz)","state_id":6},
{"id":6492,"description":"Prata (Cambé)","state_id":18},
{"id":8626,"description":"Prata (São Miguel do Oeste)","state_id":24},
{"id":6493,"description":"Prata Um (Telêmaco Borba)","state_id":18},
{"id":5672,"description":"Prata do Piauí","state_id":17},
{"id":3659,"description":"Pratinha","state_id":11},
{"id":12265,"description":"Pratiús","state_id":6},
{"id":12604,"description":"Pratos","state_id":23},
{"id":8004,"description":"Pratos (Tucunduva)","state_id":23},
{"id":3658,"description":"Pratápolis","state_id":11},
{"id":9528,"description":"Pratânia","state_id":26},
{"id":11676,"description":"Prefeita Suely Pinheiro","state_id":6},
{"id":9529,"description":"Presidente Alves","state_id":26},
{"id":3660,"description":"Presidente Bernardes","state_id":11},
{"id":9530,"description":"Presidente Bernardes","state_id":26},
{"id":4233,"description":"Presidente Castelo (Deodápolis)","state_id":12},
{"id":8627,"description":"Presidente Castelo Branco","state_id":24},
{"id":6494,"description":"Presidente Castelo Branco","state_id":18},
{"id":949,"description":"Presidente Dutra","state_id":5},
{"id":2545,"description":"Presidente Dutra","state_id":10},
{"id":9531,"description":"Presidente Epitácio","state_id":26},
{"id":259,"description":"Presidente Figueiredo","state_id":3},
{"id":8628,"description":"Presidente Getúlio","state_id":24},
{"id":3661,"description":"Presidente Juscelino","state_id":11},
{"id":2546,"description":"Presidente Juscelino","state_id":10},
{"id":8629,"description":"Presidente Juscelino (São Lourenço do Oeste)","state_id":24},
{"id":950,"description":"Presidente Jânio Quadros","state_id":5},
{"id":1971,"description":"Presidente Kennedy","state_id":8},
{"id":9923,"description":"Presidente Kennedy","state_id":27},
{"id":8630,"description":"Presidente Kennedy (Concórdia)","state_id":24},
{"id":6495,"description":"Presidente Kennedy (Verê)","state_id":18},
{"id":3662,"description":"Presidente Kubitschek","state_id":11},
{"id":8005,"description":"Presidente Lucena","state_id":23},
{"id":2547,"description":"Presidente Médici","state_id":10},
{"id":7353,"description":"Presidente Médici","state_id":21},
{"id":8631,"description":"Presidente Nereu","state_id":24},
{"id":3663,"description":"Presidente Olegário","state_id":11},
{"id":3664,"description":"Presidente Pena (Carlos Chagas)","state_id":11},
{"id":9532,"description":"Presidente Prudente","state_id":26},
{"id":2548,"description":"Presidente Sarney","state_id":10},
{"id":951,"description":"Presidente Tancredo Neves","state_id":5},
{"id":2549,"description":"Presidente Vargas","state_id":10},
{"id":9533,"description":"Presidente Venceslau","state_id":26},
{"id":952,"description":"Prevenido (América Dourada)","state_id":5},
{"id":4751,"description":"Primavera","state_id":14},
{"id":5399,"description":"Primavera","state_id":16},
{"id":9534,"description":"Primavera (Rosana)","state_id":26},
{"id":4450,"description":"Primavera (Sorriso)","state_id":13},
{"id":7354,"description":"Primavera de Rondônia","state_id":21},
{"id":4451,"description":"Primavera do Leste","state_id":13},
{"id":2550,"description":"Primeira Cruz","state_id":10},
{"id":6496,"description":"Primeiro de Maio","state_id":18},
{"id":8632,"description":"Princesa","state_id":24},
{"id":1972,"description":"Princesa (Rio Novo do Sul)","state_id":8},
{"id":5042,"description":"Princesa Isabel","state_id":15},
{"id":2292,"description":"Professor Jamil","state_id":9},
{"id":3665,"description":"Professor Sperber (Chalé)","state_id":11},
{"id":8006,"description":"Progresso","state_id":23},
{"id":8007,"description":"Progresso (Arroio do Tigre)","state_id":23},
{"id":6497,"description":"Progresso (Francisco Beltrão)","state_id":18},
{"id":4452,"description":"Progresso (Tangará da Serra)","state_id":13},
{"id":8009,"description":"Progresso (Três Palmeiras)","state_id":23},
{"id":8008,"description":"Progresso (Três de Maio)","state_id":23},
{"id":9535,"description":"Promissão","state_id":26},
{"id":8830,"description":"Propriá","state_id":25},
{"id":10112,"description":"Prosperidade (Vargem Alta)","state_id":8},
{"id":8010,"description":"Protásio Alves","state_id":23},
{"id":3666,"description":"Providência (Leopoldina)","state_id":11},
{"id":3667,"description":"Prudente de Morais","state_id":11},
{"id":1628,"description":"Prudente de Morais (Quixeramobim)","state_id":6},
{"id":6498,"description":"Prudentópolis","state_id":18},
{"id":4234,"description":"Prudêncio Thomaz (Rio Brilhante)","state_id":12},
{"id":9536,"description":"Prudêncio e Moraes (General Salgado)","state_id":26},
{"id":9924,"description":"Príncipe (Natividade)","state_id":27},
{"id":7355,"description":"Príncipe da Beira (Costa Marques)","state_id":21},
{"id":9925,"description":"Pugmil","state_id":27},
{"id":12613,"description":"Pulador","state_id":23},
{"id":8011,"description":"Pulador (Passo Fundo)","state_id":23},
{"id":6499,"description":"Pulinópolis (Mandaguaçu)","state_id":18},
{"id":7243,"description":"Pureza","state_id":20},
{"id":7027,"description":"Pureza (São Fidélis)","state_id":19},
{"id":7028,"description":"Purilândia (Porciúncula)","state_id":19},
{"id":11761,"description":"Purupuru","state_id":3},
{"id":8012,"description":"Putinga","state_id":23},
{"id":5043,"description":"Puxinanã","state_id":15},
{"id":3529,"description":"Pântano (Estiva)","state_id":11},
{"id":7939,"description":"Pântano Grande","state_id":23},
{"id":8593,"description":"Pântano do Sul (Florianópolis)","state_id":24},
{"id":136,"description":"Pão de Açúcar","state_id":2},
{"id":5372,"description":"Pão de Açúcar (Taquaritinga do Norte)","state_id":16},
{"id":5373,"description":"Pão de Açúcar do Poção (Poção)","state_id":16},
{"id":9905,"description":"Pé da Serra (Araguaína)","state_id":27},
{"id":910,"description":"Pé de Serra","state_id":5},
{"id":3557,"description":"Pé do Morro (Passa Quatro)","state_id":11},
{"id":11699,"description":"Pé-De-Serra Dos Mendes","state_id":16},
{"id":6439,"description":"Pérola","state_id":18},
{"id":6441,"description":"Pérola Independente (Maripá)","state_id":18},
{"id":6440,"description":"Pérola d'Oeste","state_id":18},
{"id":7990,"description":"Pólo Petroquímico de Triunfo (Triunfo)","state_id":23},
{"id":9537,"description":"Quadra","state_id":26},
{"id":8014,"description":"Quaraim (Três de Maio)","state_id":23},
{"id":953,"description":"Quaraçu (Cândido Sales)","state_id":5},
{"id":8013,"description":"Quaraí","state_id":23},
{"id":8633,"description":"Quarta Linha (Criciúma)","state_id":24},
{"id":3670,"description":"Quartel Geral","state_id":11},
{"id":3668,"description":"Quartel de São João (Quartel Geral)","state_id":11},
{"id":3669,"description":"Quartel do Sacramento (Bom Jesus do Galho)","state_id":11},
{"id":6838,"description":"Quarto Centenário","state_id":18},
{"id":7029,"description":"Quartéis (Silva Jardim)","state_id":19},
{"id":11794,"description":"Quati","state_id":2},
{"id":1629,"description":"Quatiguaba (Viçosa do Ceará)","state_id":6},
{"id":6500,"description":"Quatiguá","state_id":18},
{"id":4752,"description":"Quatipuru","state_id":14},
{"id":7030,"description":"Quatis","state_id":19},
{"id":3671,"description":"Quatituba (Itueta)","state_id":11},
{"id":6501,"description":"Quatro Barras","state_id":18},
{"id":4753,"description":"Quatro Bocas (Tomé-Açú)","state_id":14},
{"id":8015,"description":"Quatro Irmãos","state_id":23},
{"id":6502,"description":"Quatro Pontes","state_id":18},
{"id":9538,"description":"Quatá","state_id":26},
{"id":4235,"description":"Quebra Côco (Sidrolândia)","state_id":12},
{"id":6503,"description":"Quebra Freio (Pato Branco)","state_id":18},
{"id":4236,"description":"Quebracho (Anaurilândia)","state_id":12},
{"id":155,"description":"Quebrangulo","state_id":2},
{"id":6504,"description":"Quedas do Iguaçu","state_id":18},
{"id":5673,"description":"Queimada Nova","state_id":17},
{"id":954,"description":"Queimadas","state_id":5},
{"id":5044,"description":"Queimadas","state_id":15},
{"id":1630,"description":"Queimadas (Horizonte)","state_id":6},
{"id":1973,"description":"Queimado (Serra)","state_id":8},
{"id":7031,"description":"Queimados","state_id":19},
{"id":6505,"description":"Queimados (Guarapuava)","state_id":18},
{"id":9539,"description":"Queiroz","state_id":26},
{"id":3672,"description":"Queixada (Novo Cruzeiro)","state_id":11},
{"id":9540,"description":"Queluz","state_id":26},
{"id":3673,"description":"Queluzito","state_id":11},
{"id":3674,"description":"Quem-Quem (Janaúba)","state_id":11},
{"id":4453,"description":"Querência","state_id":13},
{"id":6506,"description":"Querência do Norte","state_id":18},
{"id":8016,"description":"Quevedos","state_id":23},
{"id":955,"description":"Quijingue","state_id":5},
{"id":8634,"description":"Quilombo","state_id":24},
{"id":8017,"description":"Quilombo (Pelotas)","state_id":23},
{"id":3675,"description":"Quilombo (Sabinópolis)","state_id":11},
{"id":12772,"description":"Quilombo Nossa Senhora Do Rosário","state_id":11},
{"id":1974,"description":"Quilômetro 14 do Mutum (Baixo Guandu)","state_id":8},
{"id":8635,"description":"Quilômetro Doze (Itajaí)","state_id":24},
{"id":1631,"description":"Quimami (Missão Velha)","state_id":6},
{"id":1632,"description":"Quincoé (Acopiara)","state_id":6},
{"id":1633,"description":"Quincuncá (Farias Brito)","state_id":6},
{"id":8018,"description":"Quinta (Rio Grande)","state_id":23},
{"id":6507,"description":"Quinta do Sol","state_id":18},
{"id":9541,"description":"Quintana","state_id":26},
{"id":3676,"description":"Quintinos (Carmo do Paranaíba)","state_id":11},
{"id":8019,"description":"Quintão (Palmares do Sul)","state_id":23},
{"id":12581,"description":"Quinze De Novembro","state_id":23},
{"id":8020,"description":"Quinze de Novembro","state_id":23},
{"id":6508,"description":"Quinzópolis (Santa Mariana)","state_id":18},
{"id":5400,"description":"Quipapá","state_id":16},
{"id":2293,"description":"Quirinópolis","state_id":9},
{"id":9542,"description":"Quiririm (Taubaté)","state_id":26},
{"id":7032,"description":"Quissamã","state_id":19},
{"id":1634,"description":"Quitaiús (Lavras da Mangabeira)","state_id":6},
{"id":6509,"description":"Quitandinha","state_id":18},
{"id":1635,"description":"Quiterianópolis","state_id":6},
{"id":5401,"description":"Quitimbu (Custódia)","state_id":16},
{"id":8021,"description":"Quitéria (São Jerônimo)","state_id":23},
{"id":957,"description":"Quixabeira","state_id":5},
{"id":5045,"description":"Quixabá","state_id":15},
{"id":5402,"description":"Quixabá","state_id":16},
{"id":956,"description":"Quixabá (Morpará)","state_id":5},
{"id":1636,"description":"Quixadá","state_id":6},
{"id":5046,"description":"Quixadá (Uiraúna)","state_id":15},
{"id":1637,"description":"Quixariú (Campos Sales)","state_id":6},
{"id":1638,"description":"Quixelô","state_id":6},
{"id":1639,"description":"Quixeramobim","state_id":6},
{"id":1640,"description":"Quixeré","state_id":6},
{"id":1641,"description":"Quixoá (Iguatu)","state_id":6},
{"id":11818,"description":"Rafael","state_id":16},
{"id":11827,"description":"Rafael","state_id":16},
{"id":7244,"description":"Rafael Fernandes","state_id":20},
{"id":7245,"description":"Rafael Godeiro","state_id":20},
{"id":958,"description":"Rafael Jambeiro","state_id":5},
{"id":9543,"description":"Rafard","state_id":26},
{"id":1642,"description":"Raimundo Martins (Santa Quitéria)","state_id":6},
{"id":12457,"description":"Rainha Do Mar","state_id":23},
{"id":5403,"description":"Rainha Isabel (Bom Conselho)","state_id":16},
{"id":11807,"description":"Raiz","state_id":16},
{"id":5404,"description":"Rajada (Petrolina)","state_id":16},
{"id":12770,"description":"Ramadinha","state_id":6},
{"id":6510,"description":"Ramilândia","state_id":18},
{"id":9544,"description":"Rancharia","state_id":26},
{"id":5405,"description":"Rancharia (Araripina)","state_id":16},
{"id":4454,"description":"Rancharia (Nova Brasilândia)","state_id":13},
{"id":12779,"description":"Ranchinho","state_id":23},
{"id":6511,"description":"Rancho Alegre","state_id":18},
{"id":6512,"description":"Rancho Alegre d'Oeste","state_id":18},
{"id":8636,"description":"Rancho Queimado","state_id":24},
{"id":8022,"description":"Rancho Velho (Palmares do Sul)","state_id":23},
{"id":11728,"description":"Rangel","state_id":16},
{"id":2551,"description":"Raposa","state_id":10},
{"id":7033,"description":"Raposo (Itaperuna)","state_id":19},
{"id":3677,"description":"Raposos","state_id":11},
{"id":12413,"description":"Raspador","state_id":5},
{"id":8637,"description":"Ratones (Florianópolis)","state_id":24},
{"id":3678,"description":"Raul Soares","state_id":11},
{"id":3679,"description":"Ravena (Sabará)","state_id":11},
{"id":11634,"description":"Realejo","state_id":6},
{"id":6513,"description":"Realeza","state_id":18},
{"id":3680,"description":"Realeza (Manhuaçu)","state_id":11},
{"id":6514,"description":"Rebouças","state_id":18},
{"id":1790,"description":"Recanto das Emas","state_id":7},
{"id":9545,"description":"Rechan (Itapetininga)","state_id":26},
{"id":5406,"description":"Recife","state_id":16},
{"id":959,"description":"Recife (Jussara)","state_id":5},
{"id":3681,"description":"Recreio","state_id":11},
{"id":9926,"description":"Recursolândia","state_id":27},
{"id":8023,"description":"Redentora","state_id":23},
{"id":1643,"description":"Redenção","state_id":6},
{"id":4754,"description":"Redenção","state_id":14},
{"id":9546,"description":"Redenção da Serra","state_id":26},
{"id":5674,"description":"Redenção do Gurguéia","state_id":17},
{"id":3682,"description":"Reduto","state_id":11},
{"id":8024,"description":"Refugiado (Vacaria)","state_id":23},
{"id":5675,"description":"Regeneração","state_id":17},
{"id":9547,"description":"Regente Feijó","state_id":26},
{"id":9548,"description":"Reginópolis","state_id":26},
{"id":9549,"description":"Registro","state_id":26},
{"id":2294,"description":"Registro do Araguaia (Montes Claros de Goiás)","state_id":9},
{"id":6515,"description":"Região dos Valos (Telêmaco Borba)","state_id":18},
{"id":1975,"description":"Regência (Linhares)","state_id":8},
{"id":6516,"description":"Reianópolis (Sengés)","state_id":18},
{"id":8025,"description":"Relvado","state_id":23},
{"id":960,"description":"Remanso","state_id":5},
{"id":4755,"description":"Remansão (Tucuruí)","state_id":14},
{"id":961,"description":"Remédios (Novo Horizonte)","state_id":5},
{"id":5047,"description":"Remígio","state_id":15},
{"id":6517,"description":"Renascença","state_id":18},
{"id":7034,"description":"Renascença (Santa Maria Madalena)","state_id":19},
{"id":260,"description":"Repartimento (Maués)","state_id":3},
{"id":4756,"description":"Repartimento (Tucuruí)","state_id":14},
{"id":1644,"description":"Reriutaba","state_id":6},
{"id":7035,"description":"Resende","state_id":19},
{"id":3683,"description":"Resende Costa","state_id":11},
{"id":6518,"description":"Reserva","state_id":18},
{"id":4455,"description":"Reserva do Cabaçal","state_id":13},
{"id":6519,"description":"Reserva do Iguaçu","state_id":18},
{"id":8638,"description":"Residência Fuck (Monte Castelo)","state_id":24},
{"id":2552,"description":"Resplandes (Barra do Corda)","state_id":10},
{"id":3684,"description":"Resplendor","state_id":11},
{"id":12572,"description":"Ressaca Do Buriti","state_id":23},
{"id":3685,"description":"Ressaquinha","state_id":11},
{"id":9550,"description":"Restinga","state_id":26},
{"id":8026,"description":"Restinga Seca","state_id":23},
{"id":8027,"description":"Restinga Seca (Santo Ângelo)","state_id":23},
{"id":11637,"description":"Retiro","state_id":2},
{"id":11795,"description":"Retiro","state_id":2},
{"id":6520,"description":"Retiro (Castro)","state_id":18},
{"id":6521,"description":"Retiro Grande (Campo Largo)","state_id":18},
{"id":12773,"description":"Retiro Velho","state_id":11},
{"id":7036,"description":"Retiro do Muriaé (Itaperuna)","state_id":19},
{"id":962,"description":"Retirolândia","state_id":5},
{"id":3686,"description":"Riachinho","state_id":11},
{"id":9927,"description":"Riachinho","state_id":27},
{"id":1976,"description":"Riacho (Aracruz)","state_id":8},
{"id":11804,"description":"Riacho Do Meio","state_id":16},
{"id":5409,"description":"Riacho Fechado (Tacaimbó)","state_id":16},
{"id":5676,"description":"Riacho Frio","state_id":17},
{"id":1791,"description":"Riacho Fundo","state_id":7},
{"id":157,"description":"Riacho Fundo de Cima (Palmeira dos Índios)","state_id":2},
{"id":1646,"description":"Riacho Grande (Araripe)","state_id":6},
{"id":9551,"description":"Riacho Grande (São Bernardo do Campo)","state_id":26},
{"id":5410,"description":"Riacho Pequeno (Belém de São Francisco)","state_id":16},
{"id":968,"description":"Riacho Seco (Curaçá)","state_id":5},
{"id":11585,"description":"Riacho Verde","state_id":6},
{"id":1647,"description":"Riacho Verde (Várzea Alegre)","state_id":6},
{"id":1648,"description":"Riacho Vermelho (Iguatu)","state_id":6},
{"id":7246,"description":"Riacho da Cruz","state_id":20},
{"id":3687,"description":"Riacho da Cruz (Januária)","state_id":11},
{"id":966,"description":"Riacho da Guia (Alagoinhas)","state_id":5},
{"id":5407,"description":"Riacho das Almas","state_id":16},
{"id":967,"description":"Riacho de Santana","state_id":5},
{"id":7247,"description":"Riacho de Santana","state_id":20},
{"id":5050,"description":"Riacho de Santo Antônio","state_id":15},
{"id":5408,"description":"Riacho do Meio (São José do Egito)","state_id":16},
{"id":156,"description":"Riacho do Sertão (Major Isidoro)","state_id":2},
{"id":5051,"description":"Riacho dos Cavalos","state_id":15},
{"id":3688,"description":"Riacho dos Machados","state_id":11},
{"id":8832,"description":"Riachuelo","state_id":25},
{"id":7248,"description":"Riachuelo","state_id":20},
{"id":2553,"description":"Riachão","state_id":10},
{"id":5048,"description":"Riachão","state_id":15},
{"id":11638,"description":"Riachão","state_id":2},
{"id":963,"description":"Riachão das Neves","state_id":5},
{"id":1645,"description":"Riachão do Banabuiú (Pedra Branca)","state_id":6},
{"id":8831,"description":"Riachão do Dantas","state_id":25},
{"id":964,"description":"Riachão do Jacuípe","state_id":5},
{"id":5049,"description":"Riachão do Poço","state_id":15},
{"id":965,"description":"Riachão do Utinga (Utinga)","state_id":5},
{"id":10144,"description":"Rialma","state_id":9},
{"id":7037,"description":"Rialto (Barra Mansa)","state_id":19},
{"id":2295,"description":"Rianápolis","state_id":9},
{"id":2554,"description":"Ribamar Fiquene","state_id":10},
{"id":4237,"description":"Ribas do Rio Pardo","state_id":12},
{"id":9552,"description":"Ribeira","state_id":26},
{"id":5052,"description":"Ribeira (Santa Rita)","state_id":15},
{"id":969,"description":"Ribeira do Amparo","state_id":5},
{"id":5677,"description":"Ribeira do Piauí","state_id":17},
{"id":970,"description":"Ribeira do Pombal","state_id":5},
{"id":5678,"description":"Ribeiro Gonçalves","state_id":17},
{"id":3692,"description":"Ribeiro Junqueira (Leopoldina)","state_id":11},
{"id":9561,"description":"Ribeiro do Vale (Guararapes)","state_id":26},
{"id":9562,"description":"Ribeiro dos Santos (Olímpia)","state_id":26},
{"id":3693,"description":"Ribeiros (São Gonçalo do Sapucaí)","state_id":11},
{"id":5411,"description":"Ribeirão","state_id":16},
{"id":2555,"description":"Ribeirão Azul (São Francisco do Maranhão)","state_id":10},
{"id":9553,"description":"Ribeirão Bonito","state_id":26},
{"id":6522,"description":"Ribeirão Bonito (Grandes Rios)","state_id":18},
{"id":9554,"description":"Ribeirão Branco","state_id":26},
{"id":4456,"description":"Ribeirão Cascalheira","state_id":13},
{"id":6523,"description":"Ribeirão Claro","state_id":18},
{"id":9555,"description":"Ribeirão Corrente","state_id":26},
{"id":11607,"description":"Ribeirão Da Folha","state_id":11},
{"id":9558,"description":"Ribeirão Grande","state_id":26},
{"id":8640,"description":"Ribeirão Pequeno (Laguna)","state_id":24},
{"id":9559,"description":"Ribeirão Pires","state_id":26},
{"id":9560,"description":"Ribeirão Preto","state_id":26},
{"id":3691,"description":"Ribeirão Vermelho","state_id":11},
{"id":8639,"description":"Ribeirão da Ilha (Florianópolis)","state_id":24},
{"id":3689,"description":"Ribeirão das Neves","state_id":11},
{"id":3690,"description":"Ribeirão de São Domingos (Santa Margarida)","state_id":11},
{"id":7038,"description":"Ribeirão de São Joaquim (Quatis)","state_id":19},
{"id":1977,"description":"Ribeirão do Cristo (Alfredo Chaves)","state_id":8},
{"id":971,"description":"Ribeirão do Largo","state_id":5},
{"id":6524,"description":"Ribeirão do Pinhal","state_id":18},
{"id":6525,"description":"Ribeirão do Pinheiro (Castro)","state_id":18},
{"id":972,"description":"Ribeirão do Salto (Itarantim)","state_id":5},
{"id":9556,"description":"Ribeirão do Sul","state_id":26},
{"id":4457,"description":"Ribeirão dos Cocais (Nossa Senhora do Livramento)","state_id":13},
{"id":9557,"description":"Ribeirão dos Índios","state_id":26},
{"id":4458,"description":"Ribeirãozinho","state_id":13},
{"id":8833,"description":"Ribeirópolis","state_id":25},
{"id":9563,"description":"Rifaina","state_id":26},
{"id":1649,"description":"Rinaré (Banabuiú)","state_id":6},
{"id":12536,"description":"Rincao Dos Pintos","state_id":23},
{"id":9564,"description":"Rincão","state_id":26},
{"id":12618,"description":"Rincão Comprido","state_id":23},
{"id":12605,"description":"Rincão Comprido","state_id":23},
{"id":12527,"description":"Rincão Da Estrela","state_id":23},
{"id":11876,"description":"Rincão De São Miguel","state_id":23},
{"id":8029,"description":"Rincão Del Rei (Rio Pardo)","state_id":23},
{"id":12542,"description":"Rincão Do Appel","state_id":23},
{"id":12636,"description":"Rincão Do Ivaí","state_id":23},
{"id":12783,"description":"Rincão Doce","state_id":23},
{"id":8033,"description":"Rincão Doce (Não-Me-Toque)","state_id":23},
{"id":12582,"description":"Rincão Dos Mellos","state_id":23},
{"id":12570,"description":"Rincão Dos Meoti","state_id":23},
{"id":12579,"description":"Rincão Dos Moraes","state_id":23},
{"id":12556,"description":"Rincão Dos Paivas","state_id":23},
{"id":12571,"description":"Rincão Dos Roratos","state_id":23},
{"id":12632,"description":"Rincão Dos Toledos","state_id":23},
{"id":12583,"description":"Rincão Maciel","state_id":23},
{"id":8036,"description":"Rincão Vermelho (Roque Gonzales)","state_id":23},
{"id":8028,"description":"Rincão de São Pedro (São Luiz Gonzaga)","state_id":23},
{"id":8030,"description":"Rincão do Cristóvão Pereira (Mostardas)","state_id":23},
{"id":8031,"description":"Rincão do Meio (São Borja)","state_id":23},
{"id":8032,"description":"Rincão do Segredo (Carazinho)","state_id":23},
{"id":8034,"description":"Rincão dos Kroeff (São Francisco de Paula)","state_id":23},
{"id":8035,"description":"Rincão dos Mendes (Santo Ângelo)","state_id":23},
{"id":9565,"description":"Rinópolis","state_id":26},
{"id":6526,"description":"Rio Abaixo (Castro)","state_id":18},
{"id":3694,"description":"Rio Acima","state_id":11},
{"id":8641,"description":"Rio Antinha (Petrolândia)","state_id":24},
{"id":6527,"description":"Rio Azul","state_id":18},
{"id":8037,"description":"Rio Azul (Aratiba)","state_id":23},
{"id":1978,"description":"Rio Bananal","state_id":8},
{"id":6528,"description":"Rio Bom","state_id":18},
{"id":7039,"description":"Rio Bonito","state_id":19},
{"id":12781,"description":"Rio Bonito","state_id":23},
{"id":6529,"description":"Rio Bonito (Francisco Alves)","state_id":18},
{"id":8642,"description":"Rio Bonito (Ituporanga)","state_id":24},
{"id":6530,"description":"Rio Bonito do Iguaçu","state_id":18},
{"id":4459,"description":"Rio Branco","state_id":13},
{"id":16,"description":"Rio Branco","state_id":1},
{"id":8038,"description":"Rio Branco (Nova Prata)","state_id":23},
{"id":6531,"description":"Rio Branco do Ivaí","state_id":18},
{"id":6532,"description":"Rio Branco do Sul","state_id":18},
{"id":4238,"description":"Rio Brilhante","state_id":12},
{"id":1979,"description":"Rio Calcado (Guarapari)","state_id":8},
{"id":3695,"description":"Rio Casca","state_id":11},
{"id":7040,"description":"Rio Claro","state_id":19},
{"id":9566,"description":"Rio Claro","state_id":26},
{"id":6533,"description":"Rio Claro do Sul (Mallet)","state_id":18},
{"id":7356,"description":"Rio Crespo","state_id":21},
{"id":8643,"description":"Rio D'Una (Imaruí)","state_id":24},
{"id":12456,"description":"Rio Do Terra","state_id":23},
{"id":3698,"description":"Rio Doce","state_id":11},
{"id":11796,"description":"Rio Dos Bichos","state_id":2},
{"id":3699,"description":"Rio Espera","state_id":11},
{"id":5413,"description":"Rio Formoso","state_id":16},
{"id":8653,"description":"Rio Fortuna","state_id":24},
{"id":979,"description":"Rio Fundo (Terra Nova)","state_id":5},
{"id":8041,"description":"Rio Grande","state_id":23},
{"id":9568,"description":"Rio Grande da Serra","state_id":26},
{"id":5679,"description":"Rio Grande do Piauí","state_id":17},
{"id":158,"description":"Rio Largo","state_id":2},
{"id":8654,"description":"Rio Maina (Criciúma)","state_id":24},
{"id":3700,"description":"Rio Manso","state_id":11},
{"id":4460,"description":"Rio Manso (Nova Brasilândia)","state_id":13},
{"id":4757,"description":"Rio Maria","state_id":14},
{"id":3701,"description":"Rio Melo (Rio Espera)","state_id":11},
{"id":1980,"description":"Rio Muqui (Itapemirim)","state_id":8},
{"id":8655,"description":"Rio Negrinho","state_id":24},
{"id":4239,"description":"Rio Negro","state_id":12},
{"id":6543,"description":"Rio Negro","state_id":18},
{"id":3702,"description":"Rio Novo","state_id":11},
{"id":6544,"description":"Rio Novo (Cascavel)","state_id":18},
{"id":6545,"description":"Rio Novo (Reserva)","state_id":18},
{"id":1981,"description":"Rio Novo do Sul","state_id":8},
{"id":3703,"description":"Rio Paranaíba","state_id":11},
{"id":8042,"description":"Rio Pardinho (Santa Cruz do Sul)","state_id":23},
{"id":8043,"description":"Rio Pardo","state_id":23},
{"id":3704,"description":"Rio Pardo de Minas","state_id":11},
{"id":6546,"description":"Rio Pinheiro (Mariópolis)","state_id":18},
{"id":3705,"description":"Rio Piracicaba","state_id":11},
{"id":3706,"description":"Rio Pomba","state_id":11},
{"id":3707,"description":"Rio Pretinho (Teófilo Otoni)","state_id":11},
{"id":3708,"description":"Rio Preto","state_id":11},
{"id":1982,"description":"Rio Preto (Nova Venécia)","state_id":8},
{"id":261,"description":"Rio Preto da Eva","state_id":3},
{"id":8656,"description":"Rio Preto do Sul (Mafra)","state_id":24},
{"id":6547,"description":"Rio Quatorze (Francisco Beltrão)","state_id":18},
{"id":2297,"description":"Rio Quente","state_id":9},
{"id":980,"description":"Rio Real","state_id":5},
{"id":8657,"description":"Rio Rufino","state_id":24},
{"id":6548,"description":"Rio Saltinho (Cascavel)","state_id":18},
{"id":6549,"description":"Rio Saudade (Francisco Beltrão)","state_id":18},
{"id":9930,"description":"Rio Sono","state_id":27},
{"id":8044,"description":"Rio Telha (Ibiaçá)","state_id":23},
{"id":8045,"description":"Rio Tigre (Sananduva)","state_id":23},
{"id":5053,"description":"Rio Tinto","state_id":15},
{"id":8046,"description":"Rio Toldo (Getúlio Vargas)","state_id":23},
{"id":2298,"description":"Rio Verde","state_id":9},
{"id":6550,"description":"Rio Verde (Juranda)","state_id":18},
{"id":4240,"description":"Rio Verde de Mato Grosso","state_id":12},
{"id":3709,"description":"Rio Vermelho","state_id":11},
{"id":4758,"description":"Rio Vermelho (Xinguara)","state_id":14},
{"id":12037,"description":"Rio Xv De Baixo","state_id":18},
{"id":8644,"description":"Rio da Anta (Itaiópolis)","state_id":24},
{"id":5412,"description":"Rio da Barra (Sertânia)","state_id":16},
{"id":9928,"description":"Rio da Conceição","state_id":27},
{"id":973,"description":"Rio da Dona (Conceição do Almeida)","state_id":5},
{"id":8039,"description":"Rio da Ilha (Taquara)","state_id":23},
{"id":8645,"description":"Rio da Luz (Jaraguá do Sul)","state_id":24},
{"id":6535,"description":"Rio da Prata (Nova Laranjeiras)","state_id":18},
{"id":6534,"description":"Rio da Prata (Santa Izabel do Oeste)","state_id":18},
{"id":8646,"description":"Rio das Antas","state_id":24},
{"id":6536,"description":"Rio das Antas (Cascavel)","state_id":18},
{"id":7041,"description":"Rio das Flores","state_id":19},
{"id":8647,"description":"Rio das Furnas (Orleans)","state_id":24},
{"id":6537,"description":"Rio das Mortes (Guarapuava)","state_id":18},
{"id":3696,"description":"Rio das Mortes (São João Del Rei)","state_id":11},
{"id":7042,"description":"Rio das Ostras","state_id":19},
{"id":9567,"description":"Rio das Pedras","state_id":26},
{"id":6538,"description":"Rio das Pedras (Guarapuava)","state_id":18},
{"id":6539,"description":"Rio das Pedras (Paranaguá)","state_id":18},
{"id":6540,"description":"Rio das Pombas (Paranaguá)","state_id":18},
{"id":974,"description":"Rio de Contas","state_id":5},
{"id":7043,"description":"Rio de Janeiro","state_id":19},
{"id":975,"description":"Rio do Antônio","state_id":5},
{"id":976,"description":"Rio do Braço (Ilhéus)","state_id":5},
{"id":8648,"description":"Rio do Campo","state_id":24},
{"id":7249,"description":"Rio do Fogo","state_id":20},
{"id":6541,"description":"Rio do Mato (Francisco Beltrão)","state_id":18},
{"id":977,"description":"Rio do Meio (Itororó)","state_id":5},
{"id":8649,"description":"Rio do Oeste","state_id":24},
{"id":978,"description":"Rio do Pires","state_id":5},
{"id":3697,"description":"Rio do Prado","state_id":11},
{"id":6542,"description":"Rio do Salto (Cascavel)","state_id":18},
{"id":8650,"description":"Rio do Sul","state_id":24},
{"id":9929,"description":"Rio dos Bois","state_id":27},
{"id":8651,"description":"Rio dos Bugres (Ituporanga)","state_id":24},
{"id":8652,"description":"Rio dos Cedros","state_id":24},
{"id":8040,"description":"Rio dos Índios","state_id":23},
{"id":7044,"description":"Riograndina (Nova Friburgo)","state_id":19},
{"id":9569,"description":"Riolândia","state_id":26},
{"id":4461,"description":"Riolândia (Nova Brasilândia)","state_id":13},
{"id":8047,"description":"Riozinho","state_id":23},
{"id":7357,"description":"Riozinho (Cacoal)","state_id":21},
{"id":4759,"description":"Riozinho (Itaituba)","state_id":14},
{"id":8658,"description":"Riqueza","state_id":24},
{"id":3710,"description":"Ritápolis","state_id":11},
{"id":1983,"description":"Rive (Alegre)","state_id":8},
{"id":2299,"description":"Riverlândia (Rio Verde)","state_id":9},
{"id":9570,"description":"Riversul","state_id":26},
{"id":9571,"description":"Roberto (Pindorama)","state_id":26},
{"id":6551,"description":"Roberto Silveira (Umuarama)","state_id":18},
{"id":8048,"description":"Roca Sales","state_id":23},
{"id":2556,"description":"Rocado (Pastos Bons)","state_id":10},
{"id":159,"description":"Rocha Cavalcante (União dos Palmares)","state_id":2},
{"id":4241,"description":"Rochedinho (Campo Grande)","state_id":12},
{"id":4242,"description":"Rochedo","state_id":12},
{"id":3713,"description":"Rochedo de Minas","state_id":11},
{"id":11344,"description":"Roda Velha","state_id":5},
{"id":3714,"description":"Rodeador (Monjolos)","state_id":11},
{"id":8659,"description":"Rodeio","state_id":24},
{"id":8049,"description":"Rodeio Bonito","state_id":23},
{"id":3715,"description":"Rodeiro","state_id":11},
{"id":981,"description":"Rodelas","state_id":5},
{"id":7250,"description":"Rodolfo Fernandes","state_id":20},
{"id":3716,"description":"Rodrigo Silva (Ouro Preto)","state_id":11},
{"id":17,"description":"Rodrigues Alves","state_id":1},
{"id":8050,"description":"Rolador","state_id":23},
{"id":8051,"description":"Rolante","state_id":23},
{"id":8052,"description":"Rolantinho da Figueira (Rolante)","state_id":23},
{"id":1650,"description":"Roldão (Morada Nova)","state_id":6},
{"id":7358,"description":"Rolim de Moura","state_id":21},
{"id":6554,"description":"Rolândia","state_id":18},
{"id":3717,"description":"Romaria","state_id":11},
{"id":8660,"description":"Romelândia","state_id":24},
{"id":6555,"description":"Romeópolis (Arapuã)","state_id":18},
{"id":6556,"description":"Roncador","state_id":18},
{"id":8053,"description":"Ronda Alta","state_id":23},
{"id":8054,"description":"Rondinha","state_id":23},
{"id":12243,"description":"Rondinha","state_id":18},
{"id":6557,"description":"Rondinha (Guarapuava)","state_id":18},
{"id":10093,"description":"Rondolândia","state_id":13},
{"id":6558,"description":"Rondon","state_id":18},
{"id":4760,"description":"Rondon do Pará","state_id":14},
{"id":4462,"description":"Rondonópolis","state_id":13},
{"id":2557,"description":"Roque (Pinheiro)","state_id":10},
{"id":8055,"description":"Roque Gonzales","state_id":23},
{"id":7384,"description":"Rorainópolis","state_id":22},
{"id":7045,"description":"Rosal (Bom Jesus do Itabapoana)","state_id":19},
{"id":2301,"description":"Rosalândia (São Luís de Montes Belos)","state_id":9},
{"id":9573,"description":"Rosana","state_id":26},
{"id":9574,"description":"Roseira","state_id":26},
{"id":3721,"description":"Roseiral (Mutum)","state_id":11},
{"id":9572,"description":"Rosália (Marília)","state_id":26},
{"id":2558,"description":"Rosário","state_id":10},
{"id":8056,"description":"Rosário (Augusto Pestana)","state_id":23},
{"id":7251,"description":"Rosário (João Dias)","state_id":20},
{"id":4463,"description":"Rosário Oeste","state_id":13},
{"id":3718,"description":"Rosário da Limeira","state_id":11},
{"id":3719,"description":"Rosário de Minas (Juiz de Fora)","state_id":11},
{"id":8834,"description":"Rosário do Catete","state_id":25},
{"id":6559,"description":"Rosário do Ivaí","state_id":18},
{"id":3720,"description":"Rosário do Pontal (Ponte Nova)","state_id":11},
{"id":8057,"description":"Rosário do Sul","state_id":23},
{"id":160,"description":"Roteiro","state_id":2},
{"id":3711,"description":"Roça Grande (São João Nepomuceno)","state_id":11},
{"id":6552,"description":"Roça Velha (Ponta Grossa)","state_id":18},
{"id":6553,"description":"Roça Velha (São José dos Pinhais)","state_id":18},
{"id":3712,"description":"Roças Novas (Caeté)","state_id":11},
{"id":5054,"description":"Rua Nova (Belém)","state_id":15},
{"id":3722,"description":"Rubelita","state_id":11},
{"id":2302,"description":"Rubiataba","state_id":9},
{"id":3723,"description":"Rubim","state_id":11},
{"id":9577,"description":"Rubinéia","state_id":26},
{"id":9575,"description":"Rubiácea","state_id":26},
{"id":9576,"description":"Rubião Júnior (Botucatu)","state_id":26},
{"id":9578,"description":"Ruilândia (Mirassol)","state_id":26},
{"id":12039,"description":"Ruralminas","state_id":11},
{"id":4761,"description":"Rurópolis","state_id":14},
{"id":1651,"description":"Russas","state_id":6},
{"id":982,"description":"Ruy Barbosa","state_id":5},
{"id":7252,"description":"Ruy Barbosa","state_id":20},
{"id":3724,"description":"Sabará","state_id":11},
{"id":9579,"description":"Sabaúna (Mogi das Cruzes)","state_id":26},
{"id":1652,"description":"Sabiaguaba (Amontada)","state_id":6},
{"id":9580,"description":"Sabino","state_id":26},
{"id":3725,"description":"Sabinópolis","state_id":11},
{"id":1653,"description":"Saboeiro","state_id":6},
{"id":6560,"description":"Sabáudia","state_id":18},
{"id":11765,"description":"Sacambu","state_id":3},
{"id":7046,"description":"Sacra Família do Tinguá (Engenheiro Paulo de Frontin)","state_id":19},
{"id":3726,"description":"Sacramento","state_id":11},
{"id":1654,"description":"Sacramento (Ipaporanga)","state_id":6},
{"id":8058,"description":"Sagrada Família","state_id":23},
{"id":1984,"description":"Sagrada Família (Alfredo Chaves)","state_id":8},
{"id":6561,"description":"Sagrada Família (Planalto)","state_id":18},
{"id":9581,"description":"Sagres","state_id":26},
{"id":8661,"description":"Sai (São Francisco do Sul)","state_id":24},
{"id":8059,"description":"Saicã (Cacequi)","state_id":23},
{"id":5414,"description":"Sairé","state_id":16},
{"id":983,"description":"Saldanha (Pilão Arcado)","state_id":5},
{"id":8060,"description":"Saldanha Marinho","state_id":23},
{"id":5055,"description":"Salema (Rio Tinto)","state_id":15},
{"id":9582,"description":"Sales","state_id":26},
{"id":9583,"description":"Sales Oliveira","state_id":26},
{"id":9584,"description":"Salesópolis","state_id":26},
{"id":8662,"description":"Salete","state_id":24},
{"id":5056,"description":"Salgadinho","state_id":15},
{"id":5415,"description":"Salgadinho","state_id":16},
{"id":8835,"description":"Salgado","state_id":25},
{"id":12681,"description":"Salgado Dos Machados","state_id":6},
{"id":6562,"description":"Salgado Filho","state_id":18},
{"id":5057,"description":"Salgado de São Félix","state_id":15},
{"id":984,"description":"Salgadália (Conceição do Coité)","state_id":5},
{"id":5416,"description":"Salgueiro","state_id":16},
{"id":3727,"description":"Salinas","state_id":11},
{"id":985,"description":"Salinas da Margarida","state_id":5},
{"id":4762,"description":"Salinópolis","state_id":14},
{"id":1656,"description":"Salitre","state_id":6},
{"id":3728,"description":"Salitre de Minas (Patrocínio)","state_id":11},
{"id":6563,"description":"Salles de Oliveira (Campina da Lagoa)","state_id":18},
{"id":9585,"description":"Salmourão","state_id":26},
{"id":986,"description":"Salobrinho (Ilhéus)","state_id":5},
{"id":987,"description":"Salobro (Canarana)","state_id":5},
{"id":5418,"description":"Salobro (Pesqueira)","state_id":16},
{"id":5417,"description":"Saloá","state_id":16},
{"id":8663,"description":"Saltinho","state_id":24},
{"id":9586,"description":"Saltinho","state_id":26},
{"id":12684,"description":"Saltinho","state_id":18},
{"id":8061,"description":"Saltinho (Itatiba do Sul)","state_id":23},
{"id":8062,"description":"Saltinho (Rodeio Bonito)","state_id":23},
{"id":6564,"description":"Saltinho do Oeste (Alto Piquiri)","state_id":18},
{"id":9587,"description":"Salto","state_id":26},
{"id":8063,"description":"Salto (Ijuí)","state_id":23},
{"id":9590,"description":"Salto Grande","state_id":26},
{"id":6567,"description":"Salto Portão (Cascavel)","state_id":18},
{"id":8664,"description":"Salto Veloso","state_id":24},
{"id":3729,"description":"Salto da Divisa","state_id":11},
{"id":9588,"description":"Salto de Pirapora","state_id":26},
{"id":9589,"description":"Salto do Avanhandava (José Bonifácio)","state_id":26},
{"id":4464,"description":"Salto do Céu","state_id":13},
{"id":6565,"description":"Salto do Itararé","state_id":18},
{"id":8064,"description":"Salto do Jacuí","state_id":23},
{"id":6566,"description":"Salto do Lontra","state_id":18},
{"id":7047,"description":"Salutaris (Paraíba do Sul)","state_id":19},
{"id":7253,"description":"Salva Vida (Martins)","state_id":20},
{"id":988,"description":"Salvador","state_id":5},
{"id":8065,"description":"Salvador das Missões","state_id":23},
{"id":8066,"description":"Salvador do Sul","state_id":23},
{"id":4763,"description":"Salvaterra","state_id":14},
{"id":1655,"description":"Salão (Senador Sá)","state_id":6},
{"id":1792,"description":"Samambaia","state_id":7},
{"id":6568,"description":"Samambaia (Guarapuava)","state_id":18},
{"id":8836,"description":"Samambaia (Tobias Barreto)","state_id":25},
{"id":7048,"description":"Sambaetiba (Itaboraí)","state_id":19},
{"id":2559,"description":"Sambaíba","state_id":10},
{"id":1657,"description":"Sambaíba (Granja)","state_id":6},
{"id":989,"description":"Sambaíba (Itapicuru)","state_id":5},
{"id":12471,"description":"Sampaio","state_id":23},
{"id":9931,"description":"Sampaio","state_id":27},
{"id":7049,"description":"Sampaio Correia (Saquarema)","state_id":19},
{"id":7050,"description":"Sana (Macaé)","state_id":19},
{"id":8067,"description":"Sananduva","state_id":23},
{"id":3730,"description":"Sanatório Santa Fé (Três Corações)","state_id":11},
{"id":2303,"description":"Sanclerlândia","state_id":9},
{"id":9932,"description":"Sandolândia","state_id":27},
{"id":9591,"description":"Sandovalina","state_id":26},
{"id":12446,"description":"Sanga Funda","state_id":23},
{"id":4243,"description":"Sanga Puitã (Ponta Porã)","state_id":12},
{"id":8665,"description":"Sanga da Toca (Araranguá)","state_id":24},
{"id":4465,"description":"Sangradouro (Barra do Garças)","state_id":13},
{"id":8666,"description":"Sangão","state_id":24},
{"id":5419,"description":"Sanharó","state_id":16},
{"id":8068,"description":"Sant'auta (Camaquã)","state_id":23},
{"id":9592,"description":"Santa Adélia","state_id":26},
{"id":9593,"description":"Santa Albertina","state_id":26},
{"id":6569,"description":"Santa Amélia","state_id":18},
{"id":9594,"description":"Santa América (Getulina)","state_id":26},
{"id":1658,"description":"Santa Ana (Pacoti)","state_id":6},
{"id":1985,"description":"Santa Angélica (Alegre)","state_id":8},
{"id":9596,"description":"Santa Branca","state_id":26},
{"id":991,"description":"Santa Brígida","state_id":5},
{"id":3731,"description":"Santa Bárbara","state_id":11},
{"id":990,"description":"Santa Bárbara","state_id":5},
{"id":12510,"description":"Santa Bárbara","state_id":23},
{"id":12101,"description":"Santa Bárbara","state_id":18},
{"id":8069,"description":"Santa Bárbara (Caçapava do Sul)","state_id":23},
{"id":8070,"description":"Santa Bárbara (São Valentim do Sul)","state_id":23},
{"id":9595,"description":"Santa Bárbara D'Oeste","state_id":26},
{"id":2304,"description":"Santa Bárbara de Goiás","state_id":9},
{"id":3732,"description":"Santa Bárbara do Leste","state_id":11},
{"id":3733,"description":"Santa Bárbara do Monte Verde","state_id":11},
{"id":4764,"description":"Santa Bárbara do Pará","state_id":14},
{"id":8071,"description":"Santa Bárbara do Sul","state_id":23},
{"id":3734,"description":"Santa Bárbara do Tugúrio","state_id":11},
{"id":4466,"description":"Santa Carmem","state_id":13},
{"id":8072,"description":"Santa Catarina (Salvador das Missões)","state_id":23},
{"id":10861,"description":"Santa Cecília","state_id":22},
{"id":8667,"description":"Santa Cecília","state_id":24},
{"id":5058,"description":"Santa Cecília de Umbuzeiro","state_id":15},
{"id":6570,"description":"Santa Cecília do Pavão","state_id":18},
{"id":8073,"description":"Santa Cecília do Sul","state_id":23},
{"id":6571,"description":"Santa Clara (Castro)","state_id":18},
{"id":7051,"description":"Santa Clara (Porciúncula)","state_id":19},
{"id":9597,"description":"Santa Clara D'Oeste","state_id":26},
{"id":12740,"description":"Santa Clara Do Monte Cristo","state_id":13},
{"id":8074,"description":"Santa Clara do Ingaí (Quinze de Novembro)","state_id":23},
{"id":8075,"description":"Santa Clara do Sul","state_id":23},
{"id":8076,"description":"Santa Cristina (Parobé)","state_id":23},
{"id":5059,"description":"Santa Cruz","state_id":15},
{"id":5420,"description":"Santa Cruz","state_id":16},
{"id":7254,"description":"Santa Cruz","state_id":20},
{"id":11983,"description":"Santa Cruz","state_id":21},
{"id":1986,"description":"Santa Cruz (Aracruz)","state_id":8},
{"id":10429,"description":"Santa Cruz (Campo Largo)","state_id":18},
{"id":8077,"description":"Santa Cruz (Planalto)","state_id":23},
{"id":7052,"description":"Santa Cruz (Santo Antônio de Pádua)","state_id":19},
{"id":992,"description":"Santa Cruz Cabrália","state_id":5},
{"id":3735,"description":"Santa Cruz da Aparecida (Monte Belo)","state_id":11},
{"id":5421,"description":"Santa Cruz da Baixa Verde","state_id":16},
{"id":9598,"description":"Santa Cruz da Conceição","state_id":26},
{"id":8078,"description":"Santa Cruz da Concórdia (Taquara)","state_id":23},
{"id":9599,"description":"Santa Cruz da Esperança","state_id":26},
{"id":9600,"description":"Santa Cruz da Estrela (Santa Rita do Passa Quatro)","state_id":26},
{"id":7053,"description":"Santa Cruz da Serra (Duque de Caxias)","state_id":19},
{"id":993,"description":"Santa Cruz da Vitória","state_id":5},
{"id":2305,"description":"Santa Cruz das Lajes (Rio Verde)","state_id":9},
{"id":9601,"description":"Santa Cruz das Palmeiras","state_id":26},
{"id":3736,"description":"Santa Cruz de Botumirim (Botumirim)","state_id":11},
{"id":2306,"description":"Santa Cruz de Goiás","state_id":9},
{"id":10107,"description":"Santa Cruz de Irupi (Irupi)","state_id":8},
{"id":3737,"description":"Santa Cruz de Minas","state_id":11},
{"id":6572,"description":"Santa Cruz de Monte Castelo","state_id":18},
{"id":3738,"description":"Santa Cruz de Salinas","state_id":11},
{"id":4765,"description":"Santa Cruz do Arari","state_id":14},
{"id":5422,"description":"Santa Cruz do Capibaribe","state_id":16},
{"id":3739,"description":"Santa Cruz do Escalvado","state_id":11},
{"id":5680,"description":"Santa Cruz do Piauí","state_id":17},
{"id":3740,"description":"Santa Cruz do Prata (Guaranésia)","state_id":11},
{"id":9602,"description":"Santa Cruz do Rio Pardo","state_id":26},
{"id":8079,"description":"Santa Cruz do Sul","state_id":23},
{"id":8668,"description":"Santa Cruz do Timbó (Porto União)","state_id":24},
{"id":10098,"description":"Santa Cruz do Xingu","state_id":13},
{"id":9603,"description":"Santa Cruz dos Lopes (Itararé)","state_id":26},
{"id":5681,"description":"Santa Cruz dos Milagres","state_id":17},
{"id":161,"description":"Santa Efigênia (Capela)","state_id":2},
{"id":3742,"description":"Santa Efigênia (Caratinga)","state_id":11},
{"id":3743,"description":"Santa Efigênia de Minas","state_id":11},
{"id":6573,"description":"Santa Eliza (Umuarama)","state_id":18},
{"id":4467,"description":"Santa Elvira (Juscimeira)","state_id":13},
{"id":12469,"description":"Santa Emília","state_id":23},
{"id":9604,"description":"Santa Ernestina","state_id":26},
{"id":6574,"description":"Santa Esmeralda (Santa Cruz de Monte Castelo)","state_id":18},
{"id":9605,"description":"Santa Eudóxia (São Carlos)","state_id":26},
{"id":1660,"description":"Santa Felícia (Acopiara)","state_id":6},
{"id":5423,"description":"Santa Filomena","state_id":16},
{"id":5682,"description":"Santa Filomena","state_id":17},
{"id":3745,"description":"Santa Filomena (Santana do Manhuaçu)","state_id":11},
{"id":2560,"description":"Santa Filomena do Maranhão","state_id":10},
{"id":8080,"description":"Santa Flora (Santa Maria)","state_id":23},
{"id":6575,"description":"Santa Fé","state_id":18},
{"id":11943,"description":"Santa Fé","state_id":6},
{"id":1659,"description":"Santa Fé (Crato)","state_id":6},
{"id":4468,"description":"Santa Fé (São José dos Quatro Marcos)","state_id":13},
{"id":7255,"description":"Santa Fé (Várzea)","state_id":20},
{"id":2307,"description":"Santa Fé de Goiás","state_id":9},
{"id":3744,"description":"Santa Fé de Minas","state_id":11},
{"id":9933,"description":"Santa Fé do Araguaia","state_id":27},
{"id":6576,"description":"Santa Fé do Pirapó (Marialva)","state_id":18},
{"id":9606,"description":"Santa Fé do Sul","state_id":26},
{"id":12615,"description":"Santa Gema","state_id":23},
{"id":9607,"description":"Santa Gertrudes","state_id":26},
{"id":5060,"description":"Santa Gertrudes (Patos)","state_id":15},
{"id":2561,"description":"Santa Helena","state_id":10},
{"id":8669,"description":"Santa Helena","state_id":24},
{"id":5061,"description":"Santa Helena","state_id":15},
{"id":6577,"description":"Santa Helena","state_id":18},
{"id":8670,"description":"Santa Helena (Joaçaba)","state_id":24},
{"id":2308,"description":"Santa Helena de Goiás","state_id":9},
{"id":3746,"description":"Santa Helena de Minas","state_id":11},
{"id":2562,"description":"Santa Inês","state_id":10},
{"id":5062,"description":"Santa Inês","state_id":15},
{"id":994,"description":"Santa Inês","state_id":5},
{"id":6578,"description":"Santa Inês","state_id":18},
{"id":8081,"description":"Santa Inês (São Luiz Gonzaga)","state_id":23},
{"id":2309,"description":"Santa Isabel","state_id":9},
{"id":9608,"description":"Santa Isabel","state_id":26},
{"id":3747,"description":"Santa Isabel (Betim)","state_id":11},
{"id":7054,"description":"Santa Isabel (São Gonçalo)","state_id":19},
{"id":6579,"description":"Santa Isabel do Ivaí","state_id":18},
{"id":9609,"description":"Santa Isabel do Marinheiro (Pedranópolis)","state_id":26},
{"id":4766,"description":"Santa Isabel do Pará","state_id":14},
{"id":262,"description":"Santa Isabel do Rio Negro","state_id":3},
{"id":7055,"description":"Santa Isabel do Rio Preto (Valença)","state_id":19},
{"id":8671,"description":"Santa Izabel (São Joaquim)","state_id":24},
{"id":6580,"description":"Santa Izabel do Oeste","state_id":18},
{"id":8082,"description":"Santa Izabel do Sul (Arroio Grande)","state_id":23},
{"id":3748,"description":"Santa Juliana","state_id":11},
{"id":1987,"description":"Santa Júlia (São Roque do Canaã)","state_id":8},
{"id":1988,"description":"Santa Leopoldina","state_id":8},
{"id":6582,"description":"Santa Lurdes (Cambé)","state_id":18},
{"id":5683,"description":"Santa Luz","state_id":17},
{"id":3749,"description":"Santa Luzia","state_id":11},
{"id":2563,"description":"Santa Luzia","state_id":10},
{"id":5063,"description":"Santa Luzia","state_id":15},
{"id":995,"description":"Santa Luzia","state_id":5},
{"id":11101,"description":"Santa Luzia","state_id":23},
{"id":12711,"description":"Santa Luzia","state_id":6},
{"id":11805,"description":"Santa Luzia","state_id":16},
{"id":8086,"description":"Santa Luzia (Lagoa Vermelha)","state_id":23},
{"id":1661,"description":"Santa Luzia (Uruburetama)","state_id":6},
{"id":7359,"description":"Santa Luzia D'Oeste","state_id":21},
{"id":6583,"description":"Santa Luzia da Alvorada (São João do Ivaí)","state_id":18},
{"id":3750,"description":"Santa Luzia da Serra (João Pinheiro)","state_id":11},
{"id":1989,"description":"Santa Luzia de Mantenópolis (Mantenópolis)","state_id":8},
{"id":1990,"description":"Santa Luzia do Azul (Água Doce do Norte)","state_id":8},
{"id":5064,"description":"Santa Luzia do Cariri (Serra Branca)","state_id":15},
{"id":8837,"description":"Santa Luzia do Itanhy","state_id":25},
{"id":162,"description":"Santa Luzia do Norte","state_id":2},
{"id":1991,"description":"Santa Luzia do Norte (Ecoporanga)","state_id":8},
{"id":314,"description":"Santa Luzia do Pacuí (Macapá)","state_id":4},
{"id":2564,"description":"Santa Luzia do Paruá","state_id":10},
{"id":4767,"description":"Santa Luzia do Pará","state_id":14},
{"id":8085,"description":"Santa Luíza (Carlos Barbosa)","state_id":23},
{"id":9610,"description":"Santa Lúcia","state_id":26},
{"id":6581,"description":"Santa Lúcia","state_id":18},
{"id":12626,"description":"Santa Lúcia","state_id":23},
{"id":8083,"description":"Santa Lúcia (Ijuí)","state_id":23},
{"id":8672,"description":"Santa Lúcia (Ouro)","state_id":24},
{"id":8673,"description":"Santa Lúcia (Palmitos)","state_id":24},
{"id":8084,"description":"Santa Lúcia do Piaí (Caxias do Sul)","state_id":23},
{"id":3751,"description":"Santa Margarida","state_id":11},
{"id":6584,"description":"Santa Margarida (Bela Vista do Paraíso)","state_id":18},
{"id":6585,"description":"Santa Margarida (Londrina)","state_id":18},
{"id":9611,"description":"Santa Margarida Paulista (Ferraz de Vasconcelos)","state_id":26},
{"id":10102,"description":"Santa Margarida do Sul","state_id":23},
{"id":7256,"description":"Santa Maria","state_id":20},
{"id":1793,"description":"Santa Maria","state_id":7},
{"id":8087,"description":"Santa Maria","state_id":23},
{"id":6586,"description":"Santa Maria (Alto Paraná)","state_id":18},
{"id":8674,"description":"Santa Maria (Benedito Novo)","state_id":24},
{"id":7056,"description":"Santa Maria (Campos dos Goytacazes)","state_id":19},
{"id":315,"description":"Santa Maria (Macapá)","state_id":4},
{"id":4768,"description":"Santa Maria (Maracanã)","state_id":14},
{"id":5065,"description":"Santa Maria (São João do Tigre)","state_id":15},
{"id":7057,"description":"Santa Maria Madalena","state_id":19},
{"id":5424,"description":"Santa Maria da Boa Vista","state_id":16},
{"id":9612,"description":"Santa Maria da Serra","state_id":26},
{"id":996,"description":"Santa Maria da Vitória","state_id":5},
{"id":4769,"description":"Santa Maria das Barreiras","state_id":14},
{"id":3752,"description":"Santa Maria de Itabira","state_id":11},
{"id":1992,"description":"Santa Maria de Jetibá","state_id":8},
{"id":10110,"description":"Santa Maria de Marechal (Marechal Floriano)","state_id":8},
{"id":5425,"description":"Santa Maria do Cambucá","state_id":16},
{"id":9613,"description":"Santa Maria do Gurupá (Promissão)","state_id":26},
{"id":8088,"description":"Santa Maria do Herval","state_id":23},
{"id":6587,"description":"Santa Maria do Oeste","state_id":18},
{"id":4770,"description":"Santa Maria do Pará","state_id":14},
{"id":6588,"description":"Santa Maria do Rio do Peixe (Congonhinhas)","state_id":18},
{"id":3753,"description":"Santa Maria do Salto","state_id":11},
{"id":3754,"description":"Santa Maria do Suaçuí","state_id":11},
{"id":9934,"description":"Santa Maria do Tocantins","state_id":27},
{"id":6589,"description":"Santa Mariana","state_id":18},
{"id":1993,"description":"Santa Marta (Ibitirama)","state_id":8},
{"id":9614,"description":"Santa Mercedes","state_id":26},
{"id":6590,"description":"Santa Mônica","state_id":18},
{"id":1662,"description":"Santa Quitéria","state_id":6},
{"id":6591,"description":"Santa Quitéria (Campo Largo)","state_id":18},
{"id":6592,"description":"Santa Quitéria (Castro)","state_id":18},
{"id":2565,"description":"Santa Quitéria do Maranhão","state_id":10},
{"id":2566,"description":"Santa Rita","state_id":10},
{"id":5066,"description":"Santa Rita","state_id":15},
{"id":11481,"description":"Santa Rita","state_id":11},
{"id":11539,"description":"Santa Rita","state_id":6},
{"id":12431,"description":"Santa Rita","state_id":23},
{"id":11725,"description":"Santa Rita","state_id":16},
{"id":6593,"description":"Santa Rita (Castro)","state_id":18},
{"id":4469,"description":"Santa Rita (Nobres)","state_id":13},
{"id":6594,"description":"Santa Rita (Pato Branco)","state_id":18},
{"id":263,"description":"Santa Rita (São Paulo de Olivença)","state_id":3},
{"id":5426,"description":"Santa Rita (Tuparetama)","state_id":16},
{"id":5067,"description":"Santa Rita (Uiraúna)","state_id":15},
{"id":9615,"description":"Santa Rita D'Oeste","state_id":26},
{"id":12489,"description":"Santa Rita Do Sul","state_id":23},
{"id":3765,"description":"Santa Rita Durão (Mariana)","state_id":11},
{"id":3755,"description":"Santa Rita da Estrela (Estrela do Sul)","state_id":11},
{"id":7058,"description":"Santa Rita da Floresta (Cantagalo)","state_id":19},
{"id":3756,"description":"Santa Rita de Caldas","state_id":11},
{"id":997,"description":"Santa Rita de Cássia","state_id":5},
{"id":3761,"description":"Santa Rita de Ibitipoca","state_id":11},
{"id":3757,"description":"Santa Rita de Jacutinga","state_id":11},
{"id":3758,"description":"Santa Rita de Minas","state_id":11},
{"id":3759,"description":"Santa Rita de Ouro Preto (Ouro Preto)","state_id":11},
{"id":2310,"description":"Santa Rita do Araguaia","state_id":9},
{"id":3760,"description":"Santa Rita do Cedro (Curvelo)","state_id":11},
{"id":3762,"description":"Santa Rita do Itueto","state_id":11},
{"id":2311,"description":"Santa Rita do Novo Destino","state_id":9},
{"id":6595,"description":"Santa Rita do Oeste (Terra Roxa)","state_id":18},
{"id":4244,"description":"Santa Rita do Pardo","state_id":12},
{"id":9616,"description":"Santa Rita do Passa Quatro","state_id":26},
{"id":9617,"description":"Santa Rita do Ribeira (Miracatu)","state_id":26},
{"id":3763,"description":"Santa Rita do Rio do Peixe (Ferros)","state_id":11},
{"id":3764,"description":"Santa Rita do Sapucaí","state_id":11},
{"id":8089,"description":"Santa Rita do Sul (Camaquã)","state_id":23},
{"id":9935,"description":"Santa Rita do Tocantins","state_id":27},
{"id":10094,"description":"Santa Rita do Trivelato","state_id":13},
{"id":18,"description":"Santa Rosa","state_id":1},
{"id":11522,"description":"Santa Rosa","state_id":6},
{"id":12545,"description":"Santa Rosa","state_id":23},
{"id":11719,"description":"Santa Rosa","state_id":16},
{"id":11733,"description":"Santa Rosa","state_id":16},
{"id":8090,"description":"Santa Rosa","state_id":23},
{"id":2312,"description":"Santa Rosa (Formosa)","state_id":9},
{"id":6596,"description":"Santa Rosa (Francisco Beltrão)","state_id":18},
{"id":8091,"description":"Santa Rosa (Palmares do Sul)","state_id":23},
{"id":3766,"description":"Santa Rosa da Serra","state_id":11},
{"id":4771,"description":"Santa Rosa da Vigia (Vigia)","state_id":14},
{"id":2313,"description":"Santa Rosa de Goiás","state_id":9},
{"id":8675,"description":"Santa Rosa de Lima","state_id":24},
{"id":8838,"description":"Santa Rosa de Lima","state_id":25},
{"id":3767,"description":"Santa Rosa de Lima (Montes Claros)","state_id":11},
{"id":9618,"description":"Santa Rosa de Viterbo","state_id":26},
{"id":5684,"description":"Santa Rosa do Piauí","state_id":17},
{"id":8676,"description":"Santa Rosa do Sul","state_id":24},
{"id":9936,"description":"Santa Rosa do Tocantins","state_id":27},
{"id":3768,"description":"Santa Rosa dos Dourados (Coromandel)","state_id":11},
{"id":9619,"description":"Santa Salete","state_id":26},
{"id":8092,"description":"Santa Silvana (Pelotas)","state_id":23},
{"id":1994,"description":"Santa Teresa","state_id":8},
{"id":7257,"description":"Santa Teresa (Santana do Matos)","state_id":20},
{"id":3769,"description":"Santa Teresa do Bonito (Peçanha)","state_id":11},
{"id":5068,"description":"Santa Teresinha","state_id":15},
{"id":8093,"description":"Santa Teresinha (Palmeira das Missões)","state_id":23},
{"id":9620,"description":"Santa Teresinha de Piracicaba (Piracicaba)","state_id":26},
{"id":8094,"description":"Santa Tereza","state_id":23},
{"id":12747,"description":"Santa Tereza","state_id":6},
{"id":1663,"description":"Santa Tereza (Aracati)","state_id":6},
{"id":8095,"description":"Santa Tereza (Catuípe)","state_id":23},
{"id":1664,"description":"Santa Tereza (Tauá)","state_id":6},
{"id":2314,"description":"Santa Tereza de Goiás","state_id":9},
{"id":6597,"description":"Santa Tereza do Oeste","state_id":18},
{"id":9937,"description":"Santa Tereza do Tocantins","state_id":27},
{"id":5427,"description":"Santa Terezinha","state_id":16},
{"id":8677,"description":"Santa Terezinha","state_id":24},
{"id":998,"description":"Santa Terezinha","state_id":5},
{"id":12617,"description":"Santa Terezinha","state_id":23},
{"id":4470,"description":"Santa Terezinha","state_id":13},
{"id":5069,"description":"Santa Terezinha (Campina Grande)","state_id":15},
{"id":4772,"description":"Santa Terezinha (Castanhal)","state_id":14},
{"id":1995,"description":"Santa Terezinha (Ecoporanga)","state_id":8},
{"id":4245,"description":"Santa Terezinha (Itaporã)","state_id":12},
{"id":5428,"description":"Santa Terezinha (Água Preta)","state_id":16},
{"id":12035,"description":"Santa Terezinha Do Rio Ferro","state_id":13},
{"id":2315,"description":"Santa Terezinha de Goiás","state_id":9},
{"id":6598,"description":"Santa Terezinha de Itaipu","state_id":18},
{"id":3770,"description":"Santa Terezinha de Minas (Itatiaiuçu)","state_id":11},
{"id":8678,"description":"Santa Terezinha do Progresso","state_id":24},
{"id":8679,"description":"Santa Terezinha do Salto (Lages)","state_id":24},
{"id":9938,"description":"Santa Terezinha do Tocantins","state_id":27},
{"id":3771,"description":"Santa Vitória","state_id":11},
{"id":8096,"description":"Santa Vitória do Palmar","state_id":23},
{"id":6599,"description":"Santa Zélia (Astorga)","state_id":18},
{"id":3741,"description":"Santa da Pedra (São João do Pacuí)","state_id":11},
{"id":999,"description":"Santaluz","state_id":5},
{"id":316,"description":"Santana","state_id":4},
{"id":1000,"description":"Santana","state_id":5},
{"id":11757,"description":"Santana","state_id":3},
{"id":8097,"description":"Santana (Chapada)","state_id":23},
{"id":1665,"description":"Santana (Crateús)","state_id":6},
{"id":6600,"description":"Santana (Cruz Machado)","state_id":18},
{"id":8098,"description":"Santana (Erval Grande)","state_id":23},
{"id":8099,"description":"Santana (Ijuí)","state_id":23},
{"id":8100,"description":"Santana da Boa Vista","state_id":23},
{"id":9621,"description":"Santana da Ponte Pensa","state_id":26},
{"id":3772,"description":"Santana da Vargem","state_id":11},
{"id":3773,"description":"Santana de Caldas (Caldas)","state_id":11},
{"id":3774,"description":"Santana de Cataguases","state_id":11},
{"id":5070,"description":"Santana de Mangueira","state_id":15},
{"id":9622,"description":"Santana de Parnaíba","state_id":26},
{"id":3775,"description":"Santana de Patos (Patos de Minas)","state_id":11},
{"id":3776,"description":"Santana de Pirapama","state_id":11},
{"id":5429,"description":"Santana de São Joaquim (São Joaquim do Monte)","state_id":16},
{"id":1666,"description":"Santana do Acaraú","state_id":6},
{"id":3777,"description":"Santana do Alfié (São Domingos do Prata)","state_id":11},
{"id":4773,"description":"Santana do Araguaia","state_id":14},
{"id":3778,"description":"Santana do Araçuaí (Ponto dos Volantes)","state_id":11},
{"id":3779,"description":"Santana do Campestre (Astolfo Dutra)","state_id":11},
{"id":3780,"description":"Santana do Capivari (Pouso Alto)","state_id":11},
{"id":1667,"description":"Santana do Cariri","state_id":6},
{"id":3781,"description":"Santana do Deserto","state_id":11},
{"id":3782,"description":"Santana do Garambéu","state_id":11},
{"id":163,"description":"Santana do Ipanema","state_id":2},
{"id":6601,"description":"Santana do Itararé","state_id":18},
{"id":3783,"description":"Santana do Jacaré","state_id":11},
{"id":8101,"description":"Santana do Livramento","state_id":23},
{"id":3784,"description":"Santana do Manhuaçu","state_id":11},
{"id":2567,"description":"Santana do Maranhão","state_id":10},
{"id":7258,"description":"Santana do Matos","state_id":20},
{"id":164,"description":"Santana do Mundaú","state_id":2},
{"id":3786,"description":"Santana do Paraopeba (Belo Vale)","state_id":11},
{"id":3785,"description":"Santana do Paraíso","state_id":11},
{"id":5685,"description":"Santana do Piauí","state_id":17},
{"id":3787,"description":"Santana do Riacho","state_id":11},
{"id":7259,"description":"Santana do Seridó","state_id":20},
{"id":1001,"description":"Santana do Sobrado (Casa Nova)","state_id":5},
{"id":8839,"description":"Santana do São Francisco","state_id":25},
{"id":3788,"description":"Santana do Tabuleiro (Raul Soares)","state_id":11},
{"id":5071,"description":"Santana dos Garrotes","state_id":15},
{"id":3789,"description":"Santana dos Montes","state_id":11},
{"id":4471,"description":"Santaninha (Vila Rica)","state_id":13},
{"id":7059,"description":"Santanésia (Piraí)","state_id":19},
{"id":1002,"description":"Santanópolis","state_id":5},
{"id":4774,"description":"Santarém","state_id":14},
{"id":5072,"description":"Santarém","state_id":15},
{"id":1668,"description":"Santarém (Orós)","state_id":6},
{"id":4775,"description":"Santarém Novo","state_id":14},
{"id":9623,"description":"Santelmo (Pederneiras)","state_id":26},
{"id":8102,"description":"Santiago","state_id":23},
{"id":1003,"description":"Santiago do Iguapé (Cachoeira)","state_id":5},
{"id":8680,"description":"Santiago do Sul","state_id":24},
{"id":4472,"description":"Santo Afonso","state_id":13},
{"id":5430,"description":"Santo Agostinho (Cabo de Santo Agostinho)","state_id":16},
{"id":1997,"description":"Santo Agostinho (Água Doce do Norte)","state_id":8},
{"id":7060,"description":"Santo Aleixo (Magé)","state_id":19},
{"id":2568,"description":"Santo Amaro","state_id":10},
{"id":1004,"description":"Santo Amaro","state_id":5},
{"id":11741,"description":"Santo Amaro","state_id":16},
{"id":8681,"description":"Santo Amaro da Imperatriz","state_id":24},
{"id":8840,"description":"Santo Amaro das Brotas","state_id":25},
{"id":7061,"description":"Santo Amaro de Campos (Campos dos Goytacazes)","state_id":19},
{"id":8103,"description":"Santo Amaro do Sul (General Câmara)","state_id":23},
{"id":9624,"description":"Santo Anastácio","state_id":26},
{"id":5073,"description":"Santo André","state_id":15},
{"id":9625,"description":"Santo André","state_id":26},
{"id":12146,"description":"Santo André","state_id":6},
{"id":12033,"description":"Santo Antonio Do Rio Bonito","state_id":13},
{"id":12655,"description":"Santo Antonio Dos Pinheirinhos","state_id":23},
{"id":12287,"description":"Santo Antão","state_id":23},
{"id":12612,"description":"Santo Antônio","state_id":23},
{"id":12559,"description":"Santo Antônio","state_id":23},
{"id":12473,"description":"Santo Antônio","state_id":23},
{"id":12785,"description":"Santo Antônio","state_id":5},
{"id":7260,"description":"Santo Antônio","state_id":20},
{"id":1669,"description":"Santo Antônio (Acopiara)","state_id":6},
{"id":1670,"description":"Santo Antônio (Ararendá)","state_id":6},
{"id":1998,"description":"Santo Antônio (Barra de São Francisco)","state_id":8},
{"id":1671,"description":"Santo Antônio (Barro)","state_id":6},
{"id":6602,"description":"Santo Antônio (Castro)","state_id":18},
{"id":8105,"description":"Santo Antônio (Cerro Largo)","state_id":23},
{"id":1672,"description":"Santo Antônio (Crateús)","state_id":6},
{"id":8106,"description":"Santo Antônio (Ijuí)","state_id":23},
{"id":6603,"description":"Santo Antônio (Laranjeiras do Sul)","state_id":18},
{"id":165,"description":"Santo Antônio (Palmeira dos Índios)","state_id":2},
{"id":4776,"description":"Santo Antônio (Redenção)","state_id":14},
{"id":8107,"description":"Santo Antônio (Santo Augusto)","state_id":23},
{"id":11874,"description":"Santo Antônio Da Esperança","state_id":9},
{"id":11764,"description":"Santo Antônio Do Matupi","state_id":3},
{"id":12416,"description":"Santo Antônio Do Salto","state_id":11},
{"id":9633,"description":"Santo Antônio Paulista (Ferraz de Vasconcelos)","state_id":26},
{"id":9626,"description":"Santo Antônio da Alegria","state_id":26},
{"id":2316,"description":"Santo Antônio da Barra","state_id":9},
{"id":3790,"description":"Santo Antônio da Boa Vista (São João da Ponte)","state_id":11},
{"id":9627,"description":"Santo Antônio da Estiva (Pirajuí)","state_id":26},
{"id":3791,"description":"Santo Antônio da Fortaleza (Ferros)","state_id":11},
{"id":8108,"description":"Santo Antônio da Patrulha","state_id":23},
{"id":1673,"description":"Santo Antônio da Pindoba (Ibiapina)","state_id":6},
{"id":6604,"description":"Santo Antônio da Platina","state_id":18},
{"id":3792,"description":"Santo Antônio da Vargem Alegre (Bonfim)","state_id":11},
{"id":8109,"description":"Santo Antônio das Missões","state_id":23},
{"id":5431,"description":"Santo Antônio das Queimadas (Jurema)","state_id":16},
{"id":1005,"description":"Santo Antônio de Barcelona (Caravelas)","state_id":5},
{"id":8110,"description":"Santo Antônio de Castro (Carlos Barbosa)","state_id":23},
{"id":2317,"description":"Santo Antônio de Goiás","state_id":9},
{"id":1006,"description":"Santo Antônio de Jesus","state_id":5},
{"id":5686,"description":"Santo Antônio de Lisboa","state_id":17},
{"id":8682,"description":"Santo Antônio de Lisboa (Florianópolis)","state_id":24},
{"id":9628,"description":"Santo Antônio de Posse","state_id":26},
{"id":7062,"description":"Santo Antônio de Pádua","state_id":19},
{"id":3793,"description":"Santo Antônio do Amparo","state_id":11},
{"id":9629,"description":"Santo Antônio do Aracanguá","state_id":26},
{"id":3794,"description":"Santo Antônio do Aventureiro","state_id":11},
{"id":8111,"description":"Santo Antônio do Bom Retiro (Ibirubá)","state_id":23},
{"id":3795,"description":"Santo Antônio do Boqueirão (Unaí)","state_id":11},
{"id":6605,"description":"Santo Antônio do Caiuá","state_id":18},
{"id":1999,"description":"Santo Antônio do Canaã (Santa Teresa)","state_id":8},
{"id":3796,"description":"Santo Antônio do Cruzeiro (Nepomuceno)","state_id":11},
{"id":2318,"description":"Santo Antônio do Descoberto","state_id":9},
{"id":3797,"description":"Santo Antônio do Glória (Vieiras)","state_id":11},
{"id":3798,"description":"Santo Antônio do Grama","state_id":11},
{"id":7063,"description":"Santo Antônio do Imbé (Santa Maria Madalena)","state_id":19},
{"id":6606,"description":"Santo Antônio do Iratim (Bituruna)","state_id":18},
{"id":3799,"description":"Santo Antônio do Itambé","state_id":11},
{"id":264,"description":"Santo Antônio do Içá","state_id":3},
{"id":3800,"description":"Santo Antônio do Jacinto","state_id":11},
{"id":9630,"description":"Santo Antônio do Jardim","state_id":26},
{"id":3801,"description":"Santo Antônio do Leite (Ouro Preto)","state_id":11},
{"id":10096,"description":"Santo Antônio do Leste","state_id":13},
{"id":4473,"description":"Santo Antônio do Leverger","state_id":13},
{"id":3802,"description":"Santo Antônio do Manhuaçu (Caratinga)","state_id":11},
{"id":3803,"description":"Santo Antônio do Monte","state_id":11},
{"id":3804,"description":"Santo Antônio do Mucuri (Malacacheta)","state_id":11},
{"id":2000,"description":"Santo Antônio do Muqui (Mimoso do Sul)","state_id":8},
{"id":3805,"description":"Santo Antônio do Norte (Conceição do Mato Dentro)","state_id":11},
{"id":8112,"description":"Santo Antônio do Palma","state_id":23},
{"id":6607,"description":"Santo Antônio do Palmital (Rio Bom)","state_id":18},
{"id":9631,"description":"Santo Antônio do Paranapanema (Cândido Mota)","state_id":26},
{"id":6608,"description":"Santo Antônio do Paraíso","state_id":18},
{"id":9632,"description":"Santo Antônio do Pinhal","state_id":26},
{"id":3806,"description":"Santo Antônio do Pirapetinga (Piranga)","state_id":11},
{"id":8113,"description":"Santo Antônio do Planalto","state_id":23},
{"id":7261,"description":"Santo Antônio do Potengi (São Gonçalo do Amarante)","state_id":20},
{"id":2001,"description":"Santo Antônio do Pousalegre (Boa Esperança)","state_id":8},
{"id":2002,"description":"Santo Antônio do Quinze (Nova Venécia)","state_id":8},
{"id":3807,"description":"Santo Antônio do Retiro","state_id":11},
{"id":3808,"description":"Santo Antônio do Rio Abaixo","state_id":11},
{"id":4474,"description":"Santo Antônio do Rio Bonito (Sorriso)","state_id":13},
{"id":2319,"description":"Santo Antônio do Rio Verde (Catalão)","state_id":9},
{"id":6609,"description":"Santo Antônio do Sudoeste","state_id":18},
{"id":4777,"description":"Santo Antônio do Tauá","state_id":14},
{"id":3809,"description":"Santo Antônio dos Araújos (São Sebastião do Maranhão)","state_id":11},
{"id":3810,"description":"Santo Antônio dos Campos (Divinópolis)","state_id":11},
{"id":1674,"description":"Santo Antônio dos Fernandes (Meruoca)","state_id":6},
{"id":2569,"description":"Santo Antônio dos Lopes","state_id":10},
{"id":5687,"description":"Santo Antônio dos Milagres","state_id":17},
{"id":5432,"description":"Santo Antônio dos Palmares (Palmares)","state_id":16},
{"id":8114,"description":"Santo Augusto","state_id":23},
{"id":8115,"description":"Santo Cristo","state_id":23},
{"id":7064,"description":"Santo Eduardo (Campos dos Goytacazes)","state_id":19},
{"id":1007,"description":"Santo Estevão","state_id":5},
{"id":9634,"description":"Santo Expedito","state_id":26},
{"id":8116,"description":"Santo Expedito do Sul","state_id":23},
{"id":3811,"description":"Santo Hilário (Pimenta)","state_id":11},
{"id":3812,"description":"Santo Hipólito","state_id":11},
{"id":6610,"description":"Santo Inácio","state_id":18},
{"id":8117,"description":"Santo Inácio (Bom Jesus)","state_id":23},
{"id":1008,"description":"Santo Inácio (Gentio do Ouro)","state_id":5},
{"id":5688,"description":"Santo Inácio do Piauí","state_id":17},
{"id":12116,"description":"Santo Izidoro","state_id":18},
{"id":6611,"description":"Santo Rei (Nova Cantu)","state_id":18},
{"id":8104,"description":"Santo Ângelo","state_id":23},
{"id":9636,"description":"Santos","state_id":26},
{"id":3813,"description":"Santos Dumont","state_id":11},
{"id":1996,"description":"Santíssima Trindade (Iúna)","state_id":8},
{"id":9635,"description":"Santópolis do Aguapeí","state_id":26},
{"id":1029,"description":"Sapeaçu","state_id":5},
{"id":4490,"description":"Sapezal","state_id":13},
{"id":9679,"description":"Sapezal (Paraguaçu Paulista)","state_id":26},
{"id":8180,"description":"Sapiranga","state_id":23},
{"id":8716,"description":"Sapiranga (Meleiro)","state_id":24},
{"id":1706,"description":"Sapo (Santana do Acaraú)","state_id":6},
{"id":6708,"description":"Sapopema","state_id":18},
{"id":7084,"description":"Sapucaia","state_id":19},
{"id":4807,"description":"Sapucaia","state_id":14},
{"id":173,"description":"Sapucaia (Arapiraca)","state_id":2},
{"id":174,"description":"Sapucaia (Atalaia)","state_id":2},
{"id":3944,"description":"Sapucaia (Caratinga)","state_id":11},
{"id":2027,"description":"Sapucaia (Marilândia)","state_id":8},
{"id":3945,"description":"Sapucaia de Guanhães (Guanhães)","state_id":11},
{"id":3946,"description":"Sapucaia do Norte (Galiléia)","state_id":11},
{"id":8181,"description":"Sapucaia do Sul","state_id":23},
{"id":5449,"description":"Sapucarana (Bezerros)","state_id":16},
{"id":3942,"description":"Sapucaí (Jacutinga)","state_id":11},
{"id":3943,"description":"Sapucaí-Mirim","state_id":11},
{"id":1707,"description":"Sapupara (Maranguape)","state_id":6},
{"id":5101,"description":"Sapé","state_id":15},
{"id":6707,"description":"Sapé (Tomazina)","state_id":18},
{"id":7085,"description":"Saquarema","state_id":19},
{"id":7086,"description":"Saracuruna (Duque de Caxias)","state_id":19},
{"id":12305,"description":"Saraiva","state_id":23},
{"id":8182,"description":"Sarandi","state_id":23},
{"id":6709,"description":"Sarandi","state_id":18},
{"id":2335,"description":"Sarandi (Itumbiara)","state_id":9},
{"id":6710,"description":"Sarandi (Santa Izabel do Oeste)","state_id":18},
{"id":3947,"description":"Sarandira (Juiz de Fora)","state_id":11},
{"id":9680,"description":"Sarapuí","state_id":26},
{"id":3948,"description":"Sardoá","state_id":11},
{"id":9681,"description":"Sarutaiá","state_id":26},
{"id":3949,"description":"Sarzedo","state_id":11},
{"id":175,"description":"Satuba","state_id":2},
{"id":2597,"description":"Satubinha","state_id":10},
{"id":1031,"description":"Saubara","state_id":5},
{"id":3950,"description":"Saudade (Mar de Espanha)","state_id":11},
{"id":6711,"description":"Saudade do Iguaçu","state_id":18},
{"id":8717,"description":"Saudades","state_id":24},
{"id":1032,"description":"Saudável (Brotas de Macaúbas)","state_id":5},
{"id":5450,"description":"Saué (Rio Formoso)","state_id":16},
{"id":1033,"description":"Saúde","state_id":5},
{"id":8183,"description":"Scharlau (São Leopoldo)","state_id":23},
{"id":8718,"description":"Schroeder","state_id":24},
{"id":1034,"description":"Seabra","state_id":5},
{"id":8719,"description":"Seara","state_id":24},
{"id":9682,"description":"Sebastianópolis do Sul","state_id":26},
{"id":5712,"description":"Sebastião Barros","state_id":17},
{"id":1035,"description":"Sebastião Laranjeiras","state_id":5},
{"id":5713,"description":"Sebastião Leal","state_id":17},
{"id":1708,"description":"Sebastião de Abreu (Pentecoste)","state_id":6},
{"id":7087,"description":"Sebastião de Lacerda (Vassouras)","state_id":19},
{"id":8184,"description":"Seberi","state_id":23},
{"id":8185,"description":"Seca (Caxias do Sul)","state_id":23},
{"id":6712,"description":"Sede Alvorada (Cascavel)","state_id":18},
{"id":8186,"description":"Sede Aurora (Quinze de Novembro)","state_id":23},
{"id":6713,"description":"Sede Chaparral (Toledo)","state_id":18},
{"id":12103,"description":"Sede Independência","state_id":23},
{"id":8187,"description":"Sede Nova","state_id":23},
{"id":6714,"description":"Sede Nova Sant'Ana (São Jorge d'Oeste)","state_id":18},
{"id":8720,"description":"Sede Oldemburg (Palmitos)","state_id":24},
{"id":6715,"description":"Sede Progresso (Francisco Beltrão)","state_id":18},
{"id":6716,"description":"Sede Progresso (Verê)","state_id":18},
{"id":8188,"description":"Segredo","state_id":23},
{"id":8189,"description":"Segredo (Ipê)","state_id":23},
{"id":12508,"description":"Seival","state_id":23},
{"id":8190,"description":"Seival (Bagé)","state_id":23},
{"id":8191,"description":"Selbach","state_id":23},
{"id":4491,"description":"Selma (Jaciara)","state_id":13},
{"id":6717,"description":"Selva (Londrina)","state_id":18},
{"id":4253,"description":"Selvíria","state_id":12},
{"id":3951,"description":"Sem-Peixe","state_id":11},
{"id":19,"description":"Sena Madureira","state_id":1},
{"id":2598,"description":"Senador Alexandre Costa","state_id":10},
{"id":3952,"description":"Senador Amaral","state_id":11},
{"id":2336,"description":"Senador Canedo","state_id":9},
{"id":1709,"description":"Senador Carlos Jereissati (Pacatuba)","state_id":6},
{"id":3953,"description":"Senador Cortes","state_id":11},
{"id":7281,"description":"Senador Elói de Souza","state_id":20},
{"id":3954,"description":"Senador Firmino","state_id":11},
{"id":7282,"description":"Senador Georgino Avelino","state_id":20},
{"id":20,"description":"Senador Guiomard","state_id":1},
{"id":3955,"description":"Senador José Bento","state_id":11},
{"id":4808,"description":"Senador José Porfírio","state_id":14},
{"id":2599,"description":"Senador La Rocque","state_id":10},
{"id":3956,"description":"Senador Melo Viana (Coronel Fabriciano)","state_id":11},
{"id":3957,"description":"Senador Modestino Gonçalves","state_id":11},
{"id":3958,"description":"Senador Mourão (Diamantina)","state_id":11},
{"id":1710,"description":"Senador Pompeu","state_id":6},
{"id":176,"description":"Senador Rui Palmeira","state_id":2},
{"id":8192,"description":"Senador Salgado Filho","state_id":23},
{"id":1711,"description":"Senador Sá","state_id":6},
{"id":6718,"description":"Sengés","state_id":18},
{"id":6719,"description":"Senhor Bom Jesus dos Gramados (Mariópolis)","state_id":18},
{"id":1036,"description":"Senhor do Bonfim","state_id":5},
{"id":3959,"description":"Senhora da Glória (Santo Hipólito)","state_id":11},
{"id":3960,"description":"Senhora da Penha (Fernandes Tourinho)","state_id":11},
{"id":3961,"description":"Senhora das Dores (Barbacena)","state_id":11},
{"id":3962,"description":"Senhora de Oliveira","state_id":11},
{"id":3963,"description":"Senhora do Carmo (Itabira)","state_id":11},
{"id":3964,"description":"Senhora do Porto","state_id":11},
{"id":3965,"description":"Senhora dos Remédios","state_id":11},
{"id":8193,"description":"Sentinela do Sul","state_id":23},
{"id":1037,"description":"Sento Sé","state_id":5},
{"id":8194,"description":"Serafim Schmidt (Sinimbu)","state_id":23},
{"id":8195,"description":"Serafina Corrêa","state_id":23},
{"id":3966,"description":"Sereno (Cataguases)","state_id":11},
{"id":1712,"description":"Sereno de Cima (Ocara)","state_id":6},
{"id":1038,"description":"Sergi (São Gonçalo dos Campos)","state_id":5},
{"id":3967,"description":"Sericita","state_id":11},
{"id":5102,"description":"Seridó (São Vicente do Seridó)","state_id":15},
{"id":7363,"description":"Seringueiras","state_id":21},
{"id":3968,"description":"Seritinga","state_id":11},
{"id":7088,"description":"Seropédica","state_id":19},
{"id":2028,"description":"Serra","state_id":8},
{"id":8721,"description":"Serra Alta","state_id":24},
{"id":9683,"description":"Serra Azul","state_id":26},
{"id":3969,"description":"Serra Azul (Mateus Leme)","state_id":11},
{"id":3970,"description":"Serra Azul de Minas","state_id":11},
{"id":3971,"description":"Serra Bonita (Buritis)","state_id":11},
{"id":5104,"description":"Serra Branca","state_id":15},
{"id":5451,"description":"Serra Branca (Ipubi)","state_id":16},
{"id":7283,"description":"Serra Caiada","state_id":20},
{"id":11748,"description":"Serra Da Cachoeira","state_id":16},
{"id":11798,"description":"Serra Da Massa","state_id":2},
{"id":11323,"description":"Serra Do Navio","state_id":4},
{"id":12782,"description":"Serra Do Pontão","state_id":23},
{"id":1041,"description":"Serra Dourada","state_id":5},
{"id":2337,"description":"Serra Dourada (Fazenda Nova)","state_id":9},
{"id":5106,"description":"Serra Grande","state_id":15},
{"id":1042,"description":"Serra Grande (Cícero Dantas)","state_id":5},
{"id":1043,"description":"Serra Grande (Valença)","state_id":5},
{"id":9684,"description":"Serra Negra","state_id":26},
{"id":11702,"description":"Serra Negra","state_id":16},
{"id":6721,"description":"Serra Negra (Guaraqueçaba)","state_id":18},
{"id":7287,"description":"Serra Negra do Norte","state_id":20},
{"id":3979,"description":"Serra Nova (Rio Pardo de Minas)","state_id":11},
{"id":4492,"description":"Serra Nova Dourada","state_id":13},
{"id":2029,"description":"Serra Pelada (Afonso Cláudio)","state_id":8},
{"id":4809,"description":"Serra Pelada (Marabá)","state_id":14},
{"id":1044,"description":"Serra Preta","state_id":5},
{"id":5107,"description":"Serra Redonda","state_id":15},
{"id":5453,"description":"Serra Talhada","state_id":16},
{"id":1039,"description":"Serra da Canabrava (Uauá)","state_id":5},
{"id":3972,"description":"Serra da Canastra (São Roque de Minas)","state_id":11},
{"id":177,"description":"Serra da Mandioca (Palmeira dos Índios)","state_id":2},
{"id":5105,"description":"Serra da Raiz","state_id":15},
{"id":3973,"description":"Serra da Saudade","state_id":11},
{"id":7284,"description":"Serra da Tapuia (Sítio Novo)","state_id":20},
{"id":3974,"description":"Serra das Araras (São Francisco)","state_id":11},
{"id":7285,"description":"Serra de São Bento","state_id":20},
{"id":3975,"description":"Serra do Camapuã (Entre Rios de Minas)","state_id":11},
{"id":1713,"description":"Serra do Félix (Beberibe)","state_id":6},
{"id":7286,"description":"Serra do Mel","state_id":20},
{"id":320,"description":"Serra do Navio (Macapá)","state_id":4},
{"id":1040,"description":"Serra do Ramalho","state_id":5},
{"id":3976,"description":"Serra do Salitre","state_id":11},
{"id":178,"description":"Serra do São José (Palmeira dos Índios)","state_id":2},
{"id":5452,"description":"Serra do Vento (Belo Jardim)","state_id":16},
{"id":3977,"description":"Serra dos Aimorés","state_id":11},
{"id":6720,"description":"Serra dos Dourados (Umuarama)","state_id":18},
{"id":8197,"description":"Serra dos Gregórios (Esmeralda)","state_id":23},
{"id":3978,"description":"Serra dos Lemes (Cabo Verde)","state_id":11},
{"id":1714,"description":"Serragem (Ocara)","state_id":6},
{"id":9685,"description":"Serrana","state_id":26},
{"id":3980,"description":"Serrania","state_id":11},
{"id":2600,"description":"Serrano do Maranhão","state_id":10},
{"id":3982,"description":"Serranos","state_id":11},
{"id":2338,"description":"Serranópolis","state_id":9},
{"id":3981,"description":"Serranópolis de Minas","state_id":11},
{"id":6722,"description":"Serranópolis do Iguaçu","state_id":18},
{"id":5108,"description":"Serraria","state_id":15},
{"id":6723,"description":"Serraria Klas (Ponta Grossa)","state_id":18},
{"id":7288,"description":"Serrinha","state_id":20},
{"id":1045,"description":"Serrinha","state_id":5},
{"id":10409,"description":"Serrinha (Bom Jesus do Itabapoana)","state_id":19},
{"id":6724,"description":"Serrinha (Cambé)","state_id":18},
{"id":6725,"description":"Serrinha (Campo Mourão)","state_id":18},
{"id":7089,"description":"Serrinha (Campos dos Goytacazes)","state_id":19},
{"id":6726,"description":"Serrinha (Castro)","state_id":18},
{"id":8198,"description":"Serrinha (São Luiz Gonzaga)","state_id":23},
{"id":11730,"description":"Serrinha Da Prata","state_id":16},
{"id":11179,"description":"Serrinha Velha","state_id":23},
{"id":7289,"description":"Serrinha dos Pintos","state_id":20},
{"id":5454,"description":"Serrita","state_id":16},
{"id":3983,"description":"Serro","state_id":11},
{"id":1046,"description":"Serrolândia","state_id":5},
{"id":5455,"description":"Serrolândia (Ipubi)","state_id":16},
{"id":1715,"description":"Serrota (Barro)","state_id":6},
{"id":1716,"description":"Serrota (Senador Sá)","state_id":6},
{"id":1717,"description":"Serrote (Iguatu)","state_id":6},
{"id":1718,"description":"Serrote (São Gonçalo do Amarante)","state_id":6},
{"id":11843,"description":"Serrote Do Urubu","state_id":16},
{"id":11829,"description":"Serrote Dos Bois De Cima","state_id":16},
{"id":6727,"description":"Sertaneja","state_id":18},
{"id":6728,"description":"Sertanópolis","state_id":18},
{"id":5456,"description":"Sertânia","state_id":16},
{"id":8199,"description":"Sertão","state_id":23},
{"id":8200,"description":"Sertão Santana","state_id":23},
{"id":5109,"description":"Sertãozinho","state_id":15},
{"id":9686,"description":"Sertãozinho","state_id":26},
{"id":8201,"description":"Sertãozinho (Alpestre)","state_id":23},
{"id":3984,"description":"Sertãozinho (Borda da Mata)","state_id":11},
{"id":6729,"description":"Sertãozinho (Engenheiro Beltrão)","state_id":18},
{"id":5457,"description":"Sertãozinho de Baixo (Maraial)","state_id":16},
{"id":9687,"description":"Sete Barras","state_id":26},
{"id":3985,"description":"Sete Cachoeiras (Ferros)","state_id":11},
{"id":3986,"description":"Sete Lagoas","state_id":11},
{"id":8205,"description":"Sete Lagoas (Itatiba do Sul)","state_id":23},
{"id":7090,"description":"Sete Pontes (São Gonçalo)","state_id":19},
{"id":4254,"description":"Sete Quedas","state_id":12},
{"id":6731,"description":"Sete Saltos de Cima (Ponta Grossa)","state_id":18},
{"id":8202,"description":"Sete de Setembro","state_id":23},
{"id":8203,"description":"Sete de Setembro (Erval Grande)","state_id":23},
{"id":8204,"description":"Sete de Setembro (Santa Rosa)","state_id":23},
{"id":3987,"description":"Setubinha","state_id":11},
{"id":7290,"description":"Severiano Melo","state_id":20},
{"id":8206,"description":"Severiano de Almeida","state_id":23},
{"id":9688,"description":"Severínia","state_id":26},
{"id":8723,"description":"Siderópolis","state_id":24},
{"id":4255,"description":"Sidrolândia","state_id":12},
{"id":5714,"description":"Sigefredo Pacheco","state_id":17},
{"id":3988,"description":"Silva Campos (Pompéu)","state_id":11},
{"id":7091,"description":"Silva Jardim","state_id":19},
{"id":8207,"description":"Silva Jardim (Serafina Corrêa)","state_id":23},
{"id":3989,"description":"Silva Xavier (Sete Lagoas)","state_id":11},
{"id":3990,"description":"Silvano (Patrocínio)","state_id":11},
{"id":9945,"description":"Silvanópolis","state_id":27},
{"id":8208,"description":"Silveira (São José dos Ausentes)","state_id":23},
{"id":3991,"description":"Silveira Carvalho (Barão de Monte Alto)","state_id":11},
{"id":8209,"description":"Silveira Martins","state_id":23},
{"id":9690,"description":"Silveiras","state_id":26},
{"id":3992,"description":"Silveirânia","state_id":11},
{"id":269,"description":"Silves","state_id":3},
{"id":3993,"description":"Silvestre (Viçosa)","state_id":11},
{"id":3994,"description":"Silvianópolis","state_id":11},
{"id":6732,"description":"Silvolândia (Campo Mourão)","state_id":18},
{"id":2339,"description":"Silvânia","state_id":9},
{"id":9689,"description":"Silvânia (Matão)","state_id":26},
{"id":2340,"description":"Simolândia","state_id":9},
{"id":9692,"description":"Simonsen (Votuporanga)","state_id":26},
{"id":3997,"description":"Simonésia","state_id":11},
{"id":5716,"description":"Simplício Mendes","state_id":17},
{"id":12192,"description":"Simão","state_id":6},
{"id":3995,"description":"Simão Campos (São João da Ponte)","state_id":11},
{"id":8847,"description":"Simão Dias","state_id":25},
{"id":3996,"description":"Simão Pereira","state_id":11},
{"id":5715,"description":"Simões","state_id":17},
{"id":9691,"description":"Simões (Cafelândia)","state_id":26},
{"id":1047,"description":"Simões Filho","state_id":5},
{"id":8210,"description":"Sinimbu","state_id":23},
{"id":4493,"description":"Sinop","state_id":13},
{"id":6733,"description":"Siqueira Belo (Barracão)","state_id":18},
{"id":6734,"description":"Siqueira Campos","state_id":18},
{"id":5458,"description":"Siriji (São Vicente Ferrer)","state_id":16},
{"id":5459,"description":"Sirinhaém","state_id":16},
{"id":8848,"description":"Siriri","state_id":25},
{"id":1719,"description":"Sitiá (Banabuiú)","state_id":6},
{"id":1721,"description":"Siupê (São Gonçalo do Amarante)","state_id":6},
{"id":1054,"description":"Soares (América Dourada)","state_id":5},
{"id":8213,"description":"Sobradinho","state_id":23},
{"id":1795,"description":"Sobradinho","state_id":7},
{"id":1055,"description":"Sobradinho","state_id":5},
{"id":5110,"description":"Sobrado","state_id":15},
{"id":1722,"description":"Sobral","state_id":6},
{"id":3998,"description":"Sobral Pinto (Astolfo Dutra)","state_id":11},
{"id":2030,"description":"Sobreiro (Laranja da Terra)","state_id":8},
{"id":3999,"description":"Sobrália","state_id":11},
{"id":6735,"description":"Socavão (Castro)","state_id":18},
{"id":9693,"description":"Socorro","state_id":26},
{"id":6736,"description":"Socorro (Guarapuava)","state_id":18},
{"id":5717,"description":"Socorro do Piauí","state_id":17},
{"id":7092,"description":"Sodrelândia (Trajano de Morais)","state_id":19},
{"id":9694,"description":"Sodrélia (Santa Cruz do Rio Pardo)","state_id":26},
{"id":8214,"description":"Soledade","state_id":23},
{"id":5112,"description":"Soledade","state_id":15},
{"id":1723,"description":"Soledade (Itapagé)","state_id":6},
{"id":4000,"description":"Soledade de Minas","state_id":11},
{"id":9695,"description":"Solemar (Praia Grande)","state_id":26},
{"id":5461,"description":"Solidão","state_id":16},
{"id":1724,"description":"Solonópole","state_id":6},
{"id":5111,"description":"Solânea","state_id":15},
{"id":8724,"description":"Sombrio","state_id":24},
{"id":4494,"description":"Sonho Azul (Mirassol D'Oeste)","state_id":13},
{"id":4256,"description":"Sonora","state_id":12},
{"id":2031,"description":"Sooretama","state_id":8},
{"id":4001,"description":"Sopa (Diamantina)","state_id":11},
{"id":9696,"description":"Sorocaba","state_id":26},
{"id":8725,"description":"Sorocaba do Sul (Biguaçu)","state_id":24},
{"id":4495,"description":"Sorriso","state_id":13},
{"id":5113,"description":"Sossego","state_id":15},
{"id":12573,"description":"Sossego","state_id":23},
{"id":7093,"description":"Sossego (Santa Maria Madalena)","state_id":19},
{"id":4810,"description":"Soure","state_id":14},
{"id":5114,"description":"Sousa","state_id":15},
{"id":9697,"description":"Sousas (Campinas)","state_id":26},
{"id":2342,"description":"Sousânia (Anápolis)","state_id":9},
{"id":12646,"description":"Souto Neto","state_id":23},
{"id":1056,"description":"Souto Soares","state_id":5},
{"id":8215,"description":"Souza Ramos (Getúlio Vargas)","state_id":23},
{"id":11521,"description":"Souzalândia","state_id":9},
{"id":1725,"description":"Suassurana (Iguatu)","state_id":6},
{"id":7094,"description":"Subaio (Cachoeiras de Macacu)","state_id":19},
{"id":1057,"description":"Subaúma (Entre Rios)","state_id":5},
{"id":10117,"description":"Sucanga (Poté)","state_id":11},
{"id":1726,"description":"Sucatinga (Beberibe)","state_id":6},
{"id":1727,"description":"Sucesso (Tamboril)","state_id":6},
{"id":9947,"description":"Sucupira","state_id":27},
{"id":2602,"description":"Sucupira do Norte","state_id":10},
{"id":2603,"description":"Sucupira do Riachão","state_id":10},
{"id":321,"description":"Sucuriju (Amapá)","state_id":4},
{"id":5115,"description":"Sucuru (Serra Branca)","state_id":15},
{"id":9698,"description":"Sud Mennucci","state_id":26},
{"id":9699,"description":"Suinana (Altair)","state_id":26},
{"id":8726,"description":"Sul Brasil","state_id":24},
{"id":6737,"description":"Sulina","state_id":18},
{"id":9700,"description":"Sumaré","state_id":26},
{"id":6738,"description":"Sumaré (Paranavaí)","state_id":18},
{"id":7095,"description":"Sumidouro","state_id":19},
{"id":4496,"description":"Sumidouro (Diamantino)","state_id":13},
{"id":5116,"description":"Sumé","state_id":15},
{"id":5462,"description":"Surubim","state_id":16},
{"id":7096,"description":"Suruí (Magé)","state_id":19},
{"id":8216,"description":"Suspiro (São Gabriel)","state_id":23},
{"id":1728,"description":"Sussuanha (Guaraciaba do Norte)","state_id":6},
{"id":5718,"description":"Sussuapara","state_id":17},
{"id":1058,"description":"Sussuarana (Tanhaçu)","state_id":5},
{"id":6739,"description":"Sussui (Engenheiro Beltrão)","state_id":18},
{"id":9701,"description":"Sussui (Palmital)","state_id":26},
{"id":6740,"description":"Sutis (Londrina)","state_id":18},
{"id":9703,"description":"Suzano","state_id":26},
{"id":9702,"description":"Suzanápolis","state_id":26},
{"id":1030,"description":"Sátiro Dias","state_id":5},
{"id":1675,"description":"São Bartolomeu (Cariús)","state_id":6},
{"id":3814,"description":"São Bartolomeu (Ouro Preto)","state_id":11},
{"id":1676,"description":"São Benedito","state_id":6},
{"id":3815,"description":"São Benedito (Santa Luzia)","state_id":11},
{"id":9637,"description":"São Benedito da Cachoeirinha (Ituverava)","state_id":26},
{"id":9638,"description":"São Benedito das Areias (Mococa)","state_id":26},
{"id":2570,"description":"São Benedito do Rio Preto","state_id":10},
{"id":5433,"description":"São Benedito do Sul","state_id":16},
{"id":2571,"description":"São Bento","state_id":10},
{"id":5074,"description":"São Bento","state_id":15},
{"id":12546,"description":"São Bento","state_id":23},
{"id":6612,"description":"São Bento (Campo Mourão)","state_id":18},
{"id":8118,"description":"São Bento (Carazinho)","state_id":23},
{"id":3816,"description":"São Bento Abade","state_id":11},
{"id":8683,"description":"São Bento Baixo (Nova Veneza)","state_id":24},
{"id":3817,"description":"São Bento de Caldas (Santa Rita de Caldas)","state_id":11},
{"id":5075,"description":"São Bento de Pombal","state_id":15},
{"id":7262,"description":"São Bento do Norte","state_id":20},
{"id":9639,"description":"São Bento do Sapucaí","state_id":26},
{"id":8684,"description":"São Bento do Sul","state_id":24},
{"id":9939,"description":"São Bento do Tocantins","state_id":27},
{"id":7263,"description":"São Bento do Trairi","state_id":20},
{"id":5434,"description":"São Bento do Una","state_id":16},
{"id":8685,"description":"São Bernardino","state_id":24},
{"id":2572,"description":"São Bernardo","state_id":10},
{"id":11586,"description":"São Bernardo","state_id":6},
{"id":7264,"description":"São Bernardo (Luís Gomes)","state_id":20},
{"id":9640,"description":"São Bernardo do Campo","state_id":26},
{"id":9641,"description":"São Berto (Manduri)","state_id":26},
{"id":8119,"description":"São Bom Jesus (Erval Seco)","state_id":23},
{"id":8686,"description":"São Bonifácio","state_id":24},
{"id":8120,"description":"São Borja","state_id":23},
{"id":6613,"description":"São Braz (Cascavel)","state_id":18},
{"id":3819,"description":"São Braz (Lagamar)","state_id":11},
{"id":6614,"description":"São Braz (Pato Branco)","state_id":18},
{"id":5689,"description":"São Braz do Piauí","state_id":17},
{"id":166,"description":"São Brás","state_id":2},
{"id":3818,"description":"São Brás do Suaçuí","state_id":11},
{"id":12656,"description":"São Caetano","state_id":23},
{"id":4778,"description":"São Caetano de Odivelas","state_id":14},
{"id":5435,"description":"São Caetano do Navio (Betânia)","state_id":16},
{"id":9642,"description":"São Caetano do Sul","state_id":26},
{"id":5436,"description":"São Caitano","state_id":16},
{"id":6615,"description":"São Camilo (Palotina)","state_id":18},
{"id":8687,"description":"São Carlos","state_id":24},
{"id":9643,"description":"São Carlos","state_id":26},
{"id":11446,"description":"São Carlos","state_id":21},
{"id":8121,"description":"São Carlos (Rosário do Sul)","state_id":23},
{"id":6616,"description":"São Carlos do Ivaí","state_id":18},
{"id":6617,"description":"São Cirilo (Castro)","state_id":18},
{"id":6618,"description":"São Clemente (Santa Helena)","state_id":18},
{"id":6619,"description":"São Cristovão (Paranavaí)","state_id":18},
{"id":4475,"description":"São Cristovão (Sinop)","state_id":13},
{"id":6620,"description":"São Cristovão (União da Vitória)","state_id":18},
{"id":8841,"description":"São Cristóvão","state_id":25},
{"id":8688,"description":"São Cristóvão (Três Barras)","state_id":24},
{"id":8689,"description":"São Cristóvão do Sul","state_id":24},
{"id":3820,"description":"São Cândido (Caratinga)","state_id":11},
{"id":8690,"description":"São Defende (Criciúma)","state_id":24},
{"id":1009,"description":"São Desidério","state_id":5},
{"id":8691,"description":"São Domingos","state_id":24},
{"id":2320,"description":"São Domingos","state_id":9},
{"id":1010,"description":"São Domingos","state_id":5},
{"id":8842,"description":"São Domingos","state_id":25},
{"id":6621,"description":"São Domingos (Apucarana)","state_id":18},
{"id":5437,"description":"São Domingos (Brejo da Madre de Deus)","state_id":16},
{"id":1677,"description":"São Domingos (Caridade)","state_id":6},
{"id":6622,"description":"São Domingos (Cruzmaltina)","state_id":18},
{"id":3821,"description":"São Domingos (Santo Antônio do Aventureiro)","state_id":11},
{"id":6623,"description":"São Domingos (União da Vitória)","state_id":18},
{"id":3822,"description":"São Domingos da Bocaina (Lima Duarte)","state_id":11},
{"id":3823,"description":"São Domingos das Dores","state_id":11},
{"id":5076,"description":"São Domingos de Pombal","state_id":15},
{"id":4779,"description":"São Domingos do Araguaia","state_id":14},
{"id":2573,"description":"São Domingos do Azeitão","state_id":10},
{"id":4780,"description":"São Domingos do Capim","state_id":14},
{"id":5077,"description":"São Domingos do Cariri","state_id":15},
{"id":2574,"description":"São Domingos do Maranhão","state_id":10},
{"id":2003,"description":"São Domingos do Norte","state_id":8},
{"id":3824,"description":"São Domingos do Prata","state_id":11},
{"id":8122,"description":"São Domingos do Sul","state_id":23},
{"id":1011,"description":"São Felipe","state_id":5},
{"id":1678,"description":"São Felipe (Brejo Santo)","state_id":6},
{"id":265,"description":"São Felipe (São Gabriel da Cachoeira)","state_id":3},
{"id":7360,"description":"São Felipe D'Oeste","state_id":21},
{"id":7265,"description":"São Fernando","state_id":20},
{"id":7065,"description":"São Fidélis","state_id":19},
{"id":3826,"description":"São Francisco","state_id":11},
{"id":9644,"description":"São Francisco","state_id":26},
{"id":5078,"description":"São Francisco","state_id":15},
{"id":8843,"description":"São Francisco","state_id":25},
{"id":8123,"description":"São Francisco (Cerro Largo)","state_id":23},
{"id":6624,"description":"São Francisco (Chopinzinho)","state_id":18},
{"id":6625,"description":"São Francisco (Guarapuava)","state_id":18},
{"id":1680,"description":"São Francisco (Meruoca)","state_id":6},
{"id":1679,"description":"São Francisco (Quiterianópolis)","state_id":6},
{"id":2004,"description":"São Francisco (São Domingos do Norte)","state_id":8},
{"id":6626,"description":"São Francisco (Umuarama)","state_id":18},
{"id":4782,"description":"São Francisco (Xinguara)","state_id":14},
{"id":11734,"description":"São Francisco Do Brígida","state_id":16},
{"id":9646,"description":"São Francisco Xavier (São José dos Campos)","state_id":26},
{"id":2005,"description":"São Francisco Xavier do Guandu (Afonso Cláudio)","state_id":8},
{"id":4783,"description":"São Francisco da Jararaca (Muaná)","state_id":14},
{"id":9645,"description":"São Francisco da Praia (São Sebastião)","state_id":26},
{"id":8124,"description":"São Francisco de Assis","state_id":23},
{"id":5691,"description":"São Francisco de Assis do Piauí","state_id":17},
{"id":2321,"description":"São Francisco de Goiás","state_id":9},
{"id":6627,"description":"São Francisco de Imbaú (Congonhinhas)","state_id":18},
{"id":7066,"description":"São Francisco de Itabapoana","state_id":19},
{"id":8125,"description":"São Francisco de Paula","state_id":23},
{"id":3827,"description":"São Francisco de Paula","state_id":11},
{"id":3828,"description":"São Francisco de Sales","state_id":11},
{"id":6628,"description":"São Francisco de Sales (Clevelândia)","state_id":18},
{"id":2576,"description":"São Francisco do Brejão","state_id":10},
{"id":1014,"description":"São Francisco do Conde","state_id":5},
{"id":3829,"description":"São Francisco do Glória","state_id":11},
{"id":7361,"description":"São Francisco do Guaporé","state_id":21},
{"id":3830,"description":"São Francisco do Humaitá (Mutum)","state_id":11},
{"id":2577,"description":"São Francisco do Maranhão","state_id":10},
{"id":7266,"description":"São Francisco do Oeste","state_id":20},
{"id":4784,"description":"São Francisco do Pará","state_id":14},
{"id":5692,"description":"São Francisco do Piauí","state_id":17},
{"id":8692,"description":"São Francisco do Sul","state_id":24},
{"id":1012,"description":"São Félix","state_id":5},
{"id":2575,"description":"São Félix de Balsas","state_id":10},
{"id":3825,"description":"São Félix de Minas","state_id":11},
{"id":4477,"description":"São Félix do Araguaia","state_id":13},
{"id":1013,"description":"São Félix do Coribe","state_id":5},
{"id":5690,"description":"São Félix do Piauí","state_id":17},
{"id":9940,"description":"São Félix do Tocantins","state_id":27},
{"id":4781,"description":"São Félix do Xingu","state_id":14},
{"id":1015,"description":"São Gabriel","state_id":5},
{"id":8126,"description":"São Gabriel","state_id":23},
{"id":6629,"description":"São Gabriel (Cambé)","state_id":18},
{"id":6630,"description":"São Gabriel (Colombo)","state_id":18},
{"id":8693,"description":"São Gabriel (Treze de Maio)","state_id":24},
{"id":266,"description":"São Gabriel da Cachoeira","state_id":3},
{"id":2006,"description":"São Gabriel da Palha","state_id":8},
{"id":2322,"description":"São Gabriel de Goiás (Planaltina de Goiás)","state_id":9},
{"id":4246,"description":"São Gabriel do Oeste","state_id":12},
{"id":3831,"description":"São Geraldo","state_id":11},
{"id":7267,"description":"São Geraldo (Caraúbas)","state_id":20},
{"id":3832,"description":"São Geraldo (Coração de Jesus)","state_id":11},
{"id":2007,"description":"São Geraldo (Mantenópolis)","state_id":8},
{"id":3833,"description":"São Geraldo da Piedade","state_id":11},
{"id":3834,"description":"São Geraldo de Tumiritinga (Tumiritinga)","state_id":11},
{"id":4785,"description":"São Geraldo do Araguaia","state_id":14},
{"id":3835,"description":"São Geraldo do Baguari (São João Evangelista)","state_id":11},
{"id":3836,"description":"São Geraldo do Baixio","state_id":11},
{"id":1681,"description":"São Gerardo (Redenção)","state_id":6},
{"id":7067,"description":"São Gonçalo","state_id":19},
{"id":12433,"description":"São Gonçalo","state_id":23},
{"id":5079,"description":"São Gonçalo (Sousa)","state_id":15},
{"id":3837,"description":"São Gonçalo de Botelhos (Botelhos)","state_id":11},
{"id":3838,"description":"São Gonçalo do Abaeté","state_id":11},
{"id":7268,"description":"São Gonçalo do Amarante","state_id":20},
{"id":1682,"description":"São Gonçalo do Amarante","state_id":6},
{"id":5693,"description":"São Gonçalo do Gurguéia","state_id":17},
{"id":3839,"description":"São Gonçalo do Monte (Itabirito)","state_id":11},
{"id":3840,"description":"São Gonçalo do Pará","state_id":11},
{"id":5694,"description":"São Gonçalo do Piauí","state_id":17},
{"id":3841,"description":"São Gonçalo do Rio Abaixo","state_id":11},
{"id":3843,"description":"São Gonçalo do Rio Preto","state_id":11},
{"id":3842,"description":"São Gonçalo do Rio das Pedras (Serro)","state_id":11},
{"id":3844,"description":"São Gonçalo do Sapucaí","state_id":11},
{"id":1683,"description":"São Gonçalo do Umari (Mombaça)","state_id":6},
{"id":1016,"description":"São Gonçalo dos Campos","state_id":5},
{"id":3845,"description":"São Gotardo","state_id":11},
{"id":6631,"description":"São Gotardo (Pato Branco)","state_id":18},
{"id":2008,"description":"São Jacinto (São Roque do Canaã)","state_id":8},
{"id":8127,"description":"São Jerônimo","state_id":23},
{"id":6632,"description":"São Jerônimo da Serra","state_id":18},
{"id":3846,"description":"São Jerônimo dos Poções (Campos Altos)","state_id":11},
{"id":8699,"description":"São Joaquim","state_id":24},
{"id":6643,"description":"São Joaquim (Arapongas)","state_id":18},
{"id":7072,"description":"São Joaquim (Cardoso Moreira)","state_id":19},
{"id":3867,"description":"São Joaquim (Coração de Jesus)","state_id":11},
{"id":6644,"description":"São Joaquim (Guarapuava)","state_id":18},
{"id":3868,"description":"São Joaquim (Januária)","state_id":11},
{"id":4478,"description":"São Joaquim (Tangará da Serra)","state_id":13},
{"id":1687,"description":"São Joaquim (Umirim)","state_id":6},
{"id":9654,"description":"São Joaquim da Barra","state_id":26},
{"id":3869,"description":"São Joaquim de Bicas","state_id":11},
{"id":5439,"description":"São Joaquim do Monte","state_id":16},
{"id":317,"description":"São Joaquim do Pacuí (Macapá)","state_id":4},
{"id":6645,"description":"São Joaquim do Pontal (Itambaracá)","state_id":18},
{"id":1688,"description":"São Joaquim do Salgado (Senador Pompeu)","state_id":6},
{"id":4792,"description":"São Joaquim do Tapará (Santarém)","state_id":14},
{"id":2584,"description":"São Joaquim dos Melos (Tuntum)","state_id":10},
{"id":8133,"description":"São Jorge","state_id":23},
{"id":10237,"description":"São Jorge (Alto Paraíso de Goiás)","state_id":9},
{"id":4479,"description":"São Jorge (Comodoro)","state_id":13},
{"id":4793,"description":"São Jorge (Santarém)","state_id":14},
{"id":6646,"description":"São Jorge d'Oeste","state_id":18},
{"id":10114,"description":"São Jorge da Barra Seca (Vila Valério)","state_id":8},
{"id":6647,"description":"São Jorge do Ivaí","state_id":18},
{"id":2013,"description":"São Jorge do Oliveira (Brejetuba)","state_id":8},
{"id":6648,"description":"São Jorge do Patrocínio","state_id":18},
{"id":2014,"description":"São Jorge do Tiradentes (Rio Bananal)","state_id":8},
{"id":8700,"description":"São José","state_id":24},
{"id":12577,"description":"São José","state_id":23},
{"id":12627,"description":"São José","state_id":23},
{"id":1689,"description":"São José (Abaiara)","state_id":6},
{"id":8844,"description":"São José (Aracaju)","state_id":25},
{"id":4480,"description":"São José (Comodoro)","state_id":13},
{"id":1690,"description":"São José (Iracema)","state_id":6},
{"id":1691,"description":"São José (Jaguaruana)","state_id":6},
{"id":6649,"description":"São José (Jandaia do Sul)","state_id":18},
{"id":1692,"description":"São José (Palhano)","state_id":6},
{"id":5440,"description":"São José (Panelas)","state_id":16},
{"id":8134,"description":"São José (Planalto)","state_id":23},
{"id":6650,"description":"São José (Santa Maria do Oeste)","state_id":18},
{"id":8135,"description":"São José (Santo Antônio das Missões)","state_id":23},
{"id":4248,"description":"São José (Vicentina)","state_id":12},
{"id":12307,"description":"São José Da Reserva","state_id":23},
{"id":12071,"description":"São José Do Pingador","state_id":13},
{"id":12633,"description":"São José Dos Campos Borges","state_id":23},
{"id":3870,"description":"São José da Barra","state_id":11},
{"id":9655,"description":"São José da Bela Vista","state_id":26},
{"id":3871,"description":"São José da Bela Vista (São Gotardo)","state_id":11},
{"id":6651,"description":"São José da Boa Vista","state_id":18},
{"id":5441,"description":"São José da Coroa Grande","state_id":16},
{"id":8136,"description":"São José da Glória (Victor Graeff)","state_id":23},
{"id":5084,"description":"São José da Lagoa Tapada","state_id":15},
{"id":167,"description":"São José da Laje","state_id":2},
{"id":3872,"description":"São José da Lapa","state_id":11},
{"id":5085,"description":"São José da Mata (Campina Grande)","state_id":15},
{"id":7270,"description":"São José da Passagem (Santana do Matos)","state_id":20},
{"id":3873,"description":"São José da Pedra Menina (Espera Feliz)","state_id":11},
{"id":3874,"description":"São José da Safira","state_id":11},
{"id":168,"description":"São José da Tapera","state_id":2},
{"id":3875,"description":"São José da Varginha","state_id":11},
{"id":1019,"description":"São José da Vitória","state_id":5},
{"id":9656,"description":"São José das Laranjeiras (Maraçaí)","state_id":26},
{"id":1693,"description":"São José das Lontras (Ipueiras)","state_id":6},
{"id":8137,"description":"São José das Missões","state_id":23},
{"id":6652,"description":"São José das Palmeiras","state_id":18},
{"id":2015,"description":"São José das Torres (Mimoso do Sul)","state_id":8},
{"id":3876,"description":"São José das Tronqueiras (Governador Valadares)","state_id":11},
{"id":5086,"description":"São José de Caiana","state_id":15},
{"id":8138,"description":"São José de Castro (Garibaldi)","state_id":23},
{"id":5087,"description":"São José de Espinharas","state_id":15},
{"id":10113,"description":"São José de Fruteiras (Vargem Alta)","state_id":8},
{"id":2016,"description":"São José de Mantenópolis (Mantenópolis)","state_id":8},
{"id":5088,"description":"São José de Marimbas (Cachoeira dos Índios)","state_id":15},
{"id":7271,"description":"São José de Mipibu","state_id":20},
{"id":5089,"description":"São José de Piranhas","state_id":15},
{"id":5090,"description":"São José de Princesa","state_id":15},
{"id":2585,"description":"São José de Ribamar","state_id":10},
{"id":1694,"description":"São José de Solonópole (Solonópole)","state_id":6},
{"id":7073,"description":"São José de Ubá","state_id":19},
{"id":3877,"description":"São José do Acácio (Engenheiro Caldas)","state_id":11},
{"id":3878,"description":"São José do Alegre","state_id":11},
{"id":4481,"description":"São José do Apuí (Alta Floresta)","state_id":13},
{"id":9657,"description":"São José do Barreiro","state_id":26},
{"id":3879,"description":"São José do Barreiro (São Roque de Minas)","state_id":11},
{"id":3880,"description":"São José do Batatal (Ubaporanga)","state_id":11},
{"id":5442,"description":"São José do Belmonte","state_id":16},
{"id":5091,"description":"São José do Bonfim","state_id":15},
{"id":5092,"description":"São José do Brejo do Cruz","state_id":15},
{"id":3881,"description":"São José do Buriti (Felixlândia)","state_id":11},
{"id":2017,"description":"São José do Calçado","state_id":8},
{"id":7272,"description":"São José do Campestre","state_id":20},
{"id":8701,"description":"São José do Cedro","state_id":24},
{"id":8139,"description":"São José do Centro (Não-Me-Toque)","state_id":23},
{"id":8702,"description":"São José do Cerrito","state_id":24},
{"id":1020,"description":"São José do Colônia (Itambé)","state_id":5},
{"id":3882,"description":"São José do Divino","state_id":11},
{"id":5701,"description":"São José do Divino","state_id":17},
{"id":5443,"description":"São José do Egito","state_id":16},
{"id":3883,"description":"São José do Goiabal","state_id":11},
{"id":4794,"description":"São José do Gurupi (Viseu)","state_id":14},
{"id":8140,"description":"São José do Herval","state_id":23},
{"id":8141,"description":"São José do Hortêncio","state_id":23},
{"id":6653,"description":"São José do Iguaçu (São Miguel do Iguaçu)","state_id":18},
{"id":8142,"description":"São José do Inhacorá","state_id":23},
{"id":6654,"description":"São José do Itavo (Itaipulândia)","state_id":18},
{"id":3884,"description":"São José do Itueto (Santa Rita do Itueto)","state_id":11},
{"id":6655,"description":"São José do Ivaí (Santa Isabel do Ivaí)","state_id":18},
{"id":3885,"description":"São José do Jacuri","state_id":11},
{"id":1021,"description":"São José do Jacuípe","state_id":5},
{"id":8703,"description":"São José do Laranjal (Iraceminha)","state_id":24},
{"id":3886,"description":"São José do Mantimento","state_id":11},
{"id":3887,"description":"São José do Mato Dentro (Ouro Fino)","state_id":11},
{"id":8143,"description":"São José do Norte","state_id":23},
{"id":8144,"description":"São José do Ouro","state_id":23},
{"id":3889,"description":"São José do Paraopeba (Brumadinho)","state_id":11},
{"id":5702,"description":"São José do Peixe","state_id":17},
{"id":5703,"description":"São José do Piauí","state_id":17},
{"id":4795,"description":"São José do Piriá (Viseu)","state_id":14},
{"id":4482,"description":"São José do Planalto (Pedra Preta)","state_id":13},
{"id":4483,"description":"São José do Povo","state_id":13},
{"id":1022,"description":"São José do Prado (Vereda)","state_id":5},
{"id":3888,"description":"São José do Pântano (Pouso Alegre)","state_id":11},
{"id":7074,"description":"São José do Ribeirão (Bom Jardim)","state_id":19},
{"id":4484,"description":"São José do Rio Claro","state_id":13},
{"id":1023,"description":"São José do Rio Grande (Riachão das Neves)","state_id":5},
{"id":9658,"description":"São José do Rio Pardo","state_id":26},
{"id":9659,"description":"São José do Rio Preto","state_id":26},
{"id":5093,"description":"São José do Sabugi","state_id":15},
{"id":7273,"description":"São José do Seridó","state_id":20},
{"id":2018,"description":"São José do Sobradinho (Boa Esperança)","state_id":8},
{"id":4249,"description":"São José do Sucuriú (Inocência)","state_id":12},
{"id":7653,"description":"São José do Sul","state_id":23},
{"id":1695,"description":"São José do Torto (Sobral)","state_id":6},
{"id":7075,"description":"São José do Turvo (Barra do Piraí)","state_id":19},
{"id":7076,"description":"São José do Vale do Rio Preto","state_id":19},
{"id":4485,"description":"São José do Xingu","state_id":13},
{"id":8145,"description":"São José dos Ausentes","state_id":23},
{"id":2586,"description":"São José dos Basílios","state_id":10},
{"id":9660,"description":"São José dos Campos","state_id":26},
{"id":5094,"description":"São José dos Cordeiros","state_id":15},
{"id":3890,"description":"São José dos Lopes (Lima Duarte)","state_id":11},
{"id":6656,"description":"São José dos Pinhais","state_id":18},
{"id":4486,"description":"São José dos Quatro Marcos","state_id":13},
{"id":5095,"description":"São José dos Ramos","state_id":15},
{"id":3891,"description":"São José dos Salgados (Carmo do Cajuru)","state_id":11},
{"id":6633,"description":"São João","state_id":18},
{"id":5438,"description":"São João","state_id":16},
{"id":12547,"description":"São João","state_id":23},
{"id":12769,"description":"São João","state_id":6},
{"id":6634,"description":"São João (Altônia)","state_id":18},
{"id":6635,"description":"São João (Campo Mourão)","state_id":18},
{"id":2323,"description":"São João (Goiás)","state_id":9},
{"id":6636,"description":"São João (Laranjeiras do Sul)","state_id":18},
{"id":8128,"description":"São João (Redentora)","state_id":23},
{"id":8694,"description":"São João Batista","state_id":24},
{"id":2578,"description":"São João Batista","state_id":10},
{"id":8129,"description":"São João Batista (Vitória das Missões)","state_id":23},
{"id":3847,"description":"São João Batista do Glória","state_id":11},
{"id":8130,"description":"São João Bosco (Ciríaco)","state_id":23},
{"id":5080,"description":"São João Bosco (Uiraúna)","state_id":15},
{"id":2324,"description":"São João D'Aliança","state_id":9},
{"id":12580,"description":"São João Das Missões","state_id":23},
{"id":3857,"description":"São João Del Rei","state_id":11},
{"id":10775,"description":"São João Do Amanari","state_id":6},
{"id":11747,"description":"São João Do Ferraz","state_id":16},
{"id":12540,"description":"São João Dos Mellos","state_id":23},
{"id":3865,"description":"São João Evangelista","state_id":11},
{"id":7071,"description":"São João Marcos (Rio Claro)","state_id":19},
{"id":3866,"description":"São João Nepomuceno","state_id":11},
{"id":9653,"description":"São João Novo (São Roque)","state_id":26},
{"id":6637,"description":"São João d'Oeste (Cascavel)","state_id":18},
{"id":7385,"description":"São João da Baliza","state_id":22},
{"id":7068,"description":"São João da Barra","state_id":19},
{"id":9647,"description":"São João da Boa Vista","state_id":26},
{"id":6638,"description":"São João da Boa Vista (Umuarama)","state_id":18},
{"id":5695,"description":"São João da Canabrava","state_id":17},
{"id":3848,"description":"São João da Chapada (Diamantina)","state_id":11},
{"id":1017,"description":"São João da Fortaleza (Cícero Dantas)","state_id":5},
{"id":5696,"description":"São João da Fronteira","state_id":17},
{"id":3849,"description":"São João da Lagoa","state_id":11},
{"id":3850,"description":"São João da Mata","state_id":11},
{"id":2325,"description":"São João da Paraúna","state_id":9},
{"id":4786,"description":"São João da Ponta","state_id":14},
{"id":3851,"description":"São João da Ponte","state_id":11},
{"id":3852,"description":"São João da Sapucaia (Laranjal)","state_id":11},
{"id":5697,"description":"São João da Serra","state_id":17},
{"id":3853,"description":"São João da Serra (Santos Dumont)","state_id":11},
{"id":3854,"description":"São João da Serra Negra (Patrocínio)","state_id":11},
{"id":8131,"description":"São João da Urtiga","state_id":23},
{"id":5698,"description":"São João da Varjota","state_id":17},
{"id":3855,"description":"São João da Vereda (Montes Claros)","state_id":11},
{"id":1018,"description":"São João da Vitória (Vitória da Conquista)","state_id":5},
{"id":9648,"description":"São João das Duas Pontes","state_id":26},
{"id":3856,"description":"São João das Missões","state_id":11},
{"id":2579,"description":"São João de Cortes (Alcântara)","state_id":10},
{"id":1684,"description":"São João de Deus (Russas)","state_id":6},
{"id":9649,"description":"São João de Iracema","state_id":26},
{"id":9650,"description":"São João de Itaguaçu (Urupês)","state_id":26},
{"id":7069,"description":"São João de Meriti","state_id":19},
{"id":2009,"description":"São João de Petrópolis (Santa Teresa)","state_id":8},
{"id":4787,"description":"São João de Pirabas","state_id":14},
{"id":2010,"description":"São João de Viçosa (Venda Nova do Imigrante)","state_id":8},
{"id":4788,"description":"São João do Acangata (Portel)","state_id":14},
{"id":4247,"description":"São João do Apore (Paranaíba)","state_id":12},
{"id":4789,"description":"São João do Araguaia","state_id":14},
{"id":5699,"description":"São João do Arraial","state_id":17},
{"id":3858,"description":"São João do Bonito (Mato Verde)","state_id":11},
{"id":6639,"description":"São João do Caiuá","state_id":18},
{"id":5081,"description":"São João do Cariri","state_id":15},
{"id":2580,"description":"São João do Carú","state_id":10},
{"id":8695,"description":"São João do Itaperiú","state_id":24},
{"id":6640,"description":"São João do Ivaí","state_id":18},
{"id":3859,"description":"São João do Jacutinga (Caratinga)","state_id":11},
{"id":1685,"description":"São João do Jaguaribe","state_id":6},
{"id":3860,"description":"São João do Manhuaçu","state_id":11},
{"id":3861,"description":"São João do Manteninha","state_id":11},
{"id":9651,"description":"São João do Marinheiro (Cardoso)","state_id":26},
{"id":10105,"description":"São João do Norte (Alegre)","state_id":8},
{"id":8696,"description":"São João do Oeste","state_id":24},
{"id":3862,"description":"São João do Oriente","state_id":11},
{"id":3863,"description":"São João do Pacuí","state_id":11},
{"id":2581,"description":"São João do Paraíso","state_id":10},
{"id":3864,"description":"São João do Paraíso","state_id":11},
{"id":7070,"description":"São João do Paraíso (Cambuci)","state_id":19},
{"id":9652,"description":"São João do Pau d'Alho","state_id":26},
{"id":5700,"description":"São João do Piauí","state_id":17},
{"id":6641,"description":"São João do Pinhal (São Jerônimo da Serra)","state_id":18},
{"id":4790,"description":"São João do Piriá (Paragominas)","state_id":14},
{"id":8132,"description":"São João do Polesine","state_id":23},
{"id":10108,"description":"São João do Príncipe (Iúna)","state_id":8},
{"id":8697,"description":"São João do Rio Vermelho (Florianópolis)","state_id":24},
{"id":5082,"description":"São João do Rio do Peixe","state_id":15},
{"id":7269,"description":"São João do Sabugi","state_id":20},
{"id":2011,"description":"São João do Sobrado (Pinheiros)","state_id":8},
{"id":8698,"description":"São João do Sul","state_id":24},
{"id":2582,"description":"São João do Sóter","state_id":10},
{"id":5083,"description":"São João do Tigre","state_id":15},
{"id":6642,"description":"São João do Triunfo","state_id":18},
{"id":2583,"description":"São João dos Patos","state_id":10},
{"id":1686,"description":"São João dos Queiróz (Quixadá)","state_id":6},
{"id":4791,"description":"São João dos Ramos (São Caetano de Odivelas)","state_id":14},
{"id":6657,"description":"São Judas Tadeu (Santo Antônio do Paraíso)","state_id":18},
{"id":5704,"description":"São Julião","state_id":17},
{"id":8704,"description":"São Leonardo (Alfredo Wagner)","state_id":24},
{"id":6658,"description":"São Leonardo (Londrina)","state_id":18},
{"id":8146,"description":"São Leopoldo","state_id":23},
{"id":11717,"description":"São Lorenço","state_id":16},
{"id":3892,"description":"São Lourenço","state_id":11},
{"id":11797,"description":"São Lourenço","state_id":2},
{"id":6659,"description":"São Lourenço (Castro)","state_id":18},
{"id":6660,"description":"São Lourenço (Cianorte)","state_id":18},
{"id":5445,"description":"São Lourenço da Mata","state_id":16},
{"id":9661,"description":"São Lourenço da Serra","state_id":26},
{"id":8147,"description":"São Lourenço das Missões (São Luiz Gonzaga)","state_id":23},
{"id":4487,"description":"São Lourenço de Fátima (Juscimeira)","state_id":13},
{"id":8705,"description":"São Lourenço do Oeste","state_id":24},
{"id":5705,"description":"São Lourenço do Piauí","state_id":17},
{"id":8148,"description":"São Lourenço do Sul","state_id":23},
{"id":9662,"description":"São Lourenço do Turvo (Matão)","state_id":26},
{"id":8706,"description":"São Ludgero","state_id":24},
{"id":7386,"description":"São Luiz","state_id":22},
{"id":12442,"description":"São Luiz","state_id":23},
{"id":12528,"description":"São Luiz","state_id":23},
{"id":6661,"description":"São Luiz (Campo Mourão)","state_id":18},
{"id":6662,"description":"São Luiz (Capanema)","state_id":18},
{"id":6663,"description":"São Luiz (Chopinzinho)","state_id":18},
{"id":6664,"description":"São Luiz (Clevelândia)","state_id":18},
{"id":6665,"description":"São Luiz (Londrina)","state_id":18},
{"id":6666,"description":"São Luiz (Marialva)","state_id":18},
{"id":6667,"description":"São Luiz (Mariluz)","state_id":18},
{"id":6668,"description":"São Luiz (Paranaguá)","state_id":18},
{"id":8150,"description":"São Luiz (Planalto)","state_id":23},
{"id":11199,"description":"São Luiz Do Oeste","state_id":18},
{"id":8151,"description":"São Luiz Gonzaga","state_id":23},
{"id":9664,"description":"São Luiz do Guaricanga (Presidente Alves)","state_id":26},
{"id":2327,"description":"São Luiz do Norte","state_id":9},
{"id":9663,"description":"São Luiz do Paraitinga","state_id":26},
{"id":6669,"description":"São Luiz do Purunã (Balsa Nova)","state_id":18},
{"id":4796,"description":"São Luiz do Tapajós (Itaituba)","state_id":14},
{"id":2328,"description":"São Luiz do Tocantins (Niquelândia)","state_id":9},
{"id":2587,"description":"São Luís","state_id":10},
{"id":2588,"description":"São Luís Gonzaga do Maranhão","state_id":10},
{"id":8149,"description":"São Luís Rei (Cacique Doble)","state_id":23},
{"id":2326,"description":"São Luís de Montes Belos","state_id":9},
{"id":1696,"description":"São Luís do Curu","state_id":6},
{"id":5706,"description":"São Luís do Piauí","state_id":17},
{"id":169,"description":"São Luís do Quitunde","state_id":2},
{"id":5444,"description":"São Lázaro (Panelas)","state_id":16},
{"id":5096,"description":"São Mamede","state_id":15},
{"id":12418,"description":"São Manoel Do Boi","state_id":11},
{"id":3893,"description":"São Manoel do Guaiaçu (Dona Eusébia)","state_id":11},
{"id":6670,"description":"São Manoel do Paraná","state_id":18},
{"id":9665,"description":"São Manuel","state_id":26},
{"id":8152,"description":"São Manuel (Vacaria)","state_id":23},
{"id":8153,"description":"São Marcos","state_id":23},
{"id":6671,"description":"São Marcos (Londrina)","state_id":18},
{"id":6672,"description":"São Marcos (São José dos Pinhais)","state_id":18},
{"id":8154,"description":"São Marcos (Uruguaiana)","state_id":23},
{"id":12644,"description":"São Marcos Baixo","state_id":23},
{"id":8155,"description":"São Martinho","state_id":23},
{"id":8707,"description":"São Martinho","state_id":24},
{"id":12306,"description":"São Martinho","state_id":23},
{"id":6673,"description":"São Martinho (Rolândia)","state_id":18},
{"id":9666,"description":"São Martinho D'Oeste (Alto Alegre)","state_id":26},
{"id":8156,"description":"São Martinho da Serra","state_id":23},
{"id":2019,"description":"São Mateus","state_id":8},
{"id":7077,"description":"São Mateus (São João de Meriti)","state_id":19},
{"id":8845,"description":"São Mateus da Palestina (Gararu)","state_id":25},
{"id":3894,"description":"São Mateus de Minas (Camanducaia)","state_id":11},
{"id":2589,"description":"São Mateus do Maranhão","state_id":10},
{"id":6674,"description":"São Mateus do Sul","state_id":18},
{"id":7274,"description":"São Miguel","state_id":20},
{"id":12608,"description":"São Miguel","state_id":23},
{"id":12651,"description":"São Miguel","state_id":23},
{"id":6675,"description":"São Miguel (Araucária)","state_id":18},
{"id":8157,"description":"São Miguel (Chapada)","state_id":23},
{"id":6676,"description":"São Miguel (Francisco Beltrão)","state_id":18},
{"id":1697,"description":"São Miguel (Mauriti)","state_id":6},
{"id":1698,"description":"São Miguel (Quixeramobim)","state_id":6},
{"id":6677,"description":"São Miguel (Toledo)","state_id":18},
{"id":9667,"description":"São Miguel Arcanjo","state_id":26},
{"id":11119,"description":"São Miguel De Pracuuba","state_id":14},
{"id":5707,"description":"São Miguel da Baixa Grande","state_id":17},
{"id":8709,"description":"São Miguel da Boa Vista","state_id":24},
{"id":8710,"description":"São Miguel da Serra (Porto União)","state_id":24},
{"id":1024,"description":"São Miguel das Matas","state_id":5},
{"id":8158,"description":"São Miguel das Missões","state_id":23},
{"id":5097,"description":"São Miguel de Taipú","state_id":15},
{"id":7275,"description":"São Miguel de Touros","state_id":20},
{"id":8846,"description":"São Miguel do Aleixo","state_id":25},
{"id":3895,"description":"São Miguel do Anta","state_id":11},
{"id":2329,"description":"São Miguel do Araguaia","state_id":9},
{"id":6678,"description":"São Miguel do Cambui (Marialva)","state_id":18},
{"id":5708,"description":"São Miguel do Fidalgo","state_id":17},
{"id":4797,"description":"São Miguel do Guamá","state_id":14},
{"id":7362,"description":"São Miguel do Guaporé","state_id":21},
{"id":6679,"description":"São Miguel do Iguaçu","state_id":18},
{"id":8708,"description":"São Miguel do Oeste","state_id":24},
{"id":2330,"description":"São Miguel do Passa Quatro","state_id":9},
{"id":5709,"description":"São Miguel do Tapuio","state_id":17},
{"id":9941,"description":"São Miguel do Tocantins","state_id":27},
{"id":170,"description":"São Miguel dos Campos","state_id":2},
{"id":4798,"description":"São Miguel dos Macacos (Breves)","state_id":14},
{"id":171,"description":"São Miguel dos Milagres","state_id":2},
{"id":8159,"description":"São Nicolau","state_id":23},
{"id":2331,"description":"São Patrício","state_id":9},
{"id":1025,"description":"São Paulinho (Itamaraju)","state_id":5},
{"id":9668,"description":"São Paulo","state_id":26},
{"id":1699,"description":"São Paulo (Acopiara)","state_id":6},
{"id":8160,"description":"São Paulo (Ipê)","state_id":23},
{"id":6680,"description":"São Paulo (Toledo)","state_id":18},
{"id":12584,"description":"São Paulo Das Tunas","state_id":23},
{"id":8161,"description":"São Paulo das Missões","state_id":23},
{"id":267,"description":"São Paulo de Olivença","state_id":3},
{"id":7276,"description":"São Paulo do Potengi","state_id":20},
{"id":7277,"description":"São Pedro","state_id":20},
{"id":12639,"description":"São Pedro","state_id":23},
{"id":12554,"description":"São Pedro","state_id":23},
{"id":9669,"description":"São Pedro","state_id":26},
{"id":6681,"description":"São Pedro (Ampére)","state_id":18},
{"id":6682,"description":"São Pedro (Apucarana)","state_id":18},
{"id":8162,"description":"São Pedro (Bento Gonçalves)","state_id":23},
{"id":6683,"description":"São Pedro (Campo Largo)","state_id":18},
{"id":4250,"description":"São Pedro (Dourados)","state_id":12},
{"id":5446,"description":"São Pedro (Garanhuns)","state_id":16},
{"id":6684,"description":"São Pedro (Guarapuava)","state_id":18},
{"id":4251,"description":"São Pedro (Inocência)","state_id":12},
{"id":1700,"description":"São Pedro (Jucás)","state_id":6},
{"id":2020,"description":"São Pedro (Muniz Freire)","state_id":8},
{"id":1701,"description":"São Pedro (Nova Russas)","state_id":6},
{"id":6685,"description":"São Pedro (Paranavaí)","state_id":18},
{"id":5098,"description":"São Pedro (Santa Cruz)","state_id":15},
{"id":11899,"description":"São Pedro Do Gavião","state_id":6},
{"id":12788,"description":"São Pedro Do Passa Três","state_id":11},
{"id":6690,"description":"São Pedro Lopei (Cascavel)","state_id":18},
{"id":8712,"description":"São Pedro Tobias (Dionísio Cerqueira)","state_id":24},
{"id":7078,"description":"São Pedro da Aldeia","state_id":19},
{"id":4488,"description":"São Pedro da Cipa","state_id":13},
{"id":3896,"description":"São Pedro da Garça (Montes Claros)","state_id":11},
{"id":8164,"description":"São Pedro da Serra","state_id":23},
{"id":10208,"description":"São Pedro da Serra (Nova Friburgo)","state_id":19},
{"id":3897,"description":"São Pedro da União","state_id":11},
{"id":2590,"description":"São Pedro da Água Branca","state_id":10},
{"id":8163,"description":"São Pedro das Missões","state_id":23},
{"id":3898,"description":"São Pedro das Tabocas (Pedras de Maria da Cruz)","state_id":11},
{"id":8711,"description":"São Pedro de Alcântara","state_id":24},
{"id":3899,"description":"São Pedro de Caldas (Caldas)","state_id":11},
{"id":2021,"description":"São Pedro de Itabapoana (Mimoso do Sul)","state_id":8},
{"id":2022,"description":"São Pedro de Rates (Guaçuí)","state_id":8},
{"id":4799,"description":"São Pedro de Viseu (Mocajuba)","state_id":14},
{"id":3900,"description":"São Pedro do Avaí (Manhuaçu)","state_id":11},
{"id":8165,"description":"São Pedro do Butiá","state_id":23},
{"id":4800,"description":"São Pedro do Capim (São Domingos do Capim)","state_id":14},
{"id":6686,"description":"São Pedro do Florido (Santo Antônio do Sudoeste)","state_id":18},
{"id":3901,"description":"São Pedro do Glória (Fervedouro)","state_id":11},
{"id":6687,"description":"São Pedro do Iguaçu","state_id":18},
{"id":8166,"description":"São Pedro do Iraxim (São José do Ouro)","state_id":23},
{"id":6688,"description":"São Pedro do Ivaí","state_id":18},
{"id":3902,"description":"São Pedro do Jequitinhonha (Jequitinhonha)","state_id":11},
{"id":6689,"description":"São Pedro do Paraná","state_id":18},
{"id":5710,"description":"São Pedro do Piauí","state_id":17},
{"id":3903,"description":"São Pedro do Suaçuí","state_id":11},
{"id":8167,"description":"São Pedro do Sul","state_id":23},
{"id":9670,"description":"São Pedro do Turvo","state_id":26},
{"id":2591,"description":"São Pedro dos Crentes","state_id":10},
{"id":3904,"description":"São Pedro dos Ferros","state_id":11},
{"id":6691,"description":"São Pio X (Francisco Beltrão)","state_id":18},
{"id":7278,"description":"São Rafael","state_id":20},
{"id":2023,"description":"São Rafael (Linhares)","state_id":8},
{"id":12745,"description":"São Raimundo","state_id":6},
{"id":5711,"description":"São Raimundo Nonato","state_id":17},
{"id":10106,"description":"São Raimundo da Pedra Menina (Dores do Rio Preto)","state_id":8},
{"id":2592,"description":"São Raimundo das Mangabeiras","state_id":10},
{"id":4801,"description":"São Raimundo de Borralhos (Santo Antônio do Tauá)","state_id":14},
{"id":2593,"description":"São Raimundo de Codó (Codó)","state_id":10},
{"id":4802,"description":"São Raimundo do Araguaia (Brejo Grande do Araguaia)","state_id":14},
{"id":2594,"description":"São Raimundo do Doca Bezerra","state_id":10},
{"id":4803,"description":"São Raimundo dos Furtados (Cametá)","state_id":14},
{"id":2595,"description":"São Roberto","state_id":10},
{"id":4804,"description":"São Roberto (Maracanã)","state_id":14},
{"id":3905,"description":"São Roberto (São João da Lagoa)","state_id":11},
{"id":3906,"description":"São Romão","state_id":11},
{"id":1702,"description":"São Romão (Altaneira)","state_id":6},
{"id":4252,"description":"São Romão (Coxim)","state_id":12},
{"id":9671,"description":"São Roque","state_id":26},
{"id":12748,"description":"São Roque","state_id":6},
{"id":6692,"description":"São Roque (Dois Vizinhos)","state_id":18},
{"id":6693,"description":"São Roque (Marechal Cândido Rondon)","state_id":18},
{"id":8168,"description":"São Roque (Passo Fundo)","state_id":23},
{"id":6694,"description":"São Roque (Realeza)","state_id":18},
{"id":8713,"description":"São Roque (São Lourenço do Oeste)","state_id":24},
{"id":10735,"description":"São Roque Do Chopim","state_id":18},
{"id":9672,"description":"São Roque da Fartura (Águas da Prata)","state_id":26},
{"id":3907,"description":"São Roque de Minas","state_id":11},
{"id":2024,"description":"São Roque do Canaã","state_id":8},
{"id":1026,"description":"São Roque do Paraguaçu (Maragogipe)","state_id":5},
{"id":6695,"description":"São Roque do Pinhal (Joaquim Távora)","state_id":18},
{"id":6696,"description":"São Salvador (Ampére)","state_id":18},
{"id":9942,"description":"São Salvador do Tocantins","state_id":27},
{"id":172,"description":"São Sebastião","state_id":2},
{"id":1794,"description":"São Sebastião","state_id":7},
{"id":12213,"description":"São Sebastião","state_id":6},
{"id":9673,"description":"São Sebastião","state_id":26},
{"id":11611,"description":"São Sebastião","state_id":11},
{"id":12009,"description":"São Sebastião","state_id":5},
{"id":1703,"description":"São Sebastião (Cariús)","state_id":6},
{"id":6697,"description":"São Sebastião (Castro)","state_id":18},
{"id":6698,"description":"São Sebastião (Cerro Azul)","state_id":18},
{"id":8169,"description":"São Sebastião (Esmeralda)","state_id":23},
{"id":6699,"description":"São Sebastião (Guarapuava)","state_id":18},
{"id":8170,"description":"São Sebastião (Ibiraiaras)","state_id":23},
{"id":6700,"description":"São Sebastião (São José dos Pinhais)","state_id":18},
{"id":6701,"description":"São Sebastião (Telêmaco Borba)","state_id":18},
{"id":6702,"description":"São Sebastião da Amoreira","state_id":18},
{"id":3908,"description":"São Sebastião da Barra (Iapu)","state_id":11},
{"id":3909,"description":"São Sebastião da Bela Vista","state_id":11},
{"id":4805,"description":"São Sebastião da Boa Vista","state_id":14},
{"id":9674,"description":"São Sebastião da Grama","state_id":26},
{"id":9675,"description":"São Sebastião da Serra (Brotas)","state_id":26},
{"id":3910,"description":"São Sebastião da Vala (Aimorés)","state_id":11},
{"id":3911,"description":"São Sebastião da Vargem Alegre","state_id":11},
{"id":3912,"description":"São Sebastião da Vitória (São João Del Rei)","state_id":11},
{"id":3913,"description":"São Sebastião de Braúnas (Belo Oriente)","state_id":11},
{"id":7079,"description":"São Sebastião de Campos (Campos dos Goytacazes)","state_id":19},
{"id":5099,"description":"São Sebastião de Lagoa de Roça","state_id":15},
{"id":4806,"description":"São Sebastião de Viçosa (Chaves)","state_id":14},
{"id":7080,"description":"São Sebastião do Alto","state_id":19},
{"id":3914,"description":"São Sebastião do Anta","state_id":11},
{"id":8714,"description":"São Sebastião do Arvoredo (São Joaquim)","state_id":24},
{"id":3915,"description":"São Sebastião do Baixio (Açucena)","state_id":11},
{"id":3916,"description":"São Sebastião do Barreado (Rio Preto)","state_id":11},
{"id":3917,"description":"São Sebastião do Barreiro (Jampruca)","state_id":11},
{"id":3918,"description":"São Sebastião do Bonsucesso (Conceição do Mato Dentro)","state_id":11},
{"id":3919,"description":"São Sebastião do Bugre (Coroaci)","state_id":11},
{"id":8171,"description":"São Sebastião do Caí","state_id":23},
{"id":3920,"description":"São Sebastião do Gil (Desterro de Entre Rios)","state_id":11},
{"id":318,"description":"São Sebastião do Livramento (Macapá)","state_id":4},
{"id":3921,"description":"São Sebastião do Maranhão","state_id":11},
{"id":3923,"description":"São Sebastião do Oeste","state_id":11},
{"id":7081,"description":"São Sebastião do Paraíba (Cantagalo)","state_id":19},
{"id":3924,"description":"São Sebastião do Paraíso","state_id":11},
{"id":1027,"description":"São Sebastião do Passe","state_id":5},
{"id":3925,"description":"São Sebastião do Pontal (Carneirinho)","state_id":11},
{"id":2332,"description":"São Sebastião do Rio Claro (Jussara)","state_id":9},
{"id":3926,"description":"São Sebastião do Rio Preto","state_id":11},
{"id":3927,"description":"São Sebastião do Rio Verde","state_id":11},
{"id":3928,"description":"São Sebastião do Sacramento (Manhuaçu)","state_id":11},
{"id":3929,"description":"São Sebastião do Soberbo (Santa Cruz do Escalvado)","state_id":11},
{"id":8715,"description":"São Sebastião do Sul (Lebon Régis)","state_id":24},
{"id":9943,"description":"São Sebastião do Tocantins","state_id":27},
{"id":268,"description":"São Sebastião do Uatumã","state_id":3},
{"id":5100,"description":"São Sebastião do Umbuzeiro","state_id":15},
{"id":3922,"description":"São Sebastião do Óculo (Raul Soares)","state_id":11},
{"id":7082,"description":"São Sebastião dos Ferreiros (Vassouras)","state_id":19},
{"id":3930,"description":"São Sebastião dos Poções (Montalvânia)","state_id":11},
{"id":3931,"description":"São Sebastião dos Robertos (Jacutinga)","state_id":11},
{"id":3932,"description":"São Sebastião dos Torres (Barbacena)","state_id":11},
{"id":8172,"description":"São Sepé","state_id":23},
{"id":11718,"description":"São Severino","state_id":16},
{"id":6703,"description":"São Silvestre (Cruzeiro do Oeste)","state_id":18},
{"id":9676,"description":"São Silvestre de Jacareí (Jacareí)","state_id":26},
{"id":2333,"description":"São Simão","state_id":9},
{"id":9677,"description":"São Simão","state_id":26},
{"id":8173,"description":"São Simão (Mostardas)","state_id":23},
{"id":3935,"description":"São Thomé das Letras","state_id":11},
{"id":3933,"description":"São Tiago","state_id":11},
{"id":2025,"description":"São Tiago (Guaçuí)","state_id":8},
{"id":1028,"description":"São Timóteo (Livramento de Nossa Senhora)","state_id":5},
{"id":3934,"description":"São Tomás de Aquino","state_id":11},
{"id":7279,"description":"São Tomé","state_id":20},
{"id":6704,"description":"São Tomé","state_id":18},
{"id":319,"description":"São Tomé (Macapá)","state_id":4},
{"id":2026,"description":"São Torquato (Vila Velha)","state_id":8},
{"id":8174,"description":"São Valentim","state_id":23},
{"id":12286,"description":"São Valentim","state_id":23},
{"id":6705,"description":"São Valentim (Dois Vizinhos)","state_id":18},
{"id":8175,"description":"São Valentim (Independência)","state_id":23},
{"id":8176,"description":"São Valentim do Sul","state_id":23},
{"id":12552,"description":"São Valentin Da Gruta","state_id":23},
{"id":9944,"description":"São Valério da Natividade","state_id":27},
{"id":8177,"description":"São Valério do Sul","state_id":23},
{"id":8178,"description":"São Vendelino","state_id":23},
{"id":7280,"description":"São Vicente","state_id":20},
{"id":9678,"description":"São Vicente","state_id":26},
{"id":2334,"description":"São Vicente (Anápolis)","state_id":9},
{"id":6706,"description":"São Vicente (Araruna)","state_id":18},
{"id":3936,"description":"São Vicente (Baldim)","state_id":11},
{"id":4489,"description":"São Vicente (Cuiabá)","state_id":13},
{"id":1704,"description":"São Vicente (Icó)","state_id":6},
{"id":5447,"description":"São Vicente (Itapetim)","state_id":16},
{"id":1705,"description":"São Vicente (Mombaça)","state_id":6},
{"id":2596,"description":"São Vicente Ferrer","state_id":10},
{"id":5448,"description":"São Vicente Ferrer","state_id":16},
{"id":3937,"description":"São Vicente da Estrela (Raul Soares)","state_id":11},
{"id":3938,"description":"São Vicente de Minas","state_id":11},
{"id":7083,"description":"São Vicente de Paula (Araruama)","state_id":19},
{"id":3939,"description":"São Vicente do Grama (Jequeri)","state_id":11},
{"id":3940,"description":"São Vicente do Rio Doce (Tarumirim)","state_id":11},
{"id":5103,"description":"São Vicente do Seridó","state_id":15},
{"id":8179,"description":"São Vicente do Sul","state_id":23},
{"id":3941,"description":"São Vítor (Governador Valadares)","state_id":11},
{"id":8196,"description":"Sério","state_id":23},
{"id":8211,"description":"Sírio (Santo Cristo)","state_id":23},
{"id":12523,"description":"Sítio Alto","state_id":23},
{"id":12555,"description":"Sítio Cassemiro","state_id":23},
{"id":2341,"description":"Sítio D'Abadia","state_id":9},
{"id":12439,"description":"Sítio Do Herval","state_id":23},
{"id":11701,"description":"Sítio Dos Remédios","state_id":16},
{"id":8212,"description":"Sítio Gabriel (Miraguaí)","state_id":23},
{"id":1052,"description":"Sítio Grande (São Desidério)","state_id":5},
{"id":7291,"description":"Sítio Novo","state_id":20},
{"id":2601,"description":"Sítio Novo","state_id":10},
{"id":1053,"description":"Sítio Novo (Catu)","state_id":5},
{"id":9946,"description":"Sítio Novo do Tocantins","state_id":27},
{"id":1048,"description":"Sítio da Baraúna (Andorinha)","state_id":5},
{"id":1049,"description":"Sítio do Mato","state_id":5},
{"id":1050,"description":"Sítio do Meio (Castro Alves)","state_id":5},
{"id":1051,"description":"Sítio do Quinto","state_id":5},
{"id":5460,"description":"Sítio dos Nunes (Flores)","state_id":16},
{"id":1720,"description":"Sítios Novos (Caucaia)","state_id":6},
{"id":1729,"description":"Tabainha (Tianguá)","state_id":6},
{"id":7364,"description":"Tabajara (Ariquemes)","state_id":21},
{"id":4002,"description":"Tabajara (Inhapim)","state_id":11},
{"id":9704,"description":"Tabajara (Lavínia)","state_id":26},
{"id":8218,"description":"Tabajara (Salto do Jacuí)","state_id":23},
{"id":4497,"description":"Tabaporã","state_id":13},
{"id":9705,"description":"Tabapuã","state_id":26},
{"id":270,"description":"Tabatinga","state_id":3},
{"id":9706,"description":"Tabatinga","state_id":26},
{"id":8217,"description":"Tabaí","state_id":23},
{"id":4003,"description":"Tabaúna (Aimorés)","state_id":11},
{"id":5463,"description":"Tabira","state_id":16},
{"id":7097,"description":"Taboas (Rio das Flores)","state_id":19},
{"id":10863,"description":"Taboca","state_id":22},
{"id":11799,"description":"Tabocas","state_id":2},
{"id":5464,"description":"Tabocas (Exu)","state_id":16},
{"id":1059,"description":"Tabocas do Brejo Velho","state_id":5},
{"id":1730,"description":"Taboleiro (Antonina do Norte)","state_id":6},
{"id":7292,"description":"Taboleiro Grande","state_id":20},
{"id":1060,"description":"Taboleiro do Castro (Varzedo)","state_id":5},
{"id":179,"description":"Taboleiro do Pinto (Rio Largo)","state_id":2},
{"id":11808,"description":"Taboquinha","state_id":16},
{"id":180,"description":"Taboquinha (Arapiraca)","state_id":2},
{"id":1061,"description":"Taboquinhas (Itacaré)","state_id":5},
{"id":9707,"description":"Taboão da Serra","state_id":26},
{"id":12524,"description":"Taboãozinho","state_id":23},
{"id":4005,"description":"Tabuleiro","state_id":11},
{"id":1731,"description":"Tabuleiro do Norte","state_id":6},
{"id":4004,"description":"Tabuão (Bom Jardim de Minas)","state_id":11},
{"id":5465,"description":"Tacaimbó","state_id":16},
{"id":5466,"description":"Tacaratu","state_id":16},
{"id":9708,"description":"Taciba","state_id":26},
{"id":4257,"description":"Tacuru","state_id":12},
{"id":1796,"description":"Taguatinga","state_id":7},
{"id":9948,"description":"Taguatinga","state_id":27},
{"id":9709,"description":"Taguaí","state_id":26},
{"id":1062,"description":"Taguá (Cotegipe)","state_id":5},
{"id":9711,"description":"Taiacupeba (Mogi das Cruzes)","state_id":26},
{"id":9710,"description":"Taiaçu","state_id":26},
{"id":4811,"description":"Tailândia","state_id":14},
{"id":12496,"description":"Taim","state_id":23},
{"id":8219,"description":"Taim (Rio Grande)","state_id":23},
{"id":8220,"description":"Tainhas (São Francisco de Paula)","state_id":23},
{"id":4006,"description":"Taiobeiras","state_id":11},
{"id":6741,"description":"Taipa (Guarapuava)","state_id":18},
{"id":9949,"description":"Taipas do Tocantins","state_id":27},
{"id":7293,"description":"Taipu","state_id":20},
{"id":8727,"description":"Taió","state_id":24},
{"id":9712,"description":"Taiúva","state_id":26},
{"id":9713,"description":"Talhado (São José do Rio Preto)","state_id":26},
{"id":9950,"description":"Talismã","state_id":27},
{"id":5467,"description":"Tamandaré","state_id":16},
{"id":4258,"description":"Tamandaré (Paranaíba)","state_id":12},
{"id":12480,"description":"Tamanduá","state_id":23},
{"id":8221,"description":"Tamanduá (Segredo)","state_id":23},
{"id":6742,"description":"Tamarana","state_id":18},
{"id":6743,"description":"Tambarutaca (Paranaguá)","state_id":18},
{"id":5119,"description":"Tambauzinho (Santa Rita)","state_id":15},
{"id":9714,"description":"Tambaú","state_id":26},
{"id":6744,"description":"Tamboara","state_id":18},
{"id":5468,"description":"Tamboatá (Bom Jardim)","state_id":16},
{"id":1733,"description":"Tamboril","state_id":6},
{"id":9951,"description":"Tamboril (Nazaré)","state_id":27},
{"id":5719,"description":"Tamboril do Piauí","state_id":17},
{"id":1063,"description":"Tamburil (Morro do Chapéu)","state_id":5},
{"id":7098,"description":"Tamoios (Cabo Frio)","state_id":19},
{"id":9715,"description":"Tanabi","state_id":26},
{"id":7294,"description":"Tangará","state_id":20},
{"id":8728,"description":"Tangará","state_id":24},
{"id":4498,"description":"Tangará da Serra","state_id":13},
{"id":7099,"description":"Tanguá","state_id":19},
{"id":1064,"description":"Tanhaçu","state_id":5},
{"id":8222,"description":"Tanque (São José do Ouro)","state_id":23},
{"id":181,"description":"Tanque D'Arca","state_id":2},
{"id":6745,"description":"Tanque Grande (Castro)","state_id":18},
{"id":1065,"description":"Tanque Novo","state_id":5},
{"id":5720,"description":"Tanque do Piauí","state_id":17},
{"id":12370,"description":"Tanques","state_id":15},
{"id":1734,"description":"Tanques (Maranguape)","state_id":6},
{"id":1066,"description":"Tanquinho","state_id":5},
{"id":11345,"description":"Tanquinho","state_id":26},
{"id":1067,"description":"Tanquinho do Poço (Andorinha)","state_id":5},
{"id":4007,"description":"Taparuba","state_id":11},
{"id":271,"description":"Tapauá","state_id":3},
{"id":6746,"description":"Tapejara","state_id":18},
{"id":8223,"description":"Tapejara","state_id":23},
{"id":8224,"description":"Tapera","state_id":23},
{"id":1735,"description":"Tapera (Aquiraz)","state_id":6},
{"id":8225,"description":"Tapera (Tavares)","state_id":23},
{"id":7100,"description":"Tapera (Trajano de Morais)","state_id":19},
{"id":5120,"description":"Taperoá","state_id":15},
{"id":1068,"description":"Taperoá","state_id":5},
{"id":1736,"description":"Taperuaba (Sobral)","state_id":6},
{"id":8226,"description":"Tapes","state_id":23},
{"id":9716,"description":"Tapinas (Itápolis)","state_id":26},
{"id":6747,"description":"Tapira","state_id":18},
{"id":4008,"description":"Tapira","state_id":11},
{"id":5469,"description":"Tapiraim (São Caitano)","state_id":16},
{"id":1070,"description":"Tapirama (Gongogi)","state_id":5},
{"id":1071,"description":"Tapiramutá","state_id":5},
{"id":1072,"description":"Tapiranga (Miguel Calmon)","state_id":5},
{"id":4499,"description":"Tapirapua (Barra do Bugres)","state_id":13},
{"id":9718,"description":"Tapiratiba","state_id":26},
{"id":4009,"description":"Tapiraí","state_id":11},
{"id":9717,"description":"Tapiraí","state_id":26},
{"id":1069,"description":"Tapiraípe (Ruy Barbosa)","state_id":5},
{"id":6748,"description":"Tapui (Toledo)","state_id":18},
{"id":1737,"description":"Tapuiara (Quixadá)","state_id":6},
{"id":12220,"description":"Tapuio","state_id":6},
{"id":4010,"description":"Tapuirama (Uberlândia)","state_id":11},
{"id":4500,"description":"Tapurah","state_id":13},
{"id":1073,"description":"Tapúia (Camamu)","state_id":5},
{"id":8227,"description":"Taquara","state_id":23},
{"id":11800,"description":"Taquara","state_id":2},
{"id":6749,"description":"Taquara (Castro)","state_id":18},
{"id":8729,"description":"Taquara Verde (Caçador)","state_id":24},
{"id":9719,"description":"Taquaral","state_id":26},
{"id":11558,"description":"Taquaral","state_id":23},
{"id":12525,"description":"Taquaral","state_id":23},
{"id":12739,"description":"Taquaral","state_id":26},
{"id":2343,"description":"Taquaral de Goiás","state_id":9},
{"id":10236,"description":"Taquaral de Guanhães (Guanhães)","state_id":11},
{"id":9952,"description":"Taquaralto (Palmas)","state_id":27},
{"id":182,"description":"Taquarana","state_id":2},
{"id":8730,"description":"Taquaras (Rancho Queimado)","state_id":24},
{"id":4011,"description":"Taquaraçu de Minas","state_id":11},
{"id":1074,"description":"Taquarendi (Mirangaba)","state_id":5},
{"id":8228,"description":"Taquari","state_id":23},
{"id":4259,"description":"Taquari (Coxim)","state_id":12},
{"id":6750,"description":"Taquari dos Polacos (Ponta Grossa)","state_id":18},
{"id":6751,"description":"Taquari dos Russos (Ponta Grossa)","state_id":18},
{"id":8229,"description":"Taquarichim (Jaguari)","state_id":23},
{"id":1075,"description":"Taquarinha (Mucuri)","state_id":5},
{"id":9720,"description":"Taquaritinga","state_id":26},
{"id":5470,"description":"Taquaritinga do Norte","state_id":16},
{"id":9721,"description":"Taquarituba","state_id":26},
{"id":9722,"description":"Taquarivaí","state_id":26},
{"id":6752,"description":"Taquaruna (Londrina)","state_id":18},
{"id":4260,"description":"Taquarussu","state_id":12},
{"id":9953,"description":"Taquarussu do Tocantins (Palmas)","state_id":27},
{"id":8230,"description":"Taquaruçu do Sul","state_id":23},
{"id":5471,"description":"Tara (Pedra)","state_id":16},
{"id":9723,"description":"Tarabai","state_id":26},
{"id":21,"description":"Tarauacá","state_id":1},
{"id":1738,"description":"Targinos (Canindé)","state_id":6},
{"id":11981,"description":"Tarilândia","state_id":21},
{"id":7101,"description":"Tarituba (Parati)","state_id":19},
{"id":1739,"description":"Tarrafas","state_id":6},
{"id":1076,"description":"Tartaruga (Milagres)","state_id":5},
{"id":322,"description":"Tartarugalzinho","state_id":4},
{"id":4012,"description":"Taruaçu (São João Nepomuceno)","state_id":11},
{"id":4013,"description":"Tarumirim","state_id":11},
{"id":9724,"description":"Tarumã","state_id":26},
{"id":2604,"description":"Tasso Fragoso","state_id":10},
{"id":183,"description":"Tatuamunha (Porto de Pedras)","state_id":2},
{"id":4812,"description":"Tatuteua (Maracanã)","state_id":14},
{"id":9725,"description":"Tatuí","state_id":26},
{"id":5472,"description":"Tauapiranga (Serra Talhada)","state_id":16},
{"id":1077,"description":"Tauapé (Licínio de Almeida)","state_id":5},
{"id":4813,"description":"Tauari (Capanema)","state_id":14},
{"id":4814,"description":"Tauarizinho (Peixe-Boi)","state_id":14},
{"id":9726,"description":"Taubaté","state_id":26},
{"id":4261,"description":"Taunay (Aquidauana)","state_id":12},
{"id":1740,"description":"Tauá","state_id":6},
{"id":8231,"description":"Tavares","state_id":23},
{"id":5121,"description":"Tavares","state_id":15},
{"id":2344,"description":"Taveira (Niquelândia)","state_id":9},
{"id":1732,"description":"Taíba (São Gonçalo do Amarante)","state_id":6},
{"id":4014,"description":"Tebas (Leopoldina)","state_id":11},
{"id":9727,"description":"Tecainda (Martinópolis)","state_id":26},
{"id":272,"description":"Tefé","state_id":3},
{"id":5122,"description":"Teixeira","state_id":15},
{"id":6753,"description":"Teixeira Soares","state_id":18},
{"id":1078,"description":"Teixeira de Freitas","state_id":5},
{"id":4015,"description":"Teixeiras","state_id":11},
{"id":7365,"description":"Teixeirópolis","state_id":21},
{"id":4016,"description":"Tejuco (Januária)","state_id":11},
{"id":5473,"description":"Tejucupapo (Goiana)","state_id":16},
{"id":9728,"description":"Tejupá","state_id":26},
{"id":1741,"description":"Tejuçuoca","state_id":6},
{"id":8849,"description":"Telha","state_id":25},
{"id":6754,"description":"Telêmaco Borba","state_id":18},
{"id":11726,"description":"Tenebre","state_id":16},
{"id":7295,"description":"Tenente Ananias","state_id":20},
{"id":7296,"description":"Tenente Laurentino Cruz","state_id":20},
{"id":8232,"description":"Tenente Portela","state_id":23},
{"id":4815,"description":"Tentugal (Ourém)","state_id":14},
{"id":5123,"description":"Tenório","state_id":15},
{"id":9729,"description":"Teodoro Sampaio","state_id":26},
{"id":1079,"description":"Teodoro Sampaio","state_id":5},
{"id":1080,"description":"Teofilândia","state_id":5},
{"id":1081,"description":"Teolândia","state_id":5},
{"id":6755,"description":"Teolândia (Pato Branco)","state_id":18},
{"id":184,"description":"Teotônio Vilela","state_id":2},
{"id":4262,"description":"Terenos","state_id":12},
{"id":5721,"description":"Teresina","state_id":17},
{"id":2345,"description":"Teresina de Goiás","state_id":9},
{"id":7102,"description":"Teresópolis","state_id":19},
{"id":6756,"description":"Tereza Breda (Barbosa Ferraz)","state_id":18},
{"id":6757,"description":"Tereza Cristina (Cândido de Abreu)","state_id":18},
{"id":5474,"description":"Terezinha","state_id":16},
{"id":2346,"description":"Terezópolis de Goiás","state_id":9},
{"id":9730,"description":"Termas de Ibirá (Ibirá)","state_id":26},
{"id":4816,"description":"Terra Alta","state_id":14},
{"id":6758,"description":"Terra Boa","state_id":18},
{"id":4018,"description":"Terra Branca (Bocaiúva)","state_id":11},
{"id":1082,"description":"Terra Nova","state_id":5},
{"id":5475,"description":"Terra Nova","state_id":16},
{"id":11762,"description":"Terra Nova","state_id":3},
{"id":6759,"description":"Terra Nova (São Jerônimo da Serra)","state_id":18},
{"id":9731,"description":"Terra Nova D'Oeste (Santa Mercedes)","state_id":26},
{"id":4501,"description":"Terra Nova do Norte","state_id":13},
{"id":6760,"description":"Terra Rica","state_id":18},
{"id":6761,"description":"Terra Roxa","state_id":18},
{"id":9732,"description":"Terra Roxa","state_id":26},
{"id":4502,"description":"Terra Roxa (Juína)","state_id":13},
{"id":4817,"description":"Terra Santa","state_id":14},
{"id":11824,"description":"Terra Vermelha","state_id":16},
{"id":8233,"description":"Terra de Areia","state_id":23},
{"id":8234,"description":"Tesouras (Chapada)","state_id":23},
{"id":4503,"description":"Tesouro","state_id":13},
{"id":8235,"description":"Teutônia","state_id":23},
{"id":4017,"description":"Teófilo Otoni","state_id":11},
{"id":7366,"description":"Theobroma","state_id":21},
{"id":1742,"description":"Tianguá","state_id":6},
{"id":8236,"description":"Tiaraju (São Gabriel)","state_id":23},
{"id":6762,"description":"Tibagi","state_id":18},
{"id":7297,"description":"Tibau","state_id":20},
{"id":7298,"description":"Tibau do Sul","state_id":20},
{"id":9733,"description":"Tibiriçá (Bauru)","state_id":26},
{"id":9734,"description":"Tibiriçá do Paranapanema (Piraju)","state_id":26},
{"id":9735,"description":"Tietê","state_id":26},
{"id":8731,"description":"Tigipió (São João Batista)","state_id":24},
{"id":8732,"description":"Tigrinhos","state_id":24},
{"id":4818,"description":"Tijoca (Bragança)","state_id":14},
{"id":1083,"description":"Tijuaçú (Senhor do Bonfim)","state_id":5},
{"id":8733,"description":"Tijucas","state_id":24},
{"id":6763,"description":"Tijucas do Sul","state_id":18},
{"id":6764,"description":"Tijuco Preto (Almirante Tamandaré)","state_id":18},
{"id":6765,"description":"Tijuco Preto (Castro)","state_id":18},
{"id":5476,"description":"Timbaúba","state_id":16},
{"id":7299,"description":"Timbaúba dos Batistas","state_id":20},
{"id":10124,"description":"Timbaúba dos Marinheiros (Chorozinho)","state_id":6},
{"id":8237,"description":"Timbaúva (Bossoroca)","state_id":23},
{"id":2605,"description":"Timbiras","state_id":10},
{"id":4819,"description":"Timboteua (Nova Timboteua)","state_id":14},
{"id":6766,"description":"Timbu Velho (Colombo)","state_id":18},
{"id":9736,"description":"Timburi","state_id":26},
{"id":2032,"description":"Timbuí (Fundão)","state_id":8},
{"id":8734,"description":"Timbé do Sul","state_id":24},
{"id":8735,"description":"Timbó","state_id":24},
{"id":8736,"description":"Timbó Grande","state_id":24},
{"id":2606,"description":"Timon","state_id":10},
{"id":1743,"description":"Timonha (Granja)","state_id":6},
{"id":5477,"description":"Timorante (Exu)","state_id":16},
{"id":4019,"description":"Timóteo","state_id":11},
{"id":6767,"description":"Tindiquera (Araucária)","state_id":18},
{"id":10103,"description":"Tio Hugo","state_id":23},
{"id":1744,"description":"Tipi (Aurora)","state_id":6},
{"id":1084,"description":"Tiquaruçu (Feira de Santana)","state_id":5},
{"id":4020,"description":"Tiradentes","state_id":11},
{"id":6768,"description":"Tiradentes (Pato Branco)","state_id":18},
{"id":6769,"description":"Tiradentes (Salgado Filho)","state_id":18},
{"id":8238,"description":"Tiradentes do Sul","state_id":23},
{"id":4021,"description":"Tiros","state_id":11},
{"id":4022,"description":"Tobati (Ibiá)","state_id":11},
{"id":8850,"description":"Tobias Barreto","state_id":25},
{"id":4023,"description":"Tocandira (Porteirinha)","state_id":11},
{"id":4024,"description":"Tocantins","state_id":11},
{"id":9955,"description":"Tocantinópolis","state_id":27},
{"id":9954,"description":"Tocantínia","state_id":27},
{"id":7103,"description":"Tocos (Campos dos Goytacazes)","state_id":19},
{"id":4025,"description":"Tocos do Moji","state_id":11},
{"id":-1,"description":"Todos","state_id":-1},
{"id":2033,"description":"Todos os Santos (Guarapari)","state_id":8},
{"id":6770,"description":"Toledo","state_id":18},
{"id":4026,"description":"Toledo","state_id":11},
{"id":9737,"description":"Toledo (Tupã)","state_id":26},
{"id":11089,"description":"Toledos","state_id":11},
{"id":8851,"description":"Tomar do Geru","state_id":25},
{"id":6771,"description":"Tomaz Coelho (Araucária)","state_id":18},
{"id":6772,"description":"Tomazina","state_id":18},
{"id":4028,"description":"Tombos","state_id":11},
{"id":4027,"description":"Tomás Gonzaga (Curvelo)","state_id":11},
{"id":1745,"description":"Tomé (Quixeré)","state_id":6},
{"id":4820,"description":"Tomé-Açú","state_id":14},
{"id":273,"description":"Tonantins","state_id":3},
{"id":4029,"description":"Topázio (Teófilo Otoni)","state_id":11},
{"id":4504,"description":"Toricueyje (Barra do Garças)","state_id":13},
{"id":5478,"description":"Toritama","state_id":16},
{"id":4505,"description":"Torixoréu","state_id":13},
{"id":4030,"description":"Torneiros (Pará de Minas)","state_id":11},
{"id":8239,"description":"Toropi","state_id":23},
{"id":8240,"description":"Toroquá (São Francisco de Assis)","state_id":23},
{"id":8241,"description":"Torquato Severo (Dom Pedrito)","state_id":23},
{"id":9738,"description":"Torre de Pedra","state_id":26},
{"id":8242,"description":"Torres","state_id":23},
{"id":4031,"description":"Torreões (Juiz de Fora)","state_id":11},
{"id":9739,"description":"Torrinha","state_id":26},
{"id":8243,"description":"Torrinhas (Pinheiro Machado)","state_id":23},
{"id":8244,"description":"Touro Passo (Rosário do Sul)","state_id":23},
{"id":7300,"description":"Touros","state_id":20},
{"id":9740,"description":"Trabiju","state_id":26},
{"id":4821,"description":"Tracuateua","state_id":14},
{"id":5479,"description":"Tracunhaém","state_id":16},
{"id":12414,"description":"Tracupa","state_id":5},
{"id":185,"description":"Traipu","state_id":2},
{"id":1746,"description":"Trairi","state_id":6},
{"id":7301,"description":"Trairi (Tangará)","state_id":20},
{"id":4822,"description":"Trairão","state_id":14},
{"id":7104,"description":"Trajano de Morais","state_id":19},
{"id":8245,"description":"Tramandaí","state_id":23},
{"id":10210,"description":"Trancoso (Porto Seguro)","state_id":5},
{"id":5480,"description":"Trapiá (Riacho das Almas)","state_id":16},
{"id":1747,"description":"Trapiá (Santa Quitéria)","state_id":6},
{"id":1748,"description":"Trapiá (Sobral)","state_id":6},
{"id":8246,"description":"Travesseiro","state_id":23},
{"id":7105,"description":"Travessão (Campos dos Goytacazes)","state_id":19},
{"id":1085,"description":"Tremedal","state_id":5},
{"id":9741,"description":"Tremembé","state_id":26},
{"id":8247,"description":"Trentin (Jaboticaba)","state_id":23},
{"id":8738,"description":"Treviso","state_id":24},
{"id":11501,"description":"Trevo Do José Rosário","state_id":9},
{"id":12625,"description":"Treze De Maio","state_id":23},
{"id":8740,"description":"Treze Tílias","state_id":24},
{"id":8739,"description":"Treze de Maio","state_id":24},
{"id":1749,"description":"Trici (Tauá)","state_id":6},
{"id":4036,"description":"Trimonte (Volta Grande)","state_id":11},
{"id":2349,"description":"Trindade","state_id":9},
{"id":5482,"description":"Trindade","state_id":16},
{"id":6783,"description":"Trindade (Ponta Grossa)","state_id":18},
{"id":8257,"description":"Trindade do Sul","state_id":23},
{"id":6784,"description":"Triolândia (Ribeirão do Pinhal)","state_id":18},
{"id":5483,"description":"Triunfo","state_id":16},
{"id":5124,"description":"Triunfo","state_id":15},
{"id":8258,"description":"Triunfo","state_id":23},
{"id":12759,"description":"Triunfo","state_id":6},
{"id":11897,"description":"Triunfo","state_id":21},
{"id":7108,"description":"Triunfo (Santa Maria Madalena)","state_id":19},
{"id":7302,"description":"Triunfo Potiguar","state_id":20},
{"id":1086,"description":"Triunfo do Sincorá (Barra da Estiva)","state_id":5},
{"id":2607,"description":"Trizidela do Vale","state_id":10},
{"id":10120,"description":"Triângulo (Chorozinho)","state_id":6},
{"id":6782,"description":"Triângulo (Engenheiro Beltrão)","state_id":18},
{"id":2350,"description":"Trombas","state_id":9},
{"id":8741,"description":"Trombudo Central","state_id":24},
{"id":6785,"description":"Tronco (Castro)","state_id":18},
{"id":8259,"description":"Tronqueiras (Miraguaí)","state_id":23},
{"id":1751,"description":"Trussu (Acopiara)","state_id":6},
{"id":9742,"description":"Três Alianças (Mirandópolis)","state_id":26},
{"id":8248,"description":"Três Arroios","state_id":23},
{"id":8737,"description":"Três Barras","state_id":24},
{"id":8249,"description":"Três Barras (Aratiba)","state_id":23},
{"id":11474,"description":"Três Barras Da Estrada Real","state_id":11},
{"id":6774,"description":"Três Barras do Paraná","state_id":18},
{"id":6775,"description":"Três Bicos (Cândido de Abreu)","state_id":18},
{"id":6776,"description":"Três Bocas (Toledo)","state_id":18},
{"id":8250,"description":"Três Cachoeiras","state_id":23},
{"id":6777,"description":"Três Capões (Guarapuava)","state_id":18},
{"id":4032,"description":"Três Corações","state_id":11},
{"id":8251,"description":"Três Coroas","state_id":23},
{"id":6778,"description":"Três Córregos (Campo Largo)","state_id":18},
{"id":8253,"description":"Três Forquilhas","state_id":23},
{"id":9743,"description":"Três Fronteiras","state_id":26},
{"id":4033,"description":"Três Ilhas (Belmiro Braga)","state_id":11},
{"id":7106,"description":"Três Irmãos (Cambuci)","state_id":19},
{"id":5481,"description":"Três Ladeiras (Igarassu)","state_id":16},
{"id":4263,"description":"Três Lagoas","state_id":12},
{"id":6779,"description":"Três Lagoas (Foz do Iguaçu)","state_id":18},
{"id":4034,"description":"Três Marias","state_id":11},
{"id":12541,"description":"Três Mártires","state_id":23},
{"id":8254,"description":"Três Palmeiras","state_id":23},
{"id":8255,"description":"Três Passos","state_id":23},
{"id":12624,"description":"Três Pinheiros","state_id":23},
{"id":6780,"description":"Três Pinheiros (Guarapuava)","state_id":18},
{"id":6781,"description":"Três Placas (Umuarama)","state_id":18},
{"id":4035,"description":"Três Pontas","state_id":11},
{"id":9744,"description":"Três Pontes (Amparo)","state_id":26},
{"id":4506,"description":"Três Pontes (Rondonópolis)","state_id":13},
{"id":2348,"description":"Três Ranchos","state_id":9},
{"id":7107,"description":"Três Rios","state_id":19},
{"id":8256,"description":"Três Vendas (Cachoeira do Sul)","state_id":23},
{"id":9745,"description":"Três Vendas (Tupã)","state_id":26},
{"id":8252,"description":"Três de Maio","state_id":23},
{"id":1750,"description":"Tróia (Pedra Branca)","state_id":6},
{"id":8742,"description":"Tubarão","state_id":24},
{"id":1087,"description":"Tucano","state_id":5},
{"id":4823,"description":"Tucumã","state_id":14},
{"id":1752,"description":"Tucunduba (Caucaia)","state_id":6},
{"id":8260,"description":"Tucunduva","state_id":23},
{"id":1753,"description":"Tucuns (Crateús)","state_id":6},
{"id":4824,"description":"Tucuruí","state_id":14},
{"id":2608,"description":"Tufilândia","state_id":10},
{"id":9746,"description":"Tuiuti","state_id":26},
{"id":8261,"description":"Tuiuti (Bento Gonçalves)","state_id":23},
{"id":4037,"description":"Tuiutinga (Guiricema)","state_id":11},
{"id":11768,"description":"Tuiué","state_id":3},
{"id":9747,"description":"Tujuguaba (Conchal)","state_id":26},
{"id":4038,"description":"Tumiritinga","state_id":11},
{"id":8262,"description":"Tunas","state_id":23},
{"id":6786,"description":"Tunas do Paraná","state_id":18},
{"id":6787,"description":"Tuneiras do Oeste","state_id":18},
{"id":2609,"description":"Tuntum","state_id":10},
{"id":8743,"description":"Tunápolis","state_id":24},
{"id":4039,"description":"Tupaciguara","state_id":11},
{"id":5484,"description":"Tupanaci (Mirandiba)","state_id":16},
{"id":5485,"description":"Tupanatinga","state_id":16},
{"id":8264,"description":"Tupanci do Sul","state_id":23},
{"id":8265,"description":"Tupanciretã","state_id":23},
{"id":8266,"description":"Tupancy ou Vila Block (São Sepé)","state_id":23},
{"id":8267,"description":"Tupandi","state_id":23},
{"id":8268,"description":"Tupantuba (Santiago)","state_id":23},
{"id":4040,"description":"Tuparecê (Medina)","state_id":11},
{"id":8269,"description":"Tuparendi","state_id":23},
{"id":5487,"description":"Tuparetama","state_id":16},
{"id":5486,"description":"Tupaóca (Aliança)","state_id":16},
{"id":9749,"description":"Tupi (Piracicaba)","state_id":26},
{"id":9750,"description":"Tupi Paulista","state_id":26},
{"id":8270,"description":"Tupi Silveira (Hulha Negra)","state_id":23},
{"id":6789,"description":"Tupinambá (Astorga)","state_id":18},
{"id":8271,"description":"Tupinambá (Lagoa Vermelha)","state_id":23},
{"id":2351,"description":"Tupiracaba (Niquelândia)","state_id":9},
{"id":9956,"description":"Tupirama","state_id":27},
{"id":9958,"description":"Tupiratins","state_id":27},
{"id":9957,"description":"Tupiratã (Presidente Kennedy)","state_id":27},
{"id":8744,"description":"Tupitinga (Campos Novos)","state_id":24},
{"id":9748,"description":"Tupã","state_id":26},
{"id":6788,"description":"Tupãssi","state_id":18},
{"id":2610,"description":"Turiaçu","state_id":10},
{"id":9751,"description":"Turiba do Sul (Itaberá)","state_id":26},
{"id":2611,"description":"Turilândia","state_id":10},
{"id":9752,"description":"Turiúba","state_id":26},
{"id":4041,"description":"Turmalina","state_id":11},
{"id":9753,"description":"Turmalina","state_id":26},
{"id":1755,"description":"Tururu","state_id":6},
{"id":8272,"description":"Turuçu","state_id":23},
{"id":2353,"description":"Turvelândia","state_id":9},
{"id":8273,"description":"Turvinho (Coronel Bicaco)","state_id":23},
{"id":6790,"description":"Turvo","state_id":18},
{"id":8745,"description":"Turvo","state_id":24},
{"id":4042,"description":"Turvolândia","state_id":11},
{"id":2352,"description":"Turvânia","state_id":9},
{"id":9754,"description":"Turvínia (Bebedouro)","state_id":26},
{"id":2612,"description":"Tutóia","state_id":10},
{"id":1754,"description":"Tuína (Massapê)","state_id":6},
{"id":8263,"description":"Túnel Verde (Cidreira)","state_id":23},
{"id":274,"description":"Uarini","state_id":3},
{"id":1088,"description":"Uauá","state_id":5},
{"id":1090,"description":"Ubaitaba","state_id":5},
{"id":1756,"description":"Ubajara","state_id":6},
{"id":6791,"description":"Ubaldino Taques (Coronel Domingos Soares)","state_id":18},
{"id":4045,"description":"Ubaporanga","state_id":11},
{"id":9755,"description":"Ubarana","state_id":26},
{"id":4046,"description":"Ubari (Ubá)","state_id":11},
{"id":9756,"description":"Ubatuba","state_id":26},
{"id":1091,"description":"Ubatã","state_id":5},
{"id":6792,"description":"Ubauna (São João do Ivaí)","state_id":18},
{"id":4044,"description":"Ubaí","state_id":11},
{"id":1089,"description":"Ubaíra","state_id":5},
{"id":1757,"description":"Ubaúna (Coreaú)","state_id":6},
{"id":4047,"description":"Uberaba","state_id":11},
{"id":4048,"description":"Uberlândia","state_id":11},
{"id":1092,"description":"Ubiracaba (Brumado)","state_id":5},
{"id":1093,"description":"Ubiraitá (Andaraí)","state_id":5},
{"id":9757,"description":"Ubirajara","state_id":26},
{"id":6793,"description":"Ubiratã","state_id":18},
{"id":1758,"description":"Ubiraçu (Canindé)","state_id":6},
{"id":8274,"description":"Ubiretama","state_id":23},
{"id":4043,"description":"Ubá","state_id":11},
{"id":9758,"description":"Uchoa","state_id":26},
{"id":1094,"description":"Uibaí","state_id":5},
{"id":7387,"description":"Uiramutá","state_id":22},
{"id":1759,"description":"Uiraponga (Morada Nova)","state_id":6},
{"id":2354,"description":"Uirapuru","state_id":9},
{"id":5125,"description":"Uiraúna","state_id":15},
{"id":4825,"description":"Ulianópolis","state_id":14},
{"id":1760,"description":"Umari","state_id":6},
{"id":5126,"description":"Umari (São João do Rio do Peixe)","state_id":15},
{"id":1761,"description":"Umarituba (São Gonçalo do Amarante)","state_id":6},
{"id":7303,"description":"Umarizal","state_id":20},
{"id":10772,"description":"Umarizeiras","state_id":6},
{"id":8852,"description":"Umbaúba","state_id":25},
{"id":8275,"description":"Umbu (Cacequi)","state_id":23},
{"id":1095,"description":"Umburanas","state_id":5},
{"id":11738,"description":"Umburanas","state_id":16},
{"id":1762,"description":"Umburanas (Mauriti)","state_id":6},
{"id":4049,"description":"Umburatiba","state_id":11},
{"id":5489,"description":"Umburetama (Orobó)","state_id":16},
{"id":5127,"description":"Umbuzeiro","state_id":15},
{"id":12415,"description":"Umbuzeiro","state_id":5},
{"id":4050,"description":"Umbuzeiro (Lontra)","state_id":11},
{"id":1096,"description":"Umbuzeiro (Olindina)","state_id":5},
{"id":1763,"description":"Umirim","state_id":6},
{"id":6794,"description":"Umuarama","state_id":18},
{"id":5488,"description":"Umãs (Salgueiro)","state_id":16},
{"id":1097,"description":"Una","state_id":5},
{"id":4051,"description":"Unaí","state_id":11},
{"id":6798,"description":"Uniflor","state_id":18},
{"id":8277,"description":"Unistalda","state_id":23},
{"id":9760,"description":"Universo (Tupã)","state_id":26},
{"id":12574,"description":"União","state_id":23},
{"id":5722,"description":"União","state_id":17},
{"id":6795,"description":"União (Laranjeiras do Sul)","state_id":18},
{"id":11920,"description":"União Bandeirante","state_id":21},
{"id":11557,"description":"União Da Floresta","state_id":14},
{"id":9759,"description":"União Paulista","state_id":26},
{"id":8276,"description":"União da Serra","state_id":23},
{"id":6796,"description":"União da Vitória","state_id":18},
{"id":4052,"description":"União de Minas","state_id":11},
{"id":8746,"description":"União do Oeste","state_id":24},
{"id":6797,"description":"União do Oeste (Santa Izabel do Oeste)","state_id":18},
{"id":4507,"description":"União do Sul","state_id":13},
{"id":186,"description":"União dos Palmares","state_id":2},
{"id":7304,"description":"Upanema","state_id":20},
{"id":5490,"description":"Upatininga (Aliança)","state_id":16},
{"id":1098,"description":"Urandi","state_id":5},
{"id":6799,"description":"Uraí","state_id":18},
{"id":2613,"description":"Urbano Santos","state_id":10},
{"id":5491,"description":"Urimama (Santa Maria da Boa Vista)","state_id":16},
{"id":9762,"description":"Uru","state_id":26},
{"id":2356,"description":"Uruana","state_id":9},
{"id":4053,"description":"Uruana de Minas","state_id":11},
{"id":4826,"description":"Uruará","state_id":14},
{"id":2355,"description":"Uruaçu","state_id":9},
{"id":8747,"description":"Urubici","state_id":24},
{"id":1764,"description":"Uruburetama","state_id":6},
{"id":275,"description":"Urucará","state_id":3},
{"id":5493,"description":"Urucubá (Limoeiro)","state_id":16},
{"id":4055,"description":"Urucuia","state_id":11},
{"id":4827,"description":"Urucuri (São Miguel do Guamá)","state_id":14},
{"id":4828,"description":"Urucuriteua (São Miguel do Guamá)","state_id":14},
{"id":276,"description":"Urucurituba","state_id":3},
{"id":4054,"description":"Urucânia","state_id":11},
{"id":8748,"description":"Uruguai (Piratuba)","state_id":24},
{"id":8278,"description":"Uruguaiana","state_id":23},
{"id":2357,"description":"Uruita (Uruana)","state_id":9},
{"id":1765,"description":"Uruoca","state_id":6},
{"id":8749,"description":"Urupema","state_id":24},
{"id":7367,"description":"Urupá","state_id":21},
{"id":9763,"description":"Urupês","state_id":26},
{"id":1766,"description":"Uruquê (Quixeramobim)","state_id":6},
{"id":9764,"description":"Ururai (Santa Adélia)","state_id":26},
{"id":8750,"description":"Urussanga","state_id":24},
{"id":2358,"description":"Urutaí","state_id":9},
{"id":11845,"description":"Uruás","state_id":16},
{"id":5492,"description":"Uruçu-Mirim (Gravatá)","state_id":16},
{"id":1099,"description":"Uruçuca","state_id":5},
{"id":5723,"description":"Uruçuí","state_id":17},
{"id":9761,"description":"Urânia","state_id":26},
{"id":2034,"description":"Urânia (Alfredo Chaves)","state_id":8},
{"id":6800,"description":"Usina (Campo Mourão)","state_id":18},
{"id":187,"description":"Usina Camaçari (Coruripe)","state_id":2},
{"id":4056,"description":"Usina Monte Alegre (Monte Belo)","state_id":11},
{"id":11712,"description":"Usina Roçadinho","state_id":16},
{"id":1100,"description":"Utinga","state_id":5},
{"id":9765,"description":"Utinga (Santo André)","state_id":26},
{"id":6801,"description":"Uvaia (Ponta Grossa)","state_id":18},
{"id":2359,"description":"Uvá (Goiás)","state_id":9},
{"id":8279,"description":"Vacacai (São Gabriel)","state_id":23},
{"id":8280,"description":"Vacaria","state_id":23},
{"id":4057,"description":"Vai-Volta (Tarumirim)","state_id":11},
{"id":4829,"description":"Val-de-Cães (Belém)","state_id":14},
{"id":4058,"description":"Valadares (Juiz de Fora)","state_id":11},
{"id":2360,"description":"Valdelândia (Rubiataba)","state_id":9},
{"id":11740,"description":"Valdemar Siqueira","state_id":16},
{"id":8281,"description":"Valdástico (Encantado)","state_id":23},
{"id":12485,"description":"Vale Do Arroio Grande","state_id":23},
{"id":12470,"description":"Vale Do Sampaio","state_id":23},
{"id":11098,"description":"Vale Dos Vinhedos","state_id":23},
{"id":9766,"description":"Vale Formoso (Novo Horizonte)","state_id":26},
{"id":8284,"description":"Vale Real","state_id":23},
{"id":4509,"description":"Vale Rico (Guiratinga)","state_id":13},
{"id":8285,"description":"Vale Veneto (São João do Polesine)","state_id":23},
{"id":8286,"description":"Vale Verde","state_id":23},
{"id":1101,"description":"Vale Verde (Porto Seguro)","state_id":5},
{"id":4060,"description":"Vale Verde de Minas (Ipaba)","state_id":11},
{"id":4476,"description":"Vale de São Domingos","state_id":13},
{"id":7368,"description":"Vale do Anari","state_id":21},
{"id":7369,"description":"Vale do Paraíso","state_id":21},
{"id":8282,"description":"Vale do Rio Cai (Nova Petrópolis)","state_id":23},
{"id":8283,"description":"Vale do Sol","state_id":23},
{"id":4508,"description":"Vale dos Sonhos (Barra do Garças)","state_id":13},
{"id":1103,"description":"Valente","state_id":5},
{"id":9767,"description":"Valentim Gentil","state_id":26},
{"id":6802,"description":"Valentins (Ponta Grossa)","state_id":18},
{"id":1102,"description":"Valença","state_id":5},
{"id":7110,"description":"Valença","state_id":19},
{"id":5724,"description":"Valença do Piauí","state_id":17},
{"id":9768,"description":"Valinhos","state_id":26},
{"id":4061,"description":"Valo Fundo (Santo Hipólito)","state_id":11},
{"id":9769,"description":"Valparaíso","state_id":26},
{"id":2361,"description":"Valparaíso de Goiás","state_id":9},
{"id":4059,"description":"Valão (Poté)","state_id":11},
{"id":7109,"description":"Valão do Barro (São Sebastião do Alto)","state_id":19},
{"id":6803,"description":"Valério (Planalto)","state_id":18},
{"id":9770,"description":"Vanglória (Pederneiras)","state_id":26},
{"id":8287,"description":"Vanini","state_id":23},
{"id":12634,"description":"Varame","state_id":23},
{"id":6804,"description":"Vargeado (Castro)","state_id":18},
{"id":8752,"description":"Vargem","state_id":24},
{"id":9771,"description":"Vargem","state_id":26},
{"id":4062,"description":"Vargem Alegre","state_id":11},
{"id":7111,"description":"Vargem Alegre (Barra do Piraí)","state_id":19},
{"id":2035,"description":"Vargem Alta","state_id":8},
{"id":4063,"description":"Vargem Bonita","state_id":11},
{"id":8753,"description":"Vargem Bonita","state_id":24},
{"id":2614,"description":"Vargem Grande","state_id":10},
{"id":9773,"description":"Vargem Grande Paulista","state_id":26},
{"id":4064,"description":"Vargem Grande do Rio Pardo","state_id":11},
{"id":2036,"description":"Vargem Grande do Soturno (Cachoeiro de Itapemirim)","state_id":8},
{"id":9772,"description":"Vargem Grande do Sul","state_id":26},
{"id":4065,"description":"Vargem Linda (São Domingos do Prata)","state_id":11},
{"id":8754,"description":"Vargem do Cedro (São Martinho)","state_id":24},
{"id":8751,"description":"Vargeão","state_id":24},
{"id":4066,"description":"Varginha","state_id":11},
{"id":11801,"description":"Varginha","state_id":2},
{"id":4510,"description":"Varginha (Santo Antônio do Leverger)","state_id":13},
{"id":1767,"description":"Varjota","state_id":6},
{"id":2362,"description":"Varjão","state_id":9},
{"id":4067,"description":"Varjão de Minas","state_id":11},
{"id":9774,"description":"Varpa (Tupã)","state_id":26},
{"id":7112,"description":"Varre-Sai","state_id":19},
{"id":1110,"description":"Varzedo","state_id":5},
{"id":4069,"description":"Varzelândia","state_id":11},
{"id":11880,"description":"Vasco Alves","state_id":23},
{"id":5494,"description":"Vasques (Salgueiro)","state_id":16},
{"id":6805,"description":"Vassoural (Ibaiti)","state_id":18},
{"id":7113,"description":"Vassouras","state_id":19},
{"id":4070,"description":"Vau-Açu (Ponte Nova)","state_id":11},
{"id":4071,"description":"Vazante","state_id":11},
{"id":12350,"description":"Vazante","state_id":9},
{"id":5131,"description":"Vazante (Diamante)","state_id":15},
{"id":1772,"description":"Vazantes (Aracoiaba)","state_id":6},
{"id":12121,"description":"Vazente Do Curú","state_id":6},
{"id":12607,"description":"Veado Pardo","state_id":23},
{"id":4830,"description":"Veiros (Porto de Moz)","state_id":14},
{"id":1111,"description":"Velha Boipeba (Cairu)","state_id":5},
{"id":4264,"description":"Velhacaria (Paranaíba)","state_id":12},
{"id":9776,"description":"Venda Branca (Casa Branca)","state_id":26},
{"id":2037,"description":"Venda Nova do Imigrante","state_id":8},
{"id":7114,"description":"Venda das Flores (Miracema)","state_id":19},
{"id":7115,"description":"Venda das Pedras (Itaboraí)","state_id":19},
{"id":5495,"description":"Veneza (Parnamirim)","state_id":16},
{"id":7306,"description":"Venha-Ver","state_id":20},
{"id":6806,"description":"Ventania","state_id":18},
{"id":1773,"description":"Ventura (Alcântaras)","state_id":6},
{"id":1112,"description":"Ventura (Morro do Chapéu)","state_id":5},
{"id":5496,"description":"Venturosa","state_id":16},
{"id":8288,"description":"Venâncio Aires","state_id":23},
{"id":4512,"description":"Vera","state_id":13},
{"id":7307,"description":"Vera Cruz","state_id":20},
{"id":1113,"description":"Vera Cruz","state_id":5},
{"id":8289,"description":"Vera Cruz","state_id":23},
{"id":9777,"description":"Vera Cruz","state_id":26},
{"id":4072,"description":"Vera Cruz de Minas (Pedro Leopoldo)","state_id":11},
{"id":6807,"description":"Vera Cruz do Oeste","state_id":18},
{"id":6808,"description":"Vera Guarani (Paulo Frontin)","state_id":18},
{"id":5727,"description":"Vera Mendes","state_id":17},
{"id":8290,"description":"Veranópolis","state_id":23},
{"id":12104,"description":"Veranópolis","state_id":13},
{"id":5497,"description":"Verdejante","state_id":16},
{"id":4073,"description":"Verdelândia","state_id":11},
{"id":1114,"description":"Vereda","state_id":5},
{"id":4074,"description":"Vereda do Paraíso (São João do Paraíso)","state_id":11},
{"id":4075,"description":"Veredas (João Pinheiro)","state_id":11},
{"id":4076,"description":"Veredinha","state_id":11},
{"id":11987,"description":"Veredinha","state_id":5},
{"id":4078,"description":"Vermelho (Muriaé)","state_id":11},
{"id":4079,"description":"Vermelho Novo","state_id":11},
{"id":4080,"description":"Vermelho Velho (Raul Soares)","state_id":11},
{"id":11723,"description":"Vermelhos","state_id":16},
{"id":5498,"description":"Vertente do Lério","state_id":16},
{"id":5499,"description":"Vertentes","state_id":16},
{"id":8291,"description":"Vertentes (Uruguaiana)","state_id":23},
{"id":1774,"description":"Vertentes do Lagedo (Maranguape)","state_id":6},
{"id":6809,"description":"Verê","state_id":18},
{"id":4077,"description":"Veríssimo","state_id":11},
{"id":4081,"description":"Vespasiano","state_id":11},
{"id":8292,"description":"Vespasiano Correa","state_id":23},
{"id":8293,"description":"Viadutos","state_id":23},
{"id":8294,"description":"Viamão","state_id":23},
{"id":2615,"description":"Viana","state_id":10},
{"id":2038,"description":"Viana","state_id":8},
{"id":2363,"description":"Vianópolis","state_id":9},
{"id":8295,"description":"Vicente Dutra","state_id":23},
{"id":9778,"description":"Vicente de Carvalho (Guarujá)","state_id":26},
{"id":4265,"description":"Vicentina","state_id":12},
{"id":2364,"description":"Vicentinópolis","state_id":9},
{"id":9779,"description":"Vicentinópolis (Santo Antônio do Aracanguá)","state_id":26},
{"id":8296,"description":"Victor Graeff","state_id":23},
{"id":5500,"description":"Vicência","state_id":16},
{"id":6810,"description":"Vida Nova (Sapopema)","state_id":18},
{"id":8755,"description":"Vidal Ramos","state_id":24},
{"id":8756,"description":"Videira","state_id":24},
{"id":11630,"description":"Video","state_id":6},
{"id":6811,"description":"Vidigal (Cianorte)","state_id":18},
{"id":2039,"description":"Vieira Machado (Muniz Freire)","state_id":8},
{"id":4083,"description":"Vieiras","state_id":11},
{"id":5132,"description":"Vieirópolis","state_id":15},
{"id":4831,"description":"Vigia","state_id":14},
{"id":11084,"description":"Vila Acari","state_id":11},
{"id":6812,"description":"Vila Alta","state_id":18},
{"id":11759,"description":"Vila Amazônia","state_id":3},
{"id":189,"description":"Vila Aparecida (Arapiraca)","state_id":2},
{"id":4513,"description":"Vila Atlântica (Marcelândia)","state_id":13},
{"id":4514,"description":"Vila Bela da Santíssima Trindade","state_id":13},
{"id":11754,"description":"Vila Bem-Querer","state_id":11},
{"id":8297,"description":"Vila Bender (Crissiumal)","state_id":23},
{"id":11772,"description":"Vila Bittencourt","state_id":3},
{"id":12529,"description":"Vila Block","state_id":23},
{"id":2365,"description":"Vila Boa","state_id":9},
{"id":4084,"description":"Vila Bom Jesus (Arinos)","state_id":11},
{"id":4515,"description":"Vila Bueno (Rondonópolis)","state_id":13},
{"id":12653,"description":"Vila Campos","state_id":23},
{"id":12067,"description":"Vila Cardoso","state_id":13},
{"id":12762,"description":"Vila Celeste","state_id":18},
{"id":8757,"description":"Vila Conceição (São João do Sul)","state_id":24},
{"id":4085,"description":"Vila Costina (Pains)","state_id":11},
{"id":12419,"description":"Vila Cristina","state_id":23},
{"id":8298,"description":"Vila Cruz (Nova Palma)","state_id":23},
{"id":6813,"description":"Vila Diniz (Cruzmaltina)","state_id":18},
{"id":9780,"description":"Vila Dirce (Carapicuíba)","state_id":26},
{"id":7370,"description":"Vila Extrema (Porto Velho)","state_id":21},
{"id":11097,"description":"Vila Fernando Ferrari","state_id":23},
{"id":7309,"description":"Vila Flor","state_id":20},
{"id":8299,"description":"Vila Flores","state_id":23},
{"id":6815,"description":"Vila Flórida (Toledo)","state_id":18},
{"id":4266,"description":"Vila Formosa (Dourados)","state_id":12},
{"id":4834,"description":"Vila França (Santarém)","state_id":14},
{"id":12502,"description":"Vila Freire","state_id":23},
{"id":6816,"description":"Vila Gandhi (Primeiro de Maio)","state_id":18},
{"id":4835,"description":"Vila Goreth (Santarém)","state_id":14},
{"id":6817,"description":"Vila Guay (Ibaiti)","state_id":18},
{"id":4836,"description":"Vila Isol (Itaituba)","state_id":14},
{"id":12427,"description":"Vila Ituim","state_id":23},
{"id":8300,"description":"Vila Langaro","state_id":23},
{"id":8301,"description":"Vila Laranjeira (Santo Cristo)","state_id":23},
{"id":11756,"description":"Vila Lindóia","state_id":3},
{"id":11219,"description":"Vila Mandi","state_id":14},
{"id":8302,"description":"Vila Maria","state_id":23},
{"id":4267,"description":"Vila Marques (Aral Moreira)","state_id":12},
{"id":8759,"description":"Vila Milani (São Domingos)","state_id":24},
{"id":7118,"description":"Vila Muriqui (Mangaratiba)","state_id":19},
{"id":4516,"description":"Vila Mutum (Alta Floresta)","state_id":13},
{"id":2040,"description":"Vila Nelita (Água Doce do Norte)","state_id":8},
{"id":9781,"description":"Vila Nery (São Carlos)","state_id":26},
{"id":11844,"description":"Vila Nossa Senhora Aparecida","state_id":16},
{"id":11809,"description":"Vila Nova","state_id":16},
{"id":5501,"description":"Vila Nova (Casinhas)","state_id":16},
{"id":8760,"description":"Vila Nova (Imbituba)","state_id":24},
{"id":6818,"description":"Vila Nova (Pitanga)","state_id":18},
{"id":4837,"description":"Vila Nova (São Caetano de Odivelas)","state_id":14},
{"id":6819,"description":"Vila Nova (Toledo)","state_id":18},
{"id":11862,"description":"Vila Nova - N5","state_id":16},
{"id":12124,"description":"Vila Nova Floresta","state_id":11},
{"id":2041,"description":"Vila Nova de Bananal (Baixo Guandu)","state_id":8},
{"id":7119,"description":"Vila Nova de Campos (Campos dos Goytacazes)","state_id":19},
{"id":6820,"description":"Vila Nova de Florença (São Jerônimo da Serra)","state_id":18},
{"id":4086,"description":"Vila Nova de Minas (Montes Claros)","state_id":11},
{"id":5728,"description":"Vila Nova do Piauí","state_id":17},
{"id":8303,"description":"Vila Nova do Sul","state_id":23},
{"id":2616,"description":"Vila Nova dos Martírios","state_id":10},
{"id":4087,"description":"Vila Nova dos Poções (Janaúba)","state_id":11},
{"id":4517,"description":"Vila Operária (Rondonópolis)","state_id":13},
{"id":6821,"description":"Vila Paraíso (São João)","state_id":18},
{"id":4518,"description":"Vila Paulista (Rondonópolis)","state_id":13},
{"id":2042,"description":"Vila Pavão","state_id":8},
{"id":12640,"description":"Vila Paz","state_id":23},
{"id":4088,"description":"Vila Pereira (Nanuque)","state_id":11},
{"id":277,"description":"Vila Pitinga (Presidente Figueiredo)","state_id":3},
{"id":4838,"description":"Vila Planalto (Itaituba)","state_id":14},
{"id":4519,"description":"Vila Progresso (Salto do Céu)","state_id":13},
{"id":2367,"description":"Vila Propício","state_id":9},
{"id":6822,"description":"Vila Reis (Apucarana)","state_id":18},
{"id":4520,"description":"Vila Rica","state_id":13},
{"id":8304,"description":"Vila Rica (Chapada)","state_id":23},
{"id":4268,"description":"Vila Rica (Vicentina)","state_id":12},
{"id":6823,"description":"Vila Rica do Ivaí (Icaraíma)","state_id":18},
{"id":6824,"description":"Vila Roberto Brzezinski (Campo Mourão)","state_id":18},
{"id":4839,"description":"Vila Santa Fé (Marabá)","state_id":14},
{"id":8305,"description":"Vila Seca (Santo Ângelo)","state_id":23},
{"id":2368,"description":"Vila Sertaneja (Uirapuru)","state_id":9},
{"id":6825,"description":"Vila Silva Jardim (Paranacity)","state_id":18},
{"id":1777,"description":"Vila Soares (Apuiarés)","state_id":6},
{"id":4840,"description":"Vila Socorro (Santarém)","state_id":14},
{"id":12652,"description":"Vila Souza","state_id":23},
{"id":190,"description":"Vila São Francisco (Arapiraca)","state_id":2},
{"id":8306,"description":"Vila Turvo (Campo Novo)","state_id":23},
{"id":4269,"description":"Vila União (Deodápolis)","state_id":12},
{"id":2043,"description":"Vila Valério","state_id":8},
{"id":4270,"description":"Vila Vargas (Dourados)","state_id":12},
{"id":2044,"description":"Vila Velha","state_id":8},
{"id":323,"description":"Vila Velha (Oiapoque)","state_id":4},
{"id":6826,"description":"Vila Velha (Ponta Grossa)","state_id":18},
{"id":2045,"description":"Vila Verde (Pancas)","state_id":8},
{"id":9782,"description":"Vila Xavier (Araraquara)","state_id":26},
{"id":11758,"description":"Vila Zé Açu","state_id":3},
{"id":7116,"description":"Vila da Grama (Trajano de Morais)","state_id":19},
{"id":8758,"description":"Vila de Volta Grande (Rio Negrinho)","state_id":24},
{"id":1115,"description":"Vila do Café (Encruzilhada)","state_id":5},
{"id":4832,"description":"Vila do Carmo do Tocantins (Cametá)","state_id":14},
{"id":7117,"description":"Vila do Frade (Angra dos Reis)","state_id":19},
{"id":4833,"description":"Vila dos Cabanos (Barcarena)","state_id":14},
{"id":6814,"description":"Vila dos Roldos (Pato Branco)","state_id":18},
{"id":4841,"description":"Vilarinho do Monte (Porto de Moz)","state_id":14},
{"id":4089,"description":"Vilas Boas (Guiricema)","state_id":11},
{"id":7371,"description":"Vilhena","state_id":21},
{"id":9783,"description":"Vinhedo","state_id":26},
{"id":2046,"description":"Vinhático (Montanha)","state_id":8},
{"id":2047,"description":"Vinte e Cinco de Julho (Santa Teresa)","state_id":8},
{"id":9784,"description":"Viradouro","state_id":26},
{"id":5502,"description":"Viração (Exu)","state_id":16},
{"id":4090,"description":"Virgem da Lapa","state_id":11},
{"id":4092,"description":"Virginópolis","state_id":11},
{"id":4093,"description":"Virgolândia","state_id":11},
{"id":4091,"description":"Virgínia","state_id":11},
{"id":6827,"description":"Virmond","state_id":18},
{"id":12108,"description":"Visconde De Itaboraí","state_id":19},
{"id":11452,"description":"Visconde De Mauá","state_id":19},
{"id":7120,"description":"Visconde de Imbé (Trajano de Morais)","state_id":19},
{"id":4094,"description":"Visconde do Rio Branco","state_id":11},
{"id":4842,"description":"Viseu","state_id":14},
{"id":8307,"description":"Vista Alegre","state_id":23},
{"id":4095,"description":"Vista Alegre (Cataguases)","state_id":11},
{"id":4096,"description":"Vista Alegre (Claro dos Poções)","state_id":11},
{"id":8308,"description":"Vista Alegre (Colorado)","state_id":23},
{"id":6828,"description":"Vista Alegre (Coronel Vivida)","state_id":18},
{"id":4843,"description":"Vista Alegre (Curuçá)","state_id":14},
{"id":6829,"description":"Vista Alegre (Enéas Marques)","state_id":18},
{"id":4271,"description":"Vista Alegre (Maracajú)","state_id":12},
{"id":7372,"description":"Vista Alegre do Abunã (Porto Velho)","state_id":21},
{"id":9785,"description":"Vista Alegre do Alto","state_id":26},
{"id":4844,"description":"Vista Alegre do Pará (Marapanim)","state_id":14},
{"id":8309,"description":"Vista Alegre do Prata","state_id":23},
{"id":6830,"description":"Vista Bonita (Campo Largo)","state_id":18},
{"id":8310,"description":"Vista Gaúcha","state_id":23},
{"id":12551,"description":"Vista Gaúcha","state_id":23},
{"id":12564,"description":"Vista Nova","state_id":23},
{"id":5133,"description":"Vista Serrana","state_id":15},
{"id":9787,"description":"Vitoriana (Botucatu)","state_id":26},
{"id":6832,"description":"Vitorino","state_id":18},
{"id":2618,"description":"Vitorino Freire","state_id":10},
{"id":4097,"description":"Vitorinos (Alto Rio Doce)","state_id":11},
{"id":2048,"description":"Vitória","state_id":8},
{"id":6831,"description":"Vitória (Guarapuava)","state_id":18},
{"id":8311,"description":"Vitória (Ibiaçá)","state_id":23},
{"id":9786,"description":"Vitória Brasil","state_id":26},
{"id":1116,"description":"Vitória da Conquista","state_id":5},
{"id":8312,"description":"Vitória das Missões","state_id":23},
{"id":5503,"description":"Vitória de Santo Antão","state_id":16},
{"id":324,"description":"Vitória do Jari","state_id":4},
{"id":2617,"description":"Vitória do Mearim","state_id":10},
{"id":4845,"description":"Vitória do Xingu","state_id":14},
{"id":7308,"description":"Viçosa","state_id":20},
{"id":188,"description":"Viçosa","state_id":2},
{"id":12215,"description":"Viçosa","state_id":6},
{"id":4082,"description":"Viçosa","state_id":11},
{"id":1775,"description":"Viçosa (Fortim)","state_id":6},
{"id":1776,"description":"Viçosa do Ceará","state_id":6},
{"id":8313,"description":"Volta Alegre (Espumoso)","state_id":23},
{"id":12689,"description":"Volta Da Serra","state_id":5},
{"id":8314,"description":"Volta Fechada (Aratiba)","state_id":23},
{"id":4098,"description":"Volta Grande","state_id":11},
{"id":8315,"description":"Volta Grande (Alpestre)","state_id":23},
{"id":1117,"description":"Volta Grande (Tapiramutá)","state_id":5},
{"id":7121,"description":"Volta Redonda","state_id":19},
{"id":12629,"description":"Volta Vitória","state_id":23},
{"id":5504,"description":"Volta do Moxotó (Jatobá)","state_id":16},
{"id":9788,"description":"Votorantim","state_id":26},
{"id":9789,"description":"Votuporanga","state_id":26},
{"id":7305,"description":"Várzea","state_id":20},
{"id":5128,"description":"Várzea","state_id":15},
{"id":12517,"description":"Várzea","state_id":23},
{"id":12434,"description":"Várzea","state_id":23},
{"id":1768,"description":"Várzea (Cedro)","state_id":6},
{"id":1769,"description":"Várzea Alegre","state_id":6},
{"id":5725,"description":"Várzea Branca","state_id":17},
{"id":5129,"description":"Várzea Comprida (Pombal)","state_id":15},
{"id":12062,"description":"Várzea Da Onça","state_id":6},
{"id":12430,"description":"Várzea Dos Antunes","state_id":23},
{"id":4511,"description":"Várzea Grande","state_id":13},
{"id":5726,"description":"Várzea Grande","state_id":17},
{"id":1108,"description":"Várzea Nova","state_id":5},
{"id":5130,"description":"Várzea Nova (Santa Rita)","state_id":15},
{"id":9775,"description":"Várzea Paulista","state_id":26},
{"id":4068,"description":"Várzea da Palma","state_id":11},
{"id":1104,"description":"Várzea da Roça","state_id":5},
{"id":1770,"description":"Várzea da Volta (Moraújo)","state_id":6},
{"id":1105,"description":"Várzea do Caldas (Seabra)","state_id":5},
{"id":1106,"description":"Várzea do Cerco (Mulungu do Morro)","state_id":5},
{"id":1771,"description":"Várzea do Gilo (Ipu)","state_id":6},
{"id":1107,"description":"Várzea do Poço","state_id":5},
{"id":1109,"description":"Várzeas (Baianópolis)","state_id":5},
{"id":9959,"description":"Vênus (Araguaína)","state_id":27},
{"id":8761,"description":"Vítor Meireles","state_id":24},
{"id":1118,"description":"Wagner","state_id":5},
{"id":5729,"description":"Wall Ferraz","state_id":17},
{"id":1119,"description":"Wanderley","state_id":5},
{"id":9960,"description":"Wanderlândia","state_id":27},
{"id":6833,"description":"Warta (Londrina)","state_id":18},
{"id":6834,"description":"Wenceslau Braz","state_id":18},
{"id":4099,"description":"Wenceslau Braz","state_id":11},
{"id":1120,"description":"Wenceslau Guimarães","state_id":5},
{"id":7122,"description":"Werneck (Paraíba do Sul)","state_id":19},
{"id":10101,"description":"Westfália","state_id":23},
{"id":8762,"description":"Witmarsum","state_id":24},
{"id":8316,"description":"Xadrez (Carazinho)","state_id":23},
{"id":9961,"description":"Xambioá","state_id":27},
{"id":6835,"description":"Xambrê","state_id":18},
{"id":8317,"description":"Xangri-Lá","state_id":23},
{"id":8763,"description":"Xanxerê","state_id":24},
{"id":22,"description":"Xapuri","state_id":1},
{"id":12487,"description":"Xarqueada","state_id":23},
{"id":8764,"description":"Xavantina","state_id":24},
{"id":8765,"description":"Xaxim","state_id":24},
{"id":12483,"description":"Xaxim","state_id":23},
{"id":6836,"description":"Xaxim (Toledo)","state_id":18},
{"id":7123,"description":"Xerém (Duque de Caxias)","state_id":19},
{"id":5505,"description":"Xexéu","state_id":16},
{"id":11826,"description":"Xicuru","state_id":16},
{"id":4846,"description":"Xinguara","state_id":14},
{"id":4847,"description":"Xinguarinha (Xinguara)","state_id":14},
{"id":12530,"description":"Xiniquá","state_id":23},
{"id":1121,"description":"Xique-Xique","state_id":5},
{"id":11830,"description":"Xique-Xique","state_id":16},
{"id":5506,"description":"Xucuru (Belo Jardim)","state_id":16},
{"id":6837,"description":"Yolanda (Ubiratã)","state_id":18},
{"id":5134,"description":"Zabelê","state_id":15},
{"id":9790,"description":"Zacarias","state_id":26},
{"id":4100,"description":"Zelândia (Santa Juliana)","state_id":11},
{"id":4101,"description":"Zito Soares (Santa Cruz do Escalvado)","state_id":11},
{"id":8766,"description":"Zortéa","state_id":24},
{"id":2619,"description":"Zé Doca","state_id":10},
{"id":5507,"description":"Zé Gomes (Exu)","state_id":16},
{"id":4668,"description":"km 19 (Maracanã)","state_id":14},
{"id":4669,"description":"km 26 (Maracanã)","state_id":14},
{"id":6239,"description":"km 30 (Telêmaco Borba)","state_id":18},
{"id":5737,"description":"Água Azul (Lapa)","state_id":18},
{"id":4527,"description":"Água Azul do Norte","state_id":14},
{"id":2630,"description":"Água Boa","state_id":11},
{"id":4273,"description":"Água Boa","state_id":13},
{"id":5738,"description":"Água Boa (Paiçandu)","state_id":18},
{"id":4102,"description":"Água Boa (Rochedo)","state_id":12},
{"id":23,"description":"Água Branca","state_id":2},
{"id":5510,"description":"Água Branca","state_id":17},
{"id":4848,"description":"Água Branca","state_id":15},
{"id":5739,"description":"Água Branca (Guarapuava)","state_id":18},
{"id":2631,"description":"Água Branca de Minas (Comercinho)","state_id":11},
{"id":279,"description":"Água Branca do Amapari","state_id":4},
{"id":4103,"description":"Água Clara","state_id":12},
{"id":2632,"description":"Água Comprida","state_id":11},
{"id":12068,"description":"Água Da Prata","state_id":13},
{"id":8323,"description":"Água Doce","state_id":24},
{"id":338,"description":"Água Doce (Ibicuí)","state_id":5},
{"id":2371,"description":"Água Doce do Maranhão","state_id":10},
{"id":1800,"description":"Água Doce do Norte","state_id":8},
{"id":339,"description":"Água Fria","state_id":5},
{"id":5139,"description":"Água Fria (Belo Jardim)","state_id":16},
{"id":4274,"description":"Água Fria (Chapada dos Guimarães)","state_id":13},
{"id":4528,"description":"Água Fria (Xinguara)","state_id":14},
{"id":2053,"description":"Água Fria de Goiás","state_id":9},
{"id":2054,"description":"Água Limpa","state_id":9},
{"id":5741,"description":"Água Mineral (Guarapuava)","state_id":18},
{"id":7127,"description":"Água Nova","state_id":20},
{"id":5140,"description":"Água Preta","state_id":16},
{"id":7390,"description":"Água Santa","state_id":23},
{"id":1128,"description":"Água Verde (Guaiúba)","state_id":6},
{"id":5742,"description":"Água Vermelha (Castro)","state_id":18},
{"id":8856,"description":"Água Vermelha (São Carlos)","state_id":26},
{"id":2633,"description":"Água Viva (Estrela Dalva)","state_id":11},
{"id":5141,"description":"Águas Belas","state_id":16},
{"id":8324,"description":"Águas Brancas (Urubici)","state_id":24},
{"id":8325,"description":"Águas Claras (Mafra)","state_id":24},
{"id":4277,"description":"Águas Claras (Novo Horizonte do Norte)","state_id":13},
{"id":7391,"description":"Águas Claras (Viamão)","state_id":23},
{"id":2638,"description":"Águas Formosas","state_id":11},
{"id":8327,"description":"Águas Frias","state_id":24},
{"id":2637,"description":"Águas Férreas (São Pedro dos Ferros)","state_id":11},
{"id":2055,"description":"Águas Lindas de Goiás","state_id":9},
{"id":8328,"description":"Águas Mornas","state_id":24},
{"id":2639,"description":"Águas Vermelhas","state_id":11},
{"id":8858,"description":"Águas da Prata","state_id":26},
{"id":2635,"description":"Águas de Araxá (Araxá)","state_id":11},
{"id":8326,"description":"Águas de Chapecó","state_id":24},
{"id":2636,"description":"Águas de Contendas (Conceição do Rio Verde)","state_id":11},
{"id":8859,"description":"Águas de Lindóia","state_id":26},
{"id":8860,"description":"Águas de Santa Bárbara","state_id":26},
{"id":8861,"description":"Águas de São Pedro","state_id":26},
{"id":340,"description":"Águas do Paulista (Paratinga)","state_id":5},
{"id":1801,"description":"Águia Branca","state_id":8},
{"id":8876,"description":"Álvares Florence","state_id":26},
{"id":8877,"description":"Álvares Machado","state_id":26},
{"id":8878,"description":"Álvaro de Carvalho","state_id":26},
{"id":4120,"description":"Árvore Grande (Paranaíba)","state_id":12},
{"id":7430,"description":"Árvore Só (Santa Vitória do Palmar)","state_id":23},
{"id":7435,"description":"Áurea","state_id":23},
{"id":1811,"description":"Ângelo Frechiani (Colatina)","state_id":8},
{"id":5771,"description":"Ângulo","state_id":18},
{"id":576,"description":"Érico Cardoso","state_id":5},
{"id":8489,"description":"Índios (Lages)","state_id":24},
{"id":4717,"description":"Óbidos","state_id":14},
{"id":9424,"description":"Óleo","state_id":26},
]
